"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectSerializer = void 0;
const APIErrorResponse_1 = require("./APIErrorResponse");
const APIKeyCreateAttributes_1 = require("./APIKeyCreateAttributes");
const APIKeyCreateData_1 = require("./APIKeyCreateData");
const APIKeyCreateRequest_1 = require("./APIKeyCreateRequest");
const APIKeyRelationships_1 = require("./APIKeyRelationships");
const APIKeyResponse_1 = require("./APIKeyResponse");
const APIKeyUpdateAttributes_1 = require("./APIKeyUpdateAttributes");
const APIKeyUpdateData_1 = require("./APIKeyUpdateData");
const APIKeyUpdateRequest_1 = require("./APIKeyUpdateRequest");
const APIKeysResponse_1 = require("./APIKeysResponse");
const APIKeysResponseMeta_1 = require("./APIKeysResponseMeta");
const APIKeysResponseMetaPage_1 = require("./APIKeysResponseMetaPage");
const APITrigger_1 = require("./APITrigger");
const APITriggerWrapper_1 = require("./APITriggerWrapper");
const AWSAccountCreateRequest_1 = require("./AWSAccountCreateRequest");
const AWSAccountCreateRequestAttributes_1 = require("./AWSAccountCreateRequestAttributes");
const AWSAccountCreateRequestData_1 = require("./AWSAccountCreateRequestData");
const AWSAccountResponse_1 = require("./AWSAccountResponse");
const AWSAccountResponseAttributes_1 = require("./AWSAccountResponseAttributes");
const AWSAccountResponseData_1 = require("./AWSAccountResponseData");
const AWSAccountUpdateRequest_1 = require("./AWSAccountUpdateRequest");
const AWSAccountUpdateRequestAttributes_1 = require("./AWSAccountUpdateRequestAttributes");
const AWSAccountUpdateRequestData_1 = require("./AWSAccountUpdateRequestData");
const AWSAccountsResponse_1 = require("./AWSAccountsResponse");
const AWSAssumeRole_1 = require("./AWSAssumeRole");
const AWSAssumeRoleUpdate_1 = require("./AWSAssumeRoleUpdate");
const AWSAuthConfigKeys_1 = require("./AWSAuthConfigKeys");
const AWSAuthConfigRole_1 = require("./AWSAuthConfigRole");
const AWSIntegration_1 = require("./AWSIntegration");
const AWSIntegrationUpdate_1 = require("./AWSIntegrationUpdate");
const AWSLambdaForwarderConfig_1 = require("./AWSLambdaForwarderConfig");
const AWSLogsConfig_1 = require("./AWSLogsConfig");
const AWSLogsServicesResponse_1 = require("./AWSLogsServicesResponse");
const AWSLogsServicesResponseAttributes_1 = require("./AWSLogsServicesResponseAttributes");
const AWSLogsServicesResponseData_1 = require("./AWSLogsServicesResponseData");
const AWSMetricsConfig_1 = require("./AWSMetricsConfig");
const AWSNamespaceFiltersExcludeOnly_1 = require("./AWSNamespaceFiltersExcludeOnly");
const AWSNamespaceFiltersIncludeOnly_1 = require("./AWSNamespaceFiltersIncludeOnly");
const AWSNamespaceTagFilter_1 = require("./AWSNamespaceTagFilter");
const AWSNamespacesResponse_1 = require("./AWSNamespacesResponse");
const AWSNamespacesResponseAttributes_1 = require("./AWSNamespacesResponseAttributes");
const AWSNamespacesResponseData_1 = require("./AWSNamespacesResponseData");
const AWSNewExternalIDResponse_1 = require("./AWSNewExternalIDResponse");
const AWSNewExternalIDResponseAttributes_1 = require("./AWSNewExternalIDResponseAttributes");
const AWSNewExternalIDResponseData_1 = require("./AWSNewExternalIDResponseData");
const AWSRegionsIncludeAll_1 = require("./AWSRegionsIncludeAll");
const AWSRegionsIncludeOnly_1 = require("./AWSRegionsIncludeOnly");
const AWSResourcesConfig_1 = require("./AWSResourcesConfig");
const AWSTracesConfig_1 = require("./AWSTracesConfig");
const AccountFilteringConfig_1 = require("./AccountFilteringConfig");
const ActionConnectionAttributes_1 = require("./ActionConnectionAttributes");
const ActionConnectionAttributesUpdate_1 = require("./ActionConnectionAttributesUpdate");
const ActionConnectionData_1 = require("./ActionConnectionData");
const ActionConnectionDataUpdate_1 = require("./ActionConnectionDataUpdate");
const ActionQuery_1 = require("./ActionQuery");
const ActionQueryMockedOutputsObject_1 = require("./ActionQueryMockedOutputsObject");
const ActionQueryProperties_1 = require("./ActionQueryProperties");
const ActionQuerySpecConnectionGroup_1 = require("./ActionQuerySpecConnectionGroup");
const ActionQuerySpecObject_1 = require("./ActionQuerySpecObject");
const ActiveBillingDimensionsAttributes_1 = require("./ActiveBillingDimensionsAttributes");
const ActiveBillingDimensionsBody_1 = require("./ActiveBillingDimensionsBody");
const ActiveBillingDimensionsResponse_1 = require("./ActiveBillingDimensionsResponse");
const Advisory_1 = require("./Advisory");
const Annotation_1 = require("./Annotation");
const AnnotationDisplay_1 = require("./AnnotationDisplay");
const AnnotationDisplayBounds_1 = require("./AnnotationDisplayBounds");
const AnnotationMarkdownTextAnnotation_1 = require("./AnnotationMarkdownTextAnnotation");
const AppBuilderEvent_1 = require("./AppBuilderEvent");
const AppMeta_1 = require("./AppMeta");
const AppRelationship_1 = require("./AppRelationship");
const AppTriggerWrapper_1 = require("./AppTriggerWrapper");
const ApplicationKeyCreateAttributes_1 = require("./ApplicationKeyCreateAttributes");
const ApplicationKeyCreateData_1 = require("./ApplicationKeyCreateData");
const ApplicationKeyCreateRequest_1 = require("./ApplicationKeyCreateRequest");
const ApplicationKeyRelationships_1 = require("./ApplicationKeyRelationships");
const ApplicationKeyResponse_1 = require("./ApplicationKeyResponse");
const ApplicationKeyResponseMeta_1 = require("./ApplicationKeyResponseMeta");
const ApplicationKeyResponseMetaPage_1 = require("./ApplicationKeyResponseMetaPage");
const ApplicationKeyUpdateAttributes_1 = require("./ApplicationKeyUpdateAttributes");
const ApplicationKeyUpdateData_1 = require("./ApplicationKeyUpdateData");
const ApplicationKeyUpdateRequest_1 = require("./ApplicationKeyUpdateRequest");
const ApplicationSecurityWafCustomRuleAction_1 = require("./ApplicationSecurityWafCustomRuleAction");
const ApplicationSecurityWafCustomRuleActionParameters_1 = require("./ApplicationSecurityWafCustomRuleActionParameters");
const ApplicationSecurityWafCustomRuleAttributes_1 = require("./ApplicationSecurityWafCustomRuleAttributes");
const ApplicationSecurityWafCustomRuleCondition_1 = require("./ApplicationSecurityWafCustomRuleCondition");
const ApplicationSecurityWafCustomRuleConditionInput_1 = require("./ApplicationSecurityWafCustomRuleConditionInput");
const ApplicationSecurityWafCustomRuleConditionOptions_1 = require("./ApplicationSecurityWafCustomRuleConditionOptions");
const ApplicationSecurityWafCustomRuleConditionParameters_1 = require("./ApplicationSecurityWafCustomRuleConditionParameters");
const ApplicationSecurityWafCustomRuleCreateAttributes_1 = require("./ApplicationSecurityWafCustomRuleCreateAttributes");
const ApplicationSecurityWafCustomRuleCreateData_1 = require("./ApplicationSecurityWafCustomRuleCreateData");
const ApplicationSecurityWafCustomRuleCreateRequest_1 = require("./ApplicationSecurityWafCustomRuleCreateRequest");
const ApplicationSecurityWafCustomRuleData_1 = require("./ApplicationSecurityWafCustomRuleData");
const ApplicationSecurityWafCustomRuleListResponse_1 = require("./ApplicationSecurityWafCustomRuleListResponse");
const ApplicationSecurityWafCustomRuleMetadata_1 = require("./ApplicationSecurityWafCustomRuleMetadata");
const ApplicationSecurityWafCustomRuleResponse_1 = require("./ApplicationSecurityWafCustomRuleResponse");
const ApplicationSecurityWafCustomRuleScope_1 = require("./ApplicationSecurityWafCustomRuleScope");
const ApplicationSecurityWafCustomRuleTags_1 = require("./ApplicationSecurityWafCustomRuleTags");
const ApplicationSecurityWafCustomRuleUpdateAttributes_1 = require("./ApplicationSecurityWafCustomRuleUpdateAttributes");
const ApplicationSecurityWafCustomRuleUpdateData_1 = require("./ApplicationSecurityWafCustomRuleUpdateData");
const ApplicationSecurityWafCustomRuleUpdateRequest_1 = require("./ApplicationSecurityWafCustomRuleUpdateRequest");
const ApplicationSecurityWafExclusionFilterAttributes_1 = require("./ApplicationSecurityWafExclusionFilterAttributes");
const ApplicationSecurityWafExclusionFilterCreateAttributes_1 = require("./ApplicationSecurityWafExclusionFilterCreateAttributes");
const ApplicationSecurityWafExclusionFilterCreateData_1 = require("./ApplicationSecurityWafExclusionFilterCreateData");
const ApplicationSecurityWafExclusionFilterCreateRequest_1 = require("./ApplicationSecurityWafExclusionFilterCreateRequest");
const ApplicationSecurityWafExclusionFilterMetadata_1 = require("./ApplicationSecurityWafExclusionFilterMetadata");
const ApplicationSecurityWafExclusionFilterResource_1 = require("./ApplicationSecurityWafExclusionFilterResource");
const ApplicationSecurityWafExclusionFilterResponse_1 = require("./ApplicationSecurityWafExclusionFilterResponse");
const ApplicationSecurityWafExclusionFilterRulesTarget_1 = require("./ApplicationSecurityWafExclusionFilterRulesTarget");
const ApplicationSecurityWafExclusionFilterRulesTargetTags_1 = require("./ApplicationSecurityWafExclusionFilterRulesTargetTags");
const ApplicationSecurityWafExclusionFilterScope_1 = require("./ApplicationSecurityWafExclusionFilterScope");
const ApplicationSecurityWafExclusionFilterUpdateAttributes_1 = require("./ApplicationSecurityWafExclusionFilterUpdateAttributes");
const ApplicationSecurityWafExclusionFilterUpdateData_1 = require("./ApplicationSecurityWafExclusionFilterUpdateData");
const ApplicationSecurityWafExclusionFilterUpdateRequest_1 = require("./ApplicationSecurityWafExclusionFilterUpdateRequest");
const ApplicationSecurityWafExclusionFiltersResponse_1 = require("./ApplicationSecurityWafExclusionFiltersResponse");
const Asset_1 = require("./Asset");
const AssetAttributes_1 = require("./AssetAttributes");
const AssetOperatingSystem_1 = require("./AssetOperatingSystem");
const AssetRisks_1 = require("./AssetRisks");
const AssetVersion_1 = require("./AssetVersion");
const AuditLogsEvent_1 = require("./AuditLogsEvent");
const AuditLogsEventAttributes_1 = require("./AuditLogsEventAttributes");
const AuditLogsEventsResponse_1 = require("./AuditLogsEventsResponse");
const AuditLogsQueryFilter_1 = require("./AuditLogsQueryFilter");
const AuditLogsQueryOptions_1 = require("./AuditLogsQueryOptions");
const AuditLogsQueryPageOptions_1 = require("./AuditLogsQueryPageOptions");
const AuditLogsResponseLinks_1 = require("./AuditLogsResponseLinks");
const AuditLogsResponseMetadata_1 = require("./AuditLogsResponseMetadata");
const AuditLogsResponsePage_1 = require("./AuditLogsResponsePage");
const AuditLogsSearchEventsRequest_1 = require("./AuditLogsSearchEventsRequest");
const AuditLogsWarning_1 = require("./AuditLogsWarning");
const AuthNMapping_1 = require("./AuthNMapping");
const AuthNMappingAttributes_1 = require("./AuthNMappingAttributes");
const AuthNMappingCreateAttributes_1 = require("./AuthNMappingCreateAttributes");
const AuthNMappingCreateData_1 = require("./AuthNMappingCreateData");
const AuthNMappingCreateRequest_1 = require("./AuthNMappingCreateRequest");
const AuthNMappingRelationshipToRole_1 = require("./AuthNMappingRelationshipToRole");
const AuthNMappingRelationshipToTeam_1 = require("./AuthNMappingRelationshipToTeam");
const AuthNMappingRelationships_1 = require("./AuthNMappingRelationships");
const AuthNMappingResponse_1 = require("./AuthNMappingResponse");
const AuthNMappingTeam_1 = require("./AuthNMappingTeam");
const AuthNMappingTeamAttributes_1 = require("./AuthNMappingTeamAttributes");
const AuthNMappingUpdateAttributes_1 = require("./AuthNMappingUpdateAttributes");
const AuthNMappingUpdateData_1 = require("./AuthNMappingUpdateData");
const AuthNMappingUpdateRequest_1 = require("./AuthNMappingUpdateRequest");
const AuthNMappingsResponse_1 = require("./AuthNMappingsResponse");
const AwsCURConfig_1 = require("./AwsCURConfig");
const AwsCURConfigAttributes_1 = require("./AwsCURConfigAttributes");
const AwsCURConfigPatchData_1 = require("./AwsCURConfigPatchData");
const AwsCURConfigPatchRequest_1 = require("./AwsCURConfigPatchRequest");
const AwsCURConfigPatchRequestAttributes_1 = require("./AwsCURConfigPatchRequestAttributes");
const AwsCURConfigPostData_1 = require("./AwsCURConfigPostData");
const AwsCURConfigPostRequest_1 = require("./AwsCURConfigPostRequest");
const AwsCURConfigPostRequestAttributes_1 = require("./AwsCURConfigPostRequestAttributes");
const AwsCURConfigResponse_1 = require("./AwsCURConfigResponse");
const AwsCURConfigsResponse_1 = require("./AwsCURConfigsResponse");
const AwsOnDemandAttributes_1 = require("./AwsOnDemandAttributes");
const AwsOnDemandCreateAttributes_1 = require("./AwsOnDemandCreateAttributes");
const AwsOnDemandCreateData_1 = require("./AwsOnDemandCreateData");
const AwsOnDemandCreateRequest_1 = require("./AwsOnDemandCreateRequest");
const AwsOnDemandData_1 = require("./AwsOnDemandData");
const AwsOnDemandListResponse_1 = require("./AwsOnDemandListResponse");
const AwsOnDemandResponse_1 = require("./AwsOnDemandResponse");
const AwsScanOptionsAttributes_1 = require("./AwsScanOptionsAttributes");
const AwsScanOptionsCreateAttributes_1 = require("./AwsScanOptionsCreateAttributes");
const AwsScanOptionsCreateData_1 = require("./AwsScanOptionsCreateData");
const AwsScanOptionsCreateRequest_1 = require("./AwsScanOptionsCreateRequest");
const AwsScanOptionsData_1 = require("./AwsScanOptionsData");
const AwsScanOptionsListResponse_1 = require("./AwsScanOptionsListResponse");
const AwsScanOptionsResponse_1 = require("./AwsScanOptionsResponse");
const AwsScanOptionsUpdateAttributes_1 = require("./AwsScanOptionsUpdateAttributes");
const AwsScanOptionsUpdateData_1 = require("./AwsScanOptionsUpdateData");
const AwsScanOptionsUpdateRequest_1 = require("./AwsScanOptionsUpdateRequest");
const AzureStorageDestination_1 = require("./AzureStorageDestination");
const AzureUCConfig_1 = require("./AzureUCConfig");
const AzureUCConfigPair_1 = require("./AzureUCConfigPair");
const AzureUCConfigPairAttributes_1 = require("./AzureUCConfigPairAttributes");
const AzureUCConfigPairsResponse_1 = require("./AzureUCConfigPairsResponse");
const AzureUCConfigPatchData_1 = require("./AzureUCConfigPatchData");
const AzureUCConfigPatchRequest_1 = require("./AzureUCConfigPatchRequest");
const AzureUCConfigPatchRequestAttributes_1 = require("./AzureUCConfigPatchRequestAttributes");
const AzureUCConfigPostData_1 = require("./AzureUCConfigPostData");
const AzureUCConfigPostRequest_1 = require("./AzureUCConfigPostRequest");
const AzureUCConfigPostRequestAttributes_1 = require("./AzureUCConfigPostRequestAttributes");
const AzureUCConfigsResponse_1 = require("./AzureUCConfigsResponse");
const BillConfig_1 = require("./BillConfig");
const BillingDimensionsMappingBodyItem_1 = require("./BillingDimensionsMappingBodyItem");
const BillingDimensionsMappingBodyItemAttributes_1 = require("./BillingDimensionsMappingBodyItemAttributes");
const BillingDimensionsMappingBodyItemAttributesEndpointsItems_1 = require("./BillingDimensionsMappingBodyItemAttributesEndpointsItems");
const BillingDimensionsMappingResponse_1 = require("./BillingDimensionsMappingResponse");
const Budget_1 = require("./Budget");
const BudgetArray_1 = require("./BudgetArray");
const BudgetAttributes_1 = require("./BudgetAttributes");
const BudgetEntry_1 = require("./BudgetEntry");
const BudgetWithEntries_1 = require("./BudgetWithEntries");
const BudgetWithEntriesData_1 = require("./BudgetWithEntriesData");
const BulkMuteFindingsRequest_1 = require("./BulkMuteFindingsRequest");
const BulkMuteFindingsRequestAttributes_1 = require("./BulkMuteFindingsRequestAttributes");
const BulkMuteFindingsRequestData_1 = require("./BulkMuteFindingsRequestData");
const BulkMuteFindingsRequestMeta_1 = require("./BulkMuteFindingsRequestMeta");
const BulkMuteFindingsRequestMetaFindings_1 = require("./BulkMuteFindingsRequestMetaFindings");
const BulkMuteFindingsRequestProperties_1 = require("./BulkMuteFindingsRequestProperties");
const BulkMuteFindingsResponse_1 = require("./BulkMuteFindingsResponse");
const BulkMuteFindingsResponseData_1 = require("./BulkMuteFindingsResponseData");
const CIAppAggregateBucketValueTimeseriesPoint_1 = require("./CIAppAggregateBucketValueTimeseriesPoint");
const CIAppAggregateSort_1 = require("./CIAppAggregateSort");
const CIAppCIError_1 = require("./CIAppCIError");
const CIAppCompute_1 = require("./CIAppCompute");
const CIAppCreatePipelineEventRequest_1 = require("./CIAppCreatePipelineEventRequest");
const CIAppCreatePipelineEventRequestAttributes_1 = require("./CIAppCreatePipelineEventRequestAttributes");
const CIAppCreatePipelineEventRequestData_1 = require("./CIAppCreatePipelineEventRequestData");
const CIAppEventAttributes_1 = require("./CIAppEventAttributes");
const CIAppGitInfo_1 = require("./CIAppGitInfo");
const CIAppGroupByHistogram_1 = require("./CIAppGroupByHistogram");
const CIAppHostInfo_1 = require("./CIAppHostInfo");
const CIAppPipelineEvent_1 = require("./CIAppPipelineEvent");
const CIAppPipelineEventAttributes_1 = require("./CIAppPipelineEventAttributes");
const CIAppPipelineEventFinishedPipeline_1 = require("./CIAppPipelineEventFinishedPipeline");
const CIAppPipelineEventInProgressPipeline_1 = require("./CIAppPipelineEventInProgressPipeline");
const CIAppPipelineEventJob_1 = require("./CIAppPipelineEventJob");
const CIAppPipelineEventParentPipeline_1 = require("./CIAppPipelineEventParentPipeline");
const CIAppPipelineEventPreviousPipeline_1 = require("./CIAppPipelineEventPreviousPipeline");
const CIAppPipelineEventStage_1 = require("./CIAppPipelineEventStage");
const CIAppPipelineEventStep_1 = require("./CIAppPipelineEventStep");
const CIAppPipelineEventsRequest_1 = require("./CIAppPipelineEventsRequest");
const CIAppPipelineEventsResponse_1 = require("./CIAppPipelineEventsResponse");
const CIAppPipelinesAggregateRequest_1 = require("./CIAppPipelinesAggregateRequest");
const CIAppPipelinesAggregationBucketsResponse_1 = require("./CIAppPipelinesAggregationBucketsResponse");
const CIAppPipelinesAnalyticsAggregateResponse_1 = require("./CIAppPipelinesAnalyticsAggregateResponse");
const CIAppPipelinesBucketResponse_1 = require("./CIAppPipelinesBucketResponse");
const CIAppPipelinesGroupBy_1 = require("./CIAppPipelinesGroupBy");
const CIAppPipelinesQueryFilter_1 = require("./CIAppPipelinesQueryFilter");
const CIAppQueryOptions_1 = require("./CIAppQueryOptions");
const CIAppQueryPageOptions_1 = require("./CIAppQueryPageOptions");
const CIAppResponseLinks_1 = require("./CIAppResponseLinks");
const CIAppResponseMetadata_1 = require("./CIAppResponseMetadata");
const CIAppResponseMetadataWithPagination_1 = require("./CIAppResponseMetadataWithPagination");
const CIAppResponsePage_1 = require("./CIAppResponsePage");
const CIAppTestEvent_1 = require("./CIAppTestEvent");
const CIAppTestEventsRequest_1 = require("./CIAppTestEventsRequest");
const CIAppTestEventsResponse_1 = require("./CIAppTestEventsResponse");
const CIAppTestsAggregateRequest_1 = require("./CIAppTestsAggregateRequest");
const CIAppTestsAggregationBucketsResponse_1 = require("./CIAppTestsAggregationBucketsResponse");
const CIAppTestsAnalyticsAggregateResponse_1 = require("./CIAppTestsAnalyticsAggregateResponse");
const CIAppTestsBucketResponse_1 = require("./CIAppTestsBucketResponse");
const CIAppTestsGroupBy_1 = require("./CIAppTestsGroupBy");
const CIAppTestsQueryFilter_1 = require("./CIAppTestsQueryFilter");
const CIAppWarning_1 = require("./CIAppWarning");
const CSMAgentsMetadata_1 = require("./CSMAgentsMetadata");
const CVSS_1 = require("./CVSS");
const CalculatedField_1 = require("./CalculatedField");
const CancelDataDeletionResponseBody_1 = require("./CancelDataDeletionResponseBody");
const Case_1 = require("./Case");
const CaseAssign_1 = require("./CaseAssign");
const CaseAssignAttributes_1 = require("./CaseAssignAttributes");
const CaseAssignRequest_1 = require("./CaseAssignRequest");
const CaseAttributes_1 = require("./CaseAttributes");
const CaseCreate_1 = require("./CaseCreate");
const CaseCreateAttributes_1 = require("./CaseCreateAttributes");
const CaseCreateRelationships_1 = require("./CaseCreateRelationships");
const CaseCreateRequest_1 = require("./CaseCreateRequest");
const CaseEmpty_1 = require("./CaseEmpty");
const CaseEmptyRequest_1 = require("./CaseEmptyRequest");
const CaseRelationships_1 = require("./CaseRelationships");
const CaseResponse_1 = require("./CaseResponse");
const CaseTrigger_1 = require("./CaseTrigger");
const CaseTriggerWrapper_1 = require("./CaseTriggerWrapper");
const CaseUpdatePriority_1 = require("./CaseUpdatePriority");
const CaseUpdatePriorityAttributes_1 = require("./CaseUpdatePriorityAttributes");
const CaseUpdatePriorityRequest_1 = require("./CaseUpdatePriorityRequest");
const CaseUpdateStatus_1 = require("./CaseUpdateStatus");
const CaseUpdateStatusAttributes_1 = require("./CaseUpdateStatusAttributes");
const CaseUpdateStatusRequest_1 = require("./CaseUpdateStatusRequest");
const CasesResponse_1 = require("./CasesResponse");
const CasesResponseMeta_1 = require("./CasesResponseMeta");
const CasesResponseMetaPagination_1 = require("./CasesResponseMetaPagination");
const ChangeEventCustomAttributes_1 = require("./ChangeEventCustomAttributes");
const ChangeEventCustomAttributesAuthor_1 = require("./ChangeEventCustomAttributesAuthor");
const ChangeEventCustomAttributesChangedResource_1 = require("./ChangeEventCustomAttributesChangedResource");
const ChangeEventCustomAttributesImpactedResourcesItems_1 = require("./ChangeEventCustomAttributesImpactedResourcesItems");
const ChangeEventTriggerWrapper_1 = require("./ChangeEventTriggerWrapper");
const ChargebackBreakdown_1 = require("./ChargebackBreakdown");
const CloudConfigurationComplianceRuleOptions_1 = require("./CloudConfigurationComplianceRuleOptions");
const CloudConfigurationRegoRule_1 = require("./CloudConfigurationRegoRule");
const CloudConfigurationRuleCaseCreate_1 = require("./CloudConfigurationRuleCaseCreate");
const CloudConfigurationRuleComplianceSignalOptions_1 = require("./CloudConfigurationRuleComplianceSignalOptions");
const CloudConfigurationRuleCreatePayload_1 = require("./CloudConfigurationRuleCreatePayload");
const CloudConfigurationRuleOptions_1 = require("./CloudConfigurationRuleOptions");
const CloudConfigurationRulePayload_1 = require("./CloudConfigurationRulePayload");
const CloudWorkloadSecurityAgentPoliciesListResponse_1 = require("./CloudWorkloadSecurityAgentPoliciesListResponse");
const CloudWorkloadSecurityAgentPolicyAttributes_1 = require("./CloudWorkloadSecurityAgentPolicyAttributes");
const CloudWorkloadSecurityAgentPolicyCreateAttributes_1 = require("./CloudWorkloadSecurityAgentPolicyCreateAttributes");
const CloudWorkloadSecurityAgentPolicyCreateData_1 = require("./CloudWorkloadSecurityAgentPolicyCreateData");
const CloudWorkloadSecurityAgentPolicyCreateRequest_1 = require("./CloudWorkloadSecurityAgentPolicyCreateRequest");
const CloudWorkloadSecurityAgentPolicyData_1 = require("./CloudWorkloadSecurityAgentPolicyData");
const CloudWorkloadSecurityAgentPolicyResponse_1 = require("./CloudWorkloadSecurityAgentPolicyResponse");
const CloudWorkloadSecurityAgentPolicyUpdateAttributes_1 = require("./CloudWorkloadSecurityAgentPolicyUpdateAttributes");
const CloudWorkloadSecurityAgentPolicyUpdateData_1 = require("./CloudWorkloadSecurityAgentPolicyUpdateData");
const CloudWorkloadSecurityAgentPolicyUpdateRequest_1 = require("./CloudWorkloadSecurityAgentPolicyUpdateRequest");
const CloudWorkloadSecurityAgentPolicyUpdaterAttributes_1 = require("./CloudWorkloadSecurityAgentPolicyUpdaterAttributes");
const CloudWorkloadSecurityAgentRuleAction_1 = require("./CloudWorkloadSecurityAgentRuleAction");
const CloudWorkloadSecurityAgentRuleAttributes_1 = require("./CloudWorkloadSecurityAgentRuleAttributes");
const CloudWorkloadSecurityAgentRuleCreateAttributes_1 = require("./CloudWorkloadSecurityAgentRuleCreateAttributes");
const CloudWorkloadSecurityAgentRuleCreateData_1 = require("./CloudWorkloadSecurityAgentRuleCreateData");
const CloudWorkloadSecurityAgentRuleCreateRequest_1 = require("./CloudWorkloadSecurityAgentRuleCreateRequest");
const CloudWorkloadSecurityAgentRuleCreatorAttributes_1 = require("./CloudWorkloadSecurityAgentRuleCreatorAttributes");
const CloudWorkloadSecurityAgentRuleData_1 = require("./CloudWorkloadSecurityAgentRuleData");
const CloudWorkloadSecurityAgentRuleKill_1 = require("./CloudWorkloadSecurityAgentRuleKill");
const CloudWorkloadSecurityAgentRuleResponse_1 = require("./CloudWorkloadSecurityAgentRuleResponse");
const CloudWorkloadSecurityAgentRuleUpdateAttributes_1 = require("./CloudWorkloadSecurityAgentRuleUpdateAttributes");
const CloudWorkloadSecurityAgentRuleUpdateData_1 = require("./CloudWorkloadSecurityAgentRuleUpdateData");
const CloudWorkloadSecurityAgentRuleUpdateRequest_1 = require("./CloudWorkloadSecurityAgentRuleUpdateRequest");
const CloudWorkloadSecurityAgentRuleUpdaterAttributes_1 = require("./CloudWorkloadSecurityAgentRuleUpdaterAttributes");
const CloudWorkloadSecurityAgentRulesListResponse_1 = require("./CloudWorkloadSecurityAgentRulesListResponse");
const CloudflareAccountCreateRequest_1 = require("./CloudflareAccountCreateRequest");
const CloudflareAccountCreateRequestAttributes_1 = require("./CloudflareAccountCreateRequestAttributes");
const CloudflareAccountCreateRequestData_1 = require("./CloudflareAccountCreateRequestData");
const CloudflareAccountResponse_1 = require("./CloudflareAccountResponse");
const CloudflareAccountResponseAttributes_1 = require("./CloudflareAccountResponseAttributes");
const CloudflareAccountResponseData_1 = require("./CloudflareAccountResponseData");
const CloudflareAccountUpdateRequest_1 = require("./CloudflareAccountUpdateRequest");
const CloudflareAccountUpdateRequestAttributes_1 = require("./CloudflareAccountUpdateRequestAttributes");
const CloudflareAccountUpdateRequestData_1 = require("./CloudflareAccountUpdateRequestData");
const CloudflareAccountsResponse_1 = require("./CloudflareAccountsResponse");
const CodeLocation_1 = require("./CodeLocation");
const CompletionCondition_1 = require("./CompletionCondition");
const CompletionGate_1 = require("./CompletionGate");
const Component_1 = require("./Component");
const ComponentGrid_1 = require("./ComponentGrid");
const ComponentGridProperties_1 = require("./ComponentGridProperties");
const ComponentProperties_1 = require("./ComponentProperties");
const ConfluentAccountCreateRequest_1 = require("./ConfluentAccountCreateRequest");
const ConfluentAccountCreateRequestAttributes_1 = require("./ConfluentAccountCreateRequestAttributes");
const ConfluentAccountCreateRequestData_1 = require("./ConfluentAccountCreateRequestData");
const ConfluentAccountResourceAttributes_1 = require("./ConfluentAccountResourceAttributes");
const ConfluentAccountResponse_1 = require("./ConfluentAccountResponse");
const ConfluentAccountResponseAttributes_1 = require("./ConfluentAccountResponseAttributes");
const ConfluentAccountResponseData_1 = require("./ConfluentAccountResponseData");
const ConfluentAccountUpdateRequest_1 = require("./ConfluentAccountUpdateRequest");
const ConfluentAccountUpdateRequestAttributes_1 = require("./ConfluentAccountUpdateRequestAttributes");
const ConfluentAccountUpdateRequestData_1 = require("./ConfluentAccountUpdateRequestData");
const ConfluentAccountsResponse_1 = require("./ConfluentAccountsResponse");
const ConfluentResourceRequest_1 = require("./ConfluentResourceRequest");
const ConfluentResourceRequestAttributes_1 = require("./ConfluentResourceRequestAttributes");
const ConfluentResourceRequestData_1 = require("./ConfluentResourceRequestData");
const ConfluentResourceResponse_1 = require("./ConfluentResourceResponse");
const ConfluentResourceResponseAttributes_1 = require("./ConfluentResourceResponseAttributes");
const ConfluentResourceResponseData_1 = require("./ConfluentResourceResponseData");
const ConfluentResourcesResponse_1 = require("./ConfluentResourcesResponse");
const Connection_1 = require("./Connection");
const ConnectionEnv_1 = require("./ConnectionEnv");
const ConnectionGroup_1 = require("./ConnectionGroup");
const Container_1 = require("./Container");
const ContainerAttributes_1 = require("./ContainerAttributes");
const ContainerGroup_1 = require("./ContainerGroup");
const ContainerGroupAttributes_1 = require("./ContainerGroupAttributes");
const ContainerGroupRelationships_1 = require("./ContainerGroupRelationships");
const ContainerGroupRelationshipsLink_1 = require("./ContainerGroupRelationshipsLink");
const ContainerGroupRelationshipsLinks_1 = require("./ContainerGroupRelationshipsLinks");
const ContainerImage_1 = require("./ContainerImage");
const ContainerImageAttributes_1 = require("./ContainerImageAttributes");
const ContainerImageFlavor_1 = require("./ContainerImageFlavor");
const ContainerImageGroup_1 = require("./ContainerImageGroup");
const ContainerImageGroupAttributes_1 = require("./ContainerImageGroupAttributes");
const ContainerImageGroupImagesRelationshipsLink_1 = require("./ContainerImageGroupImagesRelationshipsLink");
const ContainerImageGroupRelationships_1 = require("./ContainerImageGroupRelationships");
const ContainerImageGroupRelationshipsLinks_1 = require("./ContainerImageGroupRelationshipsLinks");
const ContainerImageMeta_1 = require("./ContainerImageMeta");
const ContainerImageMetaPage_1 = require("./ContainerImageMetaPage");
const ContainerImageVulnerabilities_1 = require("./ContainerImageVulnerabilities");
const ContainerImagesResponse_1 = require("./ContainerImagesResponse");
const ContainerImagesResponseLinks_1 = require("./ContainerImagesResponseLinks");
const ContainerMeta_1 = require("./ContainerMeta");
const ContainerMetaPage_1 = require("./ContainerMetaPage");
const ContainersResponse_1 = require("./ContainersResponse");
const ContainersResponseLinks_1 = require("./ContainersResponseLinks");
const ConvertJobResultsToSignalsAttributes_1 = require("./ConvertJobResultsToSignalsAttributes");
const ConvertJobResultsToSignalsData_1 = require("./ConvertJobResultsToSignalsData");
const ConvertJobResultsToSignalsRequest_1 = require("./ConvertJobResultsToSignalsRequest");
const CostAttributionAggregatesBody_1 = require("./CostAttributionAggregatesBody");
const CostByOrg_1 = require("./CostByOrg");
const CostByOrgAttributes_1 = require("./CostByOrgAttributes");
const CostByOrgResponse_1 = require("./CostByOrgResponse");
const CreateActionConnectionRequest_1 = require("./CreateActionConnectionRequest");
const CreateActionConnectionResponse_1 = require("./CreateActionConnectionResponse");
const CreateAppRequest_1 = require("./CreateAppRequest");
const CreateAppRequestData_1 = require("./CreateAppRequestData");
const CreateAppRequestDataAttributes_1 = require("./CreateAppRequestDataAttributes");
const CreateAppResponse_1 = require("./CreateAppResponse");
const CreateAppResponseData_1 = require("./CreateAppResponseData");
const CreateCustomFrameworkRequest_1 = require("./CreateCustomFrameworkRequest");
const CreateCustomFrameworkResponse_1 = require("./CreateCustomFrameworkResponse");
const CreateDataDeletionRequestBody_1 = require("./CreateDataDeletionRequestBody");
const CreateDataDeletionRequestBodyAttributes_1 = require("./CreateDataDeletionRequestBodyAttributes");
const CreateDataDeletionRequestBodyData_1 = require("./CreateDataDeletionRequestBodyData");
const CreateDataDeletionResponseBody_1 = require("./CreateDataDeletionResponseBody");
const CreateNotificationRuleParameters_1 = require("./CreateNotificationRuleParameters");
const CreateNotificationRuleParametersData_1 = require("./CreateNotificationRuleParametersData");
const CreateNotificationRuleParametersDataAttributes_1 = require("./CreateNotificationRuleParametersDataAttributes");
const CreateOpenAPIResponse_1 = require("./CreateOpenAPIResponse");
const CreateOpenAPIResponseAttributes_1 = require("./CreateOpenAPIResponseAttributes");
const CreateOpenAPIResponseData_1 = require("./CreateOpenAPIResponseData");
const CreatePageRequest_1 = require("./CreatePageRequest");
const CreatePageRequestData_1 = require("./CreatePageRequestData");
const CreatePageRequestDataAttributes_1 = require("./CreatePageRequestDataAttributes");
const CreatePageRequestDataAttributesTarget_1 = require("./CreatePageRequestDataAttributesTarget");
const CreatePageResponse_1 = require("./CreatePageResponse");
const CreatePageResponseData_1 = require("./CreatePageResponseData");
const CreateRuleRequest_1 = require("./CreateRuleRequest");
const CreateRuleRequestData_1 = require("./CreateRuleRequestData");
const CreateRuleResponse_1 = require("./CreateRuleResponse");
const CreateRuleResponseData_1 = require("./CreateRuleResponseData");
const CreateWorkflowRequest_1 = require("./CreateWorkflowRequest");
const CreateWorkflowResponse_1 = require("./CreateWorkflowResponse");
const Creator_1 = require("./Creator");
const CsmAgentData_1 = require("./CsmAgentData");
const CsmAgentsAttributes_1 = require("./CsmAgentsAttributes");
const CsmAgentsResponse_1 = require("./CsmAgentsResponse");
const CsmCloudAccountsCoverageAnalysisAttributes_1 = require("./CsmCloudAccountsCoverageAnalysisAttributes");
const CsmCloudAccountsCoverageAnalysisData_1 = require("./CsmCloudAccountsCoverageAnalysisData");
const CsmCloudAccountsCoverageAnalysisResponse_1 = require("./CsmCloudAccountsCoverageAnalysisResponse");
const CsmCoverageAnalysis_1 = require("./CsmCoverageAnalysis");
const CsmHostsAndContainersCoverageAnalysisAttributes_1 = require("./CsmHostsAndContainersCoverageAnalysisAttributes");
const CsmHostsAndContainersCoverageAnalysisData_1 = require("./CsmHostsAndContainersCoverageAnalysisData");
const CsmHostsAndContainersCoverageAnalysisResponse_1 = require("./CsmHostsAndContainersCoverageAnalysisResponse");
const CsmServerlessCoverageAnalysisAttributes_1 = require("./CsmServerlessCoverageAnalysisAttributes");
const CsmServerlessCoverageAnalysisData_1 = require("./CsmServerlessCoverageAnalysisData");
const CsmServerlessCoverageAnalysisResponse_1 = require("./CsmServerlessCoverageAnalysisResponse");
const CustomConnection_1 = require("./CustomConnection");
const CustomConnectionAttributes_1 = require("./CustomConnectionAttributes");
const CustomConnectionAttributesOnPremRunner_1 = require("./CustomConnectionAttributesOnPremRunner");
const CustomCostGetResponseMeta_1 = require("./CustomCostGetResponseMeta");
const CustomCostListResponseMeta_1 = require("./CustomCostListResponseMeta");
const CustomCostUploadResponseMeta_1 = require("./CustomCostUploadResponseMeta");
const CustomCostsFileGetResponse_1 = require("./CustomCostsFileGetResponse");
const CustomCostsFileLineItem_1 = require("./CustomCostsFileLineItem");
const CustomCostsFileListResponse_1 = require("./CustomCostsFileListResponse");
const CustomCostsFileMetadata_1 = require("./CustomCostsFileMetadata");
const CustomCostsFileMetadataHighLevel_1 = require("./CustomCostsFileMetadataHighLevel");
const CustomCostsFileMetadataWithContent_1 = require("./CustomCostsFileMetadataWithContent");
const CustomCostsFileMetadataWithContentHighLevel_1 = require("./CustomCostsFileMetadataWithContentHighLevel");
const CustomCostsFileUploadResponse_1 = require("./CustomCostsFileUploadResponse");
const CustomCostsFileUsageChargePeriod_1 = require("./CustomCostsFileUsageChargePeriod");
const CustomCostsUser_1 = require("./CustomCostsUser");
const CustomDestinationCreateRequest_1 = require("./CustomDestinationCreateRequest");
const CustomDestinationCreateRequestAttributes_1 = require("./CustomDestinationCreateRequestAttributes");
const CustomDestinationCreateRequestDefinition_1 = require("./CustomDestinationCreateRequestDefinition");
const CustomDestinationElasticsearchDestinationAuth_1 = require("./CustomDestinationElasticsearchDestinationAuth");
const CustomDestinationForwardDestinationElasticsearch_1 = require("./CustomDestinationForwardDestinationElasticsearch");
const CustomDestinationForwardDestinationHttp_1 = require("./CustomDestinationForwardDestinationHttp");
const CustomDestinationForwardDestinationSplunk_1 = require("./CustomDestinationForwardDestinationSplunk");
const CustomDestinationHttpDestinationAuthBasic_1 = require("./CustomDestinationHttpDestinationAuthBasic");
const CustomDestinationHttpDestinationAuthCustomHeader_1 = require("./CustomDestinationHttpDestinationAuthCustomHeader");
const CustomDestinationResponse_1 = require("./CustomDestinationResponse");
const CustomDestinationResponseAttributes_1 = require("./CustomDestinationResponseAttributes");
const CustomDestinationResponseDefinition_1 = require("./CustomDestinationResponseDefinition");
const CustomDestinationResponseForwardDestinationElasticsearch_1 = require("./CustomDestinationResponseForwardDestinationElasticsearch");
const CustomDestinationResponseForwardDestinationHttp_1 = require("./CustomDestinationResponseForwardDestinationHttp");
const CustomDestinationResponseForwardDestinationSplunk_1 = require("./CustomDestinationResponseForwardDestinationSplunk");
const CustomDestinationResponseHttpDestinationAuthBasic_1 = require("./CustomDestinationResponseHttpDestinationAuthBasic");
const CustomDestinationResponseHttpDestinationAuthCustomHeader_1 = require("./CustomDestinationResponseHttpDestinationAuthCustomHeader");
const CustomDestinationUpdateRequest_1 = require("./CustomDestinationUpdateRequest");
const CustomDestinationUpdateRequestAttributes_1 = require("./CustomDestinationUpdateRequestAttributes");
const CustomDestinationUpdateRequestDefinition_1 = require("./CustomDestinationUpdateRequestDefinition");
const CustomDestinationsResponse_1 = require("./CustomDestinationsResponse");
const CustomFrameworkControl_1 = require("./CustomFrameworkControl");
const CustomFrameworkData_1 = require("./CustomFrameworkData");
const CustomFrameworkDataAttributes_1 = require("./CustomFrameworkDataAttributes");
const CustomFrameworkDataHandleAndVersion_1 = require("./CustomFrameworkDataHandleAndVersion");
const CustomFrameworkMetadata_1 = require("./CustomFrameworkMetadata");
const CustomFrameworkRequirement_1 = require("./CustomFrameworkRequirement");
const CustomFrameworkWithoutRequirements_1 = require("./CustomFrameworkWithoutRequirements");
const DORADeploymentRequest_1 = require("./DORADeploymentRequest");
const DORADeploymentRequestAttributes_1 = require("./DORADeploymentRequestAttributes");
const DORADeploymentRequestData_1 = require("./DORADeploymentRequestData");
const DORADeploymentResponse_1 = require("./DORADeploymentResponse");
const DORADeploymentResponseData_1 = require("./DORADeploymentResponseData");
const DORAEvent_1 = require("./DORAEvent");
const DORAFetchResponse_1 = require("./DORAFetchResponse");
const DORAGitInfo_1 = require("./DORAGitInfo");
const DORAIncidentRequest_1 = require("./DORAIncidentRequest");
const DORAIncidentRequestAttributes_1 = require("./DORAIncidentRequestAttributes");
const DORAIncidentRequestData_1 = require("./DORAIncidentRequestData");
const DORAIncidentResponse_1 = require("./DORAIncidentResponse");
const DORAIncidentResponseData_1 = require("./DORAIncidentResponseData");
const DORAListDeploymentsRequest_1 = require("./DORAListDeploymentsRequest");
const DORAListDeploymentsRequestAttributes_1 = require("./DORAListDeploymentsRequestAttributes");
const DORAListDeploymentsRequestData_1 = require("./DORAListDeploymentsRequestData");
const DORAListFailuresRequest_1 = require("./DORAListFailuresRequest");
const DORAListFailuresRequestAttributes_1 = require("./DORAListFailuresRequestAttributes");
const DORAListFailuresRequestData_1 = require("./DORAListFailuresRequestData");
const DORAListResponse_1 = require("./DORAListResponse");
const DashboardListAddItemsRequest_1 = require("./DashboardListAddItemsRequest");
const DashboardListAddItemsResponse_1 = require("./DashboardListAddItemsResponse");
const DashboardListDeleteItemsRequest_1 = require("./DashboardListDeleteItemsRequest");
const DashboardListDeleteItemsResponse_1 = require("./DashboardListDeleteItemsResponse");
const DashboardListItem_1 = require("./DashboardListItem");
const DashboardListItemRequest_1 = require("./DashboardListItemRequest");
const DashboardListItemResponse_1 = require("./DashboardListItemResponse");
const DashboardListItems_1 = require("./DashboardListItems");
const DashboardListUpdateItemsRequest_1 = require("./DashboardListUpdateItemsRequest");
const DashboardListUpdateItemsResponse_1 = require("./DashboardListUpdateItemsResponse");
const DashboardTriggerWrapper_1 = require("./DashboardTriggerWrapper");
const DataDeletionResponseItem_1 = require("./DataDeletionResponseItem");
const DataDeletionResponseItemAttributes_1 = require("./DataDeletionResponseItemAttributes");
const DataDeletionResponseMeta_1 = require("./DataDeletionResponseMeta");
const DataRelationshipsTeams_1 = require("./DataRelationshipsTeams");
const DataRelationshipsTeamsDataItems_1 = require("./DataRelationshipsTeamsDataItems");
const DataScalarColumn_1 = require("./DataScalarColumn");
const DataTransform_1 = require("./DataTransform");
const DataTransformProperties_1 = require("./DataTransformProperties");
const DatabaseMonitoringTriggerWrapper_1 = require("./DatabaseMonitoringTriggerWrapper");
const DeleteAppResponse_1 = require("./DeleteAppResponse");
const DeleteAppResponseData_1 = require("./DeleteAppResponseData");
const DeleteAppsRequest_1 = require("./DeleteAppsRequest");
const DeleteAppsRequestDataItems_1 = require("./DeleteAppsRequestDataItems");
const DeleteAppsResponse_1 = require("./DeleteAppsResponse");
const DeleteAppsResponseDataItems_1 = require("./DeleteAppsResponseDataItems");
const DeleteCustomFrameworkResponse_1 = require("./DeleteCustomFrameworkResponse");
const DependencyLocation_1 = require("./DependencyLocation");
const Deployment_1 = require("./Deployment");
const DeploymentAttributes_1 = require("./DeploymentAttributes");
const DeploymentMetadata_1 = require("./DeploymentMetadata");
const DeploymentRelationship_1 = require("./DeploymentRelationship");
const DeploymentRelationshipData_1 = require("./DeploymentRelationshipData");
const DetailedFinding_1 = require("./DetailedFinding");
const DetailedFindingAttributes_1 = require("./DetailedFindingAttributes");
const DeviceAttributes_1 = require("./DeviceAttributes");
const DeviceAttributesInterfaceStatuses_1 = require("./DeviceAttributesInterfaceStatuses");
const DevicesListData_1 = require("./DevicesListData");
const DomainAllowlist_1 = require("./DomainAllowlist");
const DomainAllowlistAttributes_1 = require("./DomainAllowlistAttributes");
const DomainAllowlistRequest_1 = require("./DomainAllowlistRequest");
const DomainAllowlistResponse_1 = require("./DomainAllowlistResponse");
const DomainAllowlistResponseData_1 = require("./DomainAllowlistResponseData");
const DomainAllowlistResponseDataAttributes_1 = require("./DomainAllowlistResponseDataAttributes");
const DowntimeCreateRequest_1 = require("./DowntimeCreateRequest");
const DowntimeCreateRequestAttributes_1 = require("./DowntimeCreateRequestAttributes");
const DowntimeCreateRequestData_1 = require("./DowntimeCreateRequestData");
const DowntimeMeta_1 = require("./DowntimeMeta");
const DowntimeMetaPage_1 = require("./DowntimeMetaPage");
const DowntimeMonitorIdentifierId_1 = require("./DowntimeMonitorIdentifierId");
const DowntimeMonitorIdentifierTags_1 = require("./DowntimeMonitorIdentifierTags");
const DowntimeMonitorIncludedAttributes_1 = require("./DowntimeMonitorIncludedAttributes");
const DowntimeMonitorIncludedItem_1 = require("./DowntimeMonitorIncludedItem");
const DowntimeRelationships_1 = require("./DowntimeRelationships");
const DowntimeRelationshipsCreatedBy_1 = require("./DowntimeRelationshipsCreatedBy");
const DowntimeRelationshipsCreatedByData_1 = require("./DowntimeRelationshipsCreatedByData");
const DowntimeRelationshipsMonitor_1 = require("./DowntimeRelationshipsMonitor");
const DowntimeRelationshipsMonitorData_1 = require("./DowntimeRelationshipsMonitorData");
const DowntimeResponse_1 = require("./DowntimeResponse");
const DowntimeResponseAttributes_1 = require("./DowntimeResponseAttributes");
const DowntimeResponseData_1 = require("./DowntimeResponseData");
const DowntimeScheduleCurrentDowntimeResponse_1 = require("./DowntimeScheduleCurrentDowntimeResponse");
const DowntimeScheduleOneTimeCreateUpdateRequest_1 = require("./DowntimeScheduleOneTimeCreateUpdateRequest");
const DowntimeScheduleOneTimeResponse_1 = require("./DowntimeScheduleOneTimeResponse");
const DowntimeScheduleRecurrenceCreateUpdateRequest_1 = require("./DowntimeScheduleRecurrenceCreateUpdateRequest");
const DowntimeScheduleRecurrenceResponse_1 = require("./DowntimeScheduleRecurrenceResponse");
const DowntimeScheduleRecurrencesCreateRequest_1 = require("./DowntimeScheduleRecurrencesCreateRequest");
const DowntimeScheduleRecurrencesResponse_1 = require("./DowntimeScheduleRecurrencesResponse");
const DowntimeScheduleRecurrencesUpdateRequest_1 = require("./DowntimeScheduleRecurrencesUpdateRequest");
const DowntimeUpdateRequest_1 = require("./DowntimeUpdateRequest");
const DowntimeUpdateRequestAttributes_1 = require("./DowntimeUpdateRequestAttributes");
const DowntimeUpdateRequestData_1 = require("./DowntimeUpdateRequestData");
const EPSS_1 = require("./EPSS");
const EntityAttributes_1 = require("./EntityAttributes");
const EntityData_1 = require("./EntityData");
const EntityMeta_1 = require("./EntityMeta");
const EntityRelationships_1 = require("./EntityRelationships");
const EntityResponseIncludedIncident_1 = require("./EntityResponseIncludedIncident");
const EntityResponseIncludedOncall_1 = require("./EntityResponseIncludedOncall");
const EntityResponseIncludedRawSchema_1 = require("./EntityResponseIncludedRawSchema");
const EntityResponseIncludedRawSchemaAttributes_1 = require("./EntityResponseIncludedRawSchemaAttributes");
const EntityResponseIncludedRelatedEntity_1 = require("./EntityResponseIncludedRelatedEntity");
const EntityResponseIncludedRelatedEntityAttributes_1 = require("./EntityResponseIncludedRelatedEntityAttributes");
const EntityResponseIncludedRelatedEntityMeta_1 = require("./EntityResponseIncludedRelatedEntityMeta");
const EntityResponseIncludedRelatedIncidentAttributes_1 = require("./EntityResponseIncludedRelatedIncidentAttributes");
const EntityResponseIncludedRelatedOncallAttributes_1 = require("./EntityResponseIncludedRelatedOncallAttributes");
const EntityResponseIncludedRelatedOncallEscalationItem_1 = require("./EntityResponseIncludedRelatedOncallEscalationItem");
const EntityResponseIncludedSchema_1 = require("./EntityResponseIncludedSchema");
const EntityResponseIncludedSchemaAttributes_1 = require("./EntityResponseIncludedSchemaAttributes");
const EntityResponseMeta_1 = require("./EntityResponseMeta");
const EntityToIncidents_1 = require("./EntityToIncidents");
const EntityToOncalls_1 = require("./EntityToOncalls");
const EntityToRawSchema_1 = require("./EntityToRawSchema");
const EntityToRelatedEntities_1 = require("./EntityToRelatedEntities");
const EntityToSchema_1 = require("./EntityToSchema");
const EntityV3API_1 = require("./EntityV3API");
const EntityV3APIDatadog_1 = require("./EntityV3APIDatadog");
const EntityV3APISpec_1 = require("./EntityV3APISpec");
const EntityV3APISpecInterfaceDefinition_1 = require("./EntityV3APISpecInterfaceDefinition");
const EntityV3APISpecInterfaceFileRef_1 = require("./EntityV3APISpecInterfaceFileRef");
const EntityV3DatadogCodeLocationItem_1 = require("./EntityV3DatadogCodeLocationItem");
const EntityV3DatadogEventItem_1 = require("./EntityV3DatadogEventItem");
const EntityV3DatadogIntegrationOpsgenie_1 = require("./EntityV3DatadogIntegrationOpsgenie");
const EntityV3DatadogIntegrationPagerduty_1 = require("./EntityV3DatadogIntegrationPagerduty");
const EntityV3DatadogLogItem_1 = require("./EntityV3DatadogLogItem");
const EntityV3DatadogPerformance_1 = require("./EntityV3DatadogPerformance");
const EntityV3DatadogPipelines_1 = require("./EntityV3DatadogPipelines");
const EntityV3Datastore_1 = require("./EntityV3Datastore");
const EntityV3DatastoreDatadog_1 = require("./EntityV3DatastoreDatadog");
const EntityV3DatastoreSpec_1 = require("./EntityV3DatastoreSpec");
const EntityV3Integrations_1 = require("./EntityV3Integrations");
const EntityV3Metadata_1 = require("./EntityV3Metadata");
const EntityV3MetadataAdditionalOwnersItems_1 = require("./EntityV3MetadataAdditionalOwnersItems");
const EntityV3MetadataContactsItems_1 = require("./EntityV3MetadataContactsItems");
const EntityV3MetadataLinksItems_1 = require("./EntityV3MetadataLinksItems");
const EntityV3Queue_1 = require("./EntityV3Queue");
const EntityV3QueueDatadog_1 = require("./EntityV3QueueDatadog");
const EntityV3QueueSpec_1 = require("./EntityV3QueueSpec");
const EntityV3Service_1 = require("./EntityV3Service");
const EntityV3ServiceDatadog_1 = require("./EntityV3ServiceDatadog");
const EntityV3ServiceSpec_1 = require("./EntityV3ServiceSpec");
const EntityV3System_1 = require("./EntityV3System");
const EntityV3SystemDatadog_1 = require("./EntityV3SystemDatadog");
const EntityV3SystemSpec_1 = require("./EntityV3SystemSpec");
const ErrorHandler_1 = require("./ErrorHandler");
const EscalationPolicy_1 = require("./EscalationPolicy");
const EscalationPolicyCreateRequest_1 = require("./EscalationPolicyCreateRequest");
const EscalationPolicyCreateRequestData_1 = require("./EscalationPolicyCreateRequestData");
const EscalationPolicyCreateRequestDataAttributes_1 = require("./EscalationPolicyCreateRequestDataAttributes");
const EscalationPolicyCreateRequestDataAttributesStepsItems_1 = require("./EscalationPolicyCreateRequestDataAttributesStepsItems");
const EscalationPolicyCreateRequestDataRelationships_1 = require("./EscalationPolicyCreateRequestDataRelationships");
const EscalationPolicyData_1 = require("./EscalationPolicyData");
const EscalationPolicyDataAttributes_1 = require("./EscalationPolicyDataAttributes");
const EscalationPolicyDataRelationships_1 = require("./EscalationPolicyDataRelationships");
const EscalationPolicyDataRelationshipsSteps_1 = require("./EscalationPolicyDataRelationshipsSteps");
const EscalationPolicyDataRelationshipsStepsDataItems_1 = require("./EscalationPolicyDataRelationshipsStepsDataItems");
const EscalationPolicyStep_1 = require("./EscalationPolicyStep");
const EscalationPolicyStepAttributes_1 = require("./EscalationPolicyStepAttributes");
const EscalationPolicyStepRelationships_1 = require("./EscalationPolicyStepRelationships");
const EscalationPolicyStepTarget_1 = require("./EscalationPolicyStepTarget");
const EscalationPolicyUpdateRequest_1 = require("./EscalationPolicyUpdateRequest");
const EscalationPolicyUpdateRequestData_1 = require("./EscalationPolicyUpdateRequestData");
const EscalationPolicyUpdateRequestDataAttributes_1 = require("./EscalationPolicyUpdateRequestDataAttributes");
const EscalationPolicyUpdateRequestDataAttributesStepsItems_1 = require("./EscalationPolicyUpdateRequestDataAttributesStepsItems");
const EscalationPolicyUpdateRequestDataRelationships_1 = require("./EscalationPolicyUpdateRequestDataRelationships");
const EscalationPolicyUser_1 = require("./EscalationPolicyUser");
const EscalationPolicyUserAttributes_1 = require("./EscalationPolicyUserAttributes");
const EscalationTargets_1 = require("./EscalationTargets");
const Event_1 = require("./Event");
const EventAttributes_1 = require("./EventAttributes");
const EventCreateRequest_1 = require("./EventCreateRequest");
const EventCreateRequestPayload_1 = require("./EventCreateRequestPayload");
const EventCreateResponse_1 = require("./EventCreateResponse");
const EventCreateResponseAttributes_1 = require("./EventCreateResponseAttributes");
const EventCreateResponseAttributesAttributes_1 = require("./EventCreateResponseAttributesAttributes");
const EventCreateResponseAttributesAttributesEvt_1 = require("./EventCreateResponseAttributesAttributesEvt");
const EventCreateResponsePayload_1 = require("./EventCreateResponsePayload");
const EventPayload_1 = require("./EventPayload");
const EventResponse_1 = require("./EventResponse");
const EventResponseAttributes_1 = require("./EventResponseAttributes");
const EventsCompute_1 = require("./EventsCompute");
const EventsGroupBy_1 = require("./EventsGroupBy");
const EventsGroupBySort_1 = require("./EventsGroupBySort");
const EventsListRequest_1 = require("./EventsListRequest");
const EventsListResponse_1 = require("./EventsListResponse");
const EventsListResponseLinks_1 = require("./EventsListResponseLinks");
const EventsQueryFilter_1 = require("./EventsQueryFilter");
const EventsQueryOptions_1 = require("./EventsQueryOptions");
const EventsRequestPage_1 = require("./EventsRequestPage");
const EventsResponseMetadata_1 = require("./EventsResponseMetadata");
const EventsResponseMetadataPage_1 = require("./EventsResponseMetadataPage");
const EventsScalarQuery_1 = require("./EventsScalarQuery");
const EventsSearch_1 = require("./EventsSearch");
const EventsTimeseriesQuery_1 = require("./EventsTimeseriesQuery");
const EventsWarning_1 = require("./EventsWarning");
const FastlyAccounResponseAttributes_1 = require("./FastlyAccounResponseAttributes");
const FastlyAccountCreateRequest_1 = require("./FastlyAccountCreateRequest");
const FastlyAccountCreateRequestAttributes_1 = require("./FastlyAccountCreateRequestAttributes");
const FastlyAccountCreateRequestData_1 = require("./FastlyAccountCreateRequestData");
const FastlyAccountResponse_1 = require("./FastlyAccountResponse");
const FastlyAccountResponseData_1 = require("./FastlyAccountResponseData");
const FastlyAccountUpdateRequest_1 = require("./FastlyAccountUpdateRequest");
const FastlyAccountUpdateRequestAttributes_1 = require("./FastlyAccountUpdateRequestAttributes");
const FastlyAccountUpdateRequestData_1 = require("./FastlyAccountUpdateRequestData");
const FastlyAccountsResponse_1 = require("./FastlyAccountsResponse");
const FastlyService_1 = require("./FastlyService");
const FastlyServiceAttributes_1 = require("./FastlyServiceAttributes");
const FastlyServiceData_1 = require("./FastlyServiceData");
const FastlyServiceRequest_1 = require("./FastlyServiceRequest");
const FastlyServiceResponse_1 = require("./FastlyServiceResponse");
const FastlyServicesResponse_1 = require("./FastlyServicesResponse");
const Finding_1 = require("./Finding");
const FindingAttributes_1 = require("./FindingAttributes");
const FindingMute_1 = require("./FindingMute");
const FindingRule_1 = require("./FindingRule");
const FormulaLimit_1 = require("./FormulaLimit");
const FrameworkHandleAndVersionResponseData_1 = require("./FrameworkHandleAndVersionResponseData");
const FullAPIKey_1 = require("./FullAPIKey");
const FullAPIKeyAttributes_1 = require("./FullAPIKeyAttributes");
const FullApplicationKey_1 = require("./FullApplicationKey");
const FullApplicationKeyAttributes_1 = require("./FullApplicationKeyAttributes");
const FullCustomFrameworkData_1 = require("./FullCustomFrameworkData");
const FullCustomFrameworkDataAttributes_1 = require("./FullCustomFrameworkDataAttributes");
const GCPMetricNamespaceConfig_1 = require("./GCPMetricNamespaceConfig");
const GCPSTSDelegateAccount_1 = require("./GCPSTSDelegateAccount");
const GCPSTSDelegateAccountAttributes_1 = require("./GCPSTSDelegateAccountAttributes");
const GCPSTSDelegateAccountResponse_1 = require("./GCPSTSDelegateAccountResponse");
const GCPSTSServiceAccount_1 = require("./GCPSTSServiceAccount");
const GCPSTSServiceAccountAttributes_1 = require("./GCPSTSServiceAccountAttributes");
const GCPSTSServiceAccountCreateRequest_1 = require("./GCPSTSServiceAccountCreateRequest");
const GCPSTSServiceAccountData_1 = require("./GCPSTSServiceAccountData");
const GCPSTSServiceAccountResponse_1 = require("./GCPSTSServiceAccountResponse");
const GCPSTSServiceAccountUpdateRequest_1 = require("./GCPSTSServiceAccountUpdateRequest");
const GCPSTSServiceAccountUpdateRequestData_1 = require("./GCPSTSServiceAccountUpdateRequestData");
const GCPSTSServiceAccountsResponse_1 = require("./GCPSTSServiceAccountsResponse");
const GCPServiceAccountMeta_1 = require("./GCPServiceAccountMeta");
const GetActionConnectionResponse_1 = require("./GetActionConnectionResponse");
const GetAppResponse_1 = require("./GetAppResponse");
const GetAppResponseData_1 = require("./GetAppResponseData");
const GetAppResponseDataAttributes_1 = require("./GetAppResponseDataAttributes");
const GetCustomFrameworkResponse_1 = require("./GetCustomFrameworkResponse");
const GetDataDeletionsResponseBody_1 = require("./GetDataDeletionsResponseBody");
const GetDeviceAttributes_1 = require("./GetDeviceAttributes");
const GetDeviceData_1 = require("./GetDeviceData");
const GetDeviceResponse_1 = require("./GetDeviceResponse");
const GetFindingResponse_1 = require("./GetFindingResponse");
const GetInterfacesData_1 = require("./GetInterfacesData");
const GetInterfacesResponse_1 = require("./GetInterfacesResponse");
const GetResourceEvaluationFiltersResponse_1 = require("./GetResourceEvaluationFiltersResponse");
const GetResourceEvaluationFiltersResponseData_1 = require("./GetResourceEvaluationFiltersResponseData");
const GetRuleVersionHistoryData_1 = require("./GetRuleVersionHistoryData");
const GetRuleVersionHistoryResponse_1 = require("./GetRuleVersionHistoryResponse");
const GetSBOMResponse_1 = require("./GetSBOMResponse");
const GetWorkflowResponse_1 = require("./GetWorkflowResponse");
const GithubWebhookTrigger_1 = require("./GithubWebhookTrigger");
const GithubWebhookTriggerWrapper_1 = require("./GithubWebhookTriggerWrapper");
const GroupScalarColumn_1 = require("./GroupScalarColumn");
const HTTPBody_1 = require("./HTTPBody");
const HTTPCIAppError_1 = require("./HTTPCIAppError");
const HTTPCIAppErrors_1 = require("./HTTPCIAppErrors");
const HTTPHeader_1 = require("./HTTPHeader");
const HTTPHeaderUpdate_1 = require("./HTTPHeaderUpdate");
const HTTPIntegration_1 = require("./HTTPIntegration");
const HTTPIntegrationUpdate_1 = require("./HTTPIntegrationUpdate");
const HTTPLogError_1 = require("./HTTPLogError");
const HTTPLogErrors_1 = require("./HTTPLogErrors");
const HTTPLogItem_1 = require("./HTTPLogItem");
const HTTPToken_1 = require("./HTTPToken");
const HTTPTokenAuth_1 = require("./HTTPTokenAuth");
const HTTPTokenAuthUpdate_1 = require("./HTTPTokenAuthUpdate");
const HTTPTokenUpdate_1 = require("./HTTPTokenUpdate");
const HistoricalJobListMeta_1 = require("./HistoricalJobListMeta");
const HistoricalJobOptions_1 = require("./HistoricalJobOptions");
const HistoricalJobQuery_1 = require("./HistoricalJobQuery");
const HistoricalJobResponse_1 = require("./HistoricalJobResponse");
const HistoricalJobResponseAttributes_1 = require("./HistoricalJobResponseAttributes");
const HistoricalJobResponseData_1 = require("./HistoricalJobResponseData");
const HourlyUsage_1 = require("./HourlyUsage");
const HourlyUsageAttributes_1 = require("./HourlyUsageAttributes");
const HourlyUsageMeasurement_1 = require("./HourlyUsageMeasurement");
const HourlyUsageMetadata_1 = require("./HourlyUsageMetadata");
const HourlyUsagePagination_1 = require("./HourlyUsagePagination");
const HourlyUsageResponse_1 = require("./HourlyUsageResponse");
const IPAllowlistAttributes_1 = require("./IPAllowlistAttributes");
const IPAllowlistData_1 = require("./IPAllowlistData");
const IPAllowlistEntry_1 = require("./IPAllowlistEntry");
const IPAllowlistEntryAttributes_1 = require("./IPAllowlistEntryAttributes");
const IPAllowlistEntryData_1 = require("./IPAllowlistEntryData");
const IPAllowlistResponse_1 = require("./IPAllowlistResponse");
const IPAllowlistUpdateRequest_1 = require("./IPAllowlistUpdateRequest");
const IdPMetadataFormData_1 = require("./IdPMetadataFormData");
const IncidentAttachmentData_1 = require("./IncidentAttachmentData");
const IncidentAttachmentLinkAttributes_1 = require("./IncidentAttachmentLinkAttributes");
const IncidentAttachmentLinkAttributesAttachmentObject_1 = require("./IncidentAttachmentLinkAttributesAttachmentObject");
const IncidentAttachmentPostmortemAttributes_1 = require("./IncidentAttachmentPostmortemAttributes");
const IncidentAttachmentRelationships_1 = require("./IncidentAttachmentRelationships");
const IncidentAttachmentUpdateData_1 = require("./IncidentAttachmentUpdateData");
const IncidentAttachmentUpdateRequest_1 = require("./IncidentAttachmentUpdateRequest");
const IncidentAttachmentUpdateResponse_1 = require("./IncidentAttachmentUpdateResponse");
const IncidentAttachmentsPostmortemAttributesAttachmentObject_1 = require("./IncidentAttachmentsPostmortemAttributesAttachmentObject");
const IncidentAttachmentsResponse_1 = require("./IncidentAttachmentsResponse");
const IncidentCreateAttributes_1 = require("./IncidentCreateAttributes");
const IncidentCreateData_1 = require("./IncidentCreateData");
const IncidentCreateRelationships_1 = require("./IncidentCreateRelationships");
const IncidentCreateRequest_1 = require("./IncidentCreateRequest");
const IncidentFieldAttributesMultipleValue_1 = require("./IncidentFieldAttributesMultipleValue");
const IncidentFieldAttributesSingleValue_1 = require("./IncidentFieldAttributesSingleValue");
const IncidentIntegrationMetadataAttributes_1 = require("./IncidentIntegrationMetadataAttributes");
const IncidentIntegrationMetadataCreateData_1 = require("./IncidentIntegrationMetadataCreateData");
const IncidentIntegrationMetadataCreateRequest_1 = require("./IncidentIntegrationMetadataCreateRequest");
const IncidentIntegrationMetadataListResponse_1 = require("./IncidentIntegrationMetadataListResponse");
const IncidentIntegrationMetadataPatchData_1 = require("./IncidentIntegrationMetadataPatchData");
const IncidentIntegrationMetadataPatchRequest_1 = require("./IncidentIntegrationMetadataPatchRequest");
const IncidentIntegrationMetadataResponse_1 = require("./IncidentIntegrationMetadataResponse");
const IncidentIntegrationMetadataResponseData_1 = require("./IncidentIntegrationMetadataResponseData");
const IncidentIntegrationRelationships_1 = require("./IncidentIntegrationRelationships");
const IncidentNonDatadogCreator_1 = require("./IncidentNonDatadogCreator");
const IncidentNotificationHandle_1 = require("./IncidentNotificationHandle");
const IncidentResponse_1 = require("./IncidentResponse");
const IncidentResponseAttributes_1 = require("./IncidentResponseAttributes");
const IncidentResponseData_1 = require("./IncidentResponseData");
const IncidentResponseMeta_1 = require("./IncidentResponseMeta");
const IncidentResponseMetaPagination_1 = require("./IncidentResponseMetaPagination");
const IncidentResponseRelationships_1 = require("./IncidentResponseRelationships");
const IncidentSearchResponse_1 = require("./IncidentSearchResponse");
const IncidentSearchResponseAttributes_1 = require("./IncidentSearchResponseAttributes");
const IncidentSearchResponseData_1 = require("./IncidentSearchResponseData");
const IncidentSearchResponseFacetsData_1 = require("./IncidentSearchResponseFacetsData");
const IncidentSearchResponseFieldFacetData_1 = require("./IncidentSearchResponseFieldFacetData");
const IncidentSearchResponseIncidentsData_1 = require("./IncidentSearchResponseIncidentsData");
const IncidentSearchResponseMeta_1 = require("./IncidentSearchResponseMeta");
const IncidentSearchResponseNumericFacetData_1 = require("./IncidentSearchResponseNumericFacetData");
const IncidentSearchResponseNumericFacetDataAggregates_1 = require("./IncidentSearchResponseNumericFacetDataAggregates");
const IncidentSearchResponsePropertyFieldFacetData_1 = require("./IncidentSearchResponsePropertyFieldFacetData");
const IncidentSearchResponseUserFacetData_1 = require("./IncidentSearchResponseUserFacetData");
const IncidentServiceCreateAttributes_1 = require("./IncidentServiceCreateAttributes");
const IncidentServiceCreateData_1 = require("./IncidentServiceCreateData");
const IncidentServiceCreateRequest_1 = require("./IncidentServiceCreateRequest");
const IncidentServiceRelationships_1 = require("./IncidentServiceRelationships");
const IncidentServiceResponse_1 = require("./IncidentServiceResponse");
const IncidentServiceResponseAttributes_1 = require("./IncidentServiceResponseAttributes");
const IncidentServiceResponseData_1 = require("./IncidentServiceResponseData");
const IncidentServiceUpdateAttributes_1 = require("./IncidentServiceUpdateAttributes");
const IncidentServiceUpdateData_1 = require("./IncidentServiceUpdateData");
const IncidentServiceUpdateRequest_1 = require("./IncidentServiceUpdateRequest");
const IncidentServicesResponse_1 = require("./IncidentServicesResponse");
const IncidentTeamCreateAttributes_1 = require("./IncidentTeamCreateAttributes");
const IncidentTeamCreateData_1 = require("./IncidentTeamCreateData");
const IncidentTeamCreateRequest_1 = require("./IncidentTeamCreateRequest");
const IncidentTeamRelationships_1 = require("./IncidentTeamRelationships");
const IncidentTeamResponse_1 = require("./IncidentTeamResponse");
const IncidentTeamResponseAttributes_1 = require("./IncidentTeamResponseAttributes");
const IncidentTeamResponseData_1 = require("./IncidentTeamResponseData");
const IncidentTeamUpdateAttributes_1 = require("./IncidentTeamUpdateAttributes");
const IncidentTeamUpdateData_1 = require("./IncidentTeamUpdateData");
const IncidentTeamUpdateRequest_1 = require("./IncidentTeamUpdateRequest");
const IncidentTeamsResponse_1 = require("./IncidentTeamsResponse");
const IncidentTimelineCellMarkdownCreateAttributes_1 = require("./IncidentTimelineCellMarkdownCreateAttributes");
const IncidentTimelineCellMarkdownCreateAttributesContent_1 = require("./IncidentTimelineCellMarkdownCreateAttributesContent");
const IncidentTodoAnonymousAssignee_1 = require("./IncidentTodoAnonymousAssignee");
const IncidentTodoAttributes_1 = require("./IncidentTodoAttributes");
const IncidentTodoCreateData_1 = require("./IncidentTodoCreateData");
const IncidentTodoCreateRequest_1 = require("./IncidentTodoCreateRequest");
const IncidentTodoListResponse_1 = require("./IncidentTodoListResponse");
const IncidentTodoPatchData_1 = require("./IncidentTodoPatchData");
const IncidentTodoPatchRequest_1 = require("./IncidentTodoPatchRequest");
const IncidentTodoRelationships_1 = require("./IncidentTodoRelationships");
const IncidentTodoResponse_1 = require("./IncidentTodoResponse");
const IncidentTodoResponseData_1 = require("./IncidentTodoResponseData");
const IncidentTrigger_1 = require("./IncidentTrigger");
const IncidentTriggerWrapper_1 = require("./IncidentTriggerWrapper");
const IncidentTypeAttributes_1 = require("./IncidentTypeAttributes");
const IncidentTypeCreateData_1 = require("./IncidentTypeCreateData");
const IncidentTypeCreateRequest_1 = require("./IncidentTypeCreateRequest");
const IncidentTypeListResponse_1 = require("./IncidentTypeListResponse");
const IncidentTypeObject_1 = require("./IncidentTypeObject");
const IncidentTypePatchData_1 = require("./IncidentTypePatchData");
const IncidentTypePatchRequest_1 = require("./IncidentTypePatchRequest");
const IncidentTypeResponse_1 = require("./IncidentTypeResponse");
const IncidentTypeUpdateAttributes_1 = require("./IncidentTypeUpdateAttributes");
const IncidentUpdateAttributes_1 = require("./IncidentUpdateAttributes");
const IncidentUpdateData_1 = require("./IncidentUpdateData");
const IncidentUpdateRelationships_1 = require("./IncidentUpdateRelationships");
const IncidentUpdateRequest_1 = require("./IncidentUpdateRequest");
const IncidentUserAttributes_1 = require("./IncidentUserAttributes");
const IncidentUserData_1 = require("./IncidentUserData");
const IncidentsResponse_1 = require("./IncidentsResponse");
const InputSchema_1 = require("./InputSchema");
const InputSchemaParameters_1 = require("./InputSchemaParameters");
const IntakePayloadAccepted_1 = require("./IntakePayloadAccepted");
const InterfaceAttributes_1 = require("./InterfaceAttributes");
const JSONAPIErrorItem_1 = require("./JSONAPIErrorItem");
const JSONAPIErrorItemSource_1 = require("./JSONAPIErrorItemSource");
const JSONAPIErrorResponse_1 = require("./JSONAPIErrorResponse");
const JiraIntegrationMetadata_1 = require("./JiraIntegrationMetadata");
const JiraIntegrationMetadataIssuesItem_1 = require("./JiraIntegrationMetadataIssuesItem");
const JiraIssue_1 = require("./JiraIssue");
const JiraIssueResult_1 = require("./JiraIssueResult");
const JobCreateResponse_1 = require("./JobCreateResponse");
const JobCreateResponseData_1 = require("./JobCreateResponseData");
const JobDefinition_1 = require("./JobDefinition");
const JobDefinitionFromRule_1 = require("./JobDefinitionFromRule");
const Layer_1 = require("./Layer");
const LayerAttributes_1 = require("./LayerAttributes");
const LayerAttributesInterval_1 = require("./LayerAttributesInterval");
const LayerRelationships_1 = require("./LayerRelationships");
const LayerRelationshipsMembers_1 = require("./LayerRelationshipsMembers");
const LayerRelationshipsMembersDataItems_1 = require("./LayerRelationshipsMembersDataItems");
const LeakedKey_1 = require("./LeakedKey");
const LeakedKeyAttributes_1 = require("./LeakedKeyAttributes");
const Library_1 = require("./Library");
const Links_1 = require("./Links");
const ListAPIsResponse_1 = require("./ListAPIsResponse");
const ListAPIsResponseData_1 = require("./ListAPIsResponseData");
const ListAPIsResponseDataAttributes_1 = require("./ListAPIsResponseDataAttributes");
const ListAPIsResponseMeta_1 = require("./ListAPIsResponseMeta");
const ListAPIsResponseMetaPagination_1 = require("./ListAPIsResponseMetaPagination");
const ListApplicationKeysResponse_1 = require("./ListApplicationKeysResponse");
const ListAppsResponse_1 = require("./ListAppsResponse");
const ListAppsResponseDataItems_1 = require("./ListAppsResponseDataItems");
const ListAppsResponseDataItemsAttributes_1 = require("./ListAppsResponseDataItemsAttributes");
const ListAppsResponseDataItemsRelationships_1 = require("./ListAppsResponseDataItemsRelationships");
const ListAppsResponseMeta_1 = require("./ListAppsResponseMeta");
const ListAppsResponseMetaPage_1 = require("./ListAppsResponseMetaPage");
const ListDevicesResponse_1 = require("./ListDevicesResponse");
const ListDevicesResponseMetadata_1 = require("./ListDevicesResponseMetadata");
const ListDevicesResponseMetadataPage_1 = require("./ListDevicesResponseMetadataPage");
const ListDowntimesResponse_1 = require("./ListDowntimesResponse");
const ListEntityCatalogResponse_1 = require("./ListEntityCatalogResponse");
const ListEntityCatalogResponseLinks_1 = require("./ListEntityCatalogResponseLinks");
const ListFindingsMeta_1 = require("./ListFindingsMeta");
const ListFindingsPage_1 = require("./ListFindingsPage");
const ListFindingsResponse_1 = require("./ListFindingsResponse");
const ListHistoricalJobsResponse_1 = require("./ListHistoricalJobsResponse");
const ListPipelinesResponse_1 = require("./ListPipelinesResponse");
const ListPipelinesResponseMeta_1 = require("./ListPipelinesResponseMeta");
const ListPowerpacksResponse_1 = require("./ListPowerpacksResponse");
const ListRelationCatalogResponse_1 = require("./ListRelationCatalogResponse");
const ListRelationCatalogResponseLinks_1 = require("./ListRelationCatalogResponseLinks");
const ListRulesResponse_1 = require("./ListRulesResponse");
const ListRulesResponseDataItem_1 = require("./ListRulesResponseDataItem");
const ListRulesResponseLinks_1 = require("./ListRulesResponseLinks");
const ListTagsResponse_1 = require("./ListTagsResponse");
const ListTagsResponseData_1 = require("./ListTagsResponseData");
const ListTagsResponseDataAttributes_1 = require("./ListTagsResponseDataAttributes");
const ListVulnerabilitiesResponse_1 = require("./ListVulnerabilitiesResponse");
const ListVulnerableAssetsResponse_1 = require("./ListVulnerableAssetsResponse");
const Log_1 = require("./Log");
const LogAttributes_1 = require("./LogAttributes");
const LogsAggregateBucket_1 = require("./LogsAggregateBucket");
const LogsAggregateBucketValueTimeseriesPoint_1 = require("./LogsAggregateBucketValueTimeseriesPoint");
const LogsAggregateRequest_1 = require("./LogsAggregateRequest");
const LogsAggregateRequestPage_1 = require("./LogsAggregateRequestPage");
const LogsAggregateResponse_1 = require("./LogsAggregateResponse");
const LogsAggregateResponseData_1 = require("./LogsAggregateResponseData");
const LogsAggregateSort_1 = require("./LogsAggregateSort");
const LogsArchive_1 = require("./LogsArchive");
const LogsArchiveAttributes_1 = require("./LogsArchiveAttributes");
const LogsArchiveCreateRequest_1 = require("./LogsArchiveCreateRequest");
const LogsArchiveCreateRequestAttributes_1 = require("./LogsArchiveCreateRequestAttributes");
const LogsArchiveCreateRequestDefinition_1 = require("./LogsArchiveCreateRequestDefinition");
const LogsArchiveDefinition_1 = require("./LogsArchiveDefinition");
const LogsArchiveDestinationAzure_1 = require("./LogsArchiveDestinationAzure");
const LogsArchiveDestinationGCS_1 = require("./LogsArchiveDestinationGCS");
const LogsArchiveDestinationS3_1 = require("./LogsArchiveDestinationS3");
const LogsArchiveEncryptionS3_1 = require("./LogsArchiveEncryptionS3");
const LogsArchiveIntegrationAzure_1 = require("./LogsArchiveIntegrationAzure");
const LogsArchiveIntegrationGCS_1 = require("./LogsArchiveIntegrationGCS");
const LogsArchiveIntegrationS3_1 = require("./LogsArchiveIntegrationS3");
const LogsArchiveOrder_1 = require("./LogsArchiveOrder");
const LogsArchiveOrderAttributes_1 = require("./LogsArchiveOrderAttributes");
const LogsArchiveOrderDefinition_1 = require("./LogsArchiveOrderDefinition");
const LogsArchives_1 = require("./LogsArchives");
const LogsCompute_1 = require("./LogsCompute");
const LogsGroupBy_1 = require("./LogsGroupBy");
const LogsGroupByHistogram_1 = require("./LogsGroupByHistogram");
const LogsListRequest_1 = require("./LogsListRequest");
const LogsListRequestPage_1 = require("./LogsListRequestPage");
const LogsListResponse_1 = require("./LogsListResponse");
const LogsListResponseLinks_1 = require("./LogsListResponseLinks");
const LogsMetricCompute_1 = require("./LogsMetricCompute");
const LogsMetricCreateAttributes_1 = require("./LogsMetricCreateAttributes");
const LogsMetricCreateData_1 = require("./LogsMetricCreateData");
const LogsMetricCreateRequest_1 = require("./LogsMetricCreateRequest");
const LogsMetricFilter_1 = require("./LogsMetricFilter");
const LogsMetricGroupBy_1 = require("./LogsMetricGroupBy");
const LogsMetricResponse_1 = require("./LogsMetricResponse");
const LogsMetricResponseAttributes_1 = require("./LogsMetricResponseAttributes");
const LogsMetricResponseCompute_1 = require("./LogsMetricResponseCompute");
const LogsMetricResponseData_1 = require("./LogsMetricResponseData");
const LogsMetricResponseFilter_1 = require("./LogsMetricResponseFilter");
const LogsMetricResponseGroupBy_1 = require("./LogsMetricResponseGroupBy");
const LogsMetricUpdateAttributes_1 = require("./LogsMetricUpdateAttributes");
const LogsMetricUpdateCompute_1 = require("./LogsMetricUpdateCompute");
const LogsMetricUpdateData_1 = require("./LogsMetricUpdateData");
const LogsMetricUpdateRequest_1 = require("./LogsMetricUpdateRequest");
const LogsMetricsResponse_1 = require("./LogsMetricsResponse");
const LogsQueryFilter_1 = require("./LogsQueryFilter");
const LogsQueryOptions_1 = require("./LogsQueryOptions");
const LogsResponseMetadata_1 = require("./LogsResponseMetadata");
const LogsResponseMetadataPage_1 = require("./LogsResponseMetadataPage");
const LogsWarning_1 = require("./LogsWarning");
const MSTeamsIntegrationMetadata_1 = require("./MSTeamsIntegrationMetadata");
const MSTeamsIntegrationMetadataTeamsItem_1 = require("./MSTeamsIntegrationMetadataTeamsItem");
const Metadata_1 = require("./Metadata");
const Metric_1 = require("./Metric");
const MetricAllTags_1 = require("./MetricAllTags");
const MetricAllTagsAttributes_1 = require("./MetricAllTagsAttributes");
const MetricAllTagsResponse_1 = require("./MetricAllTagsResponse");
const MetricAssetAttributes_1 = require("./MetricAssetAttributes");
const MetricAssetDashboardRelationship_1 = require("./MetricAssetDashboardRelationship");
const MetricAssetDashboardRelationships_1 = require("./MetricAssetDashboardRelationships");
const MetricAssetMonitorRelationship_1 = require("./MetricAssetMonitorRelationship");
const MetricAssetMonitorRelationships_1 = require("./MetricAssetMonitorRelationships");
const MetricAssetNotebookRelationship_1 = require("./MetricAssetNotebookRelationship");
const MetricAssetNotebookRelationships_1 = require("./MetricAssetNotebookRelationships");
const MetricAssetResponseData_1 = require("./MetricAssetResponseData");
const MetricAssetResponseRelationships_1 = require("./MetricAssetResponseRelationships");
const MetricAssetSLORelationship_1 = require("./MetricAssetSLORelationship");
const MetricAssetSLORelationships_1 = require("./MetricAssetSLORelationships");
const MetricAssetsResponse_1 = require("./MetricAssetsResponse");
const MetricBulkTagConfigCreate_1 = require("./MetricBulkTagConfigCreate");
const MetricBulkTagConfigCreateAttributes_1 = require("./MetricBulkTagConfigCreateAttributes");
const MetricBulkTagConfigCreateRequest_1 = require("./MetricBulkTagConfigCreateRequest");
const MetricBulkTagConfigDelete_1 = require("./MetricBulkTagConfigDelete");
const MetricBulkTagConfigDeleteAttributes_1 = require("./MetricBulkTagConfigDeleteAttributes");
const MetricBulkTagConfigDeleteRequest_1 = require("./MetricBulkTagConfigDeleteRequest");
const MetricBulkTagConfigResponse_1 = require("./MetricBulkTagConfigResponse");
const MetricBulkTagConfigStatus_1 = require("./MetricBulkTagConfigStatus");
const MetricBulkTagConfigStatusAttributes_1 = require("./MetricBulkTagConfigStatusAttributes");
const MetricCustomAggregation_1 = require("./MetricCustomAggregation");
const MetricDashboardAsset_1 = require("./MetricDashboardAsset");
const MetricDashboardAttributes_1 = require("./MetricDashboardAttributes");
const MetricDistinctVolume_1 = require("./MetricDistinctVolume");
const MetricDistinctVolumeAttributes_1 = require("./MetricDistinctVolumeAttributes");
const MetricEstimate_1 = require("./MetricEstimate");
const MetricEstimateAttributes_1 = require("./MetricEstimateAttributes");
const MetricEstimateResponse_1 = require("./MetricEstimateResponse");
const MetricIngestedIndexedVolume_1 = require("./MetricIngestedIndexedVolume");
const MetricIngestedIndexedVolumeAttributes_1 = require("./MetricIngestedIndexedVolumeAttributes");
const MetricMetaPage_1 = require("./MetricMetaPage");
const MetricMetadata_1 = require("./MetricMetadata");
const MetricMonitorAsset_1 = require("./MetricMonitorAsset");
const MetricNotebookAsset_1 = require("./MetricNotebookAsset");
const MetricOrigin_1 = require("./MetricOrigin");
const MetricPaginationMeta_1 = require("./MetricPaginationMeta");
const MetricPayload_1 = require("./MetricPayload");
const MetricPoint_1 = require("./MetricPoint");
const MetricResource_1 = require("./MetricResource");
const MetricSLOAsset_1 = require("./MetricSLOAsset");
const MetricSeries_1 = require("./MetricSeries");
const MetricSuggestedTagsAndAggregations_1 = require("./MetricSuggestedTagsAndAggregations");
const MetricSuggestedTagsAndAggregationsResponse_1 = require("./MetricSuggestedTagsAndAggregationsResponse");
const MetricSuggestedTagsAttributes_1 = require("./MetricSuggestedTagsAttributes");
const MetricTagConfiguration_1 = require("./MetricTagConfiguration");
const MetricTagConfigurationAttributes_1 = require("./MetricTagConfigurationAttributes");
const MetricTagConfigurationCreateAttributes_1 = require("./MetricTagConfigurationCreateAttributes");
const MetricTagConfigurationCreateData_1 = require("./MetricTagConfigurationCreateData");
const MetricTagConfigurationCreateRequest_1 = require("./MetricTagConfigurationCreateRequest");
const MetricTagConfigurationResponse_1 = require("./MetricTagConfigurationResponse");
const MetricTagConfigurationUpdateAttributes_1 = require("./MetricTagConfigurationUpdateAttributes");
const MetricTagConfigurationUpdateData_1 = require("./MetricTagConfigurationUpdateData");
const MetricTagConfigurationUpdateRequest_1 = require("./MetricTagConfigurationUpdateRequest");
const MetricVolumesResponse_1 = require("./MetricVolumesResponse");
const MetricsAndMetricTagConfigurationsResponse_1 = require("./MetricsAndMetricTagConfigurationsResponse");
const MetricsListResponseLinks_1 = require("./MetricsListResponseLinks");
const MetricsScalarQuery_1 = require("./MetricsScalarQuery");
const MetricsTimeseriesQuery_1 = require("./MetricsTimeseriesQuery");
const MicrosoftSentinelDestination_1 = require("./MicrosoftSentinelDestination");
const MicrosoftTeamsChannelInfoResponseAttributes_1 = require("./MicrosoftTeamsChannelInfoResponseAttributes");
const MicrosoftTeamsChannelInfoResponseData_1 = require("./MicrosoftTeamsChannelInfoResponseData");
const MicrosoftTeamsCreateTenantBasedHandleRequest_1 = require("./MicrosoftTeamsCreateTenantBasedHandleRequest");
const MicrosoftTeamsCreateWorkflowsWebhookHandleRequest_1 = require("./MicrosoftTeamsCreateWorkflowsWebhookHandleRequest");
const MicrosoftTeamsGetChannelByNameResponse_1 = require("./MicrosoftTeamsGetChannelByNameResponse");
const MicrosoftTeamsTenantBasedHandleAttributes_1 = require("./MicrosoftTeamsTenantBasedHandleAttributes");
const MicrosoftTeamsTenantBasedHandleInfoResponseAttributes_1 = require("./MicrosoftTeamsTenantBasedHandleInfoResponseAttributes");
const MicrosoftTeamsTenantBasedHandleInfoResponseData_1 = require("./MicrosoftTeamsTenantBasedHandleInfoResponseData");
const MicrosoftTeamsTenantBasedHandleRequestAttributes_1 = require("./MicrosoftTeamsTenantBasedHandleRequestAttributes");
const MicrosoftTeamsTenantBasedHandleRequestData_1 = require("./MicrosoftTeamsTenantBasedHandleRequestData");
const MicrosoftTeamsTenantBasedHandleResponse_1 = require("./MicrosoftTeamsTenantBasedHandleResponse");
const MicrosoftTeamsTenantBasedHandleResponseData_1 = require("./MicrosoftTeamsTenantBasedHandleResponseData");
const MicrosoftTeamsTenantBasedHandlesResponse_1 = require("./MicrosoftTeamsTenantBasedHandlesResponse");
const MicrosoftTeamsUpdateTenantBasedHandleRequest_1 = require("./MicrosoftTeamsUpdateTenantBasedHandleRequest");
const MicrosoftTeamsUpdateTenantBasedHandleRequestData_1 = require("./MicrosoftTeamsUpdateTenantBasedHandleRequestData");
const MicrosoftTeamsUpdateWorkflowsWebhookHandleRequest_1 = require("./MicrosoftTeamsUpdateWorkflowsWebhookHandleRequest");
const MicrosoftTeamsUpdateWorkflowsWebhookHandleRequestData_1 = require("./MicrosoftTeamsUpdateWorkflowsWebhookHandleRequestData");
const MicrosoftTeamsWorkflowsWebhookHandleAttributes_1 = require("./MicrosoftTeamsWorkflowsWebhookHandleAttributes");
const MicrosoftTeamsWorkflowsWebhookHandleRequestAttributes_1 = require("./MicrosoftTeamsWorkflowsWebhookHandleRequestAttributes");
const MicrosoftTeamsWorkflowsWebhookHandleRequestData_1 = require("./MicrosoftTeamsWorkflowsWebhookHandleRequestData");
const MicrosoftTeamsWorkflowsWebhookHandleResponse_1 = require("./MicrosoftTeamsWorkflowsWebhookHandleResponse");
const MicrosoftTeamsWorkflowsWebhookHandleResponseData_1 = require("./MicrosoftTeamsWorkflowsWebhookHandleResponseData");
const MicrosoftTeamsWorkflowsWebhookHandlesResponse_1 = require("./MicrosoftTeamsWorkflowsWebhookHandlesResponse");
const MicrosoftTeamsWorkflowsWebhookResponseAttributes_1 = require("./MicrosoftTeamsWorkflowsWebhookResponseAttributes");
const MonitorConfigPolicyAttributeCreateRequest_1 = require("./MonitorConfigPolicyAttributeCreateRequest");
const MonitorConfigPolicyAttributeEditRequest_1 = require("./MonitorConfigPolicyAttributeEditRequest");
const MonitorConfigPolicyAttributeResponse_1 = require("./MonitorConfigPolicyAttributeResponse");
const MonitorConfigPolicyCreateData_1 = require("./MonitorConfigPolicyCreateData");
const MonitorConfigPolicyCreateRequest_1 = require("./MonitorConfigPolicyCreateRequest");
const MonitorConfigPolicyEditData_1 = require("./MonitorConfigPolicyEditData");
const MonitorConfigPolicyEditRequest_1 = require("./MonitorConfigPolicyEditRequest");
const MonitorConfigPolicyListResponse_1 = require("./MonitorConfigPolicyListResponse");
const MonitorConfigPolicyResponse_1 = require("./MonitorConfigPolicyResponse");
const MonitorConfigPolicyResponseData_1 = require("./MonitorConfigPolicyResponseData");
const MonitorConfigPolicyTagPolicy_1 = require("./MonitorConfigPolicyTagPolicy");
const MonitorConfigPolicyTagPolicyCreateRequest_1 = require("./MonitorConfigPolicyTagPolicyCreateRequest");
const MonitorDowntimeMatchResponse_1 = require("./MonitorDowntimeMatchResponse");
const MonitorDowntimeMatchResponseAttributes_1 = require("./MonitorDowntimeMatchResponseAttributes");
const MonitorDowntimeMatchResponseData_1 = require("./MonitorDowntimeMatchResponseData");
const MonitorNotificationRuleAttributes_1 = require("./MonitorNotificationRuleAttributes");
const MonitorNotificationRuleCreateRequest_1 = require("./MonitorNotificationRuleCreateRequest");
const MonitorNotificationRuleCreateRequestData_1 = require("./MonitorNotificationRuleCreateRequestData");
const MonitorNotificationRuleData_1 = require("./MonitorNotificationRuleData");
const MonitorNotificationRuleFilterTags_1 = require("./MonitorNotificationRuleFilterTags");
const MonitorNotificationRuleListResponse_1 = require("./MonitorNotificationRuleListResponse");
const MonitorNotificationRuleRelationships_1 = require("./MonitorNotificationRuleRelationships");
const MonitorNotificationRuleRelationshipsCreatedBy_1 = require("./MonitorNotificationRuleRelationshipsCreatedBy");
const MonitorNotificationRuleRelationshipsCreatedByData_1 = require("./MonitorNotificationRuleRelationshipsCreatedByData");
const MonitorNotificationRuleResponse_1 = require("./MonitorNotificationRuleResponse");
const MonitorNotificationRuleResponseAttributes_1 = require("./MonitorNotificationRuleResponseAttributes");
const MonitorNotificationRuleUpdateRequest_1 = require("./MonitorNotificationRuleUpdateRequest");
const MonitorNotificationRuleUpdateRequestData_1 = require("./MonitorNotificationRuleUpdateRequestData");
const MonitorTrigger_1 = require("./MonitorTrigger");
const MonitorTriggerWrapper_1 = require("./MonitorTriggerWrapper");
const MonitorType_1 = require("./MonitorType");
const MonthlyCostAttributionAttributes_1 = require("./MonthlyCostAttributionAttributes");
const MonthlyCostAttributionBody_1 = require("./MonthlyCostAttributionBody");
const MonthlyCostAttributionMeta_1 = require("./MonthlyCostAttributionMeta");
const MonthlyCostAttributionPagination_1 = require("./MonthlyCostAttributionPagination");
const MonthlyCostAttributionResponse_1 = require("./MonthlyCostAttributionResponse");
const NotebookTriggerWrapper_1 = require("./NotebookTriggerWrapper");
const NotificationRule_1 = require("./NotificationRule");
const NotificationRuleAttributes_1 = require("./NotificationRuleAttributes");
const NotificationRuleResponse_1 = require("./NotificationRuleResponse");
const NullableRelationshipToUser_1 = require("./NullableRelationshipToUser");
const NullableRelationshipToUserData_1 = require("./NullableRelationshipToUserData");
const NullableUserRelationship_1 = require("./NullableUserRelationship");
const NullableUserRelationshipData_1 = require("./NullableUserRelationshipData");
const ObservabilityPipeline_1 = require("./ObservabilityPipeline");
const ObservabilityPipelineAddEnvVarsProcessor_1 = require("./ObservabilityPipelineAddEnvVarsProcessor");
const ObservabilityPipelineAddEnvVarsProcessorVariable_1 = require("./ObservabilityPipelineAddEnvVarsProcessorVariable");
const ObservabilityPipelineAddFieldsProcessor_1 = require("./ObservabilityPipelineAddFieldsProcessor");
const ObservabilityPipelineAmazonDataFirehoseSource_1 = require("./ObservabilityPipelineAmazonDataFirehoseSource");
const ObservabilityPipelineAmazonOpenSearchDestination_1 = require("./ObservabilityPipelineAmazonOpenSearchDestination");
const ObservabilityPipelineAmazonOpenSearchDestinationAuth_1 = require("./ObservabilityPipelineAmazonOpenSearchDestinationAuth");
const ObservabilityPipelineAmazonS3Destination_1 = require("./ObservabilityPipelineAmazonS3Destination");
const ObservabilityPipelineAmazonS3Source_1 = require("./ObservabilityPipelineAmazonS3Source");
const ObservabilityPipelineAwsAuth_1 = require("./ObservabilityPipelineAwsAuth");
const ObservabilityPipelineConfig_1 = require("./ObservabilityPipelineConfig");
const ObservabilityPipelineData_1 = require("./ObservabilityPipelineData");
const ObservabilityPipelineDataAttributes_1 = require("./ObservabilityPipelineDataAttributes");
const ObservabilityPipelineDatadogAgentSource_1 = require("./ObservabilityPipelineDatadogAgentSource");
const ObservabilityPipelineDatadogLogsDestination_1 = require("./ObservabilityPipelineDatadogLogsDestination");
const ObservabilityPipelineDedupeProcessor_1 = require("./ObservabilityPipelineDedupeProcessor");
const ObservabilityPipelineElasticsearchDestination_1 = require("./ObservabilityPipelineElasticsearchDestination");
const ObservabilityPipelineEnrichmentTableFile_1 = require("./ObservabilityPipelineEnrichmentTableFile");
const ObservabilityPipelineEnrichmentTableFileEncoding_1 = require("./ObservabilityPipelineEnrichmentTableFileEncoding");
const ObservabilityPipelineEnrichmentTableFileKeyItems_1 = require("./ObservabilityPipelineEnrichmentTableFileKeyItems");
const ObservabilityPipelineEnrichmentTableFileSchemaItems_1 = require("./ObservabilityPipelineEnrichmentTableFileSchemaItems");
const ObservabilityPipelineEnrichmentTableGeoIp_1 = require("./ObservabilityPipelineEnrichmentTableGeoIp");
const ObservabilityPipelineEnrichmentTableProcessor_1 = require("./ObservabilityPipelineEnrichmentTableProcessor");
const ObservabilityPipelineFieldValue_1 = require("./ObservabilityPipelineFieldValue");
const ObservabilityPipelineFilterProcessor_1 = require("./ObservabilityPipelineFilterProcessor");
const ObservabilityPipelineFluentBitSource_1 = require("./ObservabilityPipelineFluentBitSource");
const ObservabilityPipelineFluentdSource_1 = require("./ObservabilityPipelineFluentdSource");
const ObservabilityPipelineGcpAuth_1 = require("./ObservabilityPipelineGcpAuth");
const ObservabilityPipelineGenerateMetricsProcessor_1 = require("./ObservabilityPipelineGenerateMetricsProcessor");
const ObservabilityPipelineGeneratedMetric_1 = require("./ObservabilityPipelineGeneratedMetric");
const ObservabilityPipelineGeneratedMetricIncrementByField_1 = require("./ObservabilityPipelineGeneratedMetricIncrementByField");
const ObservabilityPipelineGeneratedMetricIncrementByOne_1 = require("./ObservabilityPipelineGeneratedMetricIncrementByOne");
const ObservabilityPipelineGoogleChronicleDestination_1 = require("./ObservabilityPipelineGoogleChronicleDestination");
const ObservabilityPipelineGoogleCloudStorageDestination_1 = require("./ObservabilityPipelineGoogleCloudStorageDestination");
const ObservabilityPipelineGooglePubSubSource_1 = require("./ObservabilityPipelineGooglePubSubSource");
const ObservabilityPipelineHttpClientSource_1 = require("./ObservabilityPipelineHttpClientSource");
const ObservabilityPipelineHttpServerSource_1 = require("./ObservabilityPipelineHttpServerSource");
const ObservabilityPipelineKafkaSource_1 = require("./ObservabilityPipelineKafkaSource");
const ObservabilityPipelineKafkaSourceLibrdkafkaOption_1 = require("./ObservabilityPipelineKafkaSourceLibrdkafkaOption");
const ObservabilityPipelineKafkaSourceSasl_1 = require("./ObservabilityPipelineKafkaSourceSasl");
const ObservabilityPipelineLogstashSource_1 = require("./ObservabilityPipelineLogstashSource");
const ObservabilityPipelineMetadataEntry_1 = require("./ObservabilityPipelineMetadataEntry");
const ObservabilityPipelineNewRelicDestination_1 = require("./ObservabilityPipelineNewRelicDestination");
const ObservabilityPipelineOcsfMapperProcessor_1 = require("./ObservabilityPipelineOcsfMapperProcessor");
const ObservabilityPipelineOcsfMapperProcessorMapping_1 = require("./ObservabilityPipelineOcsfMapperProcessorMapping");
const ObservabilityPipelineOpenSearchDestination_1 = require("./ObservabilityPipelineOpenSearchDestination");
const ObservabilityPipelineParseGrokProcessor_1 = require("./ObservabilityPipelineParseGrokProcessor");
const ObservabilityPipelineParseGrokProcessorRule_1 = require("./ObservabilityPipelineParseGrokProcessorRule");
const ObservabilityPipelineParseGrokProcessorRuleMatchRule_1 = require("./ObservabilityPipelineParseGrokProcessorRuleMatchRule");
const ObservabilityPipelineParseGrokProcessorRuleSupportRule_1 = require("./ObservabilityPipelineParseGrokProcessorRuleSupportRule");
const ObservabilityPipelineParseJSONProcessor_1 = require("./ObservabilityPipelineParseJSONProcessor");
const ObservabilityPipelineQuotaProcessor_1 = require("./ObservabilityPipelineQuotaProcessor");
const ObservabilityPipelineQuotaProcessorLimit_1 = require("./ObservabilityPipelineQuotaProcessorLimit");
const ObservabilityPipelineQuotaProcessorOverride_1 = require("./ObservabilityPipelineQuotaProcessorOverride");
const ObservabilityPipelineReduceProcessor_1 = require("./ObservabilityPipelineReduceProcessor");
const ObservabilityPipelineReduceProcessorMergeStrategy_1 = require("./ObservabilityPipelineReduceProcessorMergeStrategy");
const ObservabilityPipelineRemoveFieldsProcessor_1 = require("./ObservabilityPipelineRemoveFieldsProcessor");
const ObservabilityPipelineRenameFieldsProcessor_1 = require("./ObservabilityPipelineRenameFieldsProcessor");
const ObservabilityPipelineRenameFieldsProcessorField_1 = require("./ObservabilityPipelineRenameFieldsProcessorField");
const ObservabilityPipelineRsyslogDestination_1 = require("./ObservabilityPipelineRsyslogDestination");
const ObservabilityPipelineRsyslogSource_1 = require("./ObservabilityPipelineRsyslogSource");
const ObservabilityPipelineSampleProcessor_1 = require("./ObservabilityPipelineSampleProcessor");
const ObservabilityPipelineSensitiveDataScannerProcessor_1 = require("./ObservabilityPipelineSensitiveDataScannerProcessor");
const ObservabilityPipelineSensitiveDataScannerProcessorActionHash_1 = require("./ObservabilityPipelineSensitiveDataScannerProcessorActionHash");
const ObservabilityPipelineSensitiveDataScannerProcessorActionPartialRedact_1 = require("./ObservabilityPipelineSensitiveDataScannerProcessorActionPartialRedact");
const ObservabilityPipelineSensitiveDataScannerProcessorActionPartialRedactOptions_1 = require("./ObservabilityPipelineSensitiveDataScannerProcessorActionPartialRedactOptions");
const ObservabilityPipelineSensitiveDataScannerProcessorActionRedact_1 = require("./ObservabilityPipelineSensitiveDataScannerProcessorActionRedact");
const ObservabilityPipelineSensitiveDataScannerProcessorActionRedactOptions_1 = require("./ObservabilityPipelineSensitiveDataScannerProcessorActionRedactOptions");
const ObservabilityPipelineSensitiveDataScannerProcessorCustomPattern_1 = require("./ObservabilityPipelineSensitiveDataScannerProcessorCustomPattern");
const ObservabilityPipelineSensitiveDataScannerProcessorCustomPatternOptions_1 = require("./ObservabilityPipelineSensitiveDataScannerProcessorCustomPatternOptions");
const ObservabilityPipelineSensitiveDataScannerProcessorKeywordOptions_1 = require("./ObservabilityPipelineSensitiveDataScannerProcessorKeywordOptions");
const ObservabilityPipelineSensitiveDataScannerProcessorLibraryPattern_1 = require("./ObservabilityPipelineSensitiveDataScannerProcessorLibraryPattern");
const ObservabilityPipelineSensitiveDataScannerProcessorLibraryPatternOptions_1 = require("./ObservabilityPipelineSensitiveDataScannerProcessorLibraryPatternOptions");
const ObservabilityPipelineSensitiveDataScannerProcessorRule_1 = require("./ObservabilityPipelineSensitiveDataScannerProcessorRule");
const ObservabilityPipelineSensitiveDataScannerProcessorScopeAll_1 = require("./ObservabilityPipelineSensitiveDataScannerProcessorScopeAll");
const ObservabilityPipelineSensitiveDataScannerProcessorScopeExclude_1 = require("./ObservabilityPipelineSensitiveDataScannerProcessorScopeExclude");
const ObservabilityPipelineSensitiveDataScannerProcessorScopeInclude_1 = require("./ObservabilityPipelineSensitiveDataScannerProcessorScopeInclude");
const ObservabilityPipelineSensitiveDataScannerProcessorScopeOptions_1 = require("./ObservabilityPipelineSensitiveDataScannerProcessorScopeOptions");
const ObservabilityPipelineSentinelOneDestination_1 = require("./ObservabilityPipelineSentinelOneDestination");
const ObservabilityPipelineSpec_1 = require("./ObservabilityPipelineSpec");
const ObservabilityPipelineSpecData_1 = require("./ObservabilityPipelineSpecData");
const ObservabilityPipelineSplunkHecDestination_1 = require("./ObservabilityPipelineSplunkHecDestination");
const ObservabilityPipelineSplunkHecSource_1 = require("./ObservabilityPipelineSplunkHecSource");
const ObservabilityPipelineSplunkTcpSource_1 = require("./ObservabilityPipelineSplunkTcpSource");
const ObservabilityPipelineSumoLogicDestination_1 = require("./ObservabilityPipelineSumoLogicDestination");
const ObservabilityPipelineSumoLogicDestinationHeaderCustomFieldsItem_1 = require("./ObservabilityPipelineSumoLogicDestinationHeaderCustomFieldsItem");
const ObservabilityPipelineSumoLogicSource_1 = require("./ObservabilityPipelineSumoLogicSource");
const ObservabilityPipelineSyslogNgDestination_1 = require("./ObservabilityPipelineSyslogNgDestination");
const ObservabilityPipelineSyslogNgSource_1 = require("./ObservabilityPipelineSyslogNgSource");
const ObservabilityPipelineThrottleProcessor_1 = require("./ObservabilityPipelineThrottleProcessor");
const ObservabilityPipelineTls_1 = require("./ObservabilityPipelineTls");
const OktaAccount_1 = require("./OktaAccount");
const OktaAccountAttributes_1 = require("./OktaAccountAttributes");
const OktaAccountRequest_1 = require("./OktaAccountRequest");
const OktaAccountResponse_1 = require("./OktaAccountResponse");
const OktaAccountResponseData_1 = require("./OktaAccountResponseData");
const OktaAccountUpdateRequest_1 = require("./OktaAccountUpdateRequest");
const OktaAccountUpdateRequestAttributes_1 = require("./OktaAccountUpdateRequestAttributes");
const OktaAccountUpdateRequestData_1 = require("./OktaAccountUpdateRequestData");
const OktaAccountsResponse_1 = require("./OktaAccountsResponse");
const OnDemandConcurrencyCap_1 = require("./OnDemandConcurrencyCap");
const OnDemandConcurrencyCapAttributes_1 = require("./OnDemandConcurrencyCapAttributes");
const OnDemandConcurrencyCapResponse_1 = require("./OnDemandConcurrencyCapResponse");
const OpenAPIEndpoint_1 = require("./OpenAPIEndpoint");
const OpenAPIFile_1 = require("./OpenAPIFile");
const OpsgenieServiceCreateAttributes_1 = require("./OpsgenieServiceCreateAttributes");
const OpsgenieServiceCreateData_1 = require("./OpsgenieServiceCreateData");
const OpsgenieServiceCreateRequest_1 = require("./OpsgenieServiceCreateRequest");
const OpsgenieServiceResponse_1 = require("./OpsgenieServiceResponse");
const OpsgenieServiceResponseAttributes_1 = require("./OpsgenieServiceResponseAttributes");
const OpsgenieServiceResponseData_1 = require("./OpsgenieServiceResponseData");
const OpsgenieServiceUpdateAttributes_1 = require("./OpsgenieServiceUpdateAttributes");
const OpsgenieServiceUpdateData_1 = require("./OpsgenieServiceUpdateData");
const OpsgenieServiceUpdateRequest_1 = require("./OpsgenieServiceUpdateRequest");
const OpsgenieServicesResponse_1 = require("./OpsgenieServicesResponse");
const OrgConfigGetResponse_1 = require("./OrgConfigGetResponse");
const OrgConfigListResponse_1 = require("./OrgConfigListResponse");
const OrgConfigRead_1 = require("./OrgConfigRead");
const OrgConfigReadAttributes_1 = require("./OrgConfigReadAttributes");
const OrgConfigWrite_1 = require("./OrgConfigWrite");
const OrgConfigWriteAttributes_1 = require("./OrgConfigWriteAttributes");
const OrgConfigWriteRequest_1 = require("./OrgConfigWriteRequest");
const Organization_1 = require("./Organization");
const OrganizationAttributes_1 = require("./OrganizationAttributes");
const OutboundEdge_1 = require("./OutboundEdge");
const OutcomesBatchAttributes_1 = require("./OutcomesBatchAttributes");
const OutcomesBatchRequest_1 = require("./OutcomesBatchRequest");
const OutcomesBatchRequestData_1 = require("./OutcomesBatchRequestData");
const OutcomesBatchRequestItem_1 = require("./OutcomesBatchRequestItem");
const OutcomesBatchResponse_1 = require("./OutcomesBatchResponse");
const OutcomesBatchResponseAttributes_1 = require("./OutcomesBatchResponseAttributes");
const OutcomesBatchResponseMeta_1 = require("./OutcomesBatchResponseMeta");
const OutcomesResponse_1 = require("./OutcomesResponse");
const OutcomesResponseDataItem_1 = require("./OutcomesResponseDataItem");
const OutcomesResponseIncludedItem_1 = require("./OutcomesResponseIncludedItem");
const OutcomesResponseIncludedRuleAttributes_1 = require("./OutcomesResponseIncludedRuleAttributes");
const OutcomesResponseLinks_1 = require("./OutcomesResponseLinks");
const OutputSchema_1 = require("./OutputSchema");
const OutputSchemaParameters_1 = require("./OutputSchemaParameters");
const Pagination_1 = require("./Pagination");
const Parameter_1 = require("./Parameter");
const PartialAPIKey_1 = require("./PartialAPIKey");
const PartialAPIKeyAttributes_1 = require("./PartialAPIKeyAttributes");
const PartialApplicationKey_1 = require("./PartialApplicationKey");
const PartialApplicationKeyAttributes_1 = require("./PartialApplicationKeyAttributes");
const PartialApplicationKeyResponse_1 = require("./PartialApplicationKeyResponse");
const PatchNotificationRuleParameters_1 = require("./PatchNotificationRuleParameters");
const PatchNotificationRuleParametersData_1 = require("./PatchNotificationRuleParametersData");
const PatchNotificationRuleParametersDataAttributes_1 = require("./PatchNotificationRuleParametersDataAttributes");
const Permission_1 = require("./Permission");
const PermissionAttributes_1 = require("./PermissionAttributes");
const PermissionsResponse_1 = require("./PermissionsResponse");
const Powerpack_1 = require("./Powerpack");
const PowerpackAttributes_1 = require("./PowerpackAttributes");
const PowerpackData_1 = require("./PowerpackData");
const PowerpackGroupWidget_1 = require("./PowerpackGroupWidget");
const PowerpackGroupWidgetDefinition_1 = require("./PowerpackGroupWidgetDefinition");
const PowerpackGroupWidgetLayout_1 = require("./PowerpackGroupWidgetLayout");
const PowerpackInnerWidgetLayout_1 = require("./PowerpackInnerWidgetLayout");
const PowerpackInnerWidgets_1 = require("./PowerpackInnerWidgets");
const PowerpackRelationships_1 = require("./PowerpackRelationships");
const PowerpackResponse_1 = require("./PowerpackResponse");
const PowerpackResponseLinks_1 = require("./PowerpackResponseLinks");
const PowerpackTemplateVariable_1 = require("./PowerpackTemplateVariable");
const PowerpacksResponseMeta_1 = require("./PowerpacksResponseMeta");
const PowerpacksResponseMetaPagination_1 = require("./PowerpacksResponseMetaPagination");
const ProcessSummariesMeta_1 = require("./ProcessSummariesMeta");
const ProcessSummariesMetaPage_1 = require("./ProcessSummariesMetaPage");
const ProcessSummariesResponse_1 = require("./ProcessSummariesResponse");
const ProcessSummary_1 = require("./ProcessSummary");
const ProcessSummaryAttributes_1 = require("./ProcessSummaryAttributes");
const Project_1 = require("./Project");
const ProjectAttributes_1 = require("./ProjectAttributes");
const ProjectCreate_1 = require("./ProjectCreate");
const ProjectCreateAttributes_1 = require("./ProjectCreateAttributes");
const ProjectCreateRequest_1 = require("./ProjectCreateRequest");
const ProjectRelationship_1 = require("./ProjectRelationship");
const ProjectRelationshipData_1 = require("./ProjectRelationshipData");
const ProjectRelationships_1 = require("./ProjectRelationships");
const ProjectResponse_1 = require("./ProjectResponse");
const ProjectedCost_1 = require("./ProjectedCost");
const ProjectedCostAttributes_1 = require("./ProjectedCostAttributes");
const ProjectedCostResponse_1 = require("./ProjectedCostResponse");
const ProjectsResponse_1 = require("./ProjectsResponse");
const PublishAppResponse_1 = require("./PublishAppResponse");
const QueryFormula_1 = require("./QueryFormula");
const RUMAggregateBucketValueTimeseriesPoint_1 = require("./RUMAggregateBucketValueTimeseriesPoint");
const RUMAggregateRequest_1 = require("./RUMAggregateRequest");
const RUMAggregateSort_1 = require("./RUMAggregateSort");
const RUMAggregationBucketsResponse_1 = require("./RUMAggregationBucketsResponse");
const RUMAnalyticsAggregateResponse_1 = require("./RUMAnalyticsAggregateResponse");
const RUMApplication_1 = require("./RUMApplication");
const RUMApplicationAttributes_1 = require("./RUMApplicationAttributes");
const RUMApplicationCreate_1 = require("./RUMApplicationCreate");
const RUMApplicationCreateAttributes_1 = require("./RUMApplicationCreateAttributes");
const RUMApplicationCreateRequest_1 = require("./RUMApplicationCreateRequest");
const RUMApplicationList_1 = require("./RUMApplicationList");
const RUMApplicationListAttributes_1 = require("./RUMApplicationListAttributes");
const RUMApplicationResponse_1 = require("./RUMApplicationResponse");
const RUMApplicationUpdate_1 = require("./RUMApplicationUpdate");
const RUMApplicationUpdateAttributes_1 = require("./RUMApplicationUpdateAttributes");
const RUMApplicationUpdateRequest_1 = require("./RUMApplicationUpdateRequest");
const RUMApplicationsResponse_1 = require("./RUMApplicationsResponse");
const RUMBucketResponse_1 = require("./RUMBucketResponse");
const RUMCompute_1 = require("./RUMCompute");
const RUMEvent_1 = require("./RUMEvent");
const RUMEventAttributes_1 = require("./RUMEventAttributes");
const RUMEventsResponse_1 = require("./RUMEventsResponse");
const RUMGroupBy_1 = require("./RUMGroupBy");
const RUMGroupByHistogram_1 = require("./RUMGroupByHistogram");
const RUMQueryFilter_1 = require("./RUMQueryFilter");
const RUMQueryOptions_1 = require("./RUMQueryOptions");
const RUMQueryPageOptions_1 = require("./RUMQueryPageOptions");
const RUMResponseLinks_1 = require("./RUMResponseLinks");
const RUMResponseMetadata_1 = require("./RUMResponseMetadata");
const RUMResponsePage_1 = require("./RUMResponsePage");
const RUMSearchEventsRequest_1 = require("./RUMSearchEventsRequest");
const RUMWarning_1 = require("./RUMWarning");
const ReadinessGate_1 = require("./ReadinessGate");
const RelationAttributes_1 = require("./RelationAttributes");
const RelationEntity_1 = require("./RelationEntity");
const RelationMeta_1 = require("./RelationMeta");
const RelationRelationships_1 = require("./RelationRelationships");
const RelationResponse_1 = require("./RelationResponse");
const RelationResponseMeta_1 = require("./RelationResponseMeta");
const RelationToEntity_1 = require("./RelationToEntity");
const RelationshipItem_1 = require("./RelationshipItem");
const RelationshipToIncidentAttachment_1 = require("./RelationshipToIncidentAttachment");
const RelationshipToIncidentAttachmentData_1 = require("./RelationshipToIncidentAttachmentData");
const RelationshipToIncidentImpactData_1 = require("./RelationshipToIncidentImpactData");
const RelationshipToIncidentImpacts_1 = require("./RelationshipToIncidentImpacts");
const RelationshipToIncidentIntegrationMetadataData_1 = require("./RelationshipToIncidentIntegrationMetadataData");
const RelationshipToIncidentIntegrationMetadatas_1 = require("./RelationshipToIncidentIntegrationMetadatas");
const RelationshipToIncidentPostmortem_1 = require("./RelationshipToIncidentPostmortem");
const RelationshipToIncidentPostmortemData_1 = require("./RelationshipToIncidentPostmortemData");
const RelationshipToIncidentResponderData_1 = require("./RelationshipToIncidentResponderData");
const RelationshipToIncidentResponders_1 = require("./RelationshipToIncidentResponders");
const RelationshipToIncidentUserDefinedFieldData_1 = require("./RelationshipToIncidentUserDefinedFieldData");
const RelationshipToIncidentUserDefinedFields_1 = require("./RelationshipToIncidentUserDefinedFields");
const RelationshipToOrganization_1 = require("./RelationshipToOrganization");
const RelationshipToOrganizationData_1 = require("./RelationshipToOrganizationData");
const RelationshipToOrganizations_1 = require("./RelationshipToOrganizations");
const RelationshipToOutcome_1 = require("./RelationshipToOutcome");
const RelationshipToOutcomeData_1 = require("./RelationshipToOutcomeData");
const RelationshipToPermission_1 = require("./RelationshipToPermission");
const RelationshipToPermissionData_1 = require("./RelationshipToPermissionData");
const RelationshipToPermissions_1 = require("./RelationshipToPermissions");
const RelationshipToRole_1 = require("./RelationshipToRole");
const RelationshipToRoleData_1 = require("./RelationshipToRoleData");
const RelationshipToRoles_1 = require("./RelationshipToRoles");
const RelationshipToRule_1 = require("./RelationshipToRule");
const RelationshipToRuleData_1 = require("./RelationshipToRuleData");
const RelationshipToRuleDataObject_1 = require("./RelationshipToRuleDataObject");
const RelationshipToSAMLAssertionAttribute_1 = require("./RelationshipToSAMLAssertionAttribute");
const RelationshipToSAMLAssertionAttributeData_1 = require("./RelationshipToSAMLAssertionAttributeData");
const RelationshipToTeam_1 = require("./RelationshipToTeam");
const RelationshipToTeamData_1 = require("./RelationshipToTeamData");
const RelationshipToTeamLinkData_1 = require("./RelationshipToTeamLinkData");
const RelationshipToTeamLinks_1 = require("./RelationshipToTeamLinks");
const RelationshipToUser_1 = require("./RelationshipToUser");
const RelationshipToUserData_1 = require("./RelationshipToUserData");
const RelationshipToUserTeamPermission_1 = require("./RelationshipToUserTeamPermission");
const RelationshipToUserTeamPermissionData_1 = require("./RelationshipToUserTeamPermissionData");
const RelationshipToUserTeamTeam_1 = require("./RelationshipToUserTeamTeam");
const RelationshipToUserTeamTeamData_1 = require("./RelationshipToUserTeamTeamData");
const RelationshipToUserTeamUser_1 = require("./RelationshipToUserTeamUser");
const RelationshipToUserTeamUserData_1 = require("./RelationshipToUserTeamUserData");
const RelationshipToUsers_1 = require("./RelationshipToUsers");
const Remediation_1 = require("./Remediation");
const ReorderRetentionFiltersRequest_1 = require("./ReorderRetentionFiltersRequest");
const ResourceFilterAttributes_1 = require("./ResourceFilterAttributes");
const ResponseMetaAttributes_1 = require("./ResponseMetaAttributes");
const RestrictionPolicy_1 = require("./RestrictionPolicy");
const RestrictionPolicyAttributes_1 = require("./RestrictionPolicyAttributes");
const RestrictionPolicyBinding_1 = require("./RestrictionPolicyBinding");
const RestrictionPolicyResponse_1 = require("./RestrictionPolicyResponse");
const RestrictionPolicyUpdateRequest_1 = require("./RestrictionPolicyUpdateRequest");
const RetentionFilter_1 = require("./RetentionFilter");
const RetentionFilterAll_1 = require("./RetentionFilterAll");
const RetentionFilterAllAttributes_1 = require("./RetentionFilterAllAttributes");
const RetentionFilterAttributes_1 = require("./RetentionFilterAttributes");
const RetentionFilterCreateAttributes_1 = require("./RetentionFilterCreateAttributes");
const RetentionFilterCreateData_1 = require("./RetentionFilterCreateData");
const RetentionFilterCreateRequest_1 = require("./RetentionFilterCreateRequest");
const RetentionFilterCreateResponse_1 = require("./RetentionFilterCreateResponse");
const RetentionFilterResponse_1 = require("./RetentionFilterResponse");
const RetentionFilterUpdateAttributes_1 = require("./RetentionFilterUpdateAttributes");
const RetentionFilterUpdateData_1 = require("./RetentionFilterUpdateData");
const RetentionFilterUpdateRequest_1 = require("./RetentionFilterUpdateRequest");
const RetentionFilterWithoutAttributes_1 = require("./RetentionFilterWithoutAttributes");
const RetentionFiltersResponse_1 = require("./RetentionFiltersResponse");
const RetryStrategy_1 = require("./RetryStrategy");
const RetryStrategyLinear_1 = require("./RetryStrategyLinear");
const Role_1 = require("./Role");
const RoleAttributes_1 = require("./RoleAttributes");
const RoleClone_1 = require("./RoleClone");
const RoleCloneAttributes_1 = require("./RoleCloneAttributes");
const RoleCloneRequest_1 = require("./RoleCloneRequest");
const RoleCreateAttributes_1 = require("./RoleCreateAttributes");
const RoleCreateData_1 = require("./RoleCreateData");
const RoleCreateRequest_1 = require("./RoleCreateRequest");
const RoleCreateResponse_1 = require("./RoleCreateResponse");
const RoleCreateResponseData_1 = require("./RoleCreateResponseData");
const RoleRelationships_1 = require("./RoleRelationships");
const RoleResponse_1 = require("./RoleResponse");
const RoleResponseRelationships_1 = require("./RoleResponseRelationships");
const RoleUpdateAttributes_1 = require("./RoleUpdateAttributes");
const RoleUpdateData_1 = require("./RoleUpdateData");
const RoleUpdateRequest_1 = require("./RoleUpdateRequest");
const RoleUpdateResponse_1 = require("./RoleUpdateResponse");
const RoleUpdateResponseData_1 = require("./RoleUpdateResponseData");
const RolesResponse_1 = require("./RolesResponse");
const RoutingRule_1 = require("./RoutingRule");
const RoutingRuleAttributes_1 = require("./RoutingRuleAttributes");
const RoutingRuleRelationships_1 = require("./RoutingRuleRelationships");
const RoutingRuleRelationshipsPolicy_1 = require("./RoutingRuleRelationshipsPolicy");
const RoutingRuleRelationshipsPolicyData_1 = require("./RoutingRuleRelationshipsPolicyData");
const RuleAttributes_1 = require("./RuleAttributes");
const RuleOutcomeRelationships_1 = require("./RuleOutcomeRelationships");
const RuleUser_1 = require("./RuleUser");
const RuleVersionHistory_1 = require("./RuleVersionHistory");
const RuleVersionUpdate_1 = require("./RuleVersionUpdate");
const RuleVersions_1 = require("./RuleVersions");
const RumMetricCompute_1 = require("./RumMetricCompute");
const RumMetricCreateAttributes_1 = require("./RumMetricCreateAttributes");
const RumMetricCreateData_1 = require("./RumMetricCreateData");
const RumMetricCreateRequest_1 = require("./RumMetricCreateRequest");
const RumMetricFilter_1 = require("./RumMetricFilter");
const RumMetricGroupBy_1 = require("./RumMetricGroupBy");
const RumMetricResponse_1 = require("./RumMetricResponse");
const RumMetricResponseAttributes_1 = require("./RumMetricResponseAttributes");
const RumMetricResponseCompute_1 = require("./RumMetricResponseCompute");
const RumMetricResponseData_1 = require("./RumMetricResponseData");
const RumMetricResponseFilter_1 = require("./RumMetricResponseFilter");
const RumMetricResponseGroupBy_1 = require("./RumMetricResponseGroupBy");
const RumMetricResponseUniqueness_1 = require("./RumMetricResponseUniqueness");
const RumMetricUniqueness_1 = require("./RumMetricUniqueness");
const RumMetricUpdateAttributes_1 = require("./RumMetricUpdateAttributes");
const RumMetricUpdateCompute_1 = require("./RumMetricUpdateCompute");
const RumMetricUpdateData_1 = require("./RumMetricUpdateData");
const RumMetricUpdateRequest_1 = require("./RumMetricUpdateRequest");
const RumMetricsResponse_1 = require("./RumMetricsResponse");
const RumRetentionFilterAttributes_1 = require("./RumRetentionFilterAttributes");
const RumRetentionFilterCreateAttributes_1 = require("./RumRetentionFilterCreateAttributes");
const RumRetentionFilterCreateData_1 = require("./RumRetentionFilterCreateData");
const RumRetentionFilterCreateRequest_1 = require("./RumRetentionFilterCreateRequest");
const RumRetentionFilterData_1 = require("./RumRetentionFilterData");
const RumRetentionFilterResponse_1 = require("./RumRetentionFilterResponse");
const RumRetentionFilterUpdateAttributes_1 = require("./RumRetentionFilterUpdateAttributes");
const RumRetentionFilterUpdateData_1 = require("./RumRetentionFilterUpdateData");
const RumRetentionFilterUpdateRequest_1 = require("./RumRetentionFilterUpdateRequest");
const RumRetentionFiltersOrderData_1 = require("./RumRetentionFiltersOrderData");
const RumRetentionFiltersOrderRequest_1 = require("./RumRetentionFiltersOrderRequest");
const RumRetentionFiltersOrderResponse_1 = require("./RumRetentionFiltersOrderResponse");
const RumRetentionFiltersResponse_1 = require("./RumRetentionFiltersResponse");
const RunHistoricalJobRequest_1 = require("./RunHistoricalJobRequest");
const RunHistoricalJobRequestAttributes_1 = require("./RunHistoricalJobRequestAttributes");
const RunHistoricalJobRequestData_1 = require("./RunHistoricalJobRequestData");
const SAMLAssertionAttribute_1 = require("./SAMLAssertionAttribute");
const SAMLAssertionAttributeAttributes_1 = require("./SAMLAssertionAttributeAttributes");
const SBOM_1 = require("./SBOM");
const SBOMAttributes_1 = require("./SBOMAttributes");
const SBOMComponent_1 = require("./SBOMComponent");
const SBOMMetadata_1 = require("./SBOMMetadata");
const SBOMMetadataComponent_1 = require("./SBOMMetadataComponent");
const SLOReportPostResponse_1 = require("./SLOReportPostResponse");
const SLOReportPostResponseData_1 = require("./SLOReportPostResponseData");
const SLOReportStatusGetResponse_1 = require("./SLOReportStatusGetResponse");
const SLOReportStatusGetResponseAttributes_1 = require("./SLOReportStatusGetResponseAttributes");
const SLOReportStatusGetResponseData_1 = require("./SLOReportStatusGetResponseData");
const ScalarFormulaQueryRequest_1 = require("./ScalarFormulaQueryRequest");
const ScalarFormulaQueryResponse_1 = require("./ScalarFormulaQueryResponse");
const ScalarFormulaRequest_1 = require("./ScalarFormulaRequest");
const ScalarFormulaRequestAttributes_1 = require("./ScalarFormulaRequestAttributes");
const ScalarFormulaResponseAtrributes_1 = require("./ScalarFormulaResponseAtrributes");
const ScalarMeta_1 = require("./ScalarMeta");
const ScalarResponse_1 = require("./ScalarResponse");
const Schedule_1 = require("./Schedule");
const ScheduleCreateRequest_1 = require("./ScheduleCreateRequest");
const ScheduleCreateRequestData_1 = require("./ScheduleCreateRequestData");
const ScheduleCreateRequestDataAttributes_1 = require("./ScheduleCreateRequestDataAttributes");
const ScheduleCreateRequestDataAttributesLayersItems_1 = require("./ScheduleCreateRequestDataAttributesLayersItems");
const ScheduleCreateRequestDataRelationships_1 = require("./ScheduleCreateRequestDataRelationships");
const ScheduleData_1 = require("./ScheduleData");
const ScheduleDataAttributes_1 = require("./ScheduleDataAttributes");
const ScheduleDataRelationships_1 = require("./ScheduleDataRelationships");
const ScheduleDataRelationshipsLayers_1 = require("./ScheduleDataRelationshipsLayers");
const ScheduleDataRelationshipsLayersDataItems_1 = require("./ScheduleDataRelationshipsLayersDataItems");
const ScheduleMember_1 = require("./ScheduleMember");
const ScheduleMemberRelationships_1 = require("./ScheduleMemberRelationships");
const ScheduleMemberRelationshipsUser_1 = require("./ScheduleMemberRelationshipsUser");
const ScheduleMemberRelationshipsUserData_1 = require("./ScheduleMemberRelationshipsUserData");
const ScheduleRequestDataAttributesLayersItemsMembersItems_1 = require("./ScheduleRequestDataAttributesLayersItemsMembersItems");
const ScheduleRequestDataAttributesLayersItemsMembersItemsUser_1 = require("./ScheduleRequestDataAttributesLayersItemsMembersItemsUser");
const ScheduleTarget_1 = require("./ScheduleTarget");
const ScheduleTrigger_1 = require("./ScheduleTrigger");
const ScheduleTriggerWrapper_1 = require("./ScheduleTriggerWrapper");
const ScheduleUpdateRequest_1 = require("./ScheduleUpdateRequest");
const ScheduleUpdateRequestData_1 = require("./ScheduleUpdateRequestData");
const ScheduleUpdateRequestDataAttributes_1 = require("./ScheduleUpdateRequestDataAttributes");
const ScheduleUpdateRequestDataAttributesLayersItems_1 = require("./ScheduleUpdateRequestDataAttributesLayersItems");
const ScheduleUpdateRequestDataRelationships_1 = require("./ScheduleUpdateRequestDataRelationships");
const ScheduleUser_1 = require("./ScheduleUser");
const ScheduleUserAttributes_1 = require("./ScheduleUserAttributes");
const SecurityFilter_1 = require("./SecurityFilter");
const SecurityFilterAttributes_1 = require("./SecurityFilterAttributes");
const SecurityFilterCreateAttributes_1 = require("./SecurityFilterCreateAttributes");
const SecurityFilterCreateData_1 = require("./SecurityFilterCreateData");
const SecurityFilterCreateRequest_1 = require("./SecurityFilterCreateRequest");
const SecurityFilterExclusionFilter_1 = require("./SecurityFilterExclusionFilter");
const SecurityFilterExclusionFilterResponse_1 = require("./SecurityFilterExclusionFilterResponse");
const SecurityFilterMeta_1 = require("./SecurityFilterMeta");
const SecurityFilterResponse_1 = require("./SecurityFilterResponse");
const SecurityFilterUpdateAttributes_1 = require("./SecurityFilterUpdateAttributes");
const SecurityFilterUpdateData_1 = require("./SecurityFilterUpdateData");
const SecurityFilterUpdateRequest_1 = require("./SecurityFilterUpdateRequest");
const SecurityFiltersResponse_1 = require("./SecurityFiltersResponse");
const SecurityMonitoringFilter_1 = require("./SecurityMonitoringFilter");
const SecurityMonitoringListRulesResponse_1 = require("./SecurityMonitoringListRulesResponse");
const SecurityMonitoringReferenceTable_1 = require("./SecurityMonitoringReferenceTable");
const SecurityMonitoringRuleCase_1 = require("./SecurityMonitoringRuleCase");
const SecurityMonitoringRuleCaseAction_1 = require("./SecurityMonitoringRuleCaseAction");
const SecurityMonitoringRuleCaseActionOptions_1 = require("./SecurityMonitoringRuleCaseActionOptions");
const SecurityMonitoringRuleCaseCreate_1 = require("./SecurityMonitoringRuleCaseCreate");
const SecurityMonitoringRuleConvertResponse_1 = require("./SecurityMonitoringRuleConvertResponse");
const SecurityMonitoringRuleImpossibleTravelOptions_1 = require("./SecurityMonitoringRuleImpossibleTravelOptions");
const SecurityMonitoringRuleNewValueOptions_1 = require("./SecurityMonitoringRuleNewValueOptions");
const SecurityMonitoringRuleOptions_1 = require("./SecurityMonitoringRuleOptions");
const SecurityMonitoringRuleQueryPayload_1 = require("./SecurityMonitoringRuleQueryPayload");
const SecurityMonitoringRuleQueryPayloadData_1 = require("./SecurityMonitoringRuleQueryPayloadData");
const SecurityMonitoringRuleTestRequest_1 = require("./SecurityMonitoringRuleTestRequest");
const SecurityMonitoringRuleTestResponse_1 = require("./SecurityMonitoringRuleTestResponse");
const SecurityMonitoringRuleThirdPartyOptions_1 = require("./SecurityMonitoringRuleThirdPartyOptions");
const SecurityMonitoringRuleUpdatePayload_1 = require("./SecurityMonitoringRuleUpdatePayload");
const SecurityMonitoringSignal_1 = require("./SecurityMonitoringSignal");
const SecurityMonitoringSignalAssigneeUpdateAttributes_1 = require("./SecurityMonitoringSignalAssigneeUpdateAttributes");
const SecurityMonitoringSignalAssigneeUpdateData_1 = require("./SecurityMonitoringSignalAssigneeUpdateData");
const SecurityMonitoringSignalAssigneeUpdateRequest_1 = require("./SecurityMonitoringSignalAssigneeUpdateRequest");
const SecurityMonitoringSignalAttributes_1 = require("./SecurityMonitoringSignalAttributes");
const SecurityMonitoringSignalIncidentsUpdateAttributes_1 = require("./SecurityMonitoringSignalIncidentsUpdateAttributes");
const SecurityMonitoringSignalIncidentsUpdateData_1 = require("./SecurityMonitoringSignalIncidentsUpdateData");
const SecurityMonitoringSignalIncidentsUpdateRequest_1 = require("./SecurityMonitoringSignalIncidentsUpdateRequest");
const SecurityMonitoringSignalListRequest_1 = require("./SecurityMonitoringSignalListRequest");
const SecurityMonitoringSignalListRequestFilter_1 = require("./SecurityMonitoringSignalListRequestFilter");
const SecurityMonitoringSignalListRequestPage_1 = require("./SecurityMonitoringSignalListRequestPage");
const SecurityMonitoringSignalResponse_1 = require("./SecurityMonitoringSignalResponse");
const SecurityMonitoringSignalRuleCreatePayload_1 = require("./SecurityMonitoringSignalRuleCreatePayload");
const SecurityMonitoringSignalRulePayload_1 = require("./SecurityMonitoringSignalRulePayload");
const SecurityMonitoringSignalRuleQuery_1 = require("./SecurityMonitoringSignalRuleQuery");
const SecurityMonitoringSignalRuleResponse_1 = require("./SecurityMonitoringSignalRuleResponse");
const SecurityMonitoringSignalRuleResponseQuery_1 = require("./SecurityMonitoringSignalRuleResponseQuery");
const SecurityMonitoringSignalStateUpdateAttributes_1 = require("./SecurityMonitoringSignalStateUpdateAttributes");
const SecurityMonitoringSignalStateUpdateData_1 = require("./SecurityMonitoringSignalStateUpdateData");
const SecurityMonitoringSignalStateUpdateRequest_1 = require("./SecurityMonitoringSignalStateUpdateRequest");
const SecurityMonitoringSignalTriageAttributes_1 = require("./SecurityMonitoringSignalTriageAttributes");
const SecurityMonitoringSignalTriageUpdateData_1 = require("./SecurityMonitoringSignalTriageUpdateData");
const SecurityMonitoringSignalTriageUpdateResponse_1 = require("./SecurityMonitoringSignalTriageUpdateResponse");
const SecurityMonitoringSignalsListResponse_1 = require("./SecurityMonitoringSignalsListResponse");
const SecurityMonitoringSignalsListResponseLinks_1 = require("./SecurityMonitoringSignalsListResponseLinks");
const SecurityMonitoringSignalsListResponseMeta_1 = require("./SecurityMonitoringSignalsListResponseMeta");
const SecurityMonitoringSignalsListResponseMetaPage_1 = require("./SecurityMonitoringSignalsListResponseMetaPage");
const SecurityMonitoringStandardRuleCreatePayload_1 = require("./SecurityMonitoringStandardRuleCreatePayload");
const SecurityMonitoringStandardRulePayload_1 = require("./SecurityMonitoringStandardRulePayload");
const SecurityMonitoringStandardRuleQuery_1 = require("./SecurityMonitoringStandardRuleQuery");
const SecurityMonitoringStandardRuleResponse_1 = require("./SecurityMonitoringStandardRuleResponse");
const SecurityMonitoringStandardRuleTestPayload_1 = require("./SecurityMonitoringStandardRuleTestPayload");
const SecurityMonitoringSuppression_1 = require("./SecurityMonitoringSuppression");
const SecurityMonitoringSuppressionAttributes_1 = require("./SecurityMonitoringSuppressionAttributes");
const SecurityMonitoringSuppressionCreateAttributes_1 = require("./SecurityMonitoringSuppressionCreateAttributes");
const SecurityMonitoringSuppressionCreateData_1 = require("./SecurityMonitoringSuppressionCreateData");
const SecurityMonitoringSuppressionCreateRequest_1 = require("./SecurityMonitoringSuppressionCreateRequest");
const SecurityMonitoringSuppressionResponse_1 = require("./SecurityMonitoringSuppressionResponse");
const SecurityMonitoringSuppressionUpdateAttributes_1 = require("./SecurityMonitoringSuppressionUpdateAttributes");
const SecurityMonitoringSuppressionUpdateData_1 = require("./SecurityMonitoringSuppressionUpdateData");
const SecurityMonitoringSuppressionUpdateRequest_1 = require("./SecurityMonitoringSuppressionUpdateRequest");
const SecurityMonitoringSuppressionsResponse_1 = require("./SecurityMonitoringSuppressionsResponse");
const SecurityMonitoringThirdPartyRootQuery_1 = require("./SecurityMonitoringThirdPartyRootQuery");
const SecurityMonitoringThirdPartyRuleCase_1 = require("./SecurityMonitoringThirdPartyRuleCase");
const SecurityMonitoringThirdPartyRuleCaseCreate_1 = require("./SecurityMonitoringThirdPartyRuleCaseCreate");
const SecurityMonitoringTriageUser_1 = require("./SecurityMonitoringTriageUser");
const SecurityMonitoringUser_1 = require("./SecurityMonitoringUser");
const SecurityTrigger_1 = require("./SecurityTrigger");
const SecurityTriggerWrapper_1 = require("./SecurityTriggerWrapper");
const Selectors_1 = require("./Selectors");
const SelfServiceTriggerWrapper_1 = require("./SelfServiceTriggerWrapper");
const SendSlackMessageAction_1 = require("./SendSlackMessageAction");
const SendTeamsMessageAction_1 = require("./SendTeamsMessageAction");
const SensitiveDataScannerConfigRequest_1 = require("./SensitiveDataScannerConfigRequest");
const SensitiveDataScannerConfiguration_1 = require("./SensitiveDataScannerConfiguration");
const SensitiveDataScannerConfigurationData_1 = require("./SensitiveDataScannerConfigurationData");
const SensitiveDataScannerConfigurationRelationships_1 = require("./SensitiveDataScannerConfigurationRelationships");
const SensitiveDataScannerCreateGroupResponse_1 = require("./SensitiveDataScannerCreateGroupResponse");
const SensitiveDataScannerCreateRuleResponse_1 = require("./SensitiveDataScannerCreateRuleResponse");
const SensitiveDataScannerFilter_1 = require("./SensitiveDataScannerFilter");
const SensitiveDataScannerGetConfigResponse_1 = require("./SensitiveDataScannerGetConfigResponse");
const SensitiveDataScannerGetConfigResponseData_1 = require("./SensitiveDataScannerGetConfigResponseData");
const SensitiveDataScannerGroup_1 = require("./SensitiveDataScannerGroup");
const SensitiveDataScannerGroupAttributes_1 = require("./SensitiveDataScannerGroupAttributes");
const SensitiveDataScannerGroupCreate_1 = require("./SensitiveDataScannerGroupCreate");
const SensitiveDataScannerGroupCreateRequest_1 = require("./SensitiveDataScannerGroupCreateRequest");
const SensitiveDataScannerGroupData_1 = require("./SensitiveDataScannerGroupData");
const SensitiveDataScannerGroupDeleteRequest_1 = require("./SensitiveDataScannerGroupDeleteRequest");
const SensitiveDataScannerGroupDeleteResponse_1 = require("./SensitiveDataScannerGroupDeleteResponse");
const SensitiveDataScannerGroupIncludedItem_1 = require("./SensitiveDataScannerGroupIncludedItem");
const SensitiveDataScannerGroupItem_1 = require("./SensitiveDataScannerGroupItem");
const SensitiveDataScannerGroupList_1 = require("./SensitiveDataScannerGroupList");
const SensitiveDataScannerGroupRelationships_1 = require("./SensitiveDataScannerGroupRelationships");
const SensitiveDataScannerGroupResponse_1 = require("./SensitiveDataScannerGroupResponse");
const SensitiveDataScannerGroupUpdate_1 = require("./SensitiveDataScannerGroupUpdate");
const SensitiveDataScannerGroupUpdateRequest_1 = require("./SensitiveDataScannerGroupUpdateRequest");
const SensitiveDataScannerGroupUpdateResponse_1 = require("./SensitiveDataScannerGroupUpdateResponse");
const SensitiveDataScannerIncludedKeywordConfiguration_1 = require("./SensitiveDataScannerIncludedKeywordConfiguration");
const SensitiveDataScannerMeta_1 = require("./SensitiveDataScannerMeta");
const SensitiveDataScannerMetaVersionOnly_1 = require("./SensitiveDataScannerMetaVersionOnly");
const SensitiveDataScannerReorderConfig_1 = require("./SensitiveDataScannerReorderConfig");
const SensitiveDataScannerReorderGroupsResponse_1 = require("./SensitiveDataScannerReorderGroupsResponse");
const SensitiveDataScannerRule_1 = require("./SensitiveDataScannerRule");
const SensitiveDataScannerRuleAttributes_1 = require("./SensitiveDataScannerRuleAttributes");
const SensitiveDataScannerRuleCreate_1 = require("./SensitiveDataScannerRuleCreate");
const SensitiveDataScannerRuleCreateRequest_1 = require("./SensitiveDataScannerRuleCreateRequest");
const SensitiveDataScannerRuleData_1 = require("./SensitiveDataScannerRuleData");
const SensitiveDataScannerRuleDeleteRequest_1 = require("./SensitiveDataScannerRuleDeleteRequest");
const SensitiveDataScannerRuleDeleteResponse_1 = require("./SensitiveDataScannerRuleDeleteResponse");
const SensitiveDataScannerRuleIncludedItem_1 = require("./SensitiveDataScannerRuleIncludedItem");
const SensitiveDataScannerRuleRelationships_1 = require("./SensitiveDataScannerRuleRelationships");
const SensitiveDataScannerRuleResponse_1 = require("./SensitiveDataScannerRuleResponse");
const SensitiveDataScannerRuleUpdate_1 = require("./SensitiveDataScannerRuleUpdate");
const SensitiveDataScannerRuleUpdateRequest_1 = require("./SensitiveDataScannerRuleUpdateRequest");
const SensitiveDataScannerRuleUpdateResponse_1 = require("./SensitiveDataScannerRuleUpdateResponse");
const SensitiveDataScannerStandardPattern_1 = require("./SensitiveDataScannerStandardPattern");
const SensitiveDataScannerStandardPatternAttributes_1 = require("./SensitiveDataScannerStandardPatternAttributes");
const SensitiveDataScannerStandardPatternData_1 = require("./SensitiveDataScannerStandardPatternData");
const SensitiveDataScannerStandardPatternsResponseData_1 = require("./SensitiveDataScannerStandardPatternsResponseData");
const SensitiveDataScannerStandardPatternsResponseItem_1 = require("./SensitiveDataScannerStandardPatternsResponseItem");
const SensitiveDataScannerTextReplacement_1 = require("./SensitiveDataScannerTextReplacement");
const ServiceAccountCreateAttributes_1 = require("./ServiceAccountCreateAttributes");
const ServiceAccountCreateData_1 = require("./ServiceAccountCreateData");
const ServiceAccountCreateRequest_1 = require("./ServiceAccountCreateRequest");
const ServiceDefinitionCreateResponse_1 = require("./ServiceDefinitionCreateResponse");
const ServiceDefinitionData_1 = require("./ServiceDefinitionData");
const ServiceDefinitionDataAttributes_1 = require("./ServiceDefinitionDataAttributes");
const ServiceDefinitionGetResponse_1 = require("./ServiceDefinitionGetResponse");
const ServiceDefinitionMeta_1 = require("./ServiceDefinitionMeta");
const ServiceDefinitionMetaWarnings_1 = require("./ServiceDefinitionMetaWarnings");
const ServiceDefinitionV1_1 = require("./ServiceDefinitionV1");
const ServiceDefinitionV1Contact_1 = require("./ServiceDefinitionV1Contact");
const ServiceDefinitionV1Info_1 = require("./ServiceDefinitionV1Info");
const ServiceDefinitionV1Integrations_1 = require("./ServiceDefinitionV1Integrations");
const ServiceDefinitionV1Org_1 = require("./ServiceDefinitionV1Org");
const ServiceDefinitionV1Resource_1 = require("./ServiceDefinitionV1Resource");
const ServiceDefinitionV2_1 = require("./ServiceDefinitionV2");
const ServiceDefinitionV2Doc_1 = require("./ServiceDefinitionV2Doc");
const ServiceDefinitionV2Dot1_1 = require("./ServiceDefinitionV2Dot1");
const ServiceDefinitionV2Dot1Email_1 = require("./ServiceDefinitionV2Dot1Email");
const ServiceDefinitionV2Dot1Integrations_1 = require("./ServiceDefinitionV2Dot1Integrations");
const ServiceDefinitionV2Dot1Link_1 = require("./ServiceDefinitionV2Dot1Link");
const ServiceDefinitionV2Dot1MSTeams_1 = require("./ServiceDefinitionV2Dot1MSTeams");
const ServiceDefinitionV2Dot1Opsgenie_1 = require("./ServiceDefinitionV2Dot1Opsgenie");
const ServiceDefinitionV2Dot1Pagerduty_1 = require("./ServiceDefinitionV2Dot1Pagerduty");
const ServiceDefinitionV2Dot1Slack_1 = require("./ServiceDefinitionV2Dot1Slack");
const ServiceDefinitionV2Dot2_1 = require("./ServiceDefinitionV2Dot2");
const ServiceDefinitionV2Dot2Contact_1 = require("./ServiceDefinitionV2Dot2Contact");
const ServiceDefinitionV2Dot2Integrations_1 = require("./ServiceDefinitionV2Dot2Integrations");
const ServiceDefinitionV2Dot2Link_1 = require("./ServiceDefinitionV2Dot2Link");
const ServiceDefinitionV2Dot2Opsgenie_1 = require("./ServiceDefinitionV2Dot2Opsgenie");
const ServiceDefinitionV2Dot2Pagerduty_1 = require("./ServiceDefinitionV2Dot2Pagerduty");
const ServiceDefinitionV2Email_1 = require("./ServiceDefinitionV2Email");
const ServiceDefinitionV2Integrations_1 = require("./ServiceDefinitionV2Integrations");
const ServiceDefinitionV2Link_1 = require("./ServiceDefinitionV2Link");
const ServiceDefinitionV2MSTeams_1 = require("./ServiceDefinitionV2MSTeams");
const ServiceDefinitionV2Opsgenie_1 = require("./ServiceDefinitionV2Opsgenie");
const ServiceDefinitionV2Repo_1 = require("./ServiceDefinitionV2Repo");
const ServiceDefinitionV2Slack_1 = require("./ServiceDefinitionV2Slack");
const ServiceDefinitionsListResponse_1 = require("./ServiceDefinitionsListResponse");
const ServiceNowTicket_1 = require("./ServiceNowTicket");
const ServiceNowTicketResult_1 = require("./ServiceNowTicketResult");
const Shift_1 = require("./Shift");
const ShiftData_1 = require("./ShiftData");
const ShiftDataAttributes_1 = require("./ShiftDataAttributes");
const ShiftDataRelationships_1 = require("./ShiftDataRelationships");
const ShiftDataRelationshipsUser_1 = require("./ShiftDataRelationshipsUser");
const ShiftDataRelationshipsUserData_1 = require("./ShiftDataRelationshipsUserData");
const SingleAggregatedConnectionResponseArray_1 = require("./SingleAggregatedConnectionResponseArray");
const SingleAggregatedConnectionResponseData_1 = require("./SingleAggregatedConnectionResponseData");
const SingleAggregatedConnectionResponseDataAttributes_1 = require("./SingleAggregatedConnectionResponseDataAttributes");
const SlackIntegrationMetadata_1 = require("./SlackIntegrationMetadata");
const SlackIntegrationMetadataChannelItem_1 = require("./SlackIntegrationMetadataChannelItem");
const SlackTriggerWrapper_1 = require("./SlackTriggerWrapper");
const SloReportCreateRequest_1 = require("./SloReportCreateRequest");
const SloReportCreateRequestAttributes_1 = require("./SloReportCreateRequestAttributes");
const SloReportCreateRequestData_1 = require("./SloReportCreateRequestData");
const SoftwareCatalogTriggerWrapper_1 = require("./SoftwareCatalogTriggerWrapper");
const Span_1 = require("./Span");
const SpansAggregateBucket_1 = require("./SpansAggregateBucket");
const SpansAggregateBucketAttributes_1 = require("./SpansAggregateBucketAttributes");
const SpansAggregateBucketValueTimeseriesPoint_1 = require("./SpansAggregateBucketValueTimeseriesPoint");
const SpansAggregateData_1 = require("./SpansAggregateData");
const SpansAggregateRequest_1 = require("./SpansAggregateRequest");
const SpansAggregateRequestAttributes_1 = require("./SpansAggregateRequestAttributes");
const SpansAggregateResponse_1 = require("./SpansAggregateResponse");
const SpansAggregateResponseMetadata_1 = require("./SpansAggregateResponseMetadata");
const SpansAggregateSort_1 = require("./SpansAggregateSort");
const SpansAttributes_1 = require("./SpansAttributes");
const SpansCompute_1 = require("./SpansCompute");
const SpansFilter_1 = require("./SpansFilter");
const SpansFilterCreate_1 = require("./SpansFilterCreate");
const SpansGroupBy_1 = require("./SpansGroupBy");
const SpansGroupByHistogram_1 = require("./SpansGroupByHistogram");
const SpansListRequest_1 = require("./SpansListRequest");
const SpansListRequestAttributes_1 = require("./SpansListRequestAttributes");
const SpansListRequestData_1 = require("./SpansListRequestData");
const SpansListRequestPage_1 = require("./SpansListRequestPage");
const SpansListResponse_1 = require("./SpansListResponse");
const SpansListResponseLinks_1 = require("./SpansListResponseLinks");
const SpansListResponseMetadata_1 = require("./SpansListResponseMetadata");
const SpansMetricCompute_1 = require("./SpansMetricCompute");
const SpansMetricCreateAttributes_1 = require("./SpansMetricCreateAttributes");
const SpansMetricCreateData_1 = require("./SpansMetricCreateData");
const SpansMetricCreateRequest_1 = require("./SpansMetricCreateRequest");
const SpansMetricFilter_1 = require("./SpansMetricFilter");
const SpansMetricGroupBy_1 = require("./SpansMetricGroupBy");
const SpansMetricResponse_1 = require("./SpansMetricResponse");
const SpansMetricResponseAttributes_1 = require("./SpansMetricResponseAttributes");
const SpansMetricResponseCompute_1 = require("./SpansMetricResponseCompute");
const SpansMetricResponseData_1 = require("./SpansMetricResponseData");
const SpansMetricResponseFilter_1 = require("./SpansMetricResponseFilter");
const SpansMetricResponseGroupBy_1 = require("./SpansMetricResponseGroupBy");
const SpansMetricUpdateAttributes_1 = require("./SpansMetricUpdateAttributes");
const SpansMetricUpdateCompute_1 = require("./SpansMetricUpdateCompute");
const SpansMetricUpdateData_1 = require("./SpansMetricUpdateData");
const SpansMetricUpdateRequest_1 = require("./SpansMetricUpdateRequest");
const SpansMetricsResponse_1 = require("./SpansMetricsResponse");
const SpansQueryFilter_1 = require("./SpansQueryFilter");
const SpansQueryOptions_1 = require("./SpansQueryOptions");
const SpansResponseMetadataPage_1 = require("./SpansResponseMetadataPage");
const SpansWarning_1 = require("./SpansWarning");
const Spec_1 = require("./Spec");
const StateVariable_1 = require("./StateVariable");
const StateVariableProperties_1 = require("./StateVariableProperties");
const Step_1 = require("./Step");
const StepDisplay_1 = require("./StepDisplay");
const StepDisplayBounds_1 = require("./StepDisplayBounds");
const TagFilter_1 = require("./TagFilter");
const Team_1 = require("./Team");
const TeamAttributes_1 = require("./TeamAttributes");
const TeamCreate_1 = require("./TeamCreate");
const TeamCreateAttributes_1 = require("./TeamCreateAttributes");
const TeamCreateRelationships_1 = require("./TeamCreateRelationships");
const TeamCreateRequest_1 = require("./TeamCreateRequest");
const TeamLink_1 = require("./TeamLink");
const TeamLinkAttributes_1 = require("./TeamLinkAttributes");
const TeamLinkCreate_1 = require("./TeamLinkCreate");
const TeamLinkCreateRequest_1 = require("./TeamLinkCreateRequest");
const TeamLinkResponse_1 = require("./TeamLinkResponse");
const TeamLinksResponse_1 = require("./TeamLinksResponse");
const TeamPermissionSetting_1 = require("./TeamPermissionSetting");
const TeamPermissionSettingAttributes_1 = require("./TeamPermissionSettingAttributes");
const TeamPermissionSettingResponse_1 = require("./TeamPermissionSettingResponse");
const TeamPermissionSettingUpdate_1 = require("./TeamPermissionSettingUpdate");
const TeamPermissionSettingUpdateAttributes_1 = require("./TeamPermissionSettingUpdateAttributes");
const TeamPermissionSettingUpdateRequest_1 = require("./TeamPermissionSettingUpdateRequest");
const TeamPermissionSettingsResponse_1 = require("./TeamPermissionSettingsResponse");
const TeamReference_1 = require("./TeamReference");
const TeamReferenceAttributes_1 = require("./TeamReferenceAttributes");
const TeamRelationships_1 = require("./TeamRelationships");
const TeamRelationshipsLinks_1 = require("./TeamRelationshipsLinks");
const TeamResponse_1 = require("./TeamResponse");
const TeamRoutingRules_1 = require("./TeamRoutingRules");
const TeamRoutingRulesData_1 = require("./TeamRoutingRulesData");
const TeamRoutingRulesDataRelationships_1 = require("./TeamRoutingRulesDataRelationships");
const TeamRoutingRulesDataRelationshipsRules_1 = require("./TeamRoutingRulesDataRelationshipsRules");
const TeamRoutingRulesDataRelationshipsRulesDataItems_1 = require("./TeamRoutingRulesDataRelationshipsRulesDataItems");
const TeamRoutingRulesRequest_1 = require("./TeamRoutingRulesRequest");
const TeamRoutingRulesRequestData_1 = require("./TeamRoutingRulesRequestData");
const TeamRoutingRulesRequestDataAttributes_1 = require("./TeamRoutingRulesRequestDataAttributes");
const TeamRoutingRulesRequestRule_1 = require("./TeamRoutingRulesRequestRule");
const TeamTarget_1 = require("./TeamTarget");
const TeamUpdate_1 = require("./TeamUpdate");
const TeamUpdateAttributes_1 = require("./TeamUpdateAttributes");
const TeamUpdateRelationships_1 = require("./TeamUpdateRelationships");
const TeamUpdateRequest_1 = require("./TeamUpdateRequest");
const TeamsResponse_1 = require("./TeamsResponse");
const TeamsResponseLinks_1 = require("./TeamsResponseLinks");
const TeamsResponseMeta_1 = require("./TeamsResponseMeta");
const TeamsResponseMetaPagination_1 = require("./TeamsResponseMetaPagination");
const TimeRestriction_1 = require("./TimeRestriction");
const TimeRestrictions_1 = require("./TimeRestrictions");
const TimeseriesFormulaQueryRequest_1 = require("./TimeseriesFormulaQueryRequest");
const TimeseriesFormulaQueryResponse_1 = require("./TimeseriesFormulaQueryResponse");
const TimeseriesFormulaRequest_1 = require("./TimeseriesFormulaRequest");
const TimeseriesFormulaRequestAttributes_1 = require("./TimeseriesFormulaRequestAttributes");
const TimeseriesResponse_1 = require("./TimeseriesResponse");
const TimeseriesResponseAttributes_1 = require("./TimeseriesResponseAttributes");
const TimeseriesResponseSeries_1 = require("./TimeseriesResponseSeries");
const TriggerRateLimit_1 = require("./TriggerRateLimit");
const Unit_1 = require("./Unit");
const UnpublishAppResponse_1 = require("./UnpublishAppResponse");
const UpdateActionConnectionRequest_1 = require("./UpdateActionConnectionRequest");
const UpdateActionConnectionResponse_1 = require("./UpdateActionConnectionResponse");
const UpdateAppRequest_1 = require("./UpdateAppRequest");
const UpdateAppRequestData_1 = require("./UpdateAppRequestData");
const UpdateAppRequestDataAttributes_1 = require("./UpdateAppRequestDataAttributes");
const UpdateAppResponse_1 = require("./UpdateAppResponse");
const UpdateAppResponseData_1 = require("./UpdateAppResponseData");
const UpdateAppResponseDataAttributes_1 = require("./UpdateAppResponseDataAttributes");
const UpdateCustomFrameworkRequest_1 = require("./UpdateCustomFrameworkRequest");
const UpdateCustomFrameworkResponse_1 = require("./UpdateCustomFrameworkResponse");
const UpdateOpenAPIResponse_1 = require("./UpdateOpenAPIResponse");
const UpdateOpenAPIResponseAttributes_1 = require("./UpdateOpenAPIResponseAttributes");
const UpdateOpenAPIResponseData_1 = require("./UpdateOpenAPIResponseData");
const UpdateResourceEvaluationFiltersRequest_1 = require("./UpdateResourceEvaluationFiltersRequest");
const UpdateResourceEvaluationFiltersRequestData_1 = require("./UpdateResourceEvaluationFiltersRequestData");
const UpdateResourceEvaluationFiltersResponse_1 = require("./UpdateResourceEvaluationFiltersResponse");
const UpdateResourceEvaluationFiltersResponseData_1 = require("./UpdateResourceEvaluationFiltersResponseData");
const UpdateRuleRequest_1 = require("./UpdateRuleRequest");
const UpdateRuleRequestData_1 = require("./UpdateRuleRequestData");
const UpdateRuleResponse_1 = require("./UpdateRuleResponse");
const UpdateRuleResponseData_1 = require("./UpdateRuleResponseData");
const UpdateWorkflowRequest_1 = require("./UpdateWorkflowRequest");
const UpdateWorkflowResponse_1 = require("./UpdateWorkflowResponse");
const UpsertCatalogEntityResponse_1 = require("./UpsertCatalogEntityResponse");
const UrlParam_1 = require("./UrlParam");
const UrlParamUpdate_1 = require("./UrlParamUpdate");
const UsageApplicationSecurityMonitoringResponse_1 = require("./UsageApplicationSecurityMonitoringResponse");
const UsageAttributesObject_1 = require("./UsageAttributesObject");
const UsageDataObject_1 = require("./UsageDataObject");
const UsageLambdaTracedInvocationsResponse_1 = require("./UsageLambdaTracedInvocationsResponse");
const UsageObservabilityPipelinesResponse_1 = require("./UsageObservabilityPipelinesResponse");
const UsageTimeSeriesObject_1 = require("./UsageTimeSeriesObject");
const User_1 = require("./User");
const UserAttributes_1 = require("./UserAttributes");
const UserCreateAttributes_1 = require("./UserCreateAttributes");
const UserCreateData_1 = require("./UserCreateData");
const UserCreateRequest_1 = require("./UserCreateRequest");
const UserInvitationData_1 = require("./UserInvitationData");
const UserInvitationDataAttributes_1 = require("./UserInvitationDataAttributes");
const UserInvitationRelationships_1 = require("./UserInvitationRelationships");
const UserInvitationResponse_1 = require("./UserInvitationResponse");
const UserInvitationResponseData_1 = require("./UserInvitationResponseData");
const UserInvitationsRequest_1 = require("./UserInvitationsRequest");
const UserInvitationsResponse_1 = require("./UserInvitationsResponse");
const UserRelationshipData_1 = require("./UserRelationshipData");
const UserRelationships_1 = require("./UserRelationships");
const UserResponse_1 = require("./UserResponse");
const UserResponseRelationships_1 = require("./UserResponseRelationships");
const UserTarget_1 = require("./UserTarget");
const UserTeam_1 = require("./UserTeam");
const UserTeamAttributes_1 = require("./UserTeamAttributes");
const UserTeamCreate_1 = require("./UserTeamCreate");
const UserTeamPermission_1 = require("./UserTeamPermission");
const UserTeamPermissionAttributes_1 = require("./UserTeamPermissionAttributes");
const UserTeamRelationships_1 = require("./UserTeamRelationships");
const UserTeamRequest_1 = require("./UserTeamRequest");
const UserTeamResponse_1 = require("./UserTeamResponse");
const UserTeamUpdate_1 = require("./UserTeamUpdate");
const UserTeamUpdateRequest_1 = require("./UserTeamUpdateRequest");
const UserTeamsResponse_1 = require("./UserTeamsResponse");
const UserUpdateAttributes_1 = require("./UserUpdateAttributes");
const UserUpdateData_1 = require("./UserUpdateData");
const UserUpdateRequest_1 = require("./UserUpdateRequest");
const UsersRelationship_1 = require("./UsersRelationship");
const UsersResponse_1 = require("./UsersResponse");
const ValidationError_1 = require("./ValidationError");
const ValidationErrorMeta_1 = require("./ValidationErrorMeta");
const ValidationResponse_1 = require("./ValidationResponse");
const Vulnerability_1 = require("./Vulnerability");
const VulnerabilityAttributes_1 = require("./VulnerabilityAttributes");
const VulnerabilityCvss_1 = require("./VulnerabilityCvss");
const VulnerabilityDependencyLocations_1 = require("./VulnerabilityDependencyLocations");
const VulnerabilityRelationships_1 = require("./VulnerabilityRelationships");
const VulnerabilityRelationshipsAffects_1 = require("./VulnerabilityRelationshipsAffects");
const VulnerabilityRelationshipsAffectsData_1 = require("./VulnerabilityRelationshipsAffectsData");
const VulnerabilityRisks_1 = require("./VulnerabilityRisks");
const WorkflowData_1 = require("./WorkflowData");
const WorkflowDataAttributes_1 = require("./WorkflowDataAttributes");
const WorkflowDataRelationships_1 = require("./WorkflowDataRelationships");
const WorkflowDataUpdate_1 = require("./WorkflowDataUpdate");
const WorkflowDataUpdateAttributes_1 = require("./WorkflowDataUpdateAttributes");
const WorkflowInstanceCreateMeta_1 = require("./WorkflowInstanceCreateMeta");
const WorkflowInstanceCreateRequest_1 = require("./WorkflowInstanceCreateRequest");
const WorkflowInstanceCreateResponse_1 = require("./WorkflowInstanceCreateResponse");
const WorkflowInstanceCreateResponseData_1 = require("./WorkflowInstanceCreateResponseData");
const WorkflowInstanceListItem_1 = require("./WorkflowInstanceListItem");
const WorkflowListInstancesResponse_1 = require("./WorkflowListInstancesResponse");
const WorkflowListInstancesResponseMeta_1 = require("./WorkflowListInstancesResponseMeta");
const WorkflowListInstancesResponseMetaPage_1 = require("./WorkflowListInstancesResponseMetaPage");
const WorkflowTriggerWrapper_1 = require("./WorkflowTriggerWrapper");
const WorkflowUserRelationship_1 = require("./WorkflowUserRelationship");
const WorkflowUserRelationshipData_1 = require("./WorkflowUserRelationshipData");
const WorklflowCancelInstanceResponse_1 = require("./WorklflowCancelInstanceResponse");
const WorklflowCancelInstanceResponseData_1 = require("./WorklflowCancelInstanceResponseData");
const WorklflowGetInstanceResponse_1 = require("./WorklflowGetInstanceResponse");
const WorklflowGetInstanceResponseData_1 = require("./WorklflowGetInstanceResponseData");
const WorklflowGetInstanceResponseDataAttributes_1 = require("./WorklflowGetInstanceResponseDataAttributes");
const XRayServicesIncludeAll_1 = require("./XRayServicesIncludeAll");
const XRayServicesIncludeOnly_1 = require("./XRayServicesIncludeOnly");
const util_1 = require("../../datadog-api-client-common/util");
const logger_1 = require("../../../logger");
const primitives = [
    "string",
    "boolean",
    "double",
    "integer",
    "long",
    "float",
    "number",
];
const ARRAY_PREFIX = "Array<";
const MAP_PREFIX = "{ [key: string]: ";
const TUPLE_PREFIX = "[";
const supportedMediaTypes = {
    "application/json": Infinity,
    "text/json": 100,
    "application/octet-stream": 0,
};
const enumsMap = {
    APIKeysSort: [
        "created_at",
        "-created_at",
        "last4",
        "-last4",
        "modified_at",
        "-modified_at",
        "name",
        "-name",
    ],
    APIKeysType: ["api_keys"],
    AWSAccountPartition: ["aws", "aws-cn", "aws-us-gov"],
    AWSAccountType: ["account"],
    AWSAssumeRoleType: ["AWSAssumeRole"],
    AWSIntegrationType: ["AWS"],
    AWSLogsServicesResponseDataType: ["logs_services"],
    AWSNamespacesResponseDataType: ["namespaces"],
    AWSNewExternalIDResponseDataType: ["external_id"],
    ActionConnectionDataType: ["action_connection"],
    ActionQueryType: ["action"],
    ActiveBillingDimensionsType: ["billing_dimensions"],
    ApmRetentionFilterType: ["apm_retention_filter"],
    AppBuilderEventName: [
        "pageChange",
        "tableRowClick",
        "_tableRowButtonClick",
        "change",
        "submit",
        "click",
        "toggleOpen",
        "close",
        "open",
        "executionFinished",
    ],
    AppBuilderEventType: [
        "custom",
        "setComponentState",
        "triggerQuery",
        "openModal",
        "closeModal",
        "openUrl",
        "downloadFile",
        "setStateVariableValue",
    ],
    AppDefinitionType: ["appDefinitions"],
    AppDeploymentType: ["deployment"],
    ApplicationKeysSort: [
        "created_at",
        "-created_at",
        "last4",
        "-last4",
        "name",
        "-name",
    ],
    ApplicationKeysType: ["application_keys"],
    ApplicationSecurityWafCustomRuleActionAction: [
        "redirect_request",
        "block_request",
    ],
    ApplicationSecurityWafCustomRuleConditionInputAddress: [
        "server.db.statement",
        "server.io.fs.file",
        "server.io.net.url",
        "server.sys.shell.cmd",
        "server.request.method",
        "server.request.uri.raw",
        "server.request.path_params",
        "server.request.query",
        "server.request.headers.no_cookies",
        "server.request.cookies",
        "server.request.trailers",
        "server.request.body",
        "server.response.status",
        "server.response.headers.no_cookies",
        "server.response.trailers",
        "grpc.server.request.metadata",
        "grpc.server.request.message",
        "grpc.server.method",
        "graphql.server.all_resolvers",
        "usr.id",
        "http.client_ip",
    ],
    ApplicationSecurityWafCustomRuleConditionOperator: [
        "match_regex",
        "!match_regex",
        "phrase_match",
        "!phrase_match",
        "is_xss",
        "is_sqli",
        "exact_match",
        "!exact_match",
        "ip_match",
        "!ip_match",
        "capture_data",
    ],
    ApplicationSecurityWafCustomRuleTagsCategory: [
        "attack_attempt",
        "business_logic",
        "security_response",
    ],
    ApplicationSecurityWafCustomRuleType: ["custom_rule"],
    ApplicationSecurityWafExclusionFilterOnMatch: ["monitor"],
    ApplicationSecurityWafExclusionFilterType: ["exclusion_filter"],
    AppsSortField: [
        "name",
        "created_at",
        "updated_at",
        "user_name",
        "-name",
        "-created_at",
        "-updated_at",
        "-user_name",
    ],
    AssetEntityType: ["assets"],
    AssetType: ["Repository", "Service", "Host", "HostImage", "Image"],
    AuditLogsEventType: ["audit"],
    AuditLogsResponseStatus: ["done", "timeout"],
    AuditLogsSort: ["timestamp", "-timestamp"],
    AuthNMappingResourceType: ["role", "team"],
    AuthNMappingsSort: [
        "created_at",
        "-created_at",
        "role_id",
        "-role_id",
        "saml_assertion_attribute_id",
        "-saml_assertion_attribute_id",
        "role.name",
        "-role.name",
        "saml_assertion_attribute.attribute_key",
        "-saml_assertion_attribute.attribute_key",
        "saml_assertion_attribute.attribute_value",
        "-saml_assertion_attribute.attribute_value",
    ],
    AuthNMappingsType: ["authn_mappings"],
    AwsCURConfigPatchRequestType: ["aws_cur_config_patch_request"],
    AwsCURConfigPostRequestType: ["aws_cur_config_post_request"],
    AwsCURConfigType: ["aws_cur_config"],
    AwsOnDemandType: ["aws_resource"],
    AwsScanOptionsType: ["aws_scan_options"],
    AzureStorageDestinationType: ["azure_storage"],
    AzureUCConfigPairType: ["azure_uc_configs"],
    AzureUCConfigPatchRequestType: ["azure_uc_config_patch_request"],
    AzureUCConfigPostRequestType: ["azure_uc_config_post_request"],
    BillingDimensionsMappingBodyItemAttributesEndpointsItemsStatus: [
        "OK",
        "NOT_FOUND",
    ],
    CIAppAggregateSortType: ["alphabetical", "measure"],
    CIAppAggregationFunction: [
        "count",
        "cardinality",
        "pc75",
        "pc90",
        "pc95",
        "pc98",
        "pc99",
        "sum",
        "min",
        "max",
        "avg",
        "median",
        "latest",
        "earliest",
        "most_frequent",
        "delta",
    ],
    CIAppCIErrorDomain: ["provider", "user", "unknown"],
    CIAppComputeType: ["timeseries", "total"],
    CIAppCreatePipelineEventRequestDataType: ["cipipeline_resource_request"],
    CIAppPipelineEventJobLevel: ["job"],
    CIAppPipelineEventJobStatus: ["success", "error", "canceled", "skipped"],
    CIAppPipelineEventPipelineInProgressStatus: ["running"],
    CIAppPipelineEventPipelineLevel: ["pipeline"],
    CIAppPipelineEventPipelineStatus: [
        "success",
        "error",
        "canceled",
        "skipped",
        "blocked",
    ],
    CIAppPipelineEventStageLevel: ["stage"],
    CIAppPipelineEventStageStatus: ["success", "error", "canceled", "skipped"],
    CIAppPipelineEventStepLevel: ["step"],
    CIAppPipelineEventStepStatus: ["success", "error"],
    CIAppPipelineEventTypeName: ["cipipeline"],
    CIAppPipelineLevel: ["pipeline", "stage", "job", "step", "custom"],
    CIAppResponseStatus: ["done", "timeout"],
    CIAppSort: ["timestamp", "-timestamp"],
    CIAppSortOrder: ["asc", "desc"],
    CIAppTestEventTypeName: ["citest"],
    CIAppTestLevel: ["session", "module", "suite", "test"],
    CSMAgentsType: ["datadog_agent"],
    Case3rdPartyTicketStatus: ["IN_PROGRESS", "COMPLETED", "FAILED"],
    CasePriority: ["NOT_DEFINED", "P1", "P2", "P3", "P4", "P5"],
    CaseResourceType: ["case"],
    CaseSortableField: ["created_at", "priority", "status"],
    CaseStatus: ["OPEN", "IN_PROGRESS", "CLOSED"],
    CaseType: ["STANDARD"],
    ChangeEventCustomAttributesAuthorType: ["user", "system"],
    ChangeEventCustomAttributesChangedResourceType: [
        "feature_flag",
        "configuration",
    ],
    ChangeEventCustomAttributesImpactedResourcesItemsType: ["service"],
    CloudConfigurationRuleType: ["cloud_configuration"],
    CloudWorkloadSecurityAgentPolicyType: ["policy"],
    CloudWorkloadSecurityAgentRuleType: ["agent_rule"],
    CloudflareAccountType: ["cloudflare-accounts"],
    CompletionConditionOperator: [
        "OPERATOR_EQUAL",
        "OPERATOR_NOT_EQUAL",
        "OPERATOR_GREATER_THAN",
        "OPERATOR_LESS_THAN",
        "OPERATOR_GREATER_THAN_OR_EQUAL_TO",
        "OPERATOR_LESS_THAN_OR_EQUAL_TO",
        "OPERATOR_CONTAINS",
        "OPERATOR_DOES_NOT_CONTAIN",
        "OPERATOR_IS_NULL",
        "OPERATOR_IS_NOT_NULL",
        "OPERATOR_IS_EMPTY",
        "OPERATOR_IS_NOT_EMPTY",
    ],
    ComponentGridType: ["grid"],
    ComponentType: [
        "table",
        "textInput",
        "textArea",
        "button",
        "text",
        "select",
        "modal",
        "schemaForm",
        "checkbox",
        "tabs",
        "vegaChart",
        "radioButtons",
        "numberInput",
        "fileInput",
        "jsonInput",
        "gridCell",
        "dateRangePicker",
        "search",
        "container",
        "calloutValue",
    ],
    ConfluentAccountType: ["confluent-cloud-accounts"],
    ConfluentResourceType: ["confluent-cloud-resources"],
    ConnectionEnvEnv: ["default"],
    ContainerGroupType: ["container_group"],
    ContainerImageGroupType: ["container_image_group"],
    ContainerImageMetaPageType: ["cursor_limit"],
    ContainerImageType: ["container_image"],
    ContainerMetaPageType: ["cursor_limit"],
    ContainerType: ["container"],
    ContentEncoding: ["identity", "gzip", "deflate"],
    ConvertJobResultsToSignalsDataType: [
        "historicalDetectionsJobResultSignalConversion",
    ],
    CostAttributionType: ["cost_by_tag"],
    CostByOrgType: ["cost_by_org"],
    CreateDataDeletionRequestBodyDataType: ["create_deletion_req"],
    CreatePageRequestDataType: ["pages"],
    CreatePageResponseDataType: ["pages"],
    CustomConnectionType: ["custom_connections"],
    CustomDestinationAttributeTagsRestrictionListType: [
        "ALLOW_LIST",
        "BLOCK_LIST",
    ],
    CustomDestinationForwardDestinationElasticsearchType: ["elasticsearch"],
    CustomDestinationForwardDestinationHttpType: ["http"],
    CustomDestinationForwardDestinationSplunkType: ["splunk_hec"],
    CustomDestinationHttpDestinationAuthBasicType: ["basic"],
    CustomDestinationHttpDestinationAuthCustomHeaderType: ["custom_header"],
    CustomDestinationResponseForwardDestinationElasticsearchType: [
        "elasticsearch",
    ],
    CustomDestinationResponseForwardDestinationHttpType: ["http"],
    CustomDestinationResponseForwardDestinationSplunkType: ["splunk_hec"],
    CustomDestinationResponseHttpDestinationAuthBasicType: ["basic"],
    CustomDestinationResponseHttpDestinationAuthCustomHeaderType: [
        "custom_header",
    ],
    CustomDestinationType: ["custom_destination"],
    CustomFrameworkType: ["custom_framework"],
    DORADeploymentType: ["dora_deployment"],
    DORAIncidentType: ["dora_incident"],
    DORAListDeploymentsRequestDataType: ["dora_deployments_list_request"],
    DORAListFailuresRequestDataType: ["dora_failures_list_request"],
    DashboardType: [
        "custom_timeboard",
        "custom_screenboard",
        "integration_screenboard",
        "integration_timeboard",
        "host_timeboard",
    ],
    DataRelationshipsTeamsDataItemsType: ["teams"],
    DataTransformType: ["dataTransform"],
    DetailedFindingType: ["detailed_finding"],
    DomainAllowlistType: ["domain_allowlist"],
    DowntimeIncludedMonitorType: ["monitors"],
    DowntimeNotifyEndStateActions: ["canceled", "expired"],
    DowntimeNotifyEndStateTypes: ["alert", "no data", "warn"],
    DowntimeResourceType: ["downtime"],
    DowntimeStatus: ["active", "canceled", "ended", "scheduled"],
    EntityResponseIncludedIncidentType: ["incident"],
    EntityResponseIncludedOncallType: ["oncall"],
    EntityResponseIncludedRawSchemaType: ["rawSchema"],
    EntityResponseIncludedRelatedEntityType: ["relatedEntity"],
    EntityResponseIncludedSchemaType: ["schema"],
    EntityV3APIKind: ["api"],
    EntityV3APIVersion: ["v3"],
    EntityV3DatastoreKind: ["datastore"],
    EntityV3QueueKind: ["queue"],
    EntityV3ServiceKind: ["service"],
    EntityV3SystemKind: ["system"],
    EscalationPolicyCreateRequestDataType: ["policies"],
    EscalationPolicyDataRelationshipsStepsDataItemsType: ["steps"],
    EscalationPolicyDataType: ["policies"],
    EscalationPolicyStepAttributesAssignment: ["default", "round-robin"],
    EscalationPolicyStepTargetType: ["users", "schedules", "teams"],
    EscalationPolicyStepType: ["steps"],
    EscalationPolicyUpdateRequestDataType: ["policies"],
    EscalationPolicyUserType: ["users"],
    EventCategory: ["change"],
    EventCreateRequestType: ["event"],
    EventPriority: ["normal", "low"],
    EventStatusType: [
        "failure",
        "error",
        "warning",
        "info",
        "success",
        "user_update",
        "recommendation",
        "snapshot",
    ],
    EventType: ["event"],
    EventsAggregation: [
        "count",
        "cardinality",
        "pc75",
        "pc90",
        "pc95",
        "pc98",
        "pc99",
        "sum",
        "min",
        "max",
        "avg",
    ],
    EventsDataSource: ["logs", "rum"],
    EventsSort: ["timestamp", "-timestamp"],
    EventsSortType: ["alphabetical", "measure"],
    FastlyAccountType: ["fastly-accounts"],
    FastlyServiceType: ["fastly-services"],
    FindingEvaluation: ["pass", "fail"],
    FindingMuteReason: [
        "PENDING_FIX",
        "FALSE_POSITIVE",
        "ACCEPTED_RISK",
        "NO_PENDING_FIX",
        "HUMAN_ERROR",
        "NO_LONGER_ACCEPTED_RISK",
        "OTHER",
    ],
    FindingStatus: ["critical", "high", "medium", "low", "info"],
    FindingType: ["finding"],
    FindingVulnerabilityType: [
        "misconfiguration",
        "attack_path",
        "identity_risk",
        "api_security",
    ],
    GCPSTSDelegateAccountType: ["gcp_sts_delegate"],
    GCPServiceAccountType: ["gcp_service_account"],
    GetRuleVersionHistoryDataType: ["GetRuleVersionHistoryResponse"],
    GetTeamMembershipsSort: [
        "manager_name",
        "-manager_name",
        "name",
        "-name",
        "handle",
        "-handle",
        "email",
        "-email",
    ],
    HTTPIntegrationType: ["HTTP"],
    HTTPTokenAuthType: ["HTTPTokenAuth"],
    HistoricalJobDataType: ["historicalDetectionsJob"],
    HourlyUsageType: [
        "app_sec_host_count",
        "observability_pipelines_bytes_processed",
        "lambda_traced_invocations_count",
    ],
    IPAllowlistEntryType: ["ip_allowlist_entry"],
    IPAllowlistType: ["ip_allowlist"],
    IncidentAttachmentAttachmentType: ["link", "postmortem"],
    IncidentAttachmentLinkAttachmentType: ["link"],
    IncidentAttachmentPostmortemAttachmentType: ["postmortem"],
    IncidentAttachmentRelatedObject: ["users"],
    IncidentAttachmentType: ["incident_attachments"],
    IncidentFieldAttributesSingleValueType: ["dropdown", "textbox"],
    IncidentFieldAttributesValueType: [
        "multiselect",
        "textarray",
        "metrictag",
        "autocomplete",
    ],
    IncidentImpactsType: ["incident_impacts"],
    IncidentIntegrationMetadataType: ["incident_integrations"],
    IncidentPostmortemType: ["incident_postmortems"],
    IncidentRelatedObject: ["users", "attachments"],
    IncidentRespondersType: ["incident_responders"],
    IncidentSearchResultsType: ["incidents_search_results"],
    IncidentSearchSortOrder: ["created", "-created"],
    IncidentServiceType: ["services"],
    IncidentSeverity: [
        "UNKNOWN",
        "SEV-0",
        "SEV-1",
        "SEV-2",
        "SEV-3",
        "SEV-4",
        "SEV-5",
    ],
    IncidentTeamType: ["teams"],
    IncidentTimelineCellMarkdownContentType: ["markdown"],
    IncidentTodoAnonymousAssigneeSource: ["slack", "microsoft_teams"],
    IncidentTodoType: ["incident_todos"],
    IncidentType: ["incidents"],
    IncidentTypeType: ["incident_types"],
    IncidentUserDefinedFieldType: ["user_defined_field"],
    IncludeType: ["schema", "raw_schema", "oncall", "incident", "relation"],
    InputSchemaParametersType: [
        "STRING",
        "NUMBER",
        "BOOLEAN",
        "OBJECT",
        "ARRAY_STRING",
        "ARRAY_NUMBER",
        "ARRAY_BOOLEAN",
        "ARRAY_OBJECT",
    ],
    InterfaceAttributesStatus: ["up", "down", "warning", "off"],
    LayerRelationshipsMembersDataItemsType: ["members"],
    LayerType: ["layers"],
    LeakedKeyType: ["leaked_keys"],
    ListTeamsInclude: ["team_links", "user_team_permissions"],
    ListTeamsSort: ["name", "-name", "user_count", "-user_count"],
    LogType: ["log"],
    LogsAggregateResponseStatus: ["done", "timeout"],
    LogsAggregateSortType: ["alphabetical", "measure"],
    LogsAggregationFunction: [
        "count",
        "cardinality",
        "pc75",
        "pc90",
        "pc95",
        "pc98",
        "pc99",
        "sum",
        "min",
        "max",
        "avg",
        "median",
    ],
    LogsArchiveDestinationAzureType: ["azure"],
    LogsArchiveDestinationGCSType: ["gcs"],
    LogsArchiveDestinationS3Type: ["s3"],
    LogsArchiveEncryptionS3Type: ["NO_OVERRIDE", "SSE_S3", "SSE_KMS"],
    LogsArchiveOrderDefinitionType: ["archive_order"],
    LogsArchiveState: ["UNKNOWN", "WORKING", "FAILING", "WORKING_AUTH_LEGACY"],
    LogsArchiveStorageClassS3Type: [
        "STANDARD",
        "STANDARD_IA",
        "ONEZONE_IA",
        "INTELLIGENT_TIERING",
        "GLACIER_IR",
    ],
    LogsComputeType: ["timeseries", "total"],
    LogsMetricComputeAggregationType: ["count", "distribution"],
    LogsMetricResponseComputeAggregationType: ["count", "distribution"],
    LogsMetricType: ["logs_metrics"],
    LogsSort: ["timestamp", "-timestamp"],
    LogsSortOrder: ["asc", "desc"],
    LogsStorageTier: ["indexes", "online-archives", "flex"],
    MetricActiveConfigurationType: ["actively_queried_configurations"],
    MetricBulkConfigureTagsType: ["metric_bulk_configure_tags"],
    MetricContentEncoding: ["deflate", "zstd1", "gzip"],
    MetricCustomSpaceAggregation: ["avg", "max", "min", "sum"],
    MetricCustomTimeAggregation: ["avg", "count", "max", "min", "sum"],
    MetricDashboardType: ["dashboards"],
    MetricDistinctVolumeType: ["distinct_metric_volumes"],
    MetricEstimateResourceType: ["metric_cardinality_estimate"],
    MetricEstimateType: ["count_or_gauge", "distribution", "percentile"],
    MetricIngestedIndexedVolumeType: ["metric_volumes"],
    MetricIntakeType: [0, 1, 2, 3],
    MetricMetaPageType: ["cursor_limit"],
    MetricMonitorType: ["monitors"],
    MetricNotebookType: ["notebooks"],
    MetricSLOType: ["slos"],
    MetricTagConfigurationMetricTypeCategory: [
        "non_distribution",
        "distribution",
    ],
    MetricTagConfigurationMetricTypes: ["gauge", "count", "rate", "distribution"],
    MetricTagConfigurationType: ["manage_tags"],
    MetricType: ["metrics"],
    MetricsAggregator: [
        "avg",
        "min",
        "max",
        "sum",
        "last",
        "percentile",
        "mean",
        "l2norm",
        "area",
    ],
    MetricsDataSource: ["metrics", "cloud_cost"],
    MicrosoftSentinelDestinationType: ["microsoft_sentinel"],
    MicrosoftTeamsChannelInfoType: ["ms-teams-channel-info"],
    MicrosoftTeamsTenantBasedHandleInfoType: [
        "ms-teams-tenant-based-handle-info",
    ],
    MicrosoftTeamsTenantBasedHandleType: ["tenant-based-handle"],
    MicrosoftTeamsWorkflowsWebhookHandleType: ["workflows-webhook-handle"],
    MonitorConfigPolicyResourceType: ["monitor-config-policy"],
    MonitorConfigPolicyType: ["tag"],
    MonitorDowntimeMatchResourceType: ["downtime_match"],
    MonitorNotificationRuleResourceType: ["monitor-notification-rule"],
    NotificationRulesType: ["notification_rules"],
    ObservabilityPipelineAddEnvVarsProcessorType: ["add_env_vars"],
    ObservabilityPipelineAddFieldsProcessorType: ["add_fields"],
    ObservabilityPipelineAmazonDataFirehoseSourceType: ["amazon_data_firehose"],
    ObservabilityPipelineAmazonOpenSearchDestinationAuthStrategy: [
        "basic",
        "aws",
    ],
    ObservabilityPipelineAmazonOpenSearchDestinationType: ["amazon_opensearch"],
    ObservabilityPipelineAmazonS3DestinationStorageClass: [
        "STANDARD",
        "REDUCED_REDUNDANCY",
        "INTELLIGENT_TIERING",
        "STANDARD_IA",
        "EXPRESS_ONEZONE",
        "ONEZONE_IA",
        "GLACIER",
        "GLACIER_IR",
        "DEEP_ARCHIVE",
    ],
    ObservabilityPipelineAmazonS3DestinationType: ["amazon_s3"],
    ObservabilityPipelineAmazonS3SourceType: ["amazon_s3"],
    ObservabilityPipelineDatadogAgentSourceType: ["datadog_agent"],
    ObservabilityPipelineDatadogLogsDestinationType: ["datadog_logs"],
    ObservabilityPipelineDecoding: ["bytes", "gelf", "json", "syslog"],
    ObservabilityPipelineDedupeProcessorMode: ["match", "ignore"],
    ObservabilityPipelineDedupeProcessorType: ["dedupe"],
    ObservabilityPipelineElasticsearchDestinationApiVersion: [
        "auto",
        "v6",
        "v7",
        "v8",
    ],
    ObservabilityPipelineElasticsearchDestinationType: ["elasticsearch"],
    ObservabilityPipelineEnrichmentTableFileEncodingType: ["csv"],
    ObservabilityPipelineEnrichmentTableFileKeyItemsComparison: ["equals"],
    ObservabilityPipelineEnrichmentTableFileSchemaItemsType: [
        "string",
        "boolean",
        "integer",
        "float",
        "date",
        "timestamp",
    ],
    ObservabilityPipelineEnrichmentTableProcessorType: ["enrichment_table"],
    ObservabilityPipelineFilterProcessorType: ["filter"],
    ObservabilityPipelineFluentBitSourceType: ["fluent_bit"],
    ObservabilityPipelineFluentdSourceType: ["fluentd"],
    ObservabilityPipelineGenerateMetricsProcessorType: [
        "generate_datadog_metrics",
    ],
    ObservabilityPipelineGeneratedMetricIncrementByFieldStrategy: [
        "increment_by_field",
    ],
    ObservabilityPipelineGeneratedMetricIncrementByOneStrategy: [
        "increment_by_one",
    ],
    ObservabilityPipelineGeneratedMetricMetricType: [
        "count",
        "gauge",
        "distribution",
    ],
    ObservabilityPipelineGoogleChronicleDestinationEncoding: [
        "json",
        "raw_message",
    ],
    ObservabilityPipelineGoogleChronicleDestinationType: ["google_chronicle"],
    ObservabilityPipelineGoogleCloudStorageDestinationAcl: [
        "private",
        "project-private",
        "public-read",
        "authenticated-read",
        "bucket-owner-read",
        "bucket-owner-full-control",
    ],
    ObservabilityPipelineGoogleCloudStorageDestinationStorageClass: [
        "STANDARD",
        "NEARLINE",
        "COLDLINE",
        "ARCHIVE",
    ],
    ObservabilityPipelineGoogleCloudStorageDestinationType: [
        "google_cloud_storage",
    ],
    ObservabilityPipelineGooglePubSubSourceType: ["google_pubsub"],
    ObservabilityPipelineHttpClientSourceAuthStrategy: ["basic", "bearer"],
    ObservabilityPipelineHttpClientSourceType: ["http_client"],
    ObservabilityPipelineHttpServerSourceAuthStrategy: ["none", "plain"],
    ObservabilityPipelineHttpServerSourceType: ["http_server"],
    ObservabilityPipelineKafkaSourceType: ["kafka"],
    ObservabilityPipelineLogstashSourceType: ["logstash"],
    ObservabilityPipelineNewRelicDestinationRegion: ["us", "eu"],
    ObservabilityPipelineNewRelicDestinationType: ["new_relic"],
    ObservabilityPipelineOcsfMapperProcessorType: ["ocsf_mapper"],
    ObservabilityPipelineOcsfMappingLibrary: [
        "CloudTrail Account Change",
        "GCP Cloud Audit CreateBucket",
        "GCP Cloud Audit CreateSink",
        "GCP Cloud Audit SetIamPolicy",
        "GCP Cloud Audit UpdateSink",
        "Github Audit Log API Activity",
        "Google Workspace Admin Audit addPrivilege",
        "Microsoft 365 Defender Incident",
        "Microsoft 365 Defender UserLoggedIn",
        "Okta System Log Authentication",
        "Palo Alto Networks Firewall Traffic",
    ],
    ObservabilityPipelineOpenSearchDestinationType: ["opensearch"],
    ObservabilityPipelineParseGrokProcessorType: ["parse_grok"],
    ObservabilityPipelineParseJSONProcessorType: ["parse_json"],
    ObservabilityPipelinePipelineKafkaSourceSaslMechanism: [
        "PLAIN",
        "SCRAM-SHA-256",
        "SCRAM-SHA-512",
    ],
    ObservabilityPipelineQuotaProcessorLimitEnforceType: ["bytes", "events"],
    ObservabilityPipelineQuotaProcessorOverflowAction: [
        "drop",
        "no_action",
        "overflow_routing",
    ],
    ObservabilityPipelineQuotaProcessorType: ["quota"],
    ObservabilityPipelineReduceProcessorMergeStrategyStrategy: [
        "discard",
        "retain",
        "sum",
        "max",
        "min",
        "array",
        "concat",
        "concat_newline",
        "concat_raw",
        "shortest_array",
        "longest_array",
        "flat_unique",
    ],
    ObservabilityPipelineReduceProcessorType: ["reduce"],
    ObservabilityPipelineRemoveFieldsProcessorType: ["remove_fields"],
    ObservabilityPipelineRenameFieldsProcessorType: ["rename_fields"],
    ObservabilityPipelineRsyslogDestinationType: ["rsyslog"],
    ObservabilityPipelineRsyslogSourceType: ["rsyslog"],
    ObservabilityPipelineSampleProcessorType: ["sample"],
    ObservabilityPipelineSensitiveDataScannerProcessorActionHashAction: ["hash"],
    ObservabilityPipelineSensitiveDataScannerProcessorActionPartialRedactAction: [
        "partial_redact",
    ],
    ObservabilityPipelineSensitiveDataScannerProcessorActionPartialRedactOptionsDirection: ["first", "last"],
    ObservabilityPipelineSensitiveDataScannerProcessorActionRedactAction: [
        "redact",
    ],
    ObservabilityPipelineSensitiveDataScannerProcessorCustomPatternType: [
        "custom",
    ],
    ObservabilityPipelineSensitiveDataScannerProcessorLibraryPatternType: [
        "library",
    ],
    ObservabilityPipelineSensitiveDataScannerProcessorScopeAllTarget: ["all"],
    ObservabilityPipelineSensitiveDataScannerProcessorScopeExcludeTarget: [
        "exclude",
    ],
    ObservabilityPipelineSensitiveDataScannerProcessorScopeIncludeTarget: [
        "include",
    ],
    ObservabilityPipelineSensitiveDataScannerProcessorType: [
        "sensitive_data_scanner",
    ],
    ObservabilityPipelineSentinelOneDestinationRegion: [
        "us",
        "eu",
        "ca",
        "data_set_us",
    ],
    ObservabilityPipelineSentinelOneDestinationType: ["sentinel_one"],
    ObservabilityPipelineSplunkHecDestinationEncoding: ["json", "raw_message"],
    ObservabilityPipelineSplunkHecDestinationType: ["splunk_hec"],
    ObservabilityPipelineSplunkHecSourceType: ["splunk_hec"],
    ObservabilityPipelineSplunkTcpSourceType: ["splunk_tcp"],
    ObservabilityPipelineSumoLogicDestinationEncoding: [
        "json",
        "raw_message",
        "logfmt",
    ],
    ObservabilityPipelineSumoLogicDestinationType: ["sumo_logic"],
    ObservabilityPipelineSumoLogicSourceType: ["sumo_logic"],
    ObservabilityPipelineSyslogNgDestinationType: ["syslog_ng"],
    ObservabilityPipelineSyslogNgSourceType: ["syslog_ng"],
    ObservabilityPipelineSyslogSourceMode: ["tcp", "udp"],
    ObservabilityPipelineThrottleProcessorType: ["throttle"],
    OktaAccountType: ["okta-accounts"],
    OnCallPageTargetType: ["team_id", "team_handle", "user_id"],
    OnDemandConcurrencyCapType: ["on_demand_concurrency_cap"],
    OpsgenieServiceRegionType: ["us", "eu", "custom"],
    OpsgenieServiceType: ["opsgenie-service"],
    OrderDirection: ["asc", "desc"],
    OrgConfigType: ["org_configs"],
    OrganizationsType: ["orgs"],
    OutcomeType: ["outcome"],
    OutcomesBatchType: ["batched-outcome"],
    OutputSchemaParametersType: [
        "STRING",
        "NUMBER",
        "BOOLEAN",
        "OBJECT",
        "ARRAY_STRING",
        "ARRAY_NUMBER",
        "ARRAY_BOOLEAN",
        "ARRAY_OBJECT",
    ],
    PageUrgency: ["low", "high"],
    PermissionsType: ["permissions"],
    ProcessSummaryType: ["process"],
    ProjectResourceType: ["project"],
    ProjectedCostType: ["projected_cost"],
    QuerySortOrder: ["asc", "desc"],
    RUMAggregateSortType: ["alphabetical", "measure"],
    RUMAggregationFunction: [
        "count",
        "cardinality",
        "pc75",
        "pc90",
        "pc95",
        "pc98",
        "pc99",
        "sum",
        "min",
        "max",
        "avg",
        "median",
    ],
    RUMApplicationCreateType: ["rum_application_create"],
    RUMApplicationListType: ["rum_application"],
    RUMApplicationType: ["rum_application"],
    RUMApplicationUpdateType: ["rum_application_update"],
    RUMComputeType: ["timeseries", "total"],
    RUMEventType: ["rum"],
    RUMResponseStatus: ["done", "timeout"],
    RUMSort: ["timestamp", "-timestamp"],
    RUMSortOrder: ["asc", "desc"],
    ReadinessGateThresholdType: ["ANY", "ALL"],
    RelationIncludeType: ["entity", "schema"],
    RelationResponseType: ["relation"],
    RelationType: [
        "RelationTypeOwns",
        "RelationTypeOwnedBy",
        "RelationTypeDependsOn",
        "RelationTypeDependencyOf",
        "RelationTypePartsOf",
        "RelationTypeHasPart",
        "RelationTypeOtherOwns",
        "RelationTypeOtherOwnedBy",
        "RelationTypeImplementedBy",
        "RelationTypeImplements",
    ],
    ResourceFilterRequestType: ["csm_resource_filter"],
    RestrictionPolicyType: ["restriction_policy"],
    RetentionFilterAllType: [
        "spans-sampling-processor",
        "spans-errors-sampling-processor",
        "spans-appsec-sampling-processor",
    ],
    RetentionFilterType: ["spans-sampling-processor"],
    RetryStrategyKind: ["RETRY_STRATEGY_LINEAR"],
    RolesSort: [
        "name",
        "-name",
        "modified_at",
        "-modified_at",
        "user_count",
        "-user_count",
    ],
    RolesType: ["roles"],
    RoutingRuleRelationshipsPolicyDataType: ["policies"],
    RoutingRuleType: ["team_routing_rules"],
    RuleSeverity: ["critical", "high", "medium", "low", "unknown", "info"],
    RuleType: ["rule"],
    RuleTypesItems: [
        "application_security",
        "log_detection",
        "workload_security",
        "signal_correlation",
        "cloud_configuration",
        "infrastructure_configuration",
        "application_code_vulnerability",
        "application_library_vulnerability",
        "attack_path",
        "container_image_vulnerability",
        "identity_risk",
        "misconfiguration",
        "api_security",
    ],
    RuleVersionUpdateType: ["create", "update", "delete"],
    RumMetricComputeAggregationType: ["count", "distribution"],
    RumMetricEventType: [
        "session",
        "view",
        "action",
        "error",
        "resource",
        "long_task",
        "vital",
    ],
    RumMetricType: ["rum_metrics"],
    RumMetricUniquenessWhen: ["match", "end"],
    RumRetentionFilterEventType: [
        "session",
        "view",
        "action",
        "error",
        "resource",
        "long_task",
        "vital",
    ],
    RumRetentionFilterType: ["retention_filters"],
    RunHistoricalJobRequestDataType: ["historicalDetectionsJobCreate"],
    SAMLAssertionAttributesType: ["saml_assertion_attributes"],
    SBOMComponentType: [
        "application",
        "container",
        "data",
        "device",
        "device-driver",
        "file",
        "firmware",
        "framework",
        "library",
        "machine-learning-model",
        "operating-system",
        "platform",
    ],
    SBOMType: ["sboms"],
    SLOReportInterval: ["daily", "weekly", "monthly"],
    SLOReportStatus: [
        "in_progress",
        "completed",
        "completed_with_errors",
        "failed",
    ],
    ScalarColumnTypeGroup: ["group"],
    ScalarColumnTypeNumber: ["number"],
    ScalarFormulaRequestType: ["scalar_request"],
    ScalarFormulaResponseType: ["scalar_response"],
    ScheduleCreateRequestDataType: ["schedules"],
    ScheduleDataRelationshipsLayersDataItemsType: ["layers"],
    ScheduleDataType: ["schedules"],
    ScheduleMemberRelationshipsUserDataType: ["users"],
    ScheduleMemberType: ["members"],
    ScheduleTargetType: ["schedules"],
    ScheduleUpdateRequestDataType: ["schedules"],
    ScheduleUserType: ["users"],
    ScorecardType: ["scorecard"],
    SecurityFilterFilteredDataType: ["logs"],
    SecurityFilterType: ["security_filters"],
    SecurityMonitoringFilterAction: ["require", "suppress"],
    SecurityMonitoringRuleCaseActionType: [
        "block_ip",
        "block_user",
        "user_behavior",
    ],
    SecurityMonitoringRuleDetectionMethod: [
        "threshold",
        "new_value",
        "anomaly_detection",
        "impossible_travel",
        "hardcoded",
        "third_party",
        "anomaly_threshold",
    ],
    SecurityMonitoringRuleEvaluationWindow: [
        0, 60, 300, 600, 900, 1800, 3600, 7200, 10800, 21600, 43200, 86400,
    ],
    SecurityMonitoringRuleHardcodedEvaluatorType: ["log4shell"],
    SecurityMonitoringRuleKeepAlive: [
        0, 60, 300, 600, 900, 1800, 3600, 7200, 10800, 21600, 43200, 86400,
    ],
    SecurityMonitoringRuleMaxSignalDuration: [
        0, 60, 300, 600, 900, 1800, 3600, 7200, 10800, 21600, 43200, 86400,
    ],
    SecurityMonitoringRuleNewValueOptionsForgetAfter: [1, 2, 7, 14, 21, 28],
    SecurityMonitoringRuleNewValueOptionsLearningDuration: [0, 1, 7],
    SecurityMonitoringRuleNewValueOptionsLearningMethod: [
        "duration",
        "threshold",
    ],
    SecurityMonitoringRuleNewValueOptionsLearningThreshold: [0, 1],
    SecurityMonitoringRuleQueryAggregation: [
        "count",
        "cardinality",
        "sum",
        "max",
        "new_value",
        "geo_data",
        "event_count",
        "none",
    ],
    SecurityMonitoringRuleSeverity: ["info", "low", "medium", "high", "critical"],
    SecurityMonitoringRuleTypeCreate: [
        "application_security",
        "log_detection",
        "workload_security",
    ],
    SecurityMonitoringRuleTypeRead: [
        "log_detection",
        "infrastructure_configuration",
        "workload_security",
        "cloud_configuration",
        "application_security",
    ],
    SecurityMonitoringRuleTypeTest: ["log_detection"],
    SecurityMonitoringSignalArchiveReason: [
        "none",
        "false_positive",
        "testing_or_maintenance",
        "investigated_case_opened",
        "other",
    ],
    SecurityMonitoringSignalMetadataType: ["signal_metadata"],
    SecurityMonitoringSignalRuleType: ["signal_correlation"],
    SecurityMonitoringSignalState: ["open", "archived", "under_review"],
    SecurityMonitoringSignalType: ["signal"],
    SecurityMonitoringSignalsSort: ["timestamp", "-timestamp"],
    SecurityMonitoringStandardDataSource: [
        "logs",
        "audit",
        "app_sec_spans",
        "spans",
        "security_runtime",
        "network",
        "events",
    ],
    SecurityMonitoringSuppressionType: ["suppressions"],
    SendSlackMessageActionType: ["send_slack_message"],
    SendTeamsMessageActionType: ["send_teams_message"],
    SensitiveDataScannerConfigurationType: [
        "sensitive_data_scanner_configuration",
    ],
    SensitiveDataScannerGroupType: ["sensitive_data_scanner_group"],
    SensitiveDataScannerProduct: ["logs", "rum", "events", "apm"],
    SensitiveDataScannerRuleType: ["sensitive_data_scanner_rule"],
    SensitiveDataScannerStandardPatternType: [
        "sensitive_data_scanner_standard_pattern",
    ],
    SensitiveDataScannerTextReplacementType: [
        "none",
        "hash",
        "replacement_string",
        "partial_replacement_from_beginning",
        "partial_replacement_from_end",
    ],
    ServiceDefinitionSchemaVersions: ["v1", "v2", "v2.1", "v2.2"],
    ServiceDefinitionV1ResourceType: [
        "doc",
        "wiki",
        "runbook",
        "url",
        "repo",
        "dashboard",
        "oncall",
        "code",
        "link",
    ],
    ServiceDefinitionV1Version: ["v1"],
    ServiceDefinitionV2Dot1EmailType: ["email"],
    ServiceDefinitionV2Dot1LinkType: [
        "doc",
        "repo",
        "runbook",
        "dashboard",
        "other",
    ],
    ServiceDefinitionV2Dot1MSTeamsType: ["microsoft-teams"],
    ServiceDefinitionV2Dot1OpsgenieRegion: ["US", "EU"],
    ServiceDefinitionV2Dot1SlackType: ["slack"],
    ServiceDefinitionV2Dot1Version: ["v2.1"],
    ServiceDefinitionV2Dot2OpsgenieRegion: ["US", "EU"],
    ServiceDefinitionV2Dot2Version: ["v2.2"],
    ServiceDefinitionV2EmailType: ["email"],
    ServiceDefinitionV2LinkType: [
        "doc",
        "wiki",
        "runbook",
        "url",
        "repo",
        "dashboard",
        "oncall",
        "code",
        "link",
    ],
    ServiceDefinitionV2MSTeamsType: ["microsoft-teams"],
    ServiceDefinitionV2OpsgenieRegion: ["US", "EU"],
    ServiceDefinitionV2SlackType: ["slack"],
    ServiceDefinitionV2Version: ["v2"],
    ShiftDataRelationshipsUserDataType: ["users"],
    ShiftDataType: ["shifts"],
    SingleAggregatedConnectionResponseDataType: ["aggregated_connection"],
    SortDirection: ["desc", "asc"],
    SpansAggregateBucketType: ["bucket"],
    SpansAggregateRequestType: ["aggregate_request"],
    SpansAggregateResponseStatus: ["done", "timeout"],
    SpansAggregateSortType: ["alphabetical", "measure"],
    SpansAggregationFunction: [
        "count",
        "cardinality",
        "pc75",
        "pc90",
        "pc95",
        "pc98",
        "pc99",
        "sum",
        "min",
        "max",
        "avg",
        "median",
    ],
    SpansComputeType: ["timeseries", "total"],
    SpansListRequestType: ["search_request"],
    SpansMetricComputeAggregationType: ["count", "distribution"],
    SpansMetricType: ["spans_metrics"],
    SpansSort: ["timestamp", "-timestamp"],
    SpansSortOrder: ["asc", "desc"],
    SpansType: ["spans"],
    SpecVersion: ["1.0", "1.1", "1.2", "1.3", "1.4", "1.5"],
    State: ["pass", "fail", "skip"],
    StateVariableType: ["stateVariable"],
    TeamLinkType: ["team_links"],
    TeamPermissionSettingSerializerAction: ["manage_membership", "edit"],
    TeamPermissionSettingType: ["team_permission_settings"],
    TeamPermissionSettingValue: [
        "admins",
        "members",
        "organization",
        "user_access_manage",
        "teams_manage",
    ],
    TeamReferenceType: ["teams"],
    TeamRoutingRulesDataRelationshipsRulesDataItemsType: ["team_routing_rules"],
    TeamRoutingRulesDataType: ["team_routing_rules"],
    TeamRoutingRulesRequestDataType: ["team_routing_rules"],
    TeamTargetType: ["teams"],
    TeamType: ["team"],
    TeamsField: [
        "id",
        "name",
        "handle",
        "summary",
        "description",
        "avatar",
        "banner",
        "visible_modules",
        "hidden_modules",
        "created_at",
        "modified_at",
        "user_count",
        "link_count",
        "team_links",
        "user_team_permissions",
    ],
    TimeseriesFormulaRequestType: ["timeseries_request"],
    TimeseriesFormulaResponseType: ["timeseries_response"],
    TokenType: ["SECRET"],
    TriggerSource: ["security_findings", "security_signals"],
    Urgency: ["low", "high", "dynamic"],
    UsageTimeSeriesType: ["usage_timeseries"],
    UserAttributesStatus: ["active", "deactivated", "pending"],
    UserInvitationsType: ["user_invitations"],
    UserResourceType: ["user"],
    UserTargetType: ["users"],
    UserTeamPermissionType: ["user_team_permissions"],
    UserTeamRole: ["admin"],
    UserTeamTeamType: ["team"],
    UserTeamType: ["team_memberships"],
    UserTeamUserType: ["users"],
    UsersType: ["users"],
    VulnerabilitiesType: ["vulnerabilities"],
    VulnerabilityEcosystem: [
        "PyPI",
        "Maven",
        "NuGet",
        "Npm",
        "RubyGems",
        "Go",
        "Packagist",
        "Ddeb",
        "Rpm",
        "Apk",
        "Windows",
    ],
    VulnerabilitySeverity: [
        "Unknown",
        "None",
        "Low",
        "Medium",
        "High",
        "Critical",
    ],
    VulnerabilityStatus: [
        "Open",
        "Muted",
        "Remediated",
        "InProgress",
        "AutoClosed",
    ],
    VulnerabilityTool: ["IAST", "SCA", "Infra"],
    VulnerabilityType: [
        "AdminConsoleActive",
        "CodeInjection",
        "CommandInjection",
        "ComponentWithKnownVulnerability",
        "DangerousWorkflows",
        "DefaultAppDeployed",
        "DefaultHtmlEscapeInvalid",
        "DirectoryListingLeak",
        "EmailHtmlInjection",
        "EndOfLife",
        "HardcodedPassword",
        "HardcodedSecret",
        "HeaderInjection",
        "HstsHeaderMissing",
        "InsecureAuthProtocol",
        "InsecureCookie",
        "InsecureJspLayout",
        "LdapInjection",
        "MaliciousPackage",
        "MandatoryRemediation",
        "NoHttpOnlyCookie",
        "NoSameSiteCookie",
        "NoSqlMongoDbInjection",
        "PathTraversal",
        "ReflectionInjection",
        "RiskyLicense",
        "SessionRewriting",
        "SessionTimeout",
        "SqlInjection",
        "Ssrf",
        "StackTraceLeak",
        "TrustBoundaryViolation",
        "Unmaintained",
        "UntrustedDeserialization",
        "UnvalidatedRedirect",
        "VerbTampering",
        "WeakCipher",
        "WeakHash",
        "WeakRandomness",
        "XContentTypeHeaderMissing",
        "XPathInjection",
        "Xss",
    ],
    Weekday: [
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
        "sunday",
    ],
    WidgetLiveSpan: [
        "1m",
        "5m",
        "10m",
        "15m",
        "30m",
        "1h",
        "4h",
        "1d",
        "2d",
        "1w",
        "1mo",
        "3mo",
        "6mo",
        "1y",
        "alert",
    ],
    WorkflowDataType: ["workflows"],
    WorkflowUserRelationshipType: ["users"],
};
const typeMap = {
    APIErrorResponse: APIErrorResponse_1.APIErrorResponse,
    APIKeyCreateAttributes: APIKeyCreateAttributes_1.APIKeyCreateAttributes,
    APIKeyCreateData: APIKeyCreateData_1.APIKeyCreateData,
    APIKeyCreateRequest: APIKeyCreateRequest_1.APIKeyCreateRequest,
    APIKeyRelationships: APIKeyRelationships_1.APIKeyRelationships,
    APIKeyResponse: APIKeyResponse_1.APIKeyResponse,
    APIKeyUpdateAttributes: APIKeyUpdateAttributes_1.APIKeyUpdateAttributes,
    APIKeyUpdateData: APIKeyUpdateData_1.APIKeyUpdateData,
    APIKeyUpdateRequest: APIKeyUpdateRequest_1.APIKeyUpdateRequest,
    APIKeysResponse: APIKeysResponse_1.APIKeysResponse,
    APIKeysResponseMeta: APIKeysResponseMeta_1.APIKeysResponseMeta,
    APIKeysResponseMetaPage: APIKeysResponseMetaPage_1.APIKeysResponseMetaPage,
    APITrigger: APITrigger_1.APITrigger,
    APITriggerWrapper: APITriggerWrapper_1.APITriggerWrapper,
    AWSAccountCreateRequest: AWSAccountCreateRequest_1.AWSAccountCreateRequest,
    AWSAccountCreateRequestAttributes: AWSAccountCreateRequestAttributes_1.AWSAccountCreateRequestAttributes,
    AWSAccountCreateRequestData: AWSAccountCreateRequestData_1.AWSAccountCreateRequestData,
    AWSAccountResponse: AWSAccountResponse_1.AWSAccountResponse,
    AWSAccountResponseAttributes: AWSAccountResponseAttributes_1.AWSAccountResponseAttributes,
    AWSAccountResponseData: AWSAccountResponseData_1.AWSAccountResponseData,
    AWSAccountUpdateRequest: AWSAccountUpdateRequest_1.AWSAccountUpdateRequest,
    AWSAccountUpdateRequestAttributes: AWSAccountUpdateRequestAttributes_1.AWSAccountUpdateRequestAttributes,
    AWSAccountUpdateRequestData: AWSAccountUpdateRequestData_1.AWSAccountUpdateRequestData,
    AWSAccountsResponse: AWSAccountsResponse_1.AWSAccountsResponse,
    AWSAssumeRole: AWSAssumeRole_1.AWSAssumeRole,
    AWSAssumeRoleUpdate: AWSAssumeRoleUpdate_1.AWSAssumeRoleUpdate,
    AWSAuthConfigKeys: AWSAuthConfigKeys_1.AWSAuthConfigKeys,
    AWSAuthConfigRole: AWSAuthConfigRole_1.AWSAuthConfigRole,
    AWSIntegration: AWSIntegration_1.AWSIntegration,
    AWSIntegrationUpdate: AWSIntegrationUpdate_1.AWSIntegrationUpdate,
    AWSLambdaForwarderConfig: AWSLambdaForwarderConfig_1.AWSLambdaForwarderConfig,
    AWSLogsConfig: AWSLogsConfig_1.AWSLogsConfig,
    AWSLogsServicesResponse: AWSLogsServicesResponse_1.AWSLogsServicesResponse,
    AWSLogsServicesResponseAttributes: AWSLogsServicesResponseAttributes_1.AWSLogsServicesResponseAttributes,
    AWSLogsServicesResponseData: AWSLogsServicesResponseData_1.AWSLogsServicesResponseData,
    AWSMetricsConfig: AWSMetricsConfig_1.AWSMetricsConfig,
    AWSNamespaceFiltersExcludeOnly: AWSNamespaceFiltersExcludeOnly_1.AWSNamespaceFiltersExcludeOnly,
    AWSNamespaceFiltersIncludeOnly: AWSNamespaceFiltersIncludeOnly_1.AWSNamespaceFiltersIncludeOnly,
    AWSNamespaceTagFilter: AWSNamespaceTagFilter_1.AWSNamespaceTagFilter,
    AWSNamespacesResponse: AWSNamespacesResponse_1.AWSNamespacesResponse,
    AWSNamespacesResponseAttributes: AWSNamespacesResponseAttributes_1.AWSNamespacesResponseAttributes,
    AWSNamespacesResponseData: AWSNamespacesResponseData_1.AWSNamespacesResponseData,
    AWSNewExternalIDResponse: AWSNewExternalIDResponse_1.AWSNewExternalIDResponse,
    AWSNewExternalIDResponseAttributes: AWSNewExternalIDResponseAttributes_1.AWSNewExternalIDResponseAttributes,
    AWSNewExternalIDResponseData: AWSNewExternalIDResponseData_1.AWSNewExternalIDResponseData,
    AWSRegionsIncludeAll: AWSRegionsIncludeAll_1.AWSRegionsIncludeAll,
    AWSRegionsIncludeOnly: AWSRegionsIncludeOnly_1.AWSRegionsIncludeOnly,
    AWSResourcesConfig: AWSResourcesConfig_1.AWSResourcesConfig,
    AWSTracesConfig: AWSTracesConfig_1.AWSTracesConfig,
    AccountFilteringConfig: AccountFilteringConfig_1.AccountFilteringConfig,
    ActionConnectionAttributes: ActionConnectionAttributes_1.ActionConnectionAttributes,
    ActionConnectionAttributesUpdate: ActionConnectionAttributesUpdate_1.ActionConnectionAttributesUpdate,
    ActionConnectionData: ActionConnectionData_1.ActionConnectionData,
    ActionConnectionDataUpdate: ActionConnectionDataUpdate_1.ActionConnectionDataUpdate,
    ActionQuery: ActionQuery_1.ActionQuery,
    ActionQueryMockedOutputsObject: ActionQueryMockedOutputsObject_1.ActionQueryMockedOutputsObject,
    ActionQueryProperties: ActionQueryProperties_1.ActionQueryProperties,
    ActionQuerySpecConnectionGroup: ActionQuerySpecConnectionGroup_1.ActionQuerySpecConnectionGroup,
    ActionQuerySpecObject: ActionQuerySpecObject_1.ActionQuerySpecObject,
    ActiveBillingDimensionsAttributes: ActiveBillingDimensionsAttributes_1.ActiveBillingDimensionsAttributes,
    ActiveBillingDimensionsBody: ActiveBillingDimensionsBody_1.ActiveBillingDimensionsBody,
    ActiveBillingDimensionsResponse: ActiveBillingDimensionsResponse_1.ActiveBillingDimensionsResponse,
    Advisory: Advisory_1.Advisory,
    Annotation: Annotation_1.Annotation,
    AnnotationDisplay: AnnotationDisplay_1.AnnotationDisplay,
    AnnotationDisplayBounds: AnnotationDisplayBounds_1.AnnotationDisplayBounds,
    AnnotationMarkdownTextAnnotation: AnnotationMarkdownTextAnnotation_1.AnnotationMarkdownTextAnnotation,
    AppBuilderEvent: AppBuilderEvent_1.AppBuilderEvent,
    AppMeta: AppMeta_1.AppMeta,
    AppRelationship: AppRelationship_1.AppRelationship,
    AppTriggerWrapper: AppTriggerWrapper_1.AppTriggerWrapper,
    ApplicationKeyCreateAttributes: ApplicationKeyCreateAttributes_1.ApplicationKeyCreateAttributes,
    ApplicationKeyCreateData: ApplicationKeyCreateData_1.ApplicationKeyCreateData,
    ApplicationKeyCreateRequest: ApplicationKeyCreateRequest_1.ApplicationKeyCreateRequest,
    ApplicationKeyRelationships: ApplicationKeyRelationships_1.ApplicationKeyRelationships,
    ApplicationKeyResponse: ApplicationKeyResponse_1.ApplicationKeyResponse,
    ApplicationKeyResponseMeta: ApplicationKeyResponseMeta_1.ApplicationKeyResponseMeta,
    ApplicationKeyResponseMetaPage: ApplicationKeyResponseMetaPage_1.ApplicationKeyResponseMetaPage,
    ApplicationKeyUpdateAttributes: ApplicationKeyUpdateAttributes_1.ApplicationKeyUpdateAttributes,
    ApplicationKeyUpdateData: ApplicationKeyUpdateData_1.ApplicationKeyUpdateData,
    ApplicationKeyUpdateRequest: ApplicationKeyUpdateRequest_1.ApplicationKeyUpdateRequest,
    ApplicationSecurityWafCustomRuleAction: ApplicationSecurityWafCustomRuleAction_1.ApplicationSecurityWafCustomRuleAction,
    ApplicationSecurityWafCustomRuleActionParameters: ApplicationSecurityWafCustomRuleActionParameters_1.ApplicationSecurityWafCustomRuleActionParameters,
    ApplicationSecurityWafCustomRuleAttributes: ApplicationSecurityWafCustomRuleAttributes_1.ApplicationSecurityWafCustomRuleAttributes,
    ApplicationSecurityWafCustomRuleCondition: ApplicationSecurityWafCustomRuleCondition_1.ApplicationSecurityWafCustomRuleCondition,
    ApplicationSecurityWafCustomRuleConditionInput: ApplicationSecurityWafCustomRuleConditionInput_1.ApplicationSecurityWafCustomRuleConditionInput,
    ApplicationSecurityWafCustomRuleConditionOptions: ApplicationSecurityWafCustomRuleConditionOptions_1.ApplicationSecurityWafCustomRuleConditionOptions,
    ApplicationSecurityWafCustomRuleConditionParameters: ApplicationSecurityWafCustomRuleConditionParameters_1.ApplicationSecurityWafCustomRuleConditionParameters,
    ApplicationSecurityWafCustomRuleCreateAttributes: ApplicationSecurityWafCustomRuleCreateAttributes_1.ApplicationSecurityWafCustomRuleCreateAttributes,
    ApplicationSecurityWafCustomRuleCreateData: ApplicationSecurityWafCustomRuleCreateData_1.ApplicationSecurityWafCustomRuleCreateData,
    ApplicationSecurityWafCustomRuleCreateRequest: ApplicationSecurityWafCustomRuleCreateRequest_1.ApplicationSecurityWafCustomRuleCreateRequest,
    ApplicationSecurityWafCustomRuleData: ApplicationSecurityWafCustomRuleData_1.ApplicationSecurityWafCustomRuleData,
    ApplicationSecurityWafCustomRuleListResponse: ApplicationSecurityWafCustomRuleListResponse_1.ApplicationSecurityWafCustomRuleListResponse,
    ApplicationSecurityWafCustomRuleMetadata: ApplicationSecurityWafCustomRuleMetadata_1.ApplicationSecurityWafCustomRuleMetadata,
    ApplicationSecurityWafCustomRuleResponse: ApplicationSecurityWafCustomRuleResponse_1.ApplicationSecurityWafCustomRuleResponse,
    ApplicationSecurityWafCustomRuleScope: ApplicationSecurityWafCustomRuleScope_1.ApplicationSecurityWafCustomRuleScope,
    ApplicationSecurityWafCustomRuleTags: ApplicationSecurityWafCustomRuleTags_1.ApplicationSecurityWafCustomRuleTags,
    ApplicationSecurityWafCustomRuleUpdateAttributes: ApplicationSecurityWafCustomRuleUpdateAttributes_1.ApplicationSecurityWafCustomRuleUpdateAttributes,
    ApplicationSecurityWafCustomRuleUpdateData: ApplicationSecurityWafCustomRuleUpdateData_1.ApplicationSecurityWafCustomRuleUpdateData,
    ApplicationSecurityWafCustomRuleUpdateRequest: ApplicationSecurityWafCustomRuleUpdateRequest_1.ApplicationSecurityWafCustomRuleUpdateRequest,
    ApplicationSecurityWafExclusionFilterAttributes: ApplicationSecurityWafExclusionFilterAttributes_1.ApplicationSecurityWafExclusionFilterAttributes,
    ApplicationSecurityWafExclusionFilterCreateAttributes: ApplicationSecurityWafExclusionFilterCreateAttributes_1.ApplicationSecurityWafExclusionFilterCreateAttributes,
    ApplicationSecurityWafExclusionFilterCreateData: ApplicationSecurityWafExclusionFilterCreateData_1.ApplicationSecurityWafExclusionFilterCreateData,
    ApplicationSecurityWafExclusionFilterCreateRequest: ApplicationSecurityWafExclusionFilterCreateRequest_1.ApplicationSecurityWafExclusionFilterCreateRequest,
    ApplicationSecurityWafExclusionFilterMetadata: ApplicationSecurityWafExclusionFilterMetadata_1.ApplicationSecurityWafExclusionFilterMetadata,
    ApplicationSecurityWafExclusionFilterResource: ApplicationSecurityWafExclusionFilterResource_1.ApplicationSecurityWafExclusionFilterResource,
    ApplicationSecurityWafExclusionFilterResponse: ApplicationSecurityWafExclusionFilterResponse_1.ApplicationSecurityWafExclusionFilterResponse,
    ApplicationSecurityWafExclusionFilterRulesTarget: ApplicationSecurityWafExclusionFilterRulesTarget_1.ApplicationSecurityWafExclusionFilterRulesTarget,
    ApplicationSecurityWafExclusionFilterRulesTargetTags: ApplicationSecurityWafExclusionFilterRulesTargetTags_1.ApplicationSecurityWafExclusionFilterRulesTargetTags,
    ApplicationSecurityWafExclusionFilterScope: ApplicationSecurityWafExclusionFilterScope_1.ApplicationSecurityWafExclusionFilterScope,
    ApplicationSecurityWafExclusionFilterUpdateAttributes: ApplicationSecurityWafExclusionFilterUpdateAttributes_1.ApplicationSecurityWafExclusionFilterUpdateAttributes,
    ApplicationSecurityWafExclusionFilterUpdateData: ApplicationSecurityWafExclusionFilterUpdateData_1.ApplicationSecurityWafExclusionFilterUpdateData,
    ApplicationSecurityWafExclusionFilterUpdateRequest: ApplicationSecurityWafExclusionFilterUpdateRequest_1.ApplicationSecurityWafExclusionFilterUpdateRequest,
    ApplicationSecurityWafExclusionFiltersResponse: ApplicationSecurityWafExclusionFiltersResponse_1.ApplicationSecurityWafExclusionFiltersResponse,
    Asset: Asset_1.Asset,
    AssetAttributes: AssetAttributes_1.AssetAttributes,
    AssetOperatingSystem: AssetOperatingSystem_1.AssetOperatingSystem,
    AssetRisks: AssetRisks_1.AssetRisks,
    AssetVersion: AssetVersion_1.AssetVersion,
    AuditLogsEvent: AuditLogsEvent_1.AuditLogsEvent,
    AuditLogsEventAttributes: AuditLogsEventAttributes_1.AuditLogsEventAttributes,
    AuditLogsEventsResponse: AuditLogsEventsResponse_1.AuditLogsEventsResponse,
    AuditLogsQueryFilter: AuditLogsQueryFilter_1.AuditLogsQueryFilter,
    AuditLogsQueryOptions: AuditLogsQueryOptions_1.AuditLogsQueryOptions,
    AuditLogsQueryPageOptions: AuditLogsQueryPageOptions_1.AuditLogsQueryPageOptions,
    AuditLogsResponseLinks: AuditLogsResponseLinks_1.AuditLogsResponseLinks,
    AuditLogsResponseMetadata: AuditLogsResponseMetadata_1.AuditLogsResponseMetadata,
    AuditLogsResponsePage: AuditLogsResponsePage_1.AuditLogsResponsePage,
    AuditLogsSearchEventsRequest: AuditLogsSearchEventsRequest_1.AuditLogsSearchEventsRequest,
    AuditLogsWarning: AuditLogsWarning_1.AuditLogsWarning,
    AuthNMapping: AuthNMapping_1.AuthNMapping,
    AuthNMappingAttributes: AuthNMappingAttributes_1.AuthNMappingAttributes,
    AuthNMappingCreateAttributes: AuthNMappingCreateAttributes_1.AuthNMappingCreateAttributes,
    AuthNMappingCreateData: AuthNMappingCreateData_1.AuthNMappingCreateData,
    AuthNMappingCreateRequest: AuthNMappingCreateRequest_1.AuthNMappingCreateRequest,
    AuthNMappingRelationshipToRole: AuthNMappingRelationshipToRole_1.AuthNMappingRelationshipToRole,
    AuthNMappingRelationshipToTeam: AuthNMappingRelationshipToTeam_1.AuthNMappingRelationshipToTeam,
    AuthNMappingRelationships: AuthNMappingRelationships_1.AuthNMappingRelationships,
    AuthNMappingResponse: AuthNMappingResponse_1.AuthNMappingResponse,
    AuthNMappingTeam: AuthNMappingTeam_1.AuthNMappingTeam,
    AuthNMappingTeamAttributes: AuthNMappingTeamAttributes_1.AuthNMappingTeamAttributes,
    AuthNMappingUpdateAttributes: AuthNMappingUpdateAttributes_1.AuthNMappingUpdateAttributes,
    AuthNMappingUpdateData: AuthNMappingUpdateData_1.AuthNMappingUpdateData,
    AuthNMappingUpdateRequest: AuthNMappingUpdateRequest_1.AuthNMappingUpdateRequest,
    AuthNMappingsResponse: AuthNMappingsResponse_1.AuthNMappingsResponse,
    AwsCURConfig: AwsCURConfig_1.AwsCURConfig,
    AwsCURConfigAttributes: AwsCURConfigAttributes_1.AwsCURConfigAttributes,
    AwsCURConfigPatchData: AwsCURConfigPatchData_1.AwsCURConfigPatchData,
    AwsCURConfigPatchRequest: AwsCURConfigPatchRequest_1.AwsCURConfigPatchRequest,
    AwsCURConfigPatchRequestAttributes: AwsCURConfigPatchRequestAttributes_1.AwsCURConfigPatchRequestAttributes,
    AwsCURConfigPostData: AwsCURConfigPostData_1.AwsCURConfigPostData,
    AwsCURConfigPostRequest: AwsCURConfigPostRequest_1.AwsCURConfigPostRequest,
    AwsCURConfigPostRequestAttributes: AwsCURConfigPostRequestAttributes_1.AwsCURConfigPostRequestAttributes,
    AwsCURConfigResponse: AwsCURConfigResponse_1.AwsCURConfigResponse,
    AwsCURConfigsResponse: AwsCURConfigsResponse_1.AwsCURConfigsResponse,
    AwsOnDemandAttributes: AwsOnDemandAttributes_1.AwsOnDemandAttributes,
    AwsOnDemandCreateAttributes: AwsOnDemandCreateAttributes_1.AwsOnDemandCreateAttributes,
    AwsOnDemandCreateData: AwsOnDemandCreateData_1.AwsOnDemandCreateData,
    AwsOnDemandCreateRequest: AwsOnDemandCreateRequest_1.AwsOnDemandCreateRequest,
    AwsOnDemandData: AwsOnDemandData_1.AwsOnDemandData,
    AwsOnDemandListResponse: AwsOnDemandListResponse_1.AwsOnDemandListResponse,
    AwsOnDemandResponse: AwsOnDemandResponse_1.AwsOnDemandResponse,
    AwsScanOptionsAttributes: AwsScanOptionsAttributes_1.AwsScanOptionsAttributes,
    AwsScanOptionsCreateAttributes: AwsScanOptionsCreateAttributes_1.AwsScanOptionsCreateAttributes,
    AwsScanOptionsCreateData: AwsScanOptionsCreateData_1.AwsScanOptionsCreateData,
    AwsScanOptionsCreateRequest: AwsScanOptionsCreateRequest_1.AwsScanOptionsCreateRequest,
    AwsScanOptionsData: AwsScanOptionsData_1.AwsScanOptionsData,
    AwsScanOptionsListResponse: AwsScanOptionsListResponse_1.AwsScanOptionsListResponse,
    AwsScanOptionsResponse: AwsScanOptionsResponse_1.AwsScanOptionsResponse,
    AwsScanOptionsUpdateAttributes: AwsScanOptionsUpdateAttributes_1.AwsScanOptionsUpdateAttributes,
    AwsScanOptionsUpdateData: AwsScanOptionsUpdateData_1.AwsScanOptionsUpdateData,
    AwsScanOptionsUpdateRequest: AwsScanOptionsUpdateRequest_1.AwsScanOptionsUpdateRequest,
    AzureStorageDestination: AzureStorageDestination_1.AzureStorageDestination,
    AzureUCConfig: AzureUCConfig_1.AzureUCConfig,
    AzureUCConfigPair: AzureUCConfigPair_1.AzureUCConfigPair,
    AzureUCConfigPairAttributes: AzureUCConfigPairAttributes_1.AzureUCConfigPairAttributes,
    AzureUCConfigPairsResponse: AzureUCConfigPairsResponse_1.AzureUCConfigPairsResponse,
    AzureUCConfigPatchData: AzureUCConfigPatchData_1.AzureUCConfigPatchData,
    AzureUCConfigPatchRequest: AzureUCConfigPatchRequest_1.AzureUCConfigPatchRequest,
    AzureUCConfigPatchRequestAttributes: AzureUCConfigPatchRequestAttributes_1.AzureUCConfigPatchRequestAttributes,
    AzureUCConfigPostData: AzureUCConfigPostData_1.AzureUCConfigPostData,
    AzureUCConfigPostRequest: AzureUCConfigPostRequest_1.AzureUCConfigPostRequest,
    AzureUCConfigPostRequestAttributes: AzureUCConfigPostRequestAttributes_1.AzureUCConfigPostRequestAttributes,
    AzureUCConfigsResponse: AzureUCConfigsResponse_1.AzureUCConfigsResponse,
    BillConfig: BillConfig_1.BillConfig,
    BillingDimensionsMappingBodyItem: BillingDimensionsMappingBodyItem_1.BillingDimensionsMappingBodyItem,
    BillingDimensionsMappingBodyItemAttributes: BillingDimensionsMappingBodyItemAttributes_1.BillingDimensionsMappingBodyItemAttributes,
    BillingDimensionsMappingBodyItemAttributesEndpointsItems: BillingDimensionsMappingBodyItemAttributesEndpointsItems_1.BillingDimensionsMappingBodyItemAttributesEndpointsItems,
    BillingDimensionsMappingResponse: BillingDimensionsMappingResponse_1.BillingDimensionsMappingResponse,
    Budget: Budget_1.Budget,
    BudgetArray: BudgetArray_1.BudgetArray,
    BudgetAttributes: BudgetAttributes_1.BudgetAttributes,
    BudgetEntry: BudgetEntry_1.BudgetEntry,
    BudgetWithEntries: BudgetWithEntries_1.BudgetWithEntries,
    BudgetWithEntriesData: BudgetWithEntriesData_1.BudgetWithEntriesData,
    BulkMuteFindingsRequest: BulkMuteFindingsRequest_1.BulkMuteFindingsRequest,
    BulkMuteFindingsRequestAttributes: BulkMuteFindingsRequestAttributes_1.BulkMuteFindingsRequestAttributes,
    BulkMuteFindingsRequestData: BulkMuteFindingsRequestData_1.BulkMuteFindingsRequestData,
    BulkMuteFindingsRequestMeta: BulkMuteFindingsRequestMeta_1.BulkMuteFindingsRequestMeta,
    BulkMuteFindingsRequestMetaFindings: BulkMuteFindingsRequestMetaFindings_1.BulkMuteFindingsRequestMetaFindings,
    BulkMuteFindingsRequestProperties: BulkMuteFindingsRequestProperties_1.BulkMuteFindingsRequestProperties,
    BulkMuteFindingsResponse: BulkMuteFindingsResponse_1.BulkMuteFindingsResponse,
    BulkMuteFindingsResponseData: BulkMuteFindingsResponseData_1.BulkMuteFindingsResponseData,
    CIAppAggregateBucketValueTimeseriesPoint: CIAppAggregateBucketValueTimeseriesPoint_1.CIAppAggregateBucketValueTimeseriesPoint,
    CIAppAggregateSort: CIAppAggregateSort_1.CIAppAggregateSort,
    CIAppCIError: CIAppCIError_1.CIAppCIError,
    CIAppCompute: CIAppCompute_1.CIAppCompute,
    CIAppCreatePipelineEventRequest: CIAppCreatePipelineEventRequest_1.CIAppCreatePipelineEventRequest,
    CIAppCreatePipelineEventRequestAttributes: CIAppCreatePipelineEventRequestAttributes_1.CIAppCreatePipelineEventRequestAttributes,
    CIAppCreatePipelineEventRequestData: CIAppCreatePipelineEventRequestData_1.CIAppCreatePipelineEventRequestData,
    CIAppEventAttributes: CIAppEventAttributes_1.CIAppEventAttributes,
    CIAppGitInfo: CIAppGitInfo_1.CIAppGitInfo,
    CIAppGroupByHistogram: CIAppGroupByHistogram_1.CIAppGroupByHistogram,
    CIAppHostInfo: CIAppHostInfo_1.CIAppHostInfo,
    CIAppPipelineEvent: CIAppPipelineEvent_1.CIAppPipelineEvent,
    CIAppPipelineEventAttributes: CIAppPipelineEventAttributes_1.CIAppPipelineEventAttributes,
    CIAppPipelineEventFinishedPipeline: CIAppPipelineEventFinishedPipeline_1.CIAppPipelineEventFinishedPipeline,
    CIAppPipelineEventInProgressPipeline: CIAppPipelineEventInProgressPipeline_1.CIAppPipelineEventInProgressPipeline,
    CIAppPipelineEventJob: CIAppPipelineEventJob_1.CIAppPipelineEventJob,
    CIAppPipelineEventParentPipeline: CIAppPipelineEventParentPipeline_1.CIAppPipelineEventParentPipeline,
    CIAppPipelineEventPreviousPipeline: CIAppPipelineEventPreviousPipeline_1.CIAppPipelineEventPreviousPipeline,
    CIAppPipelineEventStage: CIAppPipelineEventStage_1.CIAppPipelineEventStage,
    CIAppPipelineEventStep: CIAppPipelineEventStep_1.CIAppPipelineEventStep,
    CIAppPipelineEventsRequest: CIAppPipelineEventsRequest_1.CIAppPipelineEventsRequest,
    CIAppPipelineEventsResponse: CIAppPipelineEventsResponse_1.CIAppPipelineEventsResponse,
    CIAppPipelinesAggregateRequest: CIAppPipelinesAggregateRequest_1.CIAppPipelinesAggregateRequest,
    CIAppPipelinesAggregationBucketsResponse: CIAppPipelinesAggregationBucketsResponse_1.CIAppPipelinesAggregationBucketsResponse,
    CIAppPipelinesAnalyticsAggregateResponse: CIAppPipelinesAnalyticsAggregateResponse_1.CIAppPipelinesAnalyticsAggregateResponse,
    CIAppPipelinesBucketResponse: CIAppPipelinesBucketResponse_1.CIAppPipelinesBucketResponse,
    CIAppPipelinesGroupBy: CIAppPipelinesGroupBy_1.CIAppPipelinesGroupBy,
    CIAppPipelinesQueryFilter: CIAppPipelinesQueryFilter_1.CIAppPipelinesQueryFilter,
    CIAppQueryOptions: CIAppQueryOptions_1.CIAppQueryOptions,
    CIAppQueryPageOptions: CIAppQueryPageOptions_1.CIAppQueryPageOptions,
    CIAppResponseLinks: CIAppResponseLinks_1.CIAppResponseLinks,
    CIAppResponseMetadata: CIAppResponseMetadata_1.CIAppResponseMetadata,
    CIAppResponseMetadataWithPagination: CIAppResponseMetadataWithPagination_1.CIAppResponseMetadataWithPagination,
    CIAppResponsePage: CIAppResponsePage_1.CIAppResponsePage,
    CIAppTestEvent: CIAppTestEvent_1.CIAppTestEvent,
    CIAppTestEventsRequest: CIAppTestEventsRequest_1.CIAppTestEventsRequest,
    CIAppTestEventsResponse: CIAppTestEventsResponse_1.CIAppTestEventsResponse,
    CIAppTestsAggregateRequest: CIAppTestsAggregateRequest_1.CIAppTestsAggregateRequest,
    CIAppTestsAggregationBucketsResponse: CIAppTestsAggregationBucketsResponse_1.CIAppTestsAggregationBucketsResponse,
    CIAppTestsAnalyticsAggregateResponse: CIAppTestsAnalyticsAggregateResponse_1.CIAppTestsAnalyticsAggregateResponse,
    CIAppTestsBucketResponse: CIAppTestsBucketResponse_1.CIAppTestsBucketResponse,
    CIAppTestsGroupBy: CIAppTestsGroupBy_1.CIAppTestsGroupBy,
    CIAppTestsQueryFilter: CIAppTestsQueryFilter_1.CIAppTestsQueryFilter,
    CIAppWarning: CIAppWarning_1.CIAppWarning,
    CSMAgentsMetadata: CSMAgentsMetadata_1.CSMAgentsMetadata,
    CVSS: CVSS_1.CVSS,
    CalculatedField: CalculatedField_1.CalculatedField,
    CancelDataDeletionResponseBody: CancelDataDeletionResponseBody_1.CancelDataDeletionResponseBody,
    Case: Case_1.Case,
    CaseAssign: CaseAssign_1.CaseAssign,
    CaseAssignAttributes: CaseAssignAttributes_1.CaseAssignAttributes,
    CaseAssignRequest: CaseAssignRequest_1.CaseAssignRequest,
    CaseAttributes: CaseAttributes_1.CaseAttributes,
    CaseCreate: CaseCreate_1.CaseCreate,
    CaseCreateAttributes: CaseCreateAttributes_1.CaseCreateAttributes,
    CaseCreateRelationships: CaseCreateRelationships_1.CaseCreateRelationships,
    CaseCreateRequest: CaseCreateRequest_1.CaseCreateRequest,
    CaseEmpty: CaseEmpty_1.CaseEmpty,
    CaseEmptyRequest: CaseEmptyRequest_1.CaseEmptyRequest,
    CaseRelationships: CaseRelationships_1.CaseRelationships,
    CaseResponse: CaseResponse_1.CaseResponse,
    CaseTrigger: CaseTrigger_1.CaseTrigger,
    CaseTriggerWrapper: CaseTriggerWrapper_1.CaseTriggerWrapper,
    CaseUpdatePriority: CaseUpdatePriority_1.CaseUpdatePriority,
    CaseUpdatePriorityAttributes: CaseUpdatePriorityAttributes_1.CaseUpdatePriorityAttributes,
    CaseUpdatePriorityRequest: CaseUpdatePriorityRequest_1.CaseUpdatePriorityRequest,
    CaseUpdateStatus: CaseUpdateStatus_1.CaseUpdateStatus,
    CaseUpdateStatusAttributes: CaseUpdateStatusAttributes_1.CaseUpdateStatusAttributes,
    CaseUpdateStatusRequest: CaseUpdateStatusRequest_1.CaseUpdateStatusRequest,
    CasesResponse: CasesResponse_1.CasesResponse,
    CasesResponseMeta: CasesResponseMeta_1.CasesResponseMeta,
    CasesResponseMetaPagination: CasesResponseMetaPagination_1.CasesResponseMetaPagination,
    ChangeEventCustomAttributes: ChangeEventCustomAttributes_1.ChangeEventCustomAttributes,
    ChangeEventCustomAttributesAuthor: ChangeEventCustomAttributesAuthor_1.ChangeEventCustomAttributesAuthor,
    ChangeEventCustomAttributesChangedResource: ChangeEventCustomAttributesChangedResource_1.ChangeEventCustomAttributesChangedResource,
    ChangeEventCustomAttributesImpactedResourcesItems: ChangeEventCustomAttributesImpactedResourcesItems_1.ChangeEventCustomAttributesImpactedResourcesItems,
    ChangeEventTriggerWrapper: ChangeEventTriggerWrapper_1.ChangeEventTriggerWrapper,
    ChargebackBreakdown: ChargebackBreakdown_1.ChargebackBreakdown,
    CloudConfigurationComplianceRuleOptions: CloudConfigurationComplianceRuleOptions_1.CloudConfigurationComplianceRuleOptions,
    CloudConfigurationRegoRule: CloudConfigurationRegoRule_1.CloudConfigurationRegoRule,
    CloudConfigurationRuleCaseCreate: CloudConfigurationRuleCaseCreate_1.CloudConfigurationRuleCaseCreate,
    CloudConfigurationRuleComplianceSignalOptions: CloudConfigurationRuleComplianceSignalOptions_1.CloudConfigurationRuleComplianceSignalOptions,
    CloudConfigurationRuleCreatePayload: CloudConfigurationRuleCreatePayload_1.CloudConfigurationRuleCreatePayload,
    CloudConfigurationRuleOptions: CloudConfigurationRuleOptions_1.CloudConfigurationRuleOptions,
    CloudConfigurationRulePayload: CloudConfigurationRulePayload_1.CloudConfigurationRulePayload,
    CloudWorkloadSecurityAgentPoliciesListResponse: CloudWorkloadSecurityAgentPoliciesListResponse_1.CloudWorkloadSecurityAgentPoliciesListResponse,
    CloudWorkloadSecurityAgentPolicyAttributes: CloudWorkloadSecurityAgentPolicyAttributes_1.CloudWorkloadSecurityAgentPolicyAttributes,
    CloudWorkloadSecurityAgentPolicyCreateAttributes: CloudWorkloadSecurityAgentPolicyCreateAttributes_1.CloudWorkloadSecurityAgentPolicyCreateAttributes,
    CloudWorkloadSecurityAgentPolicyCreateData: CloudWorkloadSecurityAgentPolicyCreateData_1.CloudWorkloadSecurityAgentPolicyCreateData,
    CloudWorkloadSecurityAgentPolicyCreateRequest: CloudWorkloadSecurityAgentPolicyCreateRequest_1.CloudWorkloadSecurityAgentPolicyCreateRequest,
    CloudWorkloadSecurityAgentPolicyData: CloudWorkloadSecurityAgentPolicyData_1.CloudWorkloadSecurityAgentPolicyData,
    CloudWorkloadSecurityAgentPolicyResponse: CloudWorkloadSecurityAgentPolicyResponse_1.CloudWorkloadSecurityAgentPolicyResponse,
    CloudWorkloadSecurityAgentPolicyUpdateAttributes: CloudWorkloadSecurityAgentPolicyUpdateAttributes_1.CloudWorkloadSecurityAgentPolicyUpdateAttributes,
    CloudWorkloadSecurityAgentPolicyUpdateData: CloudWorkloadSecurityAgentPolicyUpdateData_1.CloudWorkloadSecurityAgentPolicyUpdateData,
    CloudWorkloadSecurityAgentPolicyUpdateRequest: CloudWorkloadSecurityAgentPolicyUpdateRequest_1.CloudWorkloadSecurityAgentPolicyUpdateRequest,
    CloudWorkloadSecurityAgentPolicyUpdaterAttributes: CloudWorkloadSecurityAgentPolicyUpdaterAttributes_1.CloudWorkloadSecurityAgentPolicyUpdaterAttributes,
    CloudWorkloadSecurityAgentRuleAction: CloudWorkloadSecurityAgentRuleAction_1.CloudWorkloadSecurityAgentRuleAction,
    CloudWorkloadSecurityAgentRuleAttributes: CloudWorkloadSecurityAgentRuleAttributes_1.CloudWorkloadSecurityAgentRuleAttributes,
    CloudWorkloadSecurityAgentRuleCreateAttributes: CloudWorkloadSecurityAgentRuleCreateAttributes_1.CloudWorkloadSecurityAgentRuleCreateAttributes,
    CloudWorkloadSecurityAgentRuleCreateData: CloudWorkloadSecurityAgentRuleCreateData_1.CloudWorkloadSecurityAgentRuleCreateData,
    CloudWorkloadSecurityAgentRuleCreateRequest: CloudWorkloadSecurityAgentRuleCreateRequest_1.CloudWorkloadSecurityAgentRuleCreateRequest,
    CloudWorkloadSecurityAgentRuleCreatorAttributes: CloudWorkloadSecurityAgentRuleCreatorAttributes_1.CloudWorkloadSecurityAgentRuleCreatorAttributes,
    CloudWorkloadSecurityAgentRuleData: CloudWorkloadSecurityAgentRuleData_1.CloudWorkloadSecurityAgentRuleData,
    CloudWorkloadSecurityAgentRuleKill: CloudWorkloadSecurityAgentRuleKill_1.CloudWorkloadSecurityAgentRuleKill,
    CloudWorkloadSecurityAgentRuleResponse: CloudWorkloadSecurityAgentRuleResponse_1.CloudWorkloadSecurityAgentRuleResponse,
    CloudWorkloadSecurityAgentRuleUpdateAttributes: CloudWorkloadSecurityAgentRuleUpdateAttributes_1.CloudWorkloadSecurityAgentRuleUpdateAttributes,
    CloudWorkloadSecurityAgentRuleUpdateData: CloudWorkloadSecurityAgentRuleUpdateData_1.CloudWorkloadSecurityAgentRuleUpdateData,
    CloudWorkloadSecurityAgentRuleUpdateRequest: CloudWorkloadSecurityAgentRuleUpdateRequest_1.CloudWorkloadSecurityAgentRuleUpdateRequest,
    CloudWorkloadSecurityAgentRuleUpdaterAttributes: CloudWorkloadSecurityAgentRuleUpdaterAttributes_1.CloudWorkloadSecurityAgentRuleUpdaterAttributes,
    CloudWorkloadSecurityAgentRulesListResponse: CloudWorkloadSecurityAgentRulesListResponse_1.CloudWorkloadSecurityAgentRulesListResponse,
    CloudflareAccountCreateRequest: CloudflareAccountCreateRequest_1.CloudflareAccountCreateRequest,
    CloudflareAccountCreateRequestAttributes: CloudflareAccountCreateRequestAttributes_1.CloudflareAccountCreateRequestAttributes,
    CloudflareAccountCreateRequestData: CloudflareAccountCreateRequestData_1.CloudflareAccountCreateRequestData,
    CloudflareAccountResponse: CloudflareAccountResponse_1.CloudflareAccountResponse,
    CloudflareAccountResponseAttributes: CloudflareAccountResponseAttributes_1.CloudflareAccountResponseAttributes,
    CloudflareAccountResponseData: CloudflareAccountResponseData_1.CloudflareAccountResponseData,
    CloudflareAccountUpdateRequest: CloudflareAccountUpdateRequest_1.CloudflareAccountUpdateRequest,
    CloudflareAccountUpdateRequestAttributes: CloudflareAccountUpdateRequestAttributes_1.CloudflareAccountUpdateRequestAttributes,
    CloudflareAccountUpdateRequestData: CloudflareAccountUpdateRequestData_1.CloudflareAccountUpdateRequestData,
    CloudflareAccountsResponse: CloudflareAccountsResponse_1.CloudflareAccountsResponse,
    CodeLocation: CodeLocation_1.CodeLocation,
    CompletionCondition: CompletionCondition_1.CompletionCondition,
    CompletionGate: CompletionGate_1.CompletionGate,
    Component: Component_1.Component,
    ComponentGrid: ComponentGrid_1.ComponentGrid,
    ComponentGridProperties: ComponentGridProperties_1.ComponentGridProperties,
    ComponentProperties: ComponentProperties_1.ComponentProperties,
    ConfluentAccountCreateRequest: ConfluentAccountCreateRequest_1.ConfluentAccountCreateRequest,
    ConfluentAccountCreateRequestAttributes: ConfluentAccountCreateRequestAttributes_1.ConfluentAccountCreateRequestAttributes,
    ConfluentAccountCreateRequestData: ConfluentAccountCreateRequestData_1.ConfluentAccountCreateRequestData,
    ConfluentAccountResourceAttributes: ConfluentAccountResourceAttributes_1.ConfluentAccountResourceAttributes,
    ConfluentAccountResponse: ConfluentAccountResponse_1.ConfluentAccountResponse,
    ConfluentAccountResponseAttributes: ConfluentAccountResponseAttributes_1.ConfluentAccountResponseAttributes,
    ConfluentAccountResponseData: ConfluentAccountResponseData_1.ConfluentAccountResponseData,
    ConfluentAccountUpdateRequest: ConfluentAccountUpdateRequest_1.ConfluentAccountUpdateRequest,
    ConfluentAccountUpdateRequestAttributes: ConfluentAccountUpdateRequestAttributes_1.ConfluentAccountUpdateRequestAttributes,
    ConfluentAccountUpdateRequestData: ConfluentAccountUpdateRequestData_1.ConfluentAccountUpdateRequestData,
    ConfluentAccountsResponse: ConfluentAccountsResponse_1.ConfluentAccountsResponse,
    ConfluentResourceRequest: ConfluentResourceRequest_1.ConfluentResourceRequest,
    ConfluentResourceRequestAttributes: ConfluentResourceRequestAttributes_1.ConfluentResourceRequestAttributes,
    ConfluentResourceRequestData: ConfluentResourceRequestData_1.ConfluentResourceRequestData,
    ConfluentResourceResponse: ConfluentResourceResponse_1.ConfluentResourceResponse,
    ConfluentResourceResponseAttributes: ConfluentResourceResponseAttributes_1.ConfluentResourceResponseAttributes,
    ConfluentResourceResponseData: ConfluentResourceResponseData_1.ConfluentResourceResponseData,
    ConfluentResourcesResponse: ConfluentResourcesResponse_1.ConfluentResourcesResponse,
    Connection: Connection_1.Connection,
    ConnectionEnv: ConnectionEnv_1.ConnectionEnv,
    ConnectionGroup: ConnectionGroup_1.ConnectionGroup,
    Container: Container_1.Container,
    ContainerAttributes: ContainerAttributes_1.ContainerAttributes,
    ContainerGroup: ContainerGroup_1.ContainerGroup,
    ContainerGroupAttributes: ContainerGroupAttributes_1.ContainerGroupAttributes,
    ContainerGroupRelationships: ContainerGroupRelationships_1.ContainerGroupRelationships,
    ContainerGroupRelationshipsLink: ContainerGroupRelationshipsLink_1.ContainerGroupRelationshipsLink,
    ContainerGroupRelationshipsLinks: ContainerGroupRelationshipsLinks_1.ContainerGroupRelationshipsLinks,
    ContainerImage: ContainerImage_1.ContainerImage,
    ContainerImageAttributes: ContainerImageAttributes_1.ContainerImageAttributes,
    ContainerImageFlavor: ContainerImageFlavor_1.ContainerImageFlavor,
    ContainerImageGroup: ContainerImageGroup_1.ContainerImageGroup,
    ContainerImageGroupAttributes: ContainerImageGroupAttributes_1.ContainerImageGroupAttributes,
    ContainerImageGroupImagesRelationshipsLink: ContainerImageGroupImagesRelationshipsLink_1.ContainerImageGroupImagesRelationshipsLink,
    ContainerImageGroupRelationships: ContainerImageGroupRelationships_1.ContainerImageGroupRelationships,
    ContainerImageGroupRelationshipsLinks: ContainerImageGroupRelationshipsLinks_1.ContainerImageGroupRelationshipsLinks,
    ContainerImageMeta: ContainerImageMeta_1.ContainerImageMeta,
    ContainerImageMetaPage: ContainerImageMetaPage_1.ContainerImageMetaPage,
    ContainerImageVulnerabilities: ContainerImageVulnerabilities_1.ContainerImageVulnerabilities,
    ContainerImagesResponse: ContainerImagesResponse_1.ContainerImagesResponse,
    ContainerImagesResponseLinks: ContainerImagesResponseLinks_1.ContainerImagesResponseLinks,
    ContainerMeta: ContainerMeta_1.ContainerMeta,
    ContainerMetaPage: ContainerMetaPage_1.ContainerMetaPage,
    ContainersResponse: ContainersResponse_1.ContainersResponse,
    ContainersResponseLinks: ContainersResponseLinks_1.ContainersResponseLinks,
    ConvertJobResultsToSignalsAttributes: ConvertJobResultsToSignalsAttributes_1.ConvertJobResultsToSignalsAttributes,
    ConvertJobResultsToSignalsData: ConvertJobResultsToSignalsData_1.ConvertJobResultsToSignalsData,
    ConvertJobResultsToSignalsRequest: ConvertJobResultsToSignalsRequest_1.ConvertJobResultsToSignalsRequest,
    CostAttributionAggregatesBody: CostAttributionAggregatesBody_1.CostAttributionAggregatesBody,
    CostByOrg: CostByOrg_1.CostByOrg,
    CostByOrgAttributes: CostByOrgAttributes_1.CostByOrgAttributes,
    CostByOrgResponse: CostByOrgResponse_1.CostByOrgResponse,
    CreateActionConnectionRequest: CreateActionConnectionRequest_1.CreateActionConnectionRequest,
    CreateActionConnectionResponse: CreateActionConnectionResponse_1.CreateActionConnectionResponse,
    CreateAppRequest: CreateAppRequest_1.CreateAppRequest,
    CreateAppRequestData: CreateAppRequestData_1.CreateAppRequestData,
    CreateAppRequestDataAttributes: CreateAppRequestDataAttributes_1.CreateAppRequestDataAttributes,
    CreateAppResponse: CreateAppResponse_1.CreateAppResponse,
    CreateAppResponseData: CreateAppResponseData_1.CreateAppResponseData,
    CreateCustomFrameworkRequest: CreateCustomFrameworkRequest_1.CreateCustomFrameworkRequest,
    CreateCustomFrameworkResponse: CreateCustomFrameworkResponse_1.CreateCustomFrameworkResponse,
    CreateDataDeletionRequestBody: CreateDataDeletionRequestBody_1.CreateDataDeletionRequestBody,
    CreateDataDeletionRequestBodyAttributes: CreateDataDeletionRequestBodyAttributes_1.CreateDataDeletionRequestBodyAttributes,
    CreateDataDeletionRequestBodyData: CreateDataDeletionRequestBodyData_1.CreateDataDeletionRequestBodyData,
    CreateDataDeletionResponseBody: CreateDataDeletionResponseBody_1.CreateDataDeletionResponseBody,
    CreateNotificationRuleParameters: CreateNotificationRuleParameters_1.CreateNotificationRuleParameters,
    CreateNotificationRuleParametersData: CreateNotificationRuleParametersData_1.CreateNotificationRuleParametersData,
    CreateNotificationRuleParametersDataAttributes: CreateNotificationRuleParametersDataAttributes_1.CreateNotificationRuleParametersDataAttributes,
    CreateOpenAPIResponse: CreateOpenAPIResponse_1.CreateOpenAPIResponse,
    CreateOpenAPIResponseAttributes: CreateOpenAPIResponseAttributes_1.CreateOpenAPIResponseAttributes,
    CreateOpenAPIResponseData: CreateOpenAPIResponseData_1.CreateOpenAPIResponseData,
    CreatePageRequest: CreatePageRequest_1.CreatePageRequest,
    CreatePageRequestData: CreatePageRequestData_1.CreatePageRequestData,
    CreatePageRequestDataAttributes: CreatePageRequestDataAttributes_1.CreatePageRequestDataAttributes,
    CreatePageRequestDataAttributesTarget: CreatePageRequestDataAttributesTarget_1.CreatePageRequestDataAttributesTarget,
    CreatePageResponse: CreatePageResponse_1.CreatePageResponse,
    CreatePageResponseData: CreatePageResponseData_1.CreatePageResponseData,
    CreateRuleRequest: CreateRuleRequest_1.CreateRuleRequest,
    CreateRuleRequestData: CreateRuleRequestData_1.CreateRuleRequestData,
    CreateRuleResponse: CreateRuleResponse_1.CreateRuleResponse,
    CreateRuleResponseData: CreateRuleResponseData_1.CreateRuleResponseData,
    CreateWorkflowRequest: CreateWorkflowRequest_1.CreateWorkflowRequest,
    CreateWorkflowResponse: CreateWorkflowResponse_1.CreateWorkflowResponse,
    Creator: Creator_1.Creator,
    CsmAgentData: CsmAgentData_1.CsmAgentData,
    CsmAgentsAttributes: CsmAgentsAttributes_1.CsmAgentsAttributes,
    CsmAgentsResponse: CsmAgentsResponse_1.CsmAgentsResponse,
    CsmCloudAccountsCoverageAnalysisAttributes: CsmCloudAccountsCoverageAnalysisAttributes_1.CsmCloudAccountsCoverageAnalysisAttributes,
    CsmCloudAccountsCoverageAnalysisData: CsmCloudAccountsCoverageAnalysisData_1.CsmCloudAccountsCoverageAnalysisData,
    CsmCloudAccountsCoverageAnalysisResponse: CsmCloudAccountsCoverageAnalysisResponse_1.CsmCloudAccountsCoverageAnalysisResponse,
    CsmCoverageAnalysis: CsmCoverageAnalysis_1.CsmCoverageAnalysis,
    CsmHostsAndContainersCoverageAnalysisAttributes: CsmHostsAndContainersCoverageAnalysisAttributes_1.CsmHostsAndContainersCoverageAnalysisAttributes,
    CsmHostsAndContainersCoverageAnalysisData: CsmHostsAndContainersCoverageAnalysisData_1.CsmHostsAndContainersCoverageAnalysisData,
    CsmHostsAndContainersCoverageAnalysisResponse: CsmHostsAndContainersCoverageAnalysisResponse_1.CsmHostsAndContainersCoverageAnalysisResponse,
    CsmServerlessCoverageAnalysisAttributes: CsmServerlessCoverageAnalysisAttributes_1.CsmServerlessCoverageAnalysisAttributes,
    CsmServerlessCoverageAnalysisData: CsmServerlessCoverageAnalysisData_1.CsmServerlessCoverageAnalysisData,
    CsmServerlessCoverageAnalysisResponse: CsmServerlessCoverageAnalysisResponse_1.CsmServerlessCoverageAnalysisResponse,
    CustomConnection: CustomConnection_1.CustomConnection,
    CustomConnectionAttributes: CustomConnectionAttributes_1.CustomConnectionAttributes,
    CustomConnectionAttributesOnPremRunner: CustomConnectionAttributesOnPremRunner_1.CustomConnectionAttributesOnPremRunner,
    CustomCostGetResponseMeta: CustomCostGetResponseMeta_1.CustomCostGetResponseMeta,
    CustomCostListResponseMeta: CustomCostListResponseMeta_1.CustomCostListResponseMeta,
    CustomCostUploadResponseMeta: CustomCostUploadResponseMeta_1.CustomCostUploadResponseMeta,
    CustomCostsFileGetResponse: CustomCostsFileGetResponse_1.CustomCostsFileGetResponse,
    CustomCostsFileLineItem: CustomCostsFileLineItem_1.CustomCostsFileLineItem,
    CustomCostsFileListResponse: CustomCostsFileListResponse_1.CustomCostsFileListResponse,
    CustomCostsFileMetadata: CustomCostsFileMetadata_1.CustomCostsFileMetadata,
    CustomCostsFileMetadataHighLevel: CustomCostsFileMetadataHighLevel_1.CustomCostsFileMetadataHighLevel,
    CustomCostsFileMetadataWithContent: CustomCostsFileMetadataWithContent_1.CustomCostsFileMetadataWithContent,
    CustomCostsFileMetadataWithContentHighLevel: CustomCostsFileMetadataWithContentHighLevel_1.CustomCostsFileMetadataWithContentHighLevel,
    CustomCostsFileUploadResponse: CustomCostsFileUploadResponse_1.CustomCostsFileUploadResponse,
    CustomCostsFileUsageChargePeriod: CustomCostsFileUsageChargePeriod_1.CustomCostsFileUsageChargePeriod,
    CustomCostsUser: CustomCostsUser_1.CustomCostsUser,
    CustomDestinationCreateRequest: CustomDestinationCreateRequest_1.CustomDestinationCreateRequest,
    CustomDestinationCreateRequestAttributes: CustomDestinationCreateRequestAttributes_1.CustomDestinationCreateRequestAttributes,
    CustomDestinationCreateRequestDefinition: CustomDestinationCreateRequestDefinition_1.CustomDestinationCreateRequestDefinition,
    CustomDestinationElasticsearchDestinationAuth: CustomDestinationElasticsearchDestinationAuth_1.CustomDestinationElasticsearchDestinationAuth,
    CustomDestinationForwardDestinationElasticsearch: CustomDestinationForwardDestinationElasticsearch_1.CustomDestinationForwardDestinationElasticsearch,
    CustomDestinationForwardDestinationHttp: CustomDestinationForwardDestinationHttp_1.CustomDestinationForwardDestinationHttp,
    CustomDestinationForwardDestinationSplunk: CustomDestinationForwardDestinationSplunk_1.CustomDestinationForwardDestinationSplunk,
    CustomDestinationHttpDestinationAuthBasic: CustomDestinationHttpDestinationAuthBasic_1.CustomDestinationHttpDestinationAuthBasic,
    CustomDestinationHttpDestinationAuthCustomHeader: CustomDestinationHttpDestinationAuthCustomHeader_1.CustomDestinationHttpDestinationAuthCustomHeader,
    CustomDestinationResponse: CustomDestinationResponse_1.CustomDestinationResponse,
    CustomDestinationResponseAttributes: CustomDestinationResponseAttributes_1.CustomDestinationResponseAttributes,
    CustomDestinationResponseDefinition: CustomDestinationResponseDefinition_1.CustomDestinationResponseDefinition,
    CustomDestinationResponseForwardDestinationElasticsearch: CustomDestinationResponseForwardDestinationElasticsearch_1.CustomDestinationResponseForwardDestinationElasticsearch,
    CustomDestinationResponseForwardDestinationHttp: CustomDestinationResponseForwardDestinationHttp_1.CustomDestinationResponseForwardDestinationHttp,
    CustomDestinationResponseForwardDestinationSplunk: CustomDestinationResponseForwardDestinationSplunk_1.CustomDestinationResponseForwardDestinationSplunk,
    CustomDestinationResponseHttpDestinationAuthBasic: CustomDestinationResponseHttpDestinationAuthBasic_1.CustomDestinationResponseHttpDestinationAuthBasic,
    CustomDestinationResponseHttpDestinationAuthCustomHeader: CustomDestinationResponseHttpDestinationAuthCustomHeader_1.CustomDestinationResponseHttpDestinationAuthCustomHeader,
    CustomDestinationUpdateRequest: CustomDestinationUpdateRequest_1.CustomDestinationUpdateRequest,
    CustomDestinationUpdateRequestAttributes: CustomDestinationUpdateRequestAttributes_1.CustomDestinationUpdateRequestAttributes,
    CustomDestinationUpdateRequestDefinition: CustomDestinationUpdateRequestDefinition_1.CustomDestinationUpdateRequestDefinition,
    CustomDestinationsResponse: CustomDestinationsResponse_1.CustomDestinationsResponse,
    CustomFrameworkControl: CustomFrameworkControl_1.CustomFrameworkControl,
    CustomFrameworkData: CustomFrameworkData_1.CustomFrameworkData,
    CustomFrameworkDataAttributes: CustomFrameworkDataAttributes_1.CustomFrameworkDataAttributes,
    CustomFrameworkDataHandleAndVersion: CustomFrameworkDataHandleAndVersion_1.CustomFrameworkDataHandleAndVersion,
    CustomFrameworkMetadata: CustomFrameworkMetadata_1.CustomFrameworkMetadata,
    CustomFrameworkRequirement: CustomFrameworkRequirement_1.CustomFrameworkRequirement,
    CustomFrameworkWithoutRequirements: CustomFrameworkWithoutRequirements_1.CustomFrameworkWithoutRequirements,
    DORADeploymentRequest: DORADeploymentRequest_1.DORADeploymentRequest,
    DORADeploymentRequestAttributes: DORADeploymentRequestAttributes_1.DORADeploymentRequestAttributes,
    DORADeploymentRequestData: DORADeploymentRequestData_1.DORADeploymentRequestData,
    DORADeploymentResponse: DORADeploymentResponse_1.DORADeploymentResponse,
    DORADeploymentResponseData: DORADeploymentResponseData_1.DORADeploymentResponseData,
    DORAEvent: DORAEvent_1.DORAEvent,
    DORAFetchResponse: DORAFetchResponse_1.DORAFetchResponse,
    DORAGitInfo: DORAGitInfo_1.DORAGitInfo,
    DORAIncidentRequest: DORAIncidentRequest_1.DORAIncidentRequest,
    DORAIncidentRequestAttributes: DORAIncidentRequestAttributes_1.DORAIncidentRequestAttributes,
    DORAIncidentRequestData: DORAIncidentRequestData_1.DORAIncidentRequestData,
    DORAIncidentResponse: DORAIncidentResponse_1.DORAIncidentResponse,
    DORAIncidentResponseData: DORAIncidentResponseData_1.DORAIncidentResponseData,
    DORAListDeploymentsRequest: DORAListDeploymentsRequest_1.DORAListDeploymentsRequest,
    DORAListDeploymentsRequestAttributes: DORAListDeploymentsRequestAttributes_1.DORAListDeploymentsRequestAttributes,
    DORAListDeploymentsRequestData: DORAListDeploymentsRequestData_1.DORAListDeploymentsRequestData,
    DORAListFailuresRequest: DORAListFailuresRequest_1.DORAListFailuresRequest,
    DORAListFailuresRequestAttributes: DORAListFailuresRequestAttributes_1.DORAListFailuresRequestAttributes,
    DORAListFailuresRequestData: DORAListFailuresRequestData_1.DORAListFailuresRequestData,
    DORAListResponse: DORAListResponse_1.DORAListResponse,
    DashboardListAddItemsRequest: DashboardListAddItemsRequest_1.DashboardListAddItemsRequest,
    DashboardListAddItemsResponse: DashboardListAddItemsResponse_1.DashboardListAddItemsResponse,
    DashboardListDeleteItemsRequest: DashboardListDeleteItemsRequest_1.DashboardListDeleteItemsRequest,
    DashboardListDeleteItemsResponse: DashboardListDeleteItemsResponse_1.DashboardListDeleteItemsResponse,
    DashboardListItem: DashboardListItem_1.DashboardListItem,
    DashboardListItemRequest: DashboardListItemRequest_1.DashboardListItemRequest,
    DashboardListItemResponse: DashboardListItemResponse_1.DashboardListItemResponse,
    DashboardListItems: DashboardListItems_1.DashboardListItems,
    DashboardListUpdateItemsRequest: DashboardListUpdateItemsRequest_1.DashboardListUpdateItemsRequest,
    DashboardListUpdateItemsResponse: DashboardListUpdateItemsResponse_1.DashboardListUpdateItemsResponse,
    DashboardTriggerWrapper: DashboardTriggerWrapper_1.DashboardTriggerWrapper,
    DataDeletionResponseItem: DataDeletionResponseItem_1.DataDeletionResponseItem,
    DataDeletionResponseItemAttributes: DataDeletionResponseItemAttributes_1.DataDeletionResponseItemAttributes,
    DataDeletionResponseMeta: DataDeletionResponseMeta_1.DataDeletionResponseMeta,
    DataRelationshipsTeams: DataRelationshipsTeams_1.DataRelationshipsTeams,
    DataRelationshipsTeamsDataItems: DataRelationshipsTeamsDataItems_1.DataRelationshipsTeamsDataItems,
    DataScalarColumn: DataScalarColumn_1.DataScalarColumn,
    DataTransform: DataTransform_1.DataTransform,
    DataTransformProperties: DataTransformProperties_1.DataTransformProperties,
    DatabaseMonitoringTriggerWrapper: DatabaseMonitoringTriggerWrapper_1.DatabaseMonitoringTriggerWrapper,
    DeleteAppResponse: DeleteAppResponse_1.DeleteAppResponse,
    DeleteAppResponseData: DeleteAppResponseData_1.DeleteAppResponseData,
    DeleteAppsRequest: DeleteAppsRequest_1.DeleteAppsRequest,
    DeleteAppsRequestDataItems: DeleteAppsRequestDataItems_1.DeleteAppsRequestDataItems,
    DeleteAppsResponse: DeleteAppsResponse_1.DeleteAppsResponse,
    DeleteAppsResponseDataItems: DeleteAppsResponseDataItems_1.DeleteAppsResponseDataItems,
    DeleteCustomFrameworkResponse: DeleteCustomFrameworkResponse_1.DeleteCustomFrameworkResponse,
    DependencyLocation: DependencyLocation_1.DependencyLocation,
    Deployment: Deployment_1.Deployment,
    DeploymentAttributes: DeploymentAttributes_1.DeploymentAttributes,
    DeploymentMetadata: DeploymentMetadata_1.DeploymentMetadata,
    DeploymentRelationship: DeploymentRelationship_1.DeploymentRelationship,
    DeploymentRelationshipData: DeploymentRelationshipData_1.DeploymentRelationshipData,
    DetailedFinding: DetailedFinding_1.DetailedFinding,
    DetailedFindingAttributes: DetailedFindingAttributes_1.DetailedFindingAttributes,
    DeviceAttributes: DeviceAttributes_1.DeviceAttributes,
    DeviceAttributesInterfaceStatuses: DeviceAttributesInterfaceStatuses_1.DeviceAttributesInterfaceStatuses,
    DevicesListData: DevicesListData_1.DevicesListData,
    DomainAllowlist: DomainAllowlist_1.DomainAllowlist,
    DomainAllowlistAttributes: DomainAllowlistAttributes_1.DomainAllowlistAttributes,
    DomainAllowlistRequest: DomainAllowlistRequest_1.DomainAllowlistRequest,
    DomainAllowlistResponse: DomainAllowlistResponse_1.DomainAllowlistResponse,
    DomainAllowlistResponseData: DomainAllowlistResponseData_1.DomainAllowlistResponseData,
    DomainAllowlistResponseDataAttributes: DomainAllowlistResponseDataAttributes_1.DomainAllowlistResponseDataAttributes,
    DowntimeCreateRequest: DowntimeCreateRequest_1.DowntimeCreateRequest,
    DowntimeCreateRequestAttributes: DowntimeCreateRequestAttributes_1.DowntimeCreateRequestAttributes,
    DowntimeCreateRequestData: DowntimeCreateRequestData_1.DowntimeCreateRequestData,
    DowntimeMeta: DowntimeMeta_1.DowntimeMeta,
    DowntimeMetaPage: DowntimeMetaPage_1.DowntimeMetaPage,
    DowntimeMonitorIdentifierId: DowntimeMonitorIdentifierId_1.DowntimeMonitorIdentifierId,
    DowntimeMonitorIdentifierTags: DowntimeMonitorIdentifierTags_1.DowntimeMonitorIdentifierTags,
    DowntimeMonitorIncludedAttributes: DowntimeMonitorIncludedAttributes_1.DowntimeMonitorIncludedAttributes,
    DowntimeMonitorIncludedItem: DowntimeMonitorIncludedItem_1.DowntimeMonitorIncludedItem,
    DowntimeRelationships: DowntimeRelationships_1.DowntimeRelationships,
    DowntimeRelationshipsCreatedBy: DowntimeRelationshipsCreatedBy_1.DowntimeRelationshipsCreatedBy,
    DowntimeRelationshipsCreatedByData: DowntimeRelationshipsCreatedByData_1.DowntimeRelationshipsCreatedByData,
    DowntimeRelationshipsMonitor: DowntimeRelationshipsMonitor_1.DowntimeRelationshipsMonitor,
    DowntimeRelationshipsMonitorData: DowntimeRelationshipsMonitorData_1.DowntimeRelationshipsMonitorData,
    DowntimeResponse: DowntimeResponse_1.DowntimeResponse,
    DowntimeResponseAttributes: DowntimeResponseAttributes_1.DowntimeResponseAttributes,
    DowntimeResponseData: DowntimeResponseData_1.DowntimeResponseData,
    DowntimeScheduleCurrentDowntimeResponse: DowntimeScheduleCurrentDowntimeResponse_1.DowntimeScheduleCurrentDowntimeResponse,
    DowntimeScheduleOneTimeCreateUpdateRequest: DowntimeScheduleOneTimeCreateUpdateRequest_1.DowntimeScheduleOneTimeCreateUpdateRequest,
    DowntimeScheduleOneTimeResponse: DowntimeScheduleOneTimeResponse_1.DowntimeScheduleOneTimeResponse,
    DowntimeScheduleRecurrenceCreateUpdateRequest: DowntimeScheduleRecurrenceCreateUpdateRequest_1.DowntimeScheduleRecurrenceCreateUpdateRequest,
    DowntimeScheduleRecurrenceResponse: DowntimeScheduleRecurrenceResponse_1.DowntimeScheduleRecurrenceResponse,
    DowntimeScheduleRecurrencesCreateRequest: DowntimeScheduleRecurrencesCreateRequest_1.DowntimeScheduleRecurrencesCreateRequest,
    DowntimeScheduleRecurrencesResponse: DowntimeScheduleRecurrencesResponse_1.DowntimeScheduleRecurrencesResponse,
    DowntimeScheduleRecurrencesUpdateRequest: DowntimeScheduleRecurrencesUpdateRequest_1.DowntimeScheduleRecurrencesUpdateRequest,
    DowntimeUpdateRequest: DowntimeUpdateRequest_1.DowntimeUpdateRequest,
    DowntimeUpdateRequestAttributes: DowntimeUpdateRequestAttributes_1.DowntimeUpdateRequestAttributes,
    DowntimeUpdateRequestData: DowntimeUpdateRequestData_1.DowntimeUpdateRequestData,
    EPSS: EPSS_1.EPSS,
    EntityAttributes: EntityAttributes_1.EntityAttributes,
    EntityData: EntityData_1.EntityData,
    EntityMeta: EntityMeta_1.EntityMeta,
    EntityRelationships: EntityRelationships_1.EntityRelationships,
    EntityResponseIncludedIncident: EntityResponseIncludedIncident_1.EntityResponseIncludedIncident,
    EntityResponseIncludedOncall: EntityResponseIncludedOncall_1.EntityResponseIncludedOncall,
    EntityResponseIncludedRawSchema: EntityResponseIncludedRawSchema_1.EntityResponseIncludedRawSchema,
    EntityResponseIncludedRawSchemaAttributes: EntityResponseIncludedRawSchemaAttributes_1.EntityResponseIncludedRawSchemaAttributes,
    EntityResponseIncludedRelatedEntity: EntityResponseIncludedRelatedEntity_1.EntityResponseIncludedRelatedEntity,
    EntityResponseIncludedRelatedEntityAttributes: EntityResponseIncludedRelatedEntityAttributes_1.EntityResponseIncludedRelatedEntityAttributes,
    EntityResponseIncludedRelatedEntityMeta: EntityResponseIncludedRelatedEntityMeta_1.EntityResponseIncludedRelatedEntityMeta,
    EntityResponseIncludedRelatedIncidentAttributes: EntityResponseIncludedRelatedIncidentAttributes_1.EntityResponseIncludedRelatedIncidentAttributes,
    EntityResponseIncludedRelatedOncallAttributes: EntityResponseIncludedRelatedOncallAttributes_1.EntityResponseIncludedRelatedOncallAttributes,
    EntityResponseIncludedRelatedOncallEscalationItem: EntityResponseIncludedRelatedOncallEscalationItem_1.EntityResponseIncludedRelatedOncallEscalationItem,
    EntityResponseIncludedSchema: EntityResponseIncludedSchema_1.EntityResponseIncludedSchema,
    EntityResponseIncludedSchemaAttributes: EntityResponseIncludedSchemaAttributes_1.EntityResponseIncludedSchemaAttributes,
    EntityResponseMeta: EntityResponseMeta_1.EntityResponseMeta,
    EntityToIncidents: EntityToIncidents_1.EntityToIncidents,
    EntityToOncalls: EntityToOncalls_1.EntityToOncalls,
    EntityToRawSchema: EntityToRawSchema_1.EntityToRawSchema,
    EntityToRelatedEntities: EntityToRelatedEntities_1.EntityToRelatedEntities,
    EntityToSchema: EntityToSchema_1.EntityToSchema,
    EntityV3API: EntityV3API_1.EntityV3API,
    EntityV3APIDatadog: EntityV3APIDatadog_1.EntityV3APIDatadog,
    EntityV3APISpec: EntityV3APISpec_1.EntityV3APISpec,
    EntityV3APISpecInterfaceDefinition: EntityV3APISpecInterfaceDefinition_1.EntityV3APISpecInterfaceDefinition,
    EntityV3APISpecInterfaceFileRef: EntityV3APISpecInterfaceFileRef_1.EntityV3APISpecInterfaceFileRef,
    EntityV3DatadogCodeLocationItem: EntityV3DatadogCodeLocationItem_1.EntityV3DatadogCodeLocationItem,
    EntityV3DatadogEventItem: EntityV3DatadogEventItem_1.EntityV3DatadogEventItem,
    EntityV3DatadogIntegrationOpsgenie: EntityV3DatadogIntegrationOpsgenie_1.EntityV3DatadogIntegrationOpsgenie,
    EntityV3DatadogIntegrationPagerduty: EntityV3DatadogIntegrationPagerduty_1.EntityV3DatadogIntegrationPagerduty,
    EntityV3DatadogLogItem: EntityV3DatadogLogItem_1.EntityV3DatadogLogItem,
    EntityV3DatadogPerformance: EntityV3DatadogPerformance_1.EntityV3DatadogPerformance,
    EntityV3DatadogPipelines: EntityV3DatadogPipelines_1.EntityV3DatadogPipelines,
    EntityV3Datastore: EntityV3Datastore_1.EntityV3Datastore,
    EntityV3DatastoreDatadog: EntityV3DatastoreDatadog_1.EntityV3DatastoreDatadog,
    EntityV3DatastoreSpec: EntityV3DatastoreSpec_1.EntityV3DatastoreSpec,
    EntityV3Integrations: EntityV3Integrations_1.EntityV3Integrations,
    EntityV3Metadata: EntityV3Metadata_1.EntityV3Metadata,
    EntityV3MetadataAdditionalOwnersItems: EntityV3MetadataAdditionalOwnersItems_1.EntityV3MetadataAdditionalOwnersItems,
    EntityV3MetadataContactsItems: EntityV3MetadataContactsItems_1.EntityV3MetadataContactsItems,
    EntityV3MetadataLinksItems: EntityV3MetadataLinksItems_1.EntityV3MetadataLinksItems,
    EntityV3Queue: EntityV3Queue_1.EntityV3Queue,
    EntityV3QueueDatadog: EntityV3QueueDatadog_1.EntityV3QueueDatadog,
    EntityV3QueueSpec: EntityV3QueueSpec_1.EntityV3QueueSpec,
    EntityV3Service: EntityV3Service_1.EntityV3Service,
    EntityV3ServiceDatadog: EntityV3ServiceDatadog_1.EntityV3ServiceDatadog,
    EntityV3ServiceSpec: EntityV3ServiceSpec_1.EntityV3ServiceSpec,
    EntityV3System: EntityV3System_1.EntityV3System,
    EntityV3SystemDatadog: EntityV3SystemDatadog_1.EntityV3SystemDatadog,
    EntityV3SystemSpec: EntityV3SystemSpec_1.EntityV3SystemSpec,
    ErrorHandler: ErrorHandler_1.ErrorHandler,
    EscalationPolicy: EscalationPolicy_1.EscalationPolicy,
    EscalationPolicyCreateRequest: EscalationPolicyCreateRequest_1.EscalationPolicyCreateRequest,
    EscalationPolicyCreateRequestData: EscalationPolicyCreateRequestData_1.EscalationPolicyCreateRequestData,
    EscalationPolicyCreateRequestDataAttributes: EscalationPolicyCreateRequestDataAttributes_1.EscalationPolicyCreateRequestDataAttributes,
    EscalationPolicyCreateRequestDataAttributesStepsItems: EscalationPolicyCreateRequestDataAttributesStepsItems_1.EscalationPolicyCreateRequestDataAttributesStepsItems,
    EscalationPolicyCreateRequestDataRelationships: EscalationPolicyCreateRequestDataRelationships_1.EscalationPolicyCreateRequestDataRelationships,
    EscalationPolicyData: EscalationPolicyData_1.EscalationPolicyData,
    EscalationPolicyDataAttributes: EscalationPolicyDataAttributes_1.EscalationPolicyDataAttributes,
    EscalationPolicyDataRelationships: EscalationPolicyDataRelationships_1.EscalationPolicyDataRelationships,
    EscalationPolicyDataRelationshipsSteps: EscalationPolicyDataRelationshipsSteps_1.EscalationPolicyDataRelationshipsSteps,
    EscalationPolicyDataRelationshipsStepsDataItems: EscalationPolicyDataRelationshipsStepsDataItems_1.EscalationPolicyDataRelationshipsStepsDataItems,
    EscalationPolicyStep: EscalationPolicyStep_1.EscalationPolicyStep,
    EscalationPolicyStepAttributes: EscalationPolicyStepAttributes_1.EscalationPolicyStepAttributes,
    EscalationPolicyStepRelationships: EscalationPolicyStepRelationships_1.EscalationPolicyStepRelationships,
    EscalationPolicyStepTarget: EscalationPolicyStepTarget_1.EscalationPolicyStepTarget,
    EscalationPolicyUpdateRequest: EscalationPolicyUpdateRequest_1.EscalationPolicyUpdateRequest,
    EscalationPolicyUpdateRequestData: EscalationPolicyUpdateRequestData_1.EscalationPolicyUpdateRequestData,
    EscalationPolicyUpdateRequestDataAttributes: EscalationPolicyUpdateRequestDataAttributes_1.EscalationPolicyUpdateRequestDataAttributes,
    EscalationPolicyUpdateRequestDataAttributesStepsItems: EscalationPolicyUpdateRequestDataAttributesStepsItems_1.EscalationPolicyUpdateRequestDataAttributesStepsItems,
    EscalationPolicyUpdateRequestDataRelationships: EscalationPolicyUpdateRequestDataRelationships_1.EscalationPolicyUpdateRequestDataRelationships,
    EscalationPolicyUser: EscalationPolicyUser_1.EscalationPolicyUser,
    EscalationPolicyUserAttributes: EscalationPolicyUserAttributes_1.EscalationPolicyUserAttributes,
    EscalationTargets: EscalationTargets_1.EscalationTargets,
    Event: Event_1.Event,
    EventAttributes: EventAttributes_1.EventAttributes,
    EventCreateRequest: EventCreateRequest_1.EventCreateRequest,
    EventCreateRequestPayload: EventCreateRequestPayload_1.EventCreateRequestPayload,
    EventCreateResponse: EventCreateResponse_1.EventCreateResponse,
    EventCreateResponseAttributes: EventCreateResponseAttributes_1.EventCreateResponseAttributes,
    EventCreateResponseAttributesAttributes: EventCreateResponseAttributesAttributes_1.EventCreateResponseAttributesAttributes,
    EventCreateResponseAttributesAttributesEvt: EventCreateResponseAttributesAttributesEvt_1.EventCreateResponseAttributesAttributesEvt,
    EventCreateResponsePayload: EventCreateResponsePayload_1.EventCreateResponsePayload,
    EventPayload: EventPayload_1.EventPayload,
    EventResponse: EventResponse_1.EventResponse,
    EventResponseAttributes: EventResponseAttributes_1.EventResponseAttributes,
    EventsCompute: EventsCompute_1.EventsCompute,
    EventsGroupBy: EventsGroupBy_1.EventsGroupBy,
    EventsGroupBySort: EventsGroupBySort_1.EventsGroupBySort,
    EventsListRequest: EventsListRequest_1.EventsListRequest,
    EventsListResponse: EventsListResponse_1.EventsListResponse,
    EventsListResponseLinks: EventsListResponseLinks_1.EventsListResponseLinks,
    EventsQueryFilter: EventsQueryFilter_1.EventsQueryFilter,
    EventsQueryOptions: EventsQueryOptions_1.EventsQueryOptions,
    EventsRequestPage: EventsRequestPage_1.EventsRequestPage,
    EventsResponseMetadata: EventsResponseMetadata_1.EventsResponseMetadata,
    EventsResponseMetadataPage: EventsResponseMetadataPage_1.EventsResponseMetadataPage,
    EventsScalarQuery: EventsScalarQuery_1.EventsScalarQuery,
    EventsSearch: EventsSearch_1.EventsSearch,
    EventsTimeseriesQuery: EventsTimeseriesQuery_1.EventsTimeseriesQuery,
    EventsWarning: EventsWarning_1.EventsWarning,
    FastlyAccounResponseAttributes: FastlyAccounResponseAttributes_1.FastlyAccounResponseAttributes,
    FastlyAccountCreateRequest: FastlyAccountCreateRequest_1.FastlyAccountCreateRequest,
    FastlyAccountCreateRequestAttributes: FastlyAccountCreateRequestAttributes_1.FastlyAccountCreateRequestAttributes,
    FastlyAccountCreateRequestData: FastlyAccountCreateRequestData_1.FastlyAccountCreateRequestData,
    FastlyAccountResponse: FastlyAccountResponse_1.FastlyAccountResponse,
    FastlyAccountResponseData: FastlyAccountResponseData_1.FastlyAccountResponseData,
    FastlyAccountUpdateRequest: FastlyAccountUpdateRequest_1.FastlyAccountUpdateRequest,
    FastlyAccountUpdateRequestAttributes: FastlyAccountUpdateRequestAttributes_1.FastlyAccountUpdateRequestAttributes,
    FastlyAccountUpdateRequestData: FastlyAccountUpdateRequestData_1.FastlyAccountUpdateRequestData,
    FastlyAccountsResponse: FastlyAccountsResponse_1.FastlyAccountsResponse,
    FastlyService: FastlyService_1.FastlyService,
    FastlyServiceAttributes: FastlyServiceAttributes_1.FastlyServiceAttributes,
    FastlyServiceData: FastlyServiceData_1.FastlyServiceData,
    FastlyServiceRequest: FastlyServiceRequest_1.FastlyServiceRequest,
    FastlyServiceResponse: FastlyServiceResponse_1.FastlyServiceResponse,
    FastlyServicesResponse: FastlyServicesResponse_1.FastlyServicesResponse,
    Finding: Finding_1.Finding,
    FindingAttributes: FindingAttributes_1.FindingAttributes,
    FindingMute: FindingMute_1.FindingMute,
    FindingRule: FindingRule_1.FindingRule,
    FormulaLimit: FormulaLimit_1.FormulaLimit,
    FrameworkHandleAndVersionResponseData: FrameworkHandleAndVersionResponseData_1.FrameworkHandleAndVersionResponseData,
    FullAPIKey: FullAPIKey_1.FullAPIKey,
    FullAPIKeyAttributes: FullAPIKeyAttributes_1.FullAPIKeyAttributes,
    FullApplicationKey: FullApplicationKey_1.FullApplicationKey,
    FullApplicationKeyAttributes: FullApplicationKeyAttributes_1.FullApplicationKeyAttributes,
    FullCustomFrameworkData: FullCustomFrameworkData_1.FullCustomFrameworkData,
    FullCustomFrameworkDataAttributes: FullCustomFrameworkDataAttributes_1.FullCustomFrameworkDataAttributes,
    GCPMetricNamespaceConfig: GCPMetricNamespaceConfig_1.GCPMetricNamespaceConfig,
    GCPSTSDelegateAccount: GCPSTSDelegateAccount_1.GCPSTSDelegateAccount,
    GCPSTSDelegateAccountAttributes: GCPSTSDelegateAccountAttributes_1.GCPSTSDelegateAccountAttributes,
    GCPSTSDelegateAccountResponse: GCPSTSDelegateAccountResponse_1.GCPSTSDelegateAccountResponse,
    GCPSTSServiceAccount: GCPSTSServiceAccount_1.GCPSTSServiceAccount,
    GCPSTSServiceAccountAttributes: GCPSTSServiceAccountAttributes_1.GCPSTSServiceAccountAttributes,
    GCPSTSServiceAccountCreateRequest: GCPSTSServiceAccountCreateRequest_1.GCPSTSServiceAccountCreateRequest,
    GCPSTSServiceAccountData: GCPSTSServiceAccountData_1.GCPSTSServiceAccountData,
    GCPSTSServiceAccountResponse: GCPSTSServiceAccountResponse_1.GCPSTSServiceAccountResponse,
    GCPSTSServiceAccountUpdateRequest: GCPSTSServiceAccountUpdateRequest_1.GCPSTSServiceAccountUpdateRequest,
    GCPSTSServiceAccountUpdateRequestData: GCPSTSServiceAccountUpdateRequestData_1.GCPSTSServiceAccountUpdateRequestData,
    GCPSTSServiceAccountsResponse: GCPSTSServiceAccountsResponse_1.GCPSTSServiceAccountsResponse,
    GCPServiceAccountMeta: GCPServiceAccountMeta_1.GCPServiceAccountMeta,
    GetActionConnectionResponse: GetActionConnectionResponse_1.GetActionConnectionResponse,
    GetAppResponse: GetAppResponse_1.GetAppResponse,
    GetAppResponseData: GetAppResponseData_1.GetAppResponseData,
    GetAppResponseDataAttributes: GetAppResponseDataAttributes_1.GetAppResponseDataAttributes,
    GetCustomFrameworkResponse: GetCustomFrameworkResponse_1.GetCustomFrameworkResponse,
    GetDataDeletionsResponseBody: GetDataDeletionsResponseBody_1.GetDataDeletionsResponseBody,
    GetDeviceAttributes: GetDeviceAttributes_1.GetDeviceAttributes,
    GetDeviceData: GetDeviceData_1.GetDeviceData,
    GetDeviceResponse: GetDeviceResponse_1.GetDeviceResponse,
    GetFindingResponse: GetFindingResponse_1.GetFindingResponse,
    GetInterfacesData: GetInterfacesData_1.GetInterfacesData,
    GetInterfacesResponse: GetInterfacesResponse_1.GetInterfacesResponse,
    GetResourceEvaluationFiltersResponse: GetResourceEvaluationFiltersResponse_1.GetResourceEvaluationFiltersResponse,
    GetResourceEvaluationFiltersResponseData: GetResourceEvaluationFiltersResponseData_1.GetResourceEvaluationFiltersResponseData,
    GetRuleVersionHistoryData: GetRuleVersionHistoryData_1.GetRuleVersionHistoryData,
    GetRuleVersionHistoryResponse: GetRuleVersionHistoryResponse_1.GetRuleVersionHistoryResponse,
    GetSBOMResponse: GetSBOMResponse_1.GetSBOMResponse,
    GetWorkflowResponse: GetWorkflowResponse_1.GetWorkflowResponse,
    GithubWebhookTrigger: GithubWebhookTrigger_1.GithubWebhookTrigger,
    GithubWebhookTriggerWrapper: GithubWebhookTriggerWrapper_1.GithubWebhookTriggerWrapper,
    GroupScalarColumn: GroupScalarColumn_1.GroupScalarColumn,
    HTTPBody: HTTPBody_1.HTTPBody,
    HTTPCIAppError: HTTPCIAppError_1.HTTPCIAppError,
    HTTPCIAppErrors: HTTPCIAppErrors_1.HTTPCIAppErrors,
    HTTPHeader: HTTPHeader_1.HTTPHeader,
    HTTPHeaderUpdate: HTTPHeaderUpdate_1.HTTPHeaderUpdate,
    HTTPIntegration: HTTPIntegration_1.HTTPIntegration,
    HTTPIntegrationUpdate: HTTPIntegrationUpdate_1.HTTPIntegrationUpdate,
    HTTPLogError: HTTPLogError_1.HTTPLogError,
    HTTPLogErrors: HTTPLogErrors_1.HTTPLogErrors,
    HTTPLogItem: HTTPLogItem_1.HTTPLogItem,
    HTTPToken: HTTPToken_1.HTTPToken,
    HTTPTokenAuth: HTTPTokenAuth_1.HTTPTokenAuth,
    HTTPTokenAuthUpdate: HTTPTokenAuthUpdate_1.HTTPTokenAuthUpdate,
    HTTPTokenUpdate: HTTPTokenUpdate_1.HTTPTokenUpdate,
    HistoricalJobListMeta: HistoricalJobListMeta_1.HistoricalJobListMeta,
    HistoricalJobOptions: HistoricalJobOptions_1.HistoricalJobOptions,
    HistoricalJobQuery: HistoricalJobQuery_1.HistoricalJobQuery,
    HistoricalJobResponse: HistoricalJobResponse_1.HistoricalJobResponse,
    HistoricalJobResponseAttributes: HistoricalJobResponseAttributes_1.HistoricalJobResponseAttributes,
    HistoricalJobResponseData: HistoricalJobResponseData_1.HistoricalJobResponseData,
    HourlyUsage: HourlyUsage_1.HourlyUsage,
    HourlyUsageAttributes: HourlyUsageAttributes_1.HourlyUsageAttributes,
    HourlyUsageMeasurement: HourlyUsageMeasurement_1.HourlyUsageMeasurement,
    HourlyUsageMetadata: HourlyUsageMetadata_1.HourlyUsageMetadata,
    HourlyUsagePagination: HourlyUsagePagination_1.HourlyUsagePagination,
    HourlyUsageResponse: HourlyUsageResponse_1.HourlyUsageResponse,
    IPAllowlistAttributes: IPAllowlistAttributes_1.IPAllowlistAttributes,
    IPAllowlistData: IPAllowlistData_1.IPAllowlistData,
    IPAllowlistEntry: IPAllowlistEntry_1.IPAllowlistEntry,
    IPAllowlistEntryAttributes: IPAllowlistEntryAttributes_1.IPAllowlistEntryAttributes,
    IPAllowlistEntryData: IPAllowlistEntryData_1.IPAllowlistEntryData,
    IPAllowlistResponse: IPAllowlistResponse_1.IPAllowlistResponse,
    IPAllowlistUpdateRequest: IPAllowlistUpdateRequest_1.IPAllowlistUpdateRequest,
    IdPMetadataFormData: IdPMetadataFormData_1.IdPMetadataFormData,
    IncidentAttachmentData: IncidentAttachmentData_1.IncidentAttachmentData,
    IncidentAttachmentLinkAttributes: IncidentAttachmentLinkAttributes_1.IncidentAttachmentLinkAttributes,
    IncidentAttachmentLinkAttributesAttachmentObject: IncidentAttachmentLinkAttributesAttachmentObject_1.IncidentAttachmentLinkAttributesAttachmentObject,
    IncidentAttachmentPostmortemAttributes: IncidentAttachmentPostmortemAttributes_1.IncidentAttachmentPostmortemAttributes,
    IncidentAttachmentRelationships: IncidentAttachmentRelationships_1.IncidentAttachmentRelationships,
    IncidentAttachmentUpdateData: IncidentAttachmentUpdateData_1.IncidentAttachmentUpdateData,
    IncidentAttachmentUpdateRequest: IncidentAttachmentUpdateRequest_1.IncidentAttachmentUpdateRequest,
    IncidentAttachmentUpdateResponse: IncidentAttachmentUpdateResponse_1.IncidentAttachmentUpdateResponse,
    IncidentAttachmentsPostmortemAttributesAttachmentObject: IncidentAttachmentsPostmortemAttributesAttachmentObject_1.IncidentAttachmentsPostmortemAttributesAttachmentObject,
    IncidentAttachmentsResponse: IncidentAttachmentsResponse_1.IncidentAttachmentsResponse,
    IncidentCreateAttributes: IncidentCreateAttributes_1.IncidentCreateAttributes,
    IncidentCreateData: IncidentCreateData_1.IncidentCreateData,
    IncidentCreateRelationships: IncidentCreateRelationships_1.IncidentCreateRelationships,
    IncidentCreateRequest: IncidentCreateRequest_1.IncidentCreateRequest,
    IncidentFieldAttributesMultipleValue: IncidentFieldAttributesMultipleValue_1.IncidentFieldAttributesMultipleValue,
    IncidentFieldAttributesSingleValue: IncidentFieldAttributesSingleValue_1.IncidentFieldAttributesSingleValue,
    IncidentIntegrationMetadataAttributes: IncidentIntegrationMetadataAttributes_1.IncidentIntegrationMetadataAttributes,
    IncidentIntegrationMetadataCreateData: IncidentIntegrationMetadataCreateData_1.IncidentIntegrationMetadataCreateData,
    IncidentIntegrationMetadataCreateRequest: IncidentIntegrationMetadataCreateRequest_1.IncidentIntegrationMetadataCreateRequest,
    IncidentIntegrationMetadataListResponse: IncidentIntegrationMetadataListResponse_1.IncidentIntegrationMetadataListResponse,
    IncidentIntegrationMetadataPatchData: IncidentIntegrationMetadataPatchData_1.IncidentIntegrationMetadataPatchData,
    IncidentIntegrationMetadataPatchRequest: IncidentIntegrationMetadataPatchRequest_1.IncidentIntegrationMetadataPatchRequest,
    IncidentIntegrationMetadataResponse: IncidentIntegrationMetadataResponse_1.IncidentIntegrationMetadataResponse,
    IncidentIntegrationMetadataResponseData: IncidentIntegrationMetadataResponseData_1.IncidentIntegrationMetadataResponseData,
    IncidentIntegrationRelationships: IncidentIntegrationRelationships_1.IncidentIntegrationRelationships,
    IncidentNonDatadogCreator: IncidentNonDatadogCreator_1.IncidentNonDatadogCreator,
    IncidentNotificationHandle: IncidentNotificationHandle_1.IncidentNotificationHandle,
    IncidentResponse: IncidentResponse_1.IncidentResponse,
    IncidentResponseAttributes: IncidentResponseAttributes_1.IncidentResponseAttributes,
    IncidentResponseData: IncidentResponseData_1.IncidentResponseData,
    IncidentResponseMeta: IncidentResponseMeta_1.IncidentResponseMeta,
    IncidentResponseMetaPagination: IncidentResponseMetaPagination_1.IncidentResponseMetaPagination,
    IncidentResponseRelationships: IncidentResponseRelationships_1.IncidentResponseRelationships,
    IncidentSearchResponse: IncidentSearchResponse_1.IncidentSearchResponse,
    IncidentSearchResponseAttributes: IncidentSearchResponseAttributes_1.IncidentSearchResponseAttributes,
    IncidentSearchResponseData: IncidentSearchResponseData_1.IncidentSearchResponseData,
    IncidentSearchResponseFacetsData: IncidentSearchResponseFacetsData_1.IncidentSearchResponseFacetsData,
    IncidentSearchResponseFieldFacetData: IncidentSearchResponseFieldFacetData_1.IncidentSearchResponseFieldFacetData,
    IncidentSearchResponseIncidentsData: IncidentSearchResponseIncidentsData_1.IncidentSearchResponseIncidentsData,
    IncidentSearchResponseMeta: IncidentSearchResponseMeta_1.IncidentSearchResponseMeta,
    IncidentSearchResponseNumericFacetData: IncidentSearchResponseNumericFacetData_1.IncidentSearchResponseNumericFacetData,
    IncidentSearchResponseNumericFacetDataAggregates: IncidentSearchResponseNumericFacetDataAggregates_1.IncidentSearchResponseNumericFacetDataAggregates,
    IncidentSearchResponsePropertyFieldFacetData: IncidentSearchResponsePropertyFieldFacetData_1.IncidentSearchResponsePropertyFieldFacetData,
    IncidentSearchResponseUserFacetData: IncidentSearchResponseUserFacetData_1.IncidentSearchResponseUserFacetData,
    IncidentServiceCreateAttributes: IncidentServiceCreateAttributes_1.IncidentServiceCreateAttributes,
    IncidentServiceCreateData: IncidentServiceCreateData_1.IncidentServiceCreateData,
    IncidentServiceCreateRequest: IncidentServiceCreateRequest_1.IncidentServiceCreateRequest,
    IncidentServiceRelationships: IncidentServiceRelationships_1.IncidentServiceRelationships,
    IncidentServiceResponse: IncidentServiceResponse_1.IncidentServiceResponse,
    IncidentServiceResponseAttributes: IncidentServiceResponseAttributes_1.IncidentServiceResponseAttributes,
    IncidentServiceResponseData: IncidentServiceResponseData_1.IncidentServiceResponseData,
    IncidentServiceUpdateAttributes: IncidentServiceUpdateAttributes_1.IncidentServiceUpdateAttributes,
    IncidentServiceUpdateData: IncidentServiceUpdateData_1.IncidentServiceUpdateData,
    IncidentServiceUpdateRequest: IncidentServiceUpdateRequest_1.IncidentServiceUpdateRequest,
    IncidentServicesResponse: IncidentServicesResponse_1.IncidentServicesResponse,
    IncidentTeamCreateAttributes: IncidentTeamCreateAttributes_1.IncidentTeamCreateAttributes,
    IncidentTeamCreateData: IncidentTeamCreateData_1.IncidentTeamCreateData,
    IncidentTeamCreateRequest: IncidentTeamCreateRequest_1.IncidentTeamCreateRequest,
    IncidentTeamRelationships: IncidentTeamRelationships_1.IncidentTeamRelationships,
    IncidentTeamResponse: IncidentTeamResponse_1.IncidentTeamResponse,
    IncidentTeamResponseAttributes: IncidentTeamResponseAttributes_1.IncidentTeamResponseAttributes,
    IncidentTeamResponseData: IncidentTeamResponseData_1.IncidentTeamResponseData,
    IncidentTeamUpdateAttributes: IncidentTeamUpdateAttributes_1.IncidentTeamUpdateAttributes,
    IncidentTeamUpdateData: IncidentTeamUpdateData_1.IncidentTeamUpdateData,
    IncidentTeamUpdateRequest: IncidentTeamUpdateRequest_1.IncidentTeamUpdateRequest,
    IncidentTeamsResponse: IncidentTeamsResponse_1.IncidentTeamsResponse,
    IncidentTimelineCellMarkdownCreateAttributes: IncidentTimelineCellMarkdownCreateAttributes_1.IncidentTimelineCellMarkdownCreateAttributes,
    IncidentTimelineCellMarkdownCreateAttributesContent: IncidentTimelineCellMarkdownCreateAttributesContent_1.IncidentTimelineCellMarkdownCreateAttributesContent,
    IncidentTodoAnonymousAssignee: IncidentTodoAnonymousAssignee_1.IncidentTodoAnonymousAssignee,
    IncidentTodoAttributes: IncidentTodoAttributes_1.IncidentTodoAttributes,
    IncidentTodoCreateData: IncidentTodoCreateData_1.IncidentTodoCreateData,
    IncidentTodoCreateRequest: IncidentTodoCreateRequest_1.IncidentTodoCreateRequest,
    IncidentTodoListResponse: IncidentTodoListResponse_1.IncidentTodoListResponse,
    IncidentTodoPatchData: IncidentTodoPatchData_1.IncidentTodoPatchData,
    IncidentTodoPatchRequest: IncidentTodoPatchRequest_1.IncidentTodoPatchRequest,
    IncidentTodoRelationships: IncidentTodoRelationships_1.IncidentTodoRelationships,
    IncidentTodoResponse: IncidentTodoResponse_1.IncidentTodoResponse,
    IncidentTodoResponseData: IncidentTodoResponseData_1.IncidentTodoResponseData,
    IncidentTrigger: IncidentTrigger_1.IncidentTrigger,
    IncidentTriggerWrapper: IncidentTriggerWrapper_1.IncidentTriggerWrapper,
    IncidentTypeAttributes: IncidentTypeAttributes_1.IncidentTypeAttributes,
    IncidentTypeCreateData: IncidentTypeCreateData_1.IncidentTypeCreateData,
    IncidentTypeCreateRequest: IncidentTypeCreateRequest_1.IncidentTypeCreateRequest,
    IncidentTypeListResponse: IncidentTypeListResponse_1.IncidentTypeListResponse,
    IncidentTypeObject: IncidentTypeObject_1.IncidentTypeObject,
    IncidentTypePatchData: IncidentTypePatchData_1.IncidentTypePatchData,
    IncidentTypePatchRequest: IncidentTypePatchRequest_1.IncidentTypePatchRequest,
    IncidentTypeResponse: IncidentTypeResponse_1.IncidentTypeResponse,
    IncidentTypeUpdateAttributes: IncidentTypeUpdateAttributes_1.IncidentTypeUpdateAttributes,
    IncidentUpdateAttributes: IncidentUpdateAttributes_1.IncidentUpdateAttributes,
    IncidentUpdateData: IncidentUpdateData_1.IncidentUpdateData,
    IncidentUpdateRelationships: IncidentUpdateRelationships_1.IncidentUpdateRelationships,
    IncidentUpdateRequest: IncidentUpdateRequest_1.IncidentUpdateRequest,
    IncidentUserAttributes: IncidentUserAttributes_1.IncidentUserAttributes,
    IncidentUserData: IncidentUserData_1.IncidentUserData,
    IncidentsResponse: IncidentsResponse_1.IncidentsResponse,
    InputSchema: InputSchema_1.InputSchema,
    InputSchemaParameters: InputSchemaParameters_1.InputSchemaParameters,
    IntakePayloadAccepted: IntakePayloadAccepted_1.IntakePayloadAccepted,
    InterfaceAttributes: InterfaceAttributes_1.InterfaceAttributes,
    JSONAPIErrorItem: JSONAPIErrorItem_1.JSONAPIErrorItem,
    JSONAPIErrorItemSource: JSONAPIErrorItemSource_1.JSONAPIErrorItemSource,
    JSONAPIErrorResponse: JSONAPIErrorResponse_1.JSONAPIErrorResponse,
    JiraIntegrationMetadata: JiraIntegrationMetadata_1.JiraIntegrationMetadata,
    JiraIntegrationMetadataIssuesItem: JiraIntegrationMetadataIssuesItem_1.JiraIntegrationMetadataIssuesItem,
    JiraIssue: JiraIssue_1.JiraIssue,
    JiraIssueResult: JiraIssueResult_1.JiraIssueResult,
    JobCreateResponse: JobCreateResponse_1.JobCreateResponse,
    JobCreateResponseData: JobCreateResponseData_1.JobCreateResponseData,
    JobDefinition: JobDefinition_1.JobDefinition,
    JobDefinitionFromRule: JobDefinitionFromRule_1.JobDefinitionFromRule,
    Layer: Layer_1.Layer,
    LayerAttributes: LayerAttributes_1.LayerAttributes,
    LayerAttributesInterval: LayerAttributesInterval_1.LayerAttributesInterval,
    LayerRelationships: LayerRelationships_1.LayerRelationships,
    LayerRelationshipsMembers: LayerRelationshipsMembers_1.LayerRelationshipsMembers,
    LayerRelationshipsMembersDataItems: LayerRelationshipsMembersDataItems_1.LayerRelationshipsMembersDataItems,
    LeakedKey: LeakedKey_1.LeakedKey,
    LeakedKeyAttributes: LeakedKeyAttributes_1.LeakedKeyAttributes,
    Library: Library_1.Library,
    Links: Links_1.Links,
    ListAPIsResponse: ListAPIsResponse_1.ListAPIsResponse,
    ListAPIsResponseData: ListAPIsResponseData_1.ListAPIsResponseData,
    ListAPIsResponseDataAttributes: ListAPIsResponseDataAttributes_1.ListAPIsResponseDataAttributes,
    ListAPIsResponseMeta: ListAPIsResponseMeta_1.ListAPIsResponseMeta,
    ListAPIsResponseMetaPagination: ListAPIsResponseMetaPagination_1.ListAPIsResponseMetaPagination,
    ListApplicationKeysResponse: ListApplicationKeysResponse_1.ListApplicationKeysResponse,
    ListAppsResponse: ListAppsResponse_1.ListAppsResponse,
    ListAppsResponseDataItems: ListAppsResponseDataItems_1.ListAppsResponseDataItems,
    ListAppsResponseDataItemsAttributes: ListAppsResponseDataItemsAttributes_1.ListAppsResponseDataItemsAttributes,
    ListAppsResponseDataItemsRelationships: ListAppsResponseDataItemsRelationships_1.ListAppsResponseDataItemsRelationships,
    ListAppsResponseMeta: ListAppsResponseMeta_1.ListAppsResponseMeta,
    ListAppsResponseMetaPage: ListAppsResponseMetaPage_1.ListAppsResponseMetaPage,
    ListDevicesResponse: ListDevicesResponse_1.ListDevicesResponse,
    ListDevicesResponseMetadata: ListDevicesResponseMetadata_1.ListDevicesResponseMetadata,
    ListDevicesResponseMetadataPage: ListDevicesResponseMetadataPage_1.ListDevicesResponseMetadataPage,
    ListDowntimesResponse: ListDowntimesResponse_1.ListDowntimesResponse,
    ListEntityCatalogResponse: ListEntityCatalogResponse_1.ListEntityCatalogResponse,
    ListEntityCatalogResponseLinks: ListEntityCatalogResponseLinks_1.ListEntityCatalogResponseLinks,
    ListFindingsMeta: ListFindingsMeta_1.ListFindingsMeta,
    ListFindingsPage: ListFindingsPage_1.ListFindingsPage,
    ListFindingsResponse: ListFindingsResponse_1.ListFindingsResponse,
    ListHistoricalJobsResponse: ListHistoricalJobsResponse_1.ListHistoricalJobsResponse,
    ListPipelinesResponse: ListPipelinesResponse_1.ListPipelinesResponse,
    ListPipelinesResponseMeta: ListPipelinesResponseMeta_1.ListPipelinesResponseMeta,
    ListPowerpacksResponse: ListPowerpacksResponse_1.ListPowerpacksResponse,
    ListRelationCatalogResponse: ListRelationCatalogResponse_1.ListRelationCatalogResponse,
    ListRelationCatalogResponseLinks: ListRelationCatalogResponseLinks_1.ListRelationCatalogResponseLinks,
    ListRulesResponse: ListRulesResponse_1.ListRulesResponse,
    ListRulesResponseDataItem: ListRulesResponseDataItem_1.ListRulesResponseDataItem,
    ListRulesResponseLinks: ListRulesResponseLinks_1.ListRulesResponseLinks,
    ListTagsResponse: ListTagsResponse_1.ListTagsResponse,
    ListTagsResponseData: ListTagsResponseData_1.ListTagsResponseData,
    ListTagsResponseDataAttributes: ListTagsResponseDataAttributes_1.ListTagsResponseDataAttributes,
    ListVulnerabilitiesResponse: ListVulnerabilitiesResponse_1.ListVulnerabilitiesResponse,
    ListVulnerableAssetsResponse: ListVulnerableAssetsResponse_1.ListVulnerableAssetsResponse,
    Log: Log_1.Log,
    LogAttributes: LogAttributes_1.LogAttributes,
    LogsAggregateBucket: LogsAggregateBucket_1.LogsAggregateBucket,
    LogsAggregateBucketValueTimeseriesPoint: LogsAggregateBucketValueTimeseriesPoint_1.LogsAggregateBucketValueTimeseriesPoint,
    LogsAggregateRequest: LogsAggregateRequest_1.LogsAggregateRequest,
    LogsAggregateRequestPage: LogsAggregateRequestPage_1.LogsAggregateRequestPage,
    LogsAggregateResponse: LogsAggregateResponse_1.LogsAggregateResponse,
    LogsAggregateResponseData: LogsAggregateResponseData_1.LogsAggregateResponseData,
    LogsAggregateSort: LogsAggregateSort_1.LogsAggregateSort,
    LogsArchive: LogsArchive_1.LogsArchive,
    LogsArchiveAttributes: LogsArchiveAttributes_1.LogsArchiveAttributes,
    LogsArchiveCreateRequest: LogsArchiveCreateRequest_1.LogsArchiveCreateRequest,
    LogsArchiveCreateRequestAttributes: LogsArchiveCreateRequestAttributes_1.LogsArchiveCreateRequestAttributes,
    LogsArchiveCreateRequestDefinition: LogsArchiveCreateRequestDefinition_1.LogsArchiveCreateRequestDefinition,
    LogsArchiveDefinition: LogsArchiveDefinition_1.LogsArchiveDefinition,
    LogsArchiveDestinationAzure: LogsArchiveDestinationAzure_1.LogsArchiveDestinationAzure,
    LogsArchiveDestinationGCS: LogsArchiveDestinationGCS_1.LogsArchiveDestinationGCS,
    LogsArchiveDestinationS3: LogsArchiveDestinationS3_1.LogsArchiveDestinationS3,
    LogsArchiveEncryptionS3: LogsArchiveEncryptionS3_1.LogsArchiveEncryptionS3,
    LogsArchiveIntegrationAzure: LogsArchiveIntegrationAzure_1.LogsArchiveIntegrationAzure,
    LogsArchiveIntegrationGCS: LogsArchiveIntegrationGCS_1.LogsArchiveIntegrationGCS,
    LogsArchiveIntegrationS3: LogsArchiveIntegrationS3_1.LogsArchiveIntegrationS3,
    LogsArchiveOrder: LogsArchiveOrder_1.LogsArchiveOrder,
    LogsArchiveOrderAttributes: LogsArchiveOrderAttributes_1.LogsArchiveOrderAttributes,
    LogsArchiveOrderDefinition: LogsArchiveOrderDefinition_1.LogsArchiveOrderDefinition,
    LogsArchives: LogsArchives_1.LogsArchives,
    LogsCompute: LogsCompute_1.LogsCompute,
    LogsGroupBy: LogsGroupBy_1.LogsGroupBy,
    LogsGroupByHistogram: LogsGroupByHistogram_1.LogsGroupByHistogram,
    LogsListRequest: LogsListRequest_1.LogsListRequest,
    LogsListRequestPage: LogsListRequestPage_1.LogsListRequestPage,
    LogsListResponse: LogsListResponse_1.LogsListResponse,
    LogsListResponseLinks: LogsListResponseLinks_1.LogsListResponseLinks,
    LogsMetricCompute: LogsMetricCompute_1.LogsMetricCompute,
    LogsMetricCreateAttributes: LogsMetricCreateAttributes_1.LogsMetricCreateAttributes,
    LogsMetricCreateData: LogsMetricCreateData_1.LogsMetricCreateData,
    LogsMetricCreateRequest: LogsMetricCreateRequest_1.LogsMetricCreateRequest,
    LogsMetricFilter: LogsMetricFilter_1.LogsMetricFilter,
    LogsMetricGroupBy: LogsMetricGroupBy_1.LogsMetricGroupBy,
    LogsMetricResponse: LogsMetricResponse_1.LogsMetricResponse,
    LogsMetricResponseAttributes: LogsMetricResponseAttributes_1.LogsMetricResponseAttributes,
    LogsMetricResponseCompute: LogsMetricResponseCompute_1.LogsMetricResponseCompute,
    LogsMetricResponseData: LogsMetricResponseData_1.LogsMetricResponseData,
    LogsMetricResponseFilter: LogsMetricResponseFilter_1.LogsMetricResponseFilter,
    LogsMetricResponseGroupBy: LogsMetricResponseGroupBy_1.LogsMetricResponseGroupBy,
    LogsMetricUpdateAttributes: LogsMetricUpdateAttributes_1.LogsMetricUpdateAttributes,
    LogsMetricUpdateCompute: LogsMetricUpdateCompute_1.LogsMetricUpdateCompute,
    LogsMetricUpdateData: LogsMetricUpdateData_1.LogsMetricUpdateData,
    LogsMetricUpdateRequest: LogsMetricUpdateRequest_1.LogsMetricUpdateRequest,
    LogsMetricsResponse: LogsMetricsResponse_1.LogsMetricsResponse,
    LogsQueryFilter: LogsQueryFilter_1.LogsQueryFilter,
    LogsQueryOptions: LogsQueryOptions_1.LogsQueryOptions,
    LogsResponseMetadata: LogsResponseMetadata_1.LogsResponseMetadata,
    LogsResponseMetadataPage: LogsResponseMetadataPage_1.LogsResponseMetadataPage,
    LogsWarning: LogsWarning_1.LogsWarning,
    MSTeamsIntegrationMetadata: MSTeamsIntegrationMetadata_1.MSTeamsIntegrationMetadata,
    MSTeamsIntegrationMetadataTeamsItem: MSTeamsIntegrationMetadataTeamsItem_1.MSTeamsIntegrationMetadataTeamsItem,
    Metadata: Metadata_1.Metadata,
    Metric: Metric_1.Metric,
    MetricAllTags: MetricAllTags_1.MetricAllTags,
    MetricAllTagsAttributes: MetricAllTagsAttributes_1.MetricAllTagsAttributes,
    MetricAllTagsResponse: MetricAllTagsResponse_1.MetricAllTagsResponse,
    MetricAssetAttributes: MetricAssetAttributes_1.MetricAssetAttributes,
    MetricAssetDashboardRelationship: MetricAssetDashboardRelationship_1.MetricAssetDashboardRelationship,
    MetricAssetDashboardRelationships: MetricAssetDashboardRelationships_1.MetricAssetDashboardRelationships,
    MetricAssetMonitorRelationship: MetricAssetMonitorRelationship_1.MetricAssetMonitorRelationship,
    MetricAssetMonitorRelationships: MetricAssetMonitorRelationships_1.MetricAssetMonitorRelationships,
    MetricAssetNotebookRelationship: MetricAssetNotebookRelationship_1.MetricAssetNotebookRelationship,
    MetricAssetNotebookRelationships: MetricAssetNotebookRelationships_1.MetricAssetNotebookRelationships,
    MetricAssetResponseData: MetricAssetResponseData_1.MetricAssetResponseData,
    MetricAssetResponseRelationships: MetricAssetResponseRelationships_1.MetricAssetResponseRelationships,
    MetricAssetSLORelationship: MetricAssetSLORelationship_1.MetricAssetSLORelationship,
    MetricAssetSLORelationships: MetricAssetSLORelationships_1.MetricAssetSLORelationships,
    MetricAssetsResponse: MetricAssetsResponse_1.MetricAssetsResponse,
    MetricBulkTagConfigCreate: MetricBulkTagConfigCreate_1.MetricBulkTagConfigCreate,
    MetricBulkTagConfigCreateAttributes: MetricBulkTagConfigCreateAttributes_1.MetricBulkTagConfigCreateAttributes,
    MetricBulkTagConfigCreateRequest: MetricBulkTagConfigCreateRequest_1.MetricBulkTagConfigCreateRequest,
    MetricBulkTagConfigDelete: MetricBulkTagConfigDelete_1.MetricBulkTagConfigDelete,
    MetricBulkTagConfigDeleteAttributes: MetricBulkTagConfigDeleteAttributes_1.MetricBulkTagConfigDeleteAttributes,
    MetricBulkTagConfigDeleteRequest: MetricBulkTagConfigDeleteRequest_1.MetricBulkTagConfigDeleteRequest,
    MetricBulkTagConfigResponse: MetricBulkTagConfigResponse_1.MetricBulkTagConfigResponse,
    MetricBulkTagConfigStatus: MetricBulkTagConfigStatus_1.MetricBulkTagConfigStatus,
    MetricBulkTagConfigStatusAttributes: MetricBulkTagConfigStatusAttributes_1.MetricBulkTagConfigStatusAttributes,
    MetricCustomAggregation: MetricCustomAggregation_1.MetricCustomAggregation,
    MetricDashboardAsset: MetricDashboardAsset_1.MetricDashboardAsset,
    MetricDashboardAttributes: MetricDashboardAttributes_1.MetricDashboardAttributes,
    MetricDistinctVolume: MetricDistinctVolume_1.MetricDistinctVolume,
    MetricDistinctVolumeAttributes: MetricDistinctVolumeAttributes_1.MetricDistinctVolumeAttributes,
    MetricEstimate: MetricEstimate_1.MetricEstimate,
    MetricEstimateAttributes: MetricEstimateAttributes_1.MetricEstimateAttributes,
    MetricEstimateResponse: MetricEstimateResponse_1.MetricEstimateResponse,
    MetricIngestedIndexedVolume: MetricIngestedIndexedVolume_1.MetricIngestedIndexedVolume,
    MetricIngestedIndexedVolumeAttributes: MetricIngestedIndexedVolumeAttributes_1.MetricIngestedIndexedVolumeAttributes,
    MetricMetaPage: MetricMetaPage_1.MetricMetaPage,
    MetricMetadata: MetricMetadata_1.MetricMetadata,
    MetricMonitorAsset: MetricMonitorAsset_1.MetricMonitorAsset,
    MetricNotebookAsset: MetricNotebookAsset_1.MetricNotebookAsset,
    MetricOrigin: MetricOrigin_1.MetricOrigin,
    MetricPaginationMeta: MetricPaginationMeta_1.MetricPaginationMeta,
    MetricPayload: MetricPayload_1.MetricPayload,
    MetricPoint: MetricPoint_1.MetricPoint,
    MetricResource: MetricResource_1.MetricResource,
    MetricSLOAsset: MetricSLOAsset_1.MetricSLOAsset,
    MetricSeries: MetricSeries_1.MetricSeries,
    MetricSuggestedTagsAndAggregations: MetricSuggestedTagsAndAggregations_1.MetricSuggestedTagsAndAggregations,
    MetricSuggestedTagsAndAggregationsResponse: MetricSuggestedTagsAndAggregationsResponse_1.MetricSuggestedTagsAndAggregationsResponse,
    MetricSuggestedTagsAttributes: MetricSuggestedTagsAttributes_1.MetricSuggestedTagsAttributes,
    MetricTagConfiguration: MetricTagConfiguration_1.MetricTagConfiguration,
    MetricTagConfigurationAttributes: MetricTagConfigurationAttributes_1.MetricTagConfigurationAttributes,
    MetricTagConfigurationCreateAttributes: MetricTagConfigurationCreateAttributes_1.MetricTagConfigurationCreateAttributes,
    MetricTagConfigurationCreateData: MetricTagConfigurationCreateData_1.MetricTagConfigurationCreateData,
    MetricTagConfigurationCreateRequest: MetricTagConfigurationCreateRequest_1.MetricTagConfigurationCreateRequest,
    MetricTagConfigurationResponse: MetricTagConfigurationResponse_1.MetricTagConfigurationResponse,
    MetricTagConfigurationUpdateAttributes: MetricTagConfigurationUpdateAttributes_1.MetricTagConfigurationUpdateAttributes,
    MetricTagConfigurationUpdateData: MetricTagConfigurationUpdateData_1.MetricTagConfigurationUpdateData,
    MetricTagConfigurationUpdateRequest: MetricTagConfigurationUpdateRequest_1.MetricTagConfigurationUpdateRequest,
    MetricVolumesResponse: MetricVolumesResponse_1.MetricVolumesResponse,
    MetricsAndMetricTagConfigurationsResponse: MetricsAndMetricTagConfigurationsResponse_1.MetricsAndMetricTagConfigurationsResponse,
    MetricsListResponseLinks: MetricsListResponseLinks_1.MetricsListResponseLinks,
    MetricsScalarQuery: MetricsScalarQuery_1.MetricsScalarQuery,
    MetricsTimeseriesQuery: MetricsTimeseriesQuery_1.MetricsTimeseriesQuery,
    MicrosoftSentinelDestination: MicrosoftSentinelDestination_1.MicrosoftSentinelDestination,
    MicrosoftTeamsChannelInfoResponseAttributes: MicrosoftTeamsChannelInfoResponseAttributes_1.MicrosoftTeamsChannelInfoResponseAttributes,
    MicrosoftTeamsChannelInfoResponseData: MicrosoftTeamsChannelInfoResponseData_1.MicrosoftTeamsChannelInfoResponseData,
    MicrosoftTeamsCreateTenantBasedHandleRequest: MicrosoftTeamsCreateTenantBasedHandleRequest_1.MicrosoftTeamsCreateTenantBasedHandleRequest,
    MicrosoftTeamsCreateWorkflowsWebhookHandleRequest: MicrosoftTeamsCreateWorkflowsWebhookHandleRequest_1.MicrosoftTeamsCreateWorkflowsWebhookHandleRequest,
    MicrosoftTeamsGetChannelByNameResponse: MicrosoftTeamsGetChannelByNameResponse_1.MicrosoftTeamsGetChannelByNameResponse,
    MicrosoftTeamsTenantBasedHandleAttributes: MicrosoftTeamsTenantBasedHandleAttributes_1.MicrosoftTeamsTenantBasedHandleAttributes,
    MicrosoftTeamsTenantBasedHandleInfoResponseAttributes: MicrosoftTeamsTenantBasedHandleInfoResponseAttributes_1.MicrosoftTeamsTenantBasedHandleInfoResponseAttributes,
    MicrosoftTeamsTenantBasedHandleInfoResponseData: MicrosoftTeamsTenantBasedHandleInfoResponseData_1.MicrosoftTeamsTenantBasedHandleInfoResponseData,
    MicrosoftTeamsTenantBasedHandleRequestAttributes: MicrosoftTeamsTenantBasedHandleRequestAttributes_1.MicrosoftTeamsTenantBasedHandleRequestAttributes,
    MicrosoftTeamsTenantBasedHandleRequestData: MicrosoftTeamsTenantBasedHandleRequestData_1.MicrosoftTeamsTenantBasedHandleRequestData,
    MicrosoftTeamsTenantBasedHandleResponse: MicrosoftTeamsTenantBasedHandleResponse_1.MicrosoftTeamsTenantBasedHandleResponse,
    MicrosoftTeamsTenantBasedHandleResponseData: MicrosoftTeamsTenantBasedHandleResponseData_1.MicrosoftTeamsTenantBasedHandleResponseData,
    MicrosoftTeamsTenantBasedHandlesResponse: MicrosoftTeamsTenantBasedHandlesResponse_1.MicrosoftTeamsTenantBasedHandlesResponse,
    MicrosoftTeamsUpdateTenantBasedHandleRequest: MicrosoftTeamsUpdateTenantBasedHandleRequest_1.MicrosoftTeamsUpdateTenantBasedHandleRequest,
    MicrosoftTeamsUpdateTenantBasedHandleRequestData: MicrosoftTeamsUpdateTenantBasedHandleRequestData_1.MicrosoftTeamsUpdateTenantBasedHandleRequestData,
    MicrosoftTeamsUpdateWorkflowsWebhookHandleRequest: MicrosoftTeamsUpdateWorkflowsWebhookHandleRequest_1.MicrosoftTeamsUpdateWorkflowsWebhookHandleRequest,
    MicrosoftTeamsUpdateWorkflowsWebhookHandleRequestData: MicrosoftTeamsUpdateWorkflowsWebhookHandleRequestData_1.MicrosoftTeamsUpdateWorkflowsWebhookHandleRequestData,
    MicrosoftTeamsWorkflowsWebhookHandleAttributes: MicrosoftTeamsWorkflowsWebhookHandleAttributes_1.MicrosoftTeamsWorkflowsWebhookHandleAttributes,
    MicrosoftTeamsWorkflowsWebhookHandleRequestAttributes: MicrosoftTeamsWorkflowsWebhookHandleRequestAttributes_1.MicrosoftTeamsWorkflowsWebhookHandleRequestAttributes,
    MicrosoftTeamsWorkflowsWebhookHandleRequestData: MicrosoftTeamsWorkflowsWebhookHandleRequestData_1.MicrosoftTeamsWorkflowsWebhookHandleRequestData,
    MicrosoftTeamsWorkflowsWebhookHandleResponse: MicrosoftTeamsWorkflowsWebhookHandleResponse_1.MicrosoftTeamsWorkflowsWebhookHandleResponse,
    MicrosoftTeamsWorkflowsWebhookHandleResponseData: MicrosoftTeamsWorkflowsWebhookHandleResponseData_1.MicrosoftTeamsWorkflowsWebhookHandleResponseData,
    MicrosoftTeamsWorkflowsWebhookHandlesResponse: MicrosoftTeamsWorkflowsWebhookHandlesResponse_1.MicrosoftTeamsWorkflowsWebhookHandlesResponse,
    MicrosoftTeamsWorkflowsWebhookResponseAttributes: MicrosoftTeamsWorkflowsWebhookResponseAttributes_1.MicrosoftTeamsWorkflowsWebhookResponseAttributes,
    MonitorConfigPolicyAttributeCreateRequest: MonitorConfigPolicyAttributeCreateRequest_1.MonitorConfigPolicyAttributeCreateRequest,
    MonitorConfigPolicyAttributeEditRequest: MonitorConfigPolicyAttributeEditRequest_1.MonitorConfigPolicyAttributeEditRequest,
    MonitorConfigPolicyAttributeResponse: MonitorConfigPolicyAttributeResponse_1.MonitorConfigPolicyAttributeResponse,
    MonitorConfigPolicyCreateData: MonitorConfigPolicyCreateData_1.MonitorConfigPolicyCreateData,
    MonitorConfigPolicyCreateRequest: MonitorConfigPolicyCreateRequest_1.MonitorConfigPolicyCreateRequest,
    MonitorConfigPolicyEditData: MonitorConfigPolicyEditData_1.MonitorConfigPolicyEditData,
    MonitorConfigPolicyEditRequest: MonitorConfigPolicyEditRequest_1.MonitorConfigPolicyEditRequest,
    MonitorConfigPolicyListResponse: MonitorConfigPolicyListResponse_1.MonitorConfigPolicyListResponse,
    MonitorConfigPolicyResponse: MonitorConfigPolicyResponse_1.MonitorConfigPolicyResponse,
    MonitorConfigPolicyResponseData: MonitorConfigPolicyResponseData_1.MonitorConfigPolicyResponseData,
    MonitorConfigPolicyTagPolicy: MonitorConfigPolicyTagPolicy_1.MonitorConfigPolicyTagPolicy,
    MonitorConfigPolicyTagPolicyCreateRequest: MonitorConfigPolicyTagPolicyCreateRequest_1.MonitorConfigPolicyTagPolicyCreateRequest,
    MonitorDowntimeMatchResponse: MonitorDowntimeMatchResponse_1.MonitorDowntimeMatchResponse,
    MonitorDowntimeMatchResponseAttributes: MonitorDowntimeMatchResponseAttributes_1.MonitorDowntimeMatchResponseAttributes,
    MonitorDowntimeMatchResponseData: MonitorDowntimeMatchResponseData_1.MonitorDowntimeMatchResponseData,
    MonitorNotificationRuleAttributes: MonitorNotificationRuleAttributes_1.MonitorNotificationRuleAttributes,
    MonitorNotificationRuleCreateRequest: MonitorNotificationRuleCreateRequest_1.MonitorNotificationRuleCreateRequest,
    MonitorNotificationRuleCreateRequestData: MonitorNotificationRuleCreateRequestData_1.MonitorNotificationRuleCreateRequestData,
    MonitorNotificationRuleData: MonitorNotificationRuleData_1.MonitorNotificationRuleData,
    MonitorNotificationRuleFilterTags: MonitorNotificationRuleFilterTags_1.MonitorNotificationRuleFilterTags,
    MonitorNotificationRuleListResponse: MonitorNotificationRuleListResponse_1.MonitorNotificationRuleListResponse,
    MonitorNotificationRuleRelationships: MonitorNotificationRuleRelationships_1.MonitorNotificationRuleRelationships,
    MonitorNotificationRuleRelationshipsCreatedBy: MonitorNotificationRuleRelationshipsCreatedBy_1.MonitorNotificationRuleRelationshipsCreatedBy,
    MonitorNotificationRuleRelationshipsCreatedByData: MonitorNotificationRuleRelationshipsCreatedByData_1.MonitorNotificationRuleRelationshipsCreatedByData,
    MonitorNotificationRuleResponse: MonitorNotificationRuleResponse_1.MonitorNotificationRuleResponse,
    MonitorNotificationRuleResponseAttributes: MonitorNotificationRuleResponseAttributes_1.MonitorNotificationRuleResponseAttributes,
    MonitorNotificationRuleUpdateRequest: MonitorNotificationRuleUpdateRequest_1.MonitorNotificationRuleUpdateRequest,
    MonitorNotificationRuleUpdateRequestData: MonitorNotificationRuleUpdateRequestData_1.MonitorNotificationRuleUpdateRequestData,
    MonitorTrigger: MonitorTrigger_1.MonitorTrigger,
    MonitorTriggerWrapper: MonitorTriggerWrapper_1.MonitorTriggerWrapper,
    MonitorType: MonitorType_1.MonitorType,
    MonthlyCostAttributionAttributes: MonthlyCostAttributionAttributes_1.MonthlyCostAttributionAttributes,
    MonthlyCostAttributionBody: MonthlyCostAttributionBody_1.MonthlyCostAttributionBody,
    MonthlyCostAttributionMeta: MonthlyCostAttributionMeta_1.MonthlyCostAttributionMeta,
    MonthlyCostAttributionPagination: MonthlyCostAttributionPagination_1.MonthlyCostAttributionPagination,
    MonthlyCostAttributionResponse: MonthlyCostAttributionResponse_1.MonthlyCostAttributionResponse,
    NotebookTriggerWrapper: NotebookTriggerWrapper_1.NotebookTriggerWrapper,
    NotificationRule: NotificationRule_1.NotificationRule,
    NotificationRuleAttributes: NotificationRuleAttributes_1.NotificationRuleAttributes,
    NotificationRuleResponse: NotificationRuleResponse_1.NotificationRuleResponse,
    NullableRelationshipToUser: NullableRelationshipToUser_1.NullableRelationshipToUser,
    NullableRelationshipToUserData: NullableRelationshipToUserData_1.NullableRelationshipToUserData,
    NullableUserRelationship: NullableUserRelationship_1.NullableUserRelationship,
    NullableUserRelationshipData: NullableUserRelationshipData_1.NullableUserRelationshipData,
    ObservabilityPipeline: ObservabilityPipeline_1.ObservabilityPipeline,
    ObservabilityPipelineAddEnvVarsProcessor: ObservabilityPipelineAddEnvVarsProcessor_1.ObservabilityPipelineAddEnvVarsProcessor,
    ObservabilityPipelineAddEnvVarsProcessorVariable: ObservabilityPipelineAddEnvVarsProcessorVariable_1.ObservabilityPipelineAddEnvVarsProcessorVariable,
    ObservabilityPipelineAddFieldsProcessor: ObservabilityPipelineAddFieldsProcessor_1.ObservabilityPipelineAddFieldsProcessor,
    ObservabilityPipelineAmazonDataFirehoseSource: ObservabilityPipelineAmazonDataFirehoseSource_1.ObservabilityPipelineAmazonDataFirehoseSource,
    ObservabilityPipelineAmazonOpenSearchDestination: ObservabilityPipelineAmazonOpenSearchDestination_1.ObservabilityPipelineAmazonOpenSearchDestination,
    ObservabilityPipelineAmazonOpenSearchDestinationAuth: ObservabilityPipelineAmazonOpenSearchDestinationAuth_1.ObservabilityPipelineAmazonOpenSearchDestinationAuth,
    ObservabilityPipelineAmazonS3Destination: ObservabilityPipelineAmazonS3Destination_1.ObservabilityPipelineAmazonS3Destination,
    ObservabilityPipelineAmazonS3Source: ObservabilityPipelineAmazonS3Source_1.ObservabilityPipelineAmazonS3Source,
    ObservabilityPipelineAwsAuth: ObservabilityPipelineAwsAuth_1.ObservabilityPipelineAwsAuth,
    ObservabilityPipelineConfig: ObservabilityPipelineConfig_1.ObservabilityPipelineConfig,
    ObservabilityPipelineData: ObservabilityPipelineData_1.ObservabilityPipelineData,
    ObservabilityPipelineDataAttributes: ObservabilityPipelineDataAttributes_1.ObservabilityPipelineDataAttributes,
    ObservabilityPipelineDatadogAgentSource: ObservabilityPipelineDatadogAgentSource_1.ObservabilityPipelineDatadogAgentSource,
    ObservabilityPipelineDatadogLogsDestination: ObservabilityPipelineDatadogLogsDestination_1.ObservabilityPipelineDatadogLogsDestination,
    ObservabilityPipelineDedupeProcessor: ObservabilityPipelineDedupeProcessor_1.ObservabilityPipelineDedupeProcessor,
    ObservabilityPipelineElasticsearchDestination: ObservabilityPipelineElasticsearchDestination_1.ObservabilityPipelineElasticsearchDestination,
    ObservabilityPipelineEnrichmentTableFile: ObservabilityPipelineEnrichmentTableFile_1.ObservabilityPipelineEnrichmentTableFile,
    ObservabilityPipelineEnrichmentTableFileEncoding: ObservabilityPipelineEnrichmentTableFileEncoding_1.ObservabilityPipelineEnrichmentTableFileEncoding,
    ObservabilityPipelineEnrichmentTableFileKeyItems: ObservabilityPipelineEnrichmentTableFileKeyItems_1.ObservabilityPipelineEnrichmentTableFileKeyItems,
    ObservabilityPipelineEnrichmentTableFileSchemaItems: ObservabilityPipelineEnrichmentTableFileSchemaItems_1.ObservabilityPipelineEnrichmentTableFileSchemaItems,
    ObservabilityPipelineEnrichmentTableGeoIp: ObservabilityPipelineEnrichmentTableGeoIp_1.ObservabilityPipelineEnrichmentTableGeoIp,
    ObservabilityPipelineEnrichmentTableProcessor: ObservabilityPipelineEnrichmentTableProcessor_1.ObservabilityPipelineEnrichmentTableProcessor,
    ObservabilityPipelineFieldValue: ObservabilityPipelineFieldValue_1.ObservabilityPipelineFieldValue,
    ObservabilityPipelineFilterProcessor: ObservabilityPipelineFilterProcessor_1.ObservabilityPipelineFilterProcessor,
    ObservabilityPipelineFluentBitSource: ObservabilityPipelineFluentBitSource_1.ObservabilityPipelineFluentBitSource,
    ObservabilityPipelineFluentdSource: ObservabilityPipelineFluentdSource_1.ObservabilityPipelineFluentdSource,
    ObservabilityPipelineGcpAuth: ObservabilityPipelineGcpAuth_1.ObservabilityPipelineGcpAuth,
    ObservabilityPipelineGenerateMetricsProcessor: ObservabilityPipelineGenerateMetricsProcessor_1.ObservabilityPipelineGenerateMetricsProcessor,
    ObservabilityPipelineGeneratedMetric: ObservabilityPipelineGeneratedMetric_1.ObservabilityPipelineGeneratedMetric,
    ObservabilityPipelineGeneratedMetricIncrementByField: ObservabilityPipelineGeneratedMetricIncrementByField_1.ObservabilityPipelineGeneratedMetricIncrementByField,
    ObservabilityPipelineGeneratedMetricIncrementByOne: ObservabilityPipelineGeneratedMetricIncrementByOne_1.ObservabilityPipelineGeneratedMetricIncrementByOne,
    ObservabilityPipelineGoogleChronicleDestination: ObservabilityPipelineGoogleChronicleDestination_1.ObservabilityPipelineGoogleChronicleDestination,
    ObservabilityPipelineGoogleCloudStorageDestination: ObservabilityPipelineGoogleCloudStorageDestination_1.ObservabilityPipelineGoogleCloudStorageDestination,
    ObservabilityPipelineGooglePubSubSource: ObservabilityPipelineGooglePubSubSource_1.ObservabilityPipelineGooglePubSubSource,
    ObservabilityPipelineHttpClientSource: ObservabilityPipelineHttpClientSource_1.ObservabilityPipelineHttpClientSource,
    ObservabilityPipelineHttpServerSource: ObservabilityPipelineHttpServerSource_1.ObservabilityPipelineHttpServerSource,
    ObservabilityPipelineKafkaSource: ObservabilityPipelineKafkaSource_1.ObservabilityPipelineKafkaSource,
    ObservabilityPipelineKafkaSourceLibrdkafkaOption: ObservabilityPipelineKafkaSourceLibrdkafkaOption_1.ObservabilityPipelineKafkaSourceLibrdkafkaOption,
    ObservabilityPipelineKafkaSourceSasl: ObservabilityPipelineKafkaSourceSasl_1.ObservabilityPipelineKafkaSourceSasl,
    ObservabilityPipelineLogstashSource: ObservabilityPipelineLogstashSource_1.ObservabilityPipelineLogstashSource,
    ObservabilityPipelineMetadataEntry: ObservabilityPipelineMetadataEntry_1.ObservabilityPipelineMetadataEntry,
    ObservabilityPipelineNewRelicDestination: ObservabilityPipelineNewRelicDestination_1.ObservabilityPipelineNewRelicDestination,
    ObservabilityPipelineOcsfMapperProcessor: ObservabilityPipelineOcsfMapperProcessor_1.ObservabilityPipelineOcsfMapperProcessor,
    ObservabilityPipelineOcsfMapperProcessorMapping: ObservabilityPipelineOcsfMapperProcessorMapping_1.ObservabilityPipelineOcsfMapperProcessorMapping,
    ObservabilityPipelineOpenSearchDestination: ObservabilityPipelineOpenSearchDestination_1.ObservabilityPipelineOpenSearchDestination,
    ObservabilityPipelineParseGrokProcessor: ObservabilityPipelineParseGrokProcessor_1.ObservabilityPipelineParseGrokProcessor,
    ObservabilityPipelineParseGrokProcessorRule: ObservabilityPipelineParseGrokProcessorRule_1.ObservabilityPipelineParseGrokProcessorRule,
    ObservabilityPipelineParseGrokProcessorRuleMatchRule: ObservabilityPipelineParseGrokProcessorRuleMatchRule_1.ObservabilityPipelineParseGrokProcessorRuleMatchRule,
    ObservabilityPipelineParseGrokProcessorRuleSupportRule: ObservabilityPipelineParseGrokProcessorRuleSupportRule_1.ObservabilityPipelineParseGrokProcessorRuleSupportRule,
    ObservabilityPipelineParseJSONProcessor: ObservabilityPipelineParseJSONProcessor_1.ObservabilityPipelineParseJSONProcessor,
    ObservabilityPipelineQuotaProcessor: ObservabilityPipelineQuotaProcessor_1.ObservabilityPipelineQuotaProcessor,
    ObservabilityPipelineQuotaProcessorLimit: ObservabilityPipelineQuotaProcessorLimit_1.ObservabilityPipelineQuotaProcessorLimit,
    ObservabilityPipelineQuotaProcessorOverride: ObservabilityPipelineQuotaProcessorOverride_1.ObservabilityPipelineQuotaProcessorOverride,
    ObservabilityPipelineReduceProcessor: ObservabilityPipelineReduceProcessor_1.ObservabilityPipelineReduceProcessor,
    ObservabilityPipelineReduceProcessorMergeStrategy: ObservabilityPipelineReduceProcessorMergeStrategy_1.ObservabilityPipelineReduceProcessorMergeStrategy,
    ObservabilityPipelineRemoveFieldsProcessor: ObservabilityPipelineRemoveFieldsProcessor_1.ObservabilityPipelineRemoveFieldsProcessor,
    ObservabilityPipelineRenameFieldsProcessor: ObservabilityPipelineRenameFieldsProcessor_1.ObservabilityPipelineRenameFieldsProcessor,
    ObservabilityPipelineRenameFieldsProcessorField: ObservabilityPipelineRenameFieldsProcessorField_1.ObservabilityPipelineRenameFieldsProcessorField,
    ObservabilityPipelineRsyslogDestination: ObservabilityPipelineRsyslogDestination_1.ObservabilityPipelineRsyslogDestination,
    ObservabilityPipelineRsyslogSource: ObservabilityPipelineRsyslogSource_1.ObservabilityPipelineRsyslogSource,
    ObservabilityPipelineSampleProcessor: ObservabilityPipelineSampleProcessor_1.ObservabilityPipelineSampleProcessor,
    ObservabilityPipelineSensitiveDataScannerProcessor: ObservabilityPipelineSensitiveDataScannerProcessor_1.ObservabilityPipelineSensitiveDataScannerProcessor,
    ObservabilityPipelineSensitiveDataScannerProcessorActionHash: ObservabilityPipelineSensitiveDataScannerProcessorActionHash_1.ObservabilityPipelineSensitiveDataScannerProcessorActionHash,
    ObservabilityPipelineSensitiveDataScannerProcessorActionPartialRedact: ObservabilityPipelineSensitiveDataScannerProcessorActionPartialRedact_1.ObservabilityPipelineSensitiveDataScannerProcessorActionPartialRedact,
    ObservabilityPipelineSensitiveDataScannerProcessorActionPartialRedactOptions: ObservabilityPipelineSensitiveDataScannerProcessorActionPartialRedactOptions_1.ObservabilityPipelineSensitiveDataScannerProcessorActionPartialRedactOptions,
    ObservabilityPipelineSensitiveDataScannerProcessorActionRedact: ObservabilityPipelineSensitiveDataScannerProcessorActionRedact_1.ObservabilityPipelineSensitiveDataScannerProcessorActionRedact,
    ObservabilityPipelineSensitiveDataScannerProcessorActionRedactOptions: ObservabilityPipelineSensitiveDataScannerProcessorActionRedactOptions_1.ObservabilityPipelineSensitiveDataScannerProcessorActionRedactOptions,
    ObservabilityPipelineSensitiveDataScannerProcessorCustomPattern: ObservabilityPipelineSensitiveDataScannerProcessorCustomPattern_1.ObservabilityPipelineSensitiveDataScannerProcessorCustomPattern,
    ObservabilityPipelineSensitiveDataScannerProcessorCustomPatternOptions: ObservabilityPipelineSensitiveDataScannerProcessorCustomPatternOptions_1.ObservabilityPipelineSensitiveDataScannerProcessorCustomPatternOptions,
    ObservabilityPipelineSensitiveDataScannerProcessorKeywordOptions: ObservabilityPipelineSensitiveDataScannerProcessorKeywordOptions_1.ObservabilityPipelineSensitiveDataScannerProcessorKeywordOptions,
    ObservabilityPipelineSensitiveDataScannerProcessorLibraryPattern: ObservabilityPipelineSensitiveDataScannerProcessorLibraryPattern_1.ObservabilityPipelineSensitiveDataScannerProcessorLibraryPattern,
    ObservabilityPipelineSensitiveDataScannerProcessorLibraryPatternOptions: ObservabilityPipelineSensitiveDataScannerProcessorLibraryPatternOptions_1.ObservabilityPipelineSensitiveDataScannerProcessorLibraryPatternOptions,
    ObservabilityPipelineSensitiveDataScannerProcessorRule: ObservabilityPipelineSensitiveDataScannerProcessorRule_1.ObservabilityPipelineSensitiveDataScannerProcessorRule,
    ObservabilityPipelineSensitiveDataScannerProcessorScopeAll: ObservabilityPipelineSensitiveDataScannerProcessorScopeAll_1.ObservabilityPipelineSensitiveDataScannerProcessorScopeAll,
    ObservabilityPipelineSensitiveDataScannerProcessorScopeExclude: ObservabilityPipelineSensitiveDataScannerProcessorScopeExclude_1.ObservabilityPipelineSensitiveDataScannerProcessorScopeExclude,
    ObservabilityPipelineSensitiveDataScannerProcessorScopeInclude: ObservabilityPipelineSensitiveDataScannerProcessorScopeInclude_1.ObservabilityPipelineSensitiveDataScannerProcessorScopeInclude,
    ObservabilityPipelineSensitiveDataScannerProcessorScopeOptions: ObservabilityPipelineSensitiveDataScannerProcessorScopeOptions_1.ObservabilityPipelineSensitiveDataScannerProcessorScopeOptions,
    ObservabilityPipelineSentinelOneDestination: ObservabilityPipelineSentinelOneDestination_1.ObservabilityPipelineSentinelOneDestination,
    ObservabilityPipelineSpec: ObservabilityPipelineSpec_1.ObservabilityPipelineSpec,
    ObservabilityPipelineSpecData: ObservabilityPipelineSpecData_1.ObservabilityPipelineSpecData,
    ObservabilityPipelineSplunkHecDestination: ObservabilityPipelineSplunkHecDestination_1.ObservabilityPipelineSplunkHecDestination,
    ObservabilityPipelineSplunkHecSource: ObservabilityPipelineSplunkHecSource_1.ObservabilityPipelineSplunkHecSource,
    ObservabilityPipelineSplunkTcpSource: ObservabilityPipelineSplunkTcpSource_1.ObservabilityPipelineSplunkTcpSource,
    ObservabilityPipelineSumoLogicDestination: ObservabilityPipelineSumoLogicDestination_1.ObservabilityPipelineSumoLogicDestination,
    ObservabilityPipelineSumoLogicDestinationHeaderCustomFieldsItem: ObservabilityPipelineSumoLogicDestinationHeaderCustomFieldsItem_1.ObservabilityPipelineSumoLogicDestinationHeaderCustomFieldsItem,
    ObservabilityPipelineSumoLogicSource: ObservabilityPipelineSumoLogicSource_1.ObservabilityPipelineSumoLogicSource,
    ObservabilityPipelineSyslogNgDestination: ObservabilityPipelineSyslogNgDestination_1.ObservabilityPipelineSyslogNgDestination,
    ObservabilityPipelineSyslogNgSource: ObservabilityPipelineSyslogNgSource_1.ObservabilityPipelineSyslogNgSource,
    ObservabilityPipelineThrottleProcessor: ObservabilityPipelineThrottleProcessor_1.ObservabilityPipelineThrottleProcessor,
    ObservabilityPipelineTls: ObservabilityPipelineTls_1.ObservabilityPipelineTls,
    OktaAccount: OktaAccount_1.OktaAccount,
    OktaAccountAttributes: OktaAccountAttributes_1.OktaAccountAttributes,
    OktaAccountRequest: OktaAccountRequest_1.OktaAccountRequest,
    OktaAccountResponse: OktaAccountResponse_1.OktaAccountResponse,
    OktaAccountResponseData: OktaAccountResponseData_1.OktaAccountResponseData,
    OktaAccountUpdateRequest: OktaAccountUpdateRequest_1.OktaAccountUpdateRequest,
    OktaAccountUpdateRequestAttributes: OktaAccountUpdateRequestAttributes_1.OktaAccountUpdateRequestAttributes,
    OktaAccountUpdateRequestData: OktaAccountUpdateRequestData_1.OktaAccountUpdateRequestData,
    OktaAccountsResponse: OktaAccountsResponse_1.OktaAccountsResponse,
    OnDemandConcurrencyCap: OnDemandConcurrencyCap_1.OnDemandConcurrencyCap,
    OnDemandConcurrencyCapAttributes: OnDemandConcurrencyCapAttributes_1.OnDemandConcurrencyCapAttributes,
    OnDemandConcurrencyCapResponse: OnDemandConcurrencyCapResponse_1.OnDemandConcurrencyCapResponse,
    OpenAPIEndpoint: OpenAPIEndpoint_1.OpenAPIEndpoint,
    OpenAPIFile: OpenAPIFile_1.OpenAPIFile,
    OpsgenieServiceCreateAttributes: OpsgenieServiceCreateAttributes_1.OpsgenieServiceCreateAttributes,
    OpsgenieServiceCreateData: OpsgenieServiceCreateData_1.OpsgenieServiceCreateData,
    OpsgenieServiceCreateRequest: OpsgenieServiceCreateRequest_1.OpsgenieServiceCreateRequest,
    OpsgenieServiceResponse: OpsgenieServiceResponse_1.OpsgenieServiceResponse,
    OpsgenieServiceResponseAttributes: OpsgenieServiceResponseAttributes_1.OpsgenieServiceResponseAttributes,
    OpsgenieServiceResponseData: OpsgenieServiceResponseData_1.OpsgenieServiceResponseData,
    OpsgenieServiceUpdateAttributes: OpsgenieServiceUpdateAttributes_1.OpsgenieServiceUpdateAttributes,
    OpsgenieServiceUpdateData: OpsgenieServiceUpdateData_1.OpsgenieServiceUpdateData,
    OpsgenieServiceUpdateRequest: OpsgenieServiceUpdateRequest_1.OpsgenieServiceUpdateRequest,
    OpsgenieServicesResponse: OpsgenieServicesResponse_1.OpsgenieServicesResponse,
    OrgConfigGetResponse: OrgConfigGetResponse_1.OrgConfigGetResponse,
    OrgConfigListResponse: OrgConfigListResponse_1.OrgConfigListResponse,
    OrgConfigRead: OrgConfigRead_1.OrgConfigRead,
    OrgConfigReadAttributes: OrgConfigReadAttributes_1.OrgConfigReadAttributes,
    OrgConfigWrite: OrgConfigWrite_1.OrgConfigWrite,
    OrgConfigWriteAttributes: OrgConfigWriteAttributes_1.OrgConfigWriteAttributes,
    OrgConfigWriteRequest: OrgConfigWriteRequest_1.OrgConfigWriteRequest,
    Organization: Organization_1.Organization,
    OrganizationAttributes: OrganizationAttributes_1.OrganizationAttributes,
    OutboundEdge: OutboundEdge_1.OutboundEdge,
    OutcomesBatchAttributes: OutcomesBatchAttributes_1.OutcomesBatchAttributes,
    OutcomesBatchRequest: OutcomesBatchRequest_1.OutcomesBatchRequest,
    OutcomesBatchRequestData: OutcomesBatchRequestData_1.OutcomesBatchRequestData,
    OutcomesBatchRequestItem: OutcomesBatchRequestItem_1.OutcomesBatchRequestItem,
    OutcomesBatchResponse: OutcomesBatchResponse_1.OutcomesBatchResponse,
    OutcomesBatchResponseAttributes: OutcomesBatchResponseAttributes_1.OutcomesBatchResponseAttributes,
    OutcomesBatchResponseMeta: OutcomesBatchResponseMeta_1.OutcomesBatchResponseMeta,
    OutcomesResponse: OutcomesResponse_1.OutcomesResponse,
    OutcomesResponseDataItem: OutcomesResponseDataItem_1.OutcomesResponseDataItem,
    OutcomesResponseIncludedItem: OutcomesResponseIncludedItem_1.OutcomesResponseIncludedItem,
    OutcomesResponseIncludedRuleAttributes: OutcomesResponseIncludedRuleAttributes_1.OutcomesResponseIncludedRuleAttributes,
    OutcomesResponseLinks: OutcomesResponseLinks_1.OutcomesResponseLinks,
    OutputSchema: OutputSchema_1.OutputSchema,
    OutputSchemaParameters: OutputSchemaParameters_1.OutputSchemaParameters,
    Pagination: Pagination_1.Pagination,
    Parameter: Parameter_1.Parameter,
    PartialAPIKey: PartialAPIKey_1.PartialAPIKey,
    PartialAPIKeyAttributes: PartialAPIKeyAttributes_1.PartialAPIKeyAttributes,
    PartialApplicationKey: PartialApplicationKey_1.PartialApplicationKey,
    PartialApplicationKeyAttributes: PartialApplicationKeyAttributes_1.PartialApplicationKeyAttributes,
    PartialApplicationKeyResponse: PartialApplicationKeyResponse_1.PartialApplicationKeyResponse,
    PatchNotificationRuleParameters: PatchNotificationRuleParameters_1.PatchNotificationRuleParameters,
    PatchNotificationRuleParametersData: PatchNotificationRuleParametersData_1.PatchNotificationRuleParametersData,
    PatchNotificationRuleParametersDataAttributes: PatchNotificationRuleParametersDataAttributes_1.PatchNotificationRuleParametersDataAttributes,
    Permission: Permission_1.Permission,
    PermissionAttributes: PermissionAttributes_1.PermissionAttributes,
    PermissionsResponse: PermissionsResponse_1.PermissionsResponse,
    Powerpack: Powerpack_1.Powerpack,
    PowerpackAttributes: PowerpackAttributes_1.PowerpackAttributes,
    PowerpackData: PowerpackData_1.PowerpackData,
    PowerpackGroupWidget: PowerpackGroupWidget_1.PowerpackGroupWidget,
    PowerpackGroupWidgetDefinition: PowerpackGroupWidgetDefinition_1.PowerpackGroupWidgetDefinition,
    PowerpackGroupWidgetLayout: PowerpackGroupWidgetLayout_1.PowerpackGroupWidgetLayout,
    PowerpackInnerWidgetLayout: PowerpackInnerWidgetLayout_1.PowerpackInnerWidgetLayout,
    PowerpackInnerWidgets: PowerpackInnerWidgets_1.PowerpackInnerWidgets,
    PowerpackRelationships: PowerpackRelationships_1.PowerpackRelationships,
    PowerpackResponse: PowerpackResponse_1.PowerpackResponse,
    PowerpackResponseLinks: PowerpackResponseLinks_1.PowerpackResponseLinks,
    PowerpackTemplateVariable: PowerpackTemplateVariable_1.PowerpackTemplateVariable,
    PowerpacksResponseMeta: PowerpacksResponseMeta_1.PowerpacksResponseMeta,
    PowerpacksResponseMetaPagination: PowerpacksResponseMetaPagination_1.PowerpacksResponseMetaPagination,
    ProcessSummariesMeta: ProcessSummariesMeta_1.ProcessSummariesMeta,
    ProcessSummariesMetaPage: ProcessSummariesMetaPage_1.ProcessSummariesMetaPage,
    ProcessSummariesResponse: ProcessSummariesResponse_1.ProcessSummariesResponse,
    ProcessSummary: ProcessSummary_1.ProcessSummary,
    ProcessSummaryAttributes: ProcessSummaryAttributes_1.ProcessSummaryAttributes,
    Project: Project_1.Project,
    ProjectAttributes: ProjectAttributes_1.ProjectAttributes,
    ProjectCreate: ProjectCreate_1.ProjectCreate,
    ProjectCreateAttributes: ProjectCreateAttributes_1.ProjectCreateAttributes,
    ProjectCreateRequest: ProjectCreateRequest_1.ProjectCreateRequest,
    ProjectRelationship: ProjectRelationship_1.ProjectRelationship,
    ProjectRelationshipData: ProjectRelationshipData_1.ProjectRelationshipData,
    ProjectRelationships: ProjectRelationships_1.ProjectRelationships,
    ProjectResponse: ProjectResponse_1.ProjectResponse,
    ProjectedCost: ProjectedCost_1.ProjectedCost,
    ProjectedCostAttributes: ProjectedCostAttributes_1.ProjectedCostAttributes,
    ProjectedCostResponse: ProjectedCostResponse_1.ProjectedCostResponse,
    ProjectsResponse: ProjectsResponse_1.ProjectsResponse,
    PublishAppResponse: PublishAppResponse_1.PublishAppResponse,
    QueryFormula: QueryFormula_1.QueryFormula,
    RUMAggregateBucketValueTimeseriesPoint: RUMAggregateBucketValueTimeseriesPoint_1.RUMAggregateBucketValueTimeseriesPoint,
    RUMAggregateRequest: RUMAggregateRequest_1.RUMAggregateRequest,
    RUMAggregateSort: RUMAggregateSort_1.RUMAggregateSort,
    RUMAggregationBucketsResponse: RUMAggregationBucketsResponse_1.RUMAggregationBucketsResponse,
    RUMAnalyticsAggregateResponse: RUMAnalyticsAggregateResponse_1.RUMAnalyticsAggregateResponse,
    RUMApplication: RUMApplication_1.RUMApplication,
    RUMApplicationAttributes: RUMApplicationAttributes_1.RUMApplicationAttributes,
    RUMApplicationCreate: RUMApplicationCreate_1.RUMApplicationCreate,
    RUMApplicationCreateAttributes: RUMApplicationCreateAttributes_1.RUMApplicationCreateAttributes,
    RUMApplicationCreateRequest: RUMApplicationCreateRequest_1.RUMApplicationCreateRequest,
    RUMApplicationList: RUMApplicationList_1.RUMApplicationList,
    RUMApplicationListAttributes: RUMApplicationListAttributes_1.RUMApplicationListAttributes,
    RUMApplicationResponse: RUMApplicationResponse_1.RUMApplicationResponse,
    RUMApplicationUpdate: RUMApplicationUpdate_1.RUMApplicationUpdate,
    RUMApplicationUpdateAttributes: RUMApplicationUpdateAttributes_1.RUMApplicationUpdateAttributes,
    RUMApplicationUpdateRequest: RUMApplicationUpdateRequest_1.RUMApplicationUpdateRequest,
    RUMApplicationsResponse: RUMApplicationsResponse_1.RUMApplicationsResponse,
    RUMBucketResponse: RUMBucketResponse_1.RUMBucketResponse,
    RUMCompute: RUMCompute_1.RUMCompute,
    RUMEvent: RUMEvent_1.RUMEvent,
    RUMEventAttributes: RUMEventAttributes_1.RUMEventAttributes,
    RUMEventsResponse: RUMEventsResponse_1.RUMEventsResponse,
    RUMGroupBy: RUMGroupBy_1.RUMGroupBy,
    RUMGroupByHistogram: RUMGroupByHistogram_1.RUMGroupByHistogram,
    RUMQueryFilter: RUMQueryFilter_1.RUMQueryFilter,
    RUMQueryOptions: RUMQueryOptions_1.RUMQueryOptions,
    RUMQueryPageOptions: RUMQueryPageOptions_1.RUMQueryPageOptions,
    RUMResponseLinks: RUMResponseLinks_1.RUMResponseLinks,
    RUMResponseMetadata: RUMResponseMetadata_1.RUMResponseMetadata,
    RUMResponsePage: RUMResponsePage_1.RUMResponsePage,
    RUMSearchEventsRequest: RUMSearchEventsRequest_1.RUMSearchEventsRequest,
    RUMWarning: RUMWarning_1.RUMWarning,
    ReadinessGate: ReadinessGate_1.ReadinessGate,
    RelationAttributes: RelationAttributes_1.RelationAttributes,
    RelationEntity: RelationEntity_1.RelationEntity,
    RelationMeta: RelationMeta_1.RelationMeta,
    RelationRelationships: RelationRelationships_1.RelationRelationships,
    RelationResponse: RelationResponse_1.RelationResponse,
    RelationResponseMeta: RelationResponseMeta_1.RelationResponseMeta,
    RelationToEntity: RelationToEntity_1.RelationToEntity,
    RelationshipItem: RelationshipItem_1.RelationshipItem,
    RelationshipToIncidentAttachment: RelationshipToIncidentAttachment_1.RelationshipToIncidentAttachment,
    RelationshipToIncidentAttachmentData: RelationshipToIncidentAttachmentData_1.RelationshipToIncidentAttachmentData,
    RelationshipToIncidentImpactData: RelationshipToIncidentImpactData_1.RelationshipToIncidentImpactData,
    RelationshipToIncidentImpacts: RelationshipToIncidentImpacts_1.RelationshipToIncidentImpacts,
    RelationshipToIncidentIntegrationMetadataData: RelationshipToIncidentIntegrationMetadataData_1.RelationshipToIncidentIntegrationMetadataData,
    RelationshipToIncidentIntegrationMetadatas: RelationshipToIncidentIntegrationMetadatas_1.RelationshipToIncidentIntegrationMetadatas,
    RelationshipToIncidentPostmortem: RelationshipToIncidentPostmortem_1.RelationshipToIncidentPostmortem,
    RelationshipToIncidentPostmortemData: RelationshipToIncidentPostmortemData_1.RelationshipToIncidentPostmortemData,
    RelationshipToIncidentResponderData: RelationshipToIncidentResponderData_1.RelationshipToIncidentResponderData,
    RelationshipToIncidentResponders: RelationshipToIncidentResponders_1.RelationshipToIncidentResponders,
    RelationshipToIncidentUserDefinedFieldData: RelationshipToIncidentUserDefinedFieldData_1.RelationshipToIncidentUserDefinedFieldData,
    RelationshipToIncidentUserDefinedFields: RelationshipToIncidentUserDefinedFields_1.RelationshipToIncidentUserDefinedFields,
    RelationshipToOrganization: RelationshipToOrganization_1.RelationshipToOrganization,
    RelationshipToOrganizationData: RelationshipToOrganizationData_1.RelationshipToOrganizationData,
    RelationshipToOrganizations: RelationshipToOrganizations_1.RelationshipToOrganizations,
    RelationshipToOutcome: RelationshipToOutcome_1.RelationshipToOutcome,
    RelationshipToOutcomeData: RelationshipToOutcomeData_1.RelationshipToOutcomeData,
    RelationshipToPermission: RelationshipToPermission_1.RelationshipToPermission,
    RelationshipToPermissionData: RelationshipToPermissionData_1.RelationshipToPermissionData,
    RelationshipToPermissions: RelationshipToPermissions_1.RelationshipToPermissions,
    RelationshipToRole: RelationshipToRole_1.RelationshipToRole,
    RelationshipToRoleData: RelationshipToRoleData_1.RelationshipToRoleData,
    RelationshipToRoles: RelationshipToRoles_1.RelationshipToRoles,
    RelationshipToRule: RelationshipToRule_1.RelationshipToRule,
    RelationshipToRuleData: RelationshipToRuleData_1.RelationshipToRuleData,
    RelationshipToRuleDataObject: RelationshipToRuleDataObject_1.RelationshipToRuleDataObject,
    RelationshipToSAMLAssertionAttribute: RelationshipToSAMLAssertionAttribute_1.RelationshipToSAMLAssertionAttribute,
    RelationshipToSAMLAssertionAttributeData: RelationshipToSAMLAssertionAttributeData_1.RelationshipToSAMLAssertionAttributeData,
    RelationshipToTeam: RelationshipToTeam_1.RelationshipToTeam,
    RelationshipToTeamData: RelationshipToTeamData_1.RelationshipToTeamData,
    RelationshipToTeamLinkData: RelationshipToTeamLinkData_1.RelationshipToTeamLinkData,
    RelationshipToTeamLinks: RelationshipToTeamLinks_1.RelationshipToTeamLinks,
    RelationshipToUser: RelationshipToUser_1.RelationshipToUser,
    RelationshipToUserData: RelationshipToUserData_1.RelationshipToUserData,
    RelationshipToUserTeamPermission: RelationshipToUserTeamPermission_1.RelationshipToUserTeamPermission,
    RelationshipToUserTeamPermissionData: RelationshipToUserTeamPermissionData_1.RelationshipToUserTeamPermissionData,
    RelationshipToUserTeamTeam: RelationshipToUserTeamTeam_1.RelationshipToUserTeamTeam,
    RelationshipToUserTeamTeamData: RelationshipToUserTeamTeamData_1.RelationshipToUserTeamTeamData,
    RelationshipToUserTeamUser: RelationshipToUserTeamUser_1.RelationshipToUserTeamUser,
    RelationshipToUserTeamUserData: RelationshipToUserTeamUserData_1.RelationshipToUserTeamUserData,
    RelationshipToUsers: RelationshipToUsers_1.RelationshipToUsers,
    Remediation: Remediation_1.Remediation,
    ReorderRetentionFiltersRequest: ReorderRetentionFiltersRequest_1.ReorderRetentionFiltersRequest,
    ResourceFilterAttributes: ResourceFilterAttributes_1.ResourceFilterAttributes,
    ResponseMetaAttributes: ResponseMetaAttributes_1.ResponseMetaAttributes,
    RestrictionPolicy: RestrictionPolicy_1.RestrictionPolicy,
    RestrictionPolicyAttributes: RestrictionPolicyAttributes_1.RestrictionPolicyAttributes,
    RestrictionPolicyBinding: RestrictionPolicyBinding_1.RestrictionPolicyBinding,
    RestrictionPolicyResponse: RestrictionPolicyResponse_1.RestrictionPolicyResponse,
    RestrictionPolicyUpdateRequest: RestrictionPolicyUpdateRequest_1.RestrictionPolicyUpdateRequest,
    RetentionFilter: RetentionFilter_1.RetentionFilter,
    RetentionFilterAll: RetentionFilterAll_1.RetentionFilterAll,
    RetentionFilterAllAttributes: RetentionFilterAllAttributes_1.RetentionFilterAllAttributes,
    RetentionFilterAttributes: RetentionFilterAttributes_1.RetentionFilterAttributes,
    RetentionFilterCreateAttributes: RetentionFilterCreateAttributes_1.RetentionFilterCreateAttributes,
    RetentionFilterCreateData: RetentionFilterCreateData_1.RetentionFilterCreateData,
    RetentionFilterCreateRequest: RetentionFilterCreateRequest_1.RetentionFilterCreateRequest,
    RetentionFilterCreateResponse: RetentionFilterCreateResponse_1.RetentionFilterCreateResponse,
    RetentionFilterResponse: RetentionFilterResponse_1.RetentionFilterResponse,
    RetentionFilterUpdateAttributes: RetentionFilterUpdateAttributes_1.RetentionFilterUpdateAttributes,
    RetentionFilterUpdateData: RetentionFilterUpdateData_1.RetentionFilterUpdateData,
    RetentionFilterUpdateRequest: RetentionFilterUpdateRequest_1.RetentionFilterUpdateRequest,
    RetentionFilterWithoutAttributes: RetentionFilterWithoutAttributes_1.RetentionFilterWithoutAttributes,
    RetentionFiltersResponse: RetentionFiltersResponse_1.RetentionFiltersResponse,
    RetryStrategy: RetryStrategy_1.RetryStrategy,
    RetryStrategyLinear: RetryStrategyLinear_1.RetryStrategyLinear,
    Role: Role_1.Role,
    RoleAttributes: RoleAttributes_1.RoleAttributes,
    RoleClone: RoleClone_1.RoleClone,
    RoleCloneAttributes: RoleCloneAttributes_1.RoleCloneAttributes,
    RoleCloneRequest: RoleCloneRequest_1.RoleCloneRequest,
    RoleCreateAttributes: RoleCreateAttributes_1.RoleCreateAttributes,
    RoleCreateData: RoleCreateData_1.RoleCreateData,
    RoleCreateRequest: RoleCreateRequest_1.RoleCreateRequest,
    RoleCreateResponse: RoleCreateResponse_1.RoleCreateResponse,
    RoleCreateResponseData: RoleCreateResponseData_1.RoleCreateResponseData,
    RoleRelationships: RoleRelationships_1.RoleRelationships,
    RoleResponse: RoleResponse_1.RoleResponse,
    RoleResponseRelationships: RoleResponseRelationships_1.RoleResponseRelationships,
    RoleUpdateAttributes: RoleUpdateAttributes_1.RoleUpdateAttributes,
    RoleUpdateData: RoleUpdateData_1.RoleUpdateData,
    RoleUpdateRequest: RoleUpdateRequest_1.RoleUpdateRequest,
    RoleUpdateResponse: RoleUpdateResponse_1.RoleUpdateResponse,
    RoleUpdateResponseData: RoleUpdateResponseData_1.RoleUpdateResponseData,
    RolesResponse: RolesResponse_1.RolesResponse,
    RoutingRule: RoutingRule_1.RoutingRule,
    RoutingRuleAttributes: RoutingRuleAttributes_1.RoutingRuleAttributes,
    RoutingRuleRelationships: RoutingRuleRelationships_1.RoutingRuleRelationships,
    RoutingRuleRelationshipsPolicy: RoutingRuleRelationshipsPolicy_1.RoutingRuleRelationshipsPolicy,
    RoutingRuleRelationshipsPolicyData: RoutingRuleRelationshipsPolicyData_1.RoutingRuleRelationshipsPolicyData,
    RuleAttributes: RuleAttributes_1.RuleAttributes,
    RuleOutcomeRelationships: RuleOutcomeRelationships_1.RuleOutcomeRelationships,
    RuleUser: RuleUser_1.RuleUser,
    RuleVersionHistory: RuleVersionHistory_1.RuleVersionHistory,
    RuleVersionUpdate: RuleVersionUpdate_1.RuleVersionUpdate,
    RuleVersions: RuleVersions_1.RuleVersions,
    RumMetricCompute: RumMetricCompute_1.RumMetricCompute,
    RumMetricCreateAttributes: RumMetricCreateAttributes_1.RumMetricCreateAttributes,
    RumMetricCreateData: RumMetricCreateData_1.RumMetricCreateData,
    RumMetricCreateRequest: RumMetricCreateRequest_1.RumMetricCreateRequest,
    RumMetricFilter: RumMetricFilter_1.RumMetricFilter,
    RumMetricGroupBy: RumMetricGroupBy_1.RumMetricGroupBy,
    RumMetricResponse: RumMetricResponse_1.RumMetricResponse,
    RumMetricResponseAttributes: RumMetricResponseAttributes_1.RumMetricResponseAttributes,
    RumMetricResponseCompute: RumMetricResponseCompute_1.RumMetricResponseCompute,
    RumMetricResponseData: RumMetricResponseData_1.RumMetricResponseData,
    RumMetricResponseFilter: RumMetricResponseFilter_1.RumMetricResponseFilter,
    RumMetricResponseGroupBy: RumMetricResponseGroupBy_1.RumMetricResponseGroupBy,
    RumMetricResponseUniqueness: RumMetricResponseUniqueness_1.RumMetricResponseUniqueness,
    RumMetricUniqueness: RumMetricUniqueness_1.RumMetricUniqueness,
    RumMetricUpdateAttributes: RumMetricUpdateAttributes_1.RumMetricUpdateAttributes,
    RumMetricUpdateCompute: RumMetricUpdateCompute_1.RumMetricUpdateCompute,
    RumMetricUpdateData: RumMetricUpdateData_1.RumMetricUpdateData,
    RumMetricUpdateRequest: RumMetricUpdateRequest_1.RumMetricUpdateRequest,
    RumMetricsResponse: RumMetricsResponse_1.RumMetricsResponse,
    RumRetentionFilterAttributes: RumRetentionFilterAttributes_1.RumRetentionFilterAttributes,
    RumRetentionFilterCreateAttributes: RumRetentionFilterCreateAttributes_1.RumRetentionFilterCreateAttributes,
    RumRetentionFilterCreateData: RumRetentionFilterCreateData_1.RumRetentionFilterCreateData,
    RumRetentionFilterCreateRequest: RumRetentionFilterCreateRequest_1.RumRetentionFilterCreateRequest,
    RumRetentionFilterData: RumRetentionFilterData_1.RumRetentionFilterData,
    RumRetentionFilterResponse: RumRetentionFilterResponse_1.RumRetentionFilterResponse,
    RumRetentionFilterUpdateAttributes: RumRetentionFilterUpdateAttributes_1.RumRetentionFilterUpdateAttributes,
    RumRetentionFilterUpdateData: RumRetentionFilterUpdateData_1.RumRetentionFilterUpdateData,
    RumRetentionFilterUpdateRequest: RumRetentionFilterUpdateRequest_1.RumRetentionFilterUpdateRequest,
    RumRetentionFiltersOrderData: RumRetentionFiltersOrderData_1.RumRetentionFiltersOrderData,
    RumRetentionFiltersOrderRequest: RumRetentionFiltersOrderRequest_1.RumRetentionFiltersOrderRequest,
    RumRetentionFiltersOrderResponse: RumRetentionFiltersOrderResponse_1.RumRetentionFiltersOrderResponse,
    RumRetentionFiltersResponse: RumRetentionFiltersResponse_1.RumRetentionFiltersResponse,
    RunHistoricalJobRequest: RunHistoricalJobRequest_1.RunHistoricalJobRequest,
    RunHistoricalJobRequestAttributes: RunHistoricalJobRequestAttributes_1.RunHistoricalJobRequestAttributes,
    RunHistoricalJobRequestData: RunHistoricalJobRequestData_1.RunHistoricalJobRequestData,
    SAMLAssertionAttribute: SAMLAssertionAttribute_1.SAMLAssertionAttribute,
    SAMLAssertionAttributeAttributes: SAMLAssertionAttributeAttributes_1.SAMLAssertionAttributeAttributes,
    SBOM: SBOM_1.SBOM,
    SBOMAttributes: SBOMAttributes_1.SBOMAttributes,
    SBOMComponent: SBOMComponent_1.SBOMComponent,
    SBOMMetadata: SBOMMetadata_1.SBOMMetadata,
    SBOMMetadataComponent: SBOMMetadataComponent_1.SBOMMetadataComponent,
    SLOReportPostResponse: SLOReportPostResponse_1.SLOReportPostResponse,
    SLOReportPostResponseData: SLOReportPostResponseData_1.SLOReportPostResponseData,
    SLOReportStatusGetResponse: SLOReportStatusGetResponse_1.SLOReportStatusGetResponse,
    SLOReportStatusGetResponseAttributes: SLOReportStatusGetResponseAttributes_1.SLOReportStatusGetResponseAttributes,
    SLOReportStatusGetResponseData: SLOReportStatusGetResponseData_1.SLOReportStatusGetResponseData,
    ScalarFormulaQueryRequest: ScalarFormulaQueryRequest_1.ScalarFormulaQueryRequest,
    ScalarFormulaQueryResponse: ScalarFormulaQueryResponse_1.ScalarFormulaQueryResponse,
    ScalarFormulaRequest: ScalarFormulaRequest_1.ScalarFormulaRequest,
    ScalarFormulaRequestAttributes: ScalarFormulaRequestAttributes_1.ScalarFormulaRequestAttributes,
    ScalarFormulaResponseAtrributes: ScalarFormulaResponseAtrributes_1.ScalarFormulaResponseAtrributes,
    ScalarMeta: ScalarMeta_1.ScalarMeta,
    ScalarResponse: ScalarResponse_1.ScalarResponse,
    Schedule: Schedule_1.Schedule,
    ScheduleCreateRequest: ScheduleCreateRequest_1.ScheduleCreateRequest,
    ScheduleCreateRequestData: ScheduleCreateRequestData_1.ScheduleCreateRequestData,
    ScheduleCreateRequestDataAttributes: ScheduleCreateRequestDataAttributes_1.ScheduleCreateRequestDataAttributes,
    ScheduleCreateRequestDataAttributesLayersItems: ScheduleCreateRequestDataAttributesLayersItems_1.ScheduleCreateRequestDataAttributesLayersItems,
    ScheduleCreateRequestDataRelationships: ScheduleCreateRequestDataRelationships_1.ScheduleCreateRequestDataRelationships,
    ScheduleData: ScheduleData_1.ScheduleData,
    ScheduleDataAttributes: ScheduleDataAttributes_1.ScheduleDataAttributes,
    ScheduleDataRelationships: ScheduleDataRelationships_1.ScheduleDataRelationships,
    ScheduleDataRelationshipsLayers: ScheduleDataRelationshipsLayers_1.ScheduleDataRelationshipsLayers,
    ScheduleDataRelationshipsLayersDataItems: ScheduleDataRelationshipsLayersDataItems_1.ScheduleDataRelationshipsLayersDataItems,
    ScheduleMember: ScheduleMember_1.ScheduleMember,
    ScheduleMemberRelationships: ScheduleMemberRelationships_1.ScheduleMemberRelationships,
    ScheduleMemberRelationshipsUser: ScheduleMemberRelationshipsUser_1.ScheduleMemberRelationshipsUser,
    ScheduleMemberRelationshipsUserData: ScheduleMemberRelationshipsUserData_1.ScheduleMemberRelationshipsUserData,
    ScheduleRequestDataAttributesLayersItemsMembersItems: ScheduleRequestDataAttributesLayersItemsMembersItems_1.ScheduleRequestDataAttributesLayersItemsMembersItems,
    ScheduleRequestDataAttributesLayersItemsMembersItemsUser: ScheduleRequestDataAttributesLayersItemsMembersItemsUser_1.ScheduleRequestDataAttributesLayersItemsMembersItemsUser,
    ScheduleTarget: ScheduleTarget_1.ScheduleTarget,
    ScheduleTrigger: ScheduleTrigger_1.ScheduleTrigger,
    ScheduleTriggerWrapper: ScheduleTriggerWrapper_1.ScheduleTriggerWrapper,
    ScheduleUpdateRequest: ScheduleUpdateRequest_1.ScheduleUpdateRequest,
    ScheduleUpdateRequestData: ScheduleUpdateRequestData_1.ScheduleUpdateRequestData,
    ScheduleUpdateRequestDataAttributes: ScheduleUpdateRequestDataAttributes_1.ScheduleUpdateRequestDataAttributes,
    ScheduleUpdateRequestDataAttributesLayersItems: ScheduleUpdateRequestDataAttributesLayersItems_1.ScheduleUpdateRequestDataAttributesLayersItems,
    ScheduleUpdateRequestDataRelationships: ScheduleUpdateRequestDataRelationships_1.ScheduleUpdateRequestDataRelationships,
    ScheduleUser: ScheduleUser_1.ScheduleUser,
    ScheduleUserAttributes: ScheduleUserAttributes_1.ScheduleUserAttributes,
    SecurityFilter: SecurityFilter_1.SecurityFilter,
    SecurityFilterAttributes: SecurityFilterAttributes_1.SecurityFilterAttributes,
    SecurityFilterCreateAttributes: SecurityFilterCreateAttributes_1.SecurityFilterCreateAttributes,
    SecurityFilterCreateData: SecurityFilterCreateData_1.SecurityFilterCreateData,
    SecurityFilterCreateRequest: SecurityFilterCreateRequest_1.SecurityFilterCreateRequest,
    SecurityFilterExclusionFilter: SecurityFilterExclusionFilter_1.SecurityFilterExclusionFilter,
    SecurityFilterExclusionFilterResponse: SecurityFilterExclusionFilterResponse_1.SecurityFilterExclusionFilterResponse,
    SecurityFilterMeta: SecurityFilterMeta_1.SecurityFilterMeta,
    SecurityFilterResponse: SecurityFilterResponse_1.SecurityFilterResponse,
    SecurityFilterUpdateAttributes: SecurityFilterUpdateAttributes_1.SecurityFilterUpdateAttributes,
    SecurityFilterUpdateData: SecurityFilterUpdateData_1.SecurityFilterUpdateData,
    SecurityFilterUpdateRequest: SecurityFilterUpdateRequest_1.SecurityFilterUpdateRequest,
    SecurityFiltersResponse: SecurityFiltersResponse_1.SecurityFiltersResponse,
    SecurityMonitoringFilter: SecurityMonitoringFilter_1.SecurityMonitoringFilter,
    SecurityMonitoringListRulesResponse: SecurityMonitoringListRulesResponse_1.SecurityMonitoringListRulesResponse,
    SecurityMonitoringReferenceTable: SecurityMonitoringReferenceTable_1.SecurityMonitoringReferenceTable,
    SecurityMonitoringRuleCase: SecurityMonitoringRuleCase_1.SecurityMonitoringRuleCase,
    SecurityMonitoringRuleCaseAction: SecurityMonitoringRuleCaseAction_1.SecurityMonitoringRuleCaseAction,
    SecurityMonitoringRuleCaseActionOptions: SecurityMonitoringRuleCaseActionOptions_1.SecurityMonitoringRuleCaseActionOptions,
    SecurityMonitoringRuleCaseCreate: SecurityMonitoringRuleCaseCreate_1.SecurityMonitoringRuleCaseCreate,
    SecurityMonitoringRuleConvertResponse: SecurityMonitoringRuleConvertResponse_1.SecurityMonitoringRuleConvertResponse,
    SecurityMonitoringRuleImpossibleTravelOptions: SecurityMonitoringRuleImpossibleTravelOptions_1.SecurityMonitoringRuleImpossibleTravelOptions,
    SecurityMonitoringRuleNewValueOptions: SecurityMonitoringRuleNewValueOptions_1.SecurityMonitoringRuleNewValueOptions,
    SecurityMonitoringRuleOptions: SecurityMonitoringRuleOptions_1.SecurityMonitoringRuleOptions,
    SecurityMonitoringRuleQueryPayload: SecurityMonitoringRuleQueryPayload_1.SecurityMonitoringRuleQueryPayload,
    SecurityMonitoringRuleQueryPayloadData: SecurityMonitoringRuleQueryPayloadData_1.SecurityMonitoringRuleQueryPayloadData,
    SecurityMonitoringRuleTestRequest: SecurityMonitoringRuleTestRequest_1.SecurityMonitoringRuleTestRequest,
    SecurityMonitoringRuleTestResponse: SecurityMonitoringRuleTestResponse_1.SecurityMonitoringRuleTestResponse,
    SecurityMonitoringRuleThirdPartyOptions: SecurityMonitoringRuleThirdPartyOptions_1.SecurityMonitoringRuleThirdPartyOptions,
    SecurityMonitoringRuleUpdatePayload: SecurityMonitoringRuleUpdatePayload_1.SecurityMonitoringRuleUpdatePayload,
    SecurityMonitoringSignal: SecurityMonitoringSignal_1.SecurityMonitoringSignal,
    SecurityMonitoringSignalAssigneeUpdateAttributes: SecurityMonitoringSignalAssigneeUpdateAttributes_1.SecurityMonitoringSignalAssigneeUpdateAttributes,
    SecurityMonitoringSignalAssigneeUpdateData: SecurityMonitoringSignalAssigneeUpdateData_1.SecurityMonitoringSignalAssigneeUpdateData,
    SecurityMonitoringSignalAssigneeUpdateRequest: SecurityMonitoringSignalAssigneeUpdateRequest_1.SecurityMonitoringSignalAssigneeUpdateRequest,
    SecurityMonitoringSignalAttributes: SecurityMonitoringSignalAttributes_1.SecurityMonitoringSignalAttributes,
    SecurityMonitoringSignalIncidentsUpdateAttributes: SecurityMonitoringSignalIncidentsUpdateAttributes_1.SecurityMonitoringSignalIncidentsUpdateAttributes,
    SecurityMonitoringSignalIncidentsUpdateData: SecurityMonitoringSignalIncidentsUpdateData_1.SecurityMonitoringSignalIncidentsUpdateData,
    SecurityMonitoringSignalIncidentsUpdateRequest: SecurityMonitoringSignalIncidentsUpdateRequest_1.SecurityMonitoringSignalIncidentsUpdateRequest,
    SecurityMonitoringSignalListRequest: SecurityMonitoringSignalListRequest_1.SecurityMonitoringSignalListRequest,
    SecurityMonitoringSignalListRequestFilter: SecurityMonitoringSignalListRequestFilter_1.SecurityMonitoringSignalListRequestFilter,
    SecurityMonitoringSignalListRequestPage: SecurityMonitoringSignalListRequestPage_1.SecurityMonitoringSignalListRequestPage,
    SecurityMonitoringSignalResponse: SecurityMonitoringSignalResponse_1.SecurityMonitoringSignalResponse,
    SecurityMonitoringSignalRuleCreatePayload: SecurityMonitoringSignalRuleCreatePayload_1.SecurityMonitoringSignalRuleCreatePayload,
    SecurityMonitoringSignalRulePayload: SecurityMonitoringSignalRulePayload_1.SecurityMonitoringSignalRulePayload,
    SecurityMonitoringSignalRuleQuery: SecurityMonitoringSignalRuleQuery_1.SecurityMonitoringSignalRuleQuery,
    SecurityMonitoringSignalRuleResponse: SecurityMonitoringSignalRuleResponse_1.SecurityMonitoringSignalRuleResponse,
    SecurityMonitoringSignalRuleResponseQuery: SecurityMonitoringSignalRuleResponseQuery_1.SecurityMonitoringSignalRuleResponseQuery,
    SecurityMonitoringSignalStateUpdateAttributes: SecurityMonitoringSignalStateUpdateAttributes_1.SecurityMonitoringSignalStateUpdateAttributes,
    SecurityMonitoringSignalStateUpdateData: SecurityMonitoringSignalStateUpdateData_1.SecurityMonitoringSignalStateUpdateData,
    SecurityMonitoringSignalStateUpdateRequest: SecurityMonitoringSignalStateUpdateRequest_1.SecurityMonitoringSignalStateUpdateRequest,
    SecurityMonitoringSignalTriageAttributes: SecurityMonitoringSignalTriageAttributes_1.SecurityMonitoringSignalTriageAttributes,
    SecurityMonitoringSignalTriageUpdateData: SecurityMonitoringSignalTriageUpdateData_1.SecurityMonitoringSignalTriageUpdateData,
    SecurityMonitoringSignalTriageUpdateResponse: SecurityMonitoringSignalTriageUpdateResponse_1.SecurityMonitoringSignalTriageUpdateResponse,
    SecurityMonitoringSignalsListResponse: SecurityMonitoringSignalsListResponse_1.SecurityMonitoringSignalsListResponse,
    SecurityMonitoringSignalsListResponseLinks: SecurityMonitoringSignalsListResponseLinks_1.SecurityMonitoringSignalsListResponseLinks,
    SecurityMonitoringSignalsListResponseMeta: SecurityMonitoringSignalsListResponseMeta_1.SecurityMonitoringSignalsListResponseMeta,
    SecurityMonitoringSignalsListResponseMetaPage: SecurityMonitoringSignalsListResponseMetaPage_1.SecurityMonitoringSignalsListResponseMetaPage,
    SecurityMonitoringStandardRuleCreatePayload: SecurityMonitoringStandardRuleCreatePayload_1.SecurityMonitoringStandardRuleCreatePayload,
    SecurityMonitoringStandardRulePayload: SecurityMonitoringStandardRulePayload_1.SecurityMonitoringStandardRulePayload,
    SecurityMonitoringStandardRuleQuery: SecurityMonitoringStandardRuleQuery_1.SecurityMonitoringStandardRuleQuery,
    SecurityMonitoringStandardRuleResponse: SecurityMonitoringStandardRuleResponse_1.SecurityMonitoringStandardRuleResponse,
    SecurityMonitoringStandardRuleTestPayload: SecurityMonitoringStandardRuleTestPayload_1.SecurityMonitoringStandardRuleTestPayload,
    SecurityMonitoringSuppression: SecurityMonitoringSuppression_1.SecurityMonitoringSuppression,
    SecurityMonitoringSuppressionAttributes: SecurityMonitoringSuppressionAttributes_1.SecurityMonitoringSuppressionAttributes,
    SecurityMonitoringSuppressionCreateAttributes: SecurityMonitoringSuppressionCreateAttributes_1.SecurityMonitoringSuppressionCreateAttributes,
    SecurityMonitoringSuppressionCreateData: SecurityMonitoringSuppressionCreateData_1.SecurityMonitoringSuppressionCreateData,
    SecurityMonitoringSuppressionCreateRequest: SecurityMonitoringSuppressionCreateRequest_1.SecurityMonitoringSuppressionCreateRequest,
    SecurityMonitoringSuppressionResponse: SecurityMonitoringSuppressionResponse_1.SecurityMonitoringSuppressionResponse,
    SecurityMonitoringSuppressionUpdateAttributes: SecurityMonitoringSuppressionUpdateAttributes_1.SecurityMonitoringSuppressionUpdateAttributes,
    SecurityMonitoringSuppressionUpdateData: SecurityMonitoringSuppressionUpdateData_1.SecurityMonitoringSuppressionUpdateData,
    SecurityMonitoringSuppressionUpdateRequest: SecurityMonitoringSuppressionUpdateRequest_1.SecurityMonitoringSuppressionUpdateRequest,
    SecurityMonitoringSuppressionsResponse: SecurityMonitoringSuppressionsResponse_1.SecurityMonitoringSuppressionsResponse,
    SecurityMonitoringThirdPartyRootQuery: SecurityMonitoringThirdPartyRootQuery_1.SecurityMonitoringThirdPartyRootQuery,
    SecurityMonitoringThirdPartyRuleCase: SecurityMonitoringThirdPartyRuleCase_1.SecurityMonitoringThirdPartyRuleCase,
    SecurityMonitoringThirdPartyRuleCaseCreate: SecurityMonitoringThirdPartyRuleCaseCreate_1.SecurityMonitoringThirdPartyRuleCaseCreate,
    SecurityMonitoringTriageUser: SecurityMonitoringTriageUser_1.SecurityMonitoringTriageUser,
    SecurityMonitoringUser: SecurityMonitoringUser_1.SecurityMonitoringUser,
    SecurityTrigger: SecurityTrigger_1.SecurityTrigger,
    SecurityTriggerWrapper: SecurityTriggerWrapper_1.SecurityTriggerWrapper,
    Selectors: Selectors_1.Selectors,
    SelfServiceTriggerWrapper: SelfServiceTriggerWrapper_1.SelfServiceTriggerWrapper,
    SendSlackMessageAction: SendSlackMessageAction_1.SendSlackMessageAction,
    SendTeamsMessageAction: SendTeamsMessageAction_1.SendTeamsMessageAction,
    SensitiveDataScannerConfigRequest: SensitiveDataScannerConfigRequest_1.SensitiveDataScannerConfigRequest,
    SensitiveDataScannerConfiguration: SensitiveDataScannerConfiguration_1.SensitiveDataScannerConfiguration,
    SensitiveDataScannerConfigurationData: SensitiveDataScannerConfigurationData_1.SensitiveDataScannerConfigurationData,
    SensitiveDataScannerConfigurationRelationships: SensitiveDataScannerConfigurationRelationships_1.SensitiveDataScannerConfigurationRelationships,
    SensitiveDataScannerCreateGroupResponse: SensitiveDataScannerCreateGroupResponse_1.SensitiveDataScannerCreateGroupResponse,
    SensitiveDataScannerCreateRuleResponse: SensitiveDataScannerCreateRuleResponse_1.SensitiveDataScannerCreateRuleResponse,
    SensitiveDataScannerFilter: SensitiveDataScannerFilter_1.SensitiveDataScannerFilter,
    SensitiveDataScannerGetConfigResponse: SensitiveDataScannerGetConfigResponse_1.SensitiveDataScannerGetConfigResponse,
    SensitiveDataScannerGetConfigResponseData: SensitiveDataScannerGetConfigResponseData_1.SensitiveDataScannerGetConfigResponseData,
    SensitiveDataScannerGroup: SensitiveDataScannerGroup_1.SensitiveDataScannerGroup,
    SensitiveDataScannerGroupAttributes: SensitiveDataScannerGroupAttributes_1.SensitiveDataScannerGroupAttributes,
    SensitiveDataScannerGroupCreate: SensitiveDataScannerGroupCreate_1.SensitiveDataScannerGroupCreate,
    SensitiveDataScannerGroupCreateRequest: SensitiveDataScannerGroupCreateRequest_1.SensitiveDataScannerGroupCreateRequest,
    SensitiveDataScannerGroupData: SensitiveDataScannerGroupData_1.SensitiveDataScannerGroupData,
    SensitiveDataScannerGroupDeleteRequest: SensitiveDataScannerGroupDeleteRequest_1.SensitiveDataScannerGroupDeleteRequest,
    SensitiveDataScannerGroupDeleteResponse: SensitiveDataScannerGroupDeleteResponse_1.SensitiveDataScannerGroupDeleteResponse,
    SensitiveDataScannerGroupIncludedItem: SensitiveDataScannerGroupIncludedItem_1.SensitiveDataScannerGroupIncludedItem,
    SensitiveDataScannerGroupItem: SensitiveDataScannerGroupItem_1.SensitiveDataScannerGroupItem,
    SensitiveDataScannerGroupList: SensitiveDataScannerGroupList_1.SensitiveDataScannerGroupList,
    SensitiveDataScannerGroupRelationships: SensitiveDataScannerGroupRelationships_1.SensitiveDataScannerGroupRelationships,
    SensitiveDataScannerGroupResponse: SensitiveDataScannerGroupResponse_1.SensitiveDataScannerGroupResponse,
    SensitiveDataScannerGroupUpdate: SensitiveDataScannerGroupUpdate_1.SensitiveDataScannerGroupUpdate,
    SensitiveDataScannerGroupUpdateRequest: SensitiveDataScannerGroupUpdateRequest_1.SensitiveDataScannerGroupUpdateRequest,
    SensitiveDataScannerGroupUpdateResponse: SensitiveDataScannerGroupUpdateResponse_1.SensitiveDataScannerGroupUpdateResponse,
    SensitiveDataScannerIncludedKeywordConfiguration: SensitiveDataScannerIncludedKeywordConfiguration_1.SensitiveDataScannerIncludedKeywordConfiguration,
    SensitiveDataScannerMeta: SensitiveDataScannerMeta_1.SensitiveDataScannerMeta,
    SensitiveDataScannerMetaVersionOnly: SensitiveDataScannerMetaVersionOnly_1.SensitiveDataScannerMetaVersionOnly,
    SensitiveDataScannerReorderConfig: SensitiveDataScannerReorderConfig_1.SensitiveDataScannerReorderConfig,
    SensitiveDataScannerReorderGroupsResponse: SensitiveDataScannerReorderGroupsResponse_1.SensitiveDataScannerReorderGroupsResponse,
    SensitiveDataScannerRule: SensitiveDataScannerRule_1.SensitiveDataScannerRule,
    SensitiveDataScannerRuleAttributes: SensitiveDataScannerRuleAttributes_1.SensitiveDataScannerRuleAttributes,
    SensitiveDataScannerRuleCreate: SensitiveDataScannerRuleCreate_1.SensitiveDataScannerRuleCreate,
    SensitiveDataScannerRuleCreateRequest: SensitiveDataScannerRuleCreateRequest_1.SensitiveDataScannerRuleCreateRequest,
    SensitiveDataScannerRuleData: SensitiveDataScannerRuleData_1.SensitiveDataScannerRuleData,
    SensitiveDataScannerRuleDeleteRequest: SensitiveDataScannerRuleDeleteRequest_1.SensitiveDataScannerRuleDeleteRequest,
    SensitiveDataScannerRuleDeleteResponse: SensitiveDataScannerRuleDeleteResponse_1.SensitiveDataScannerRuleDeleteResponse,
    SensitiveDataScannerRuleIncludedItem: SensitiveDataScannerRuleIncludedItem_1.SensitiveDataScannerRuleIncludedItem,
    SensitiveDataScannerRuleRelationships: SensitiveDataScannerRuleRelationships_1.SensitiveDataScannerRuleRelationships,
    SensitiveDataScannerRuleResponse: SensitiveDataScannerRuleResponse_1.SensitiveDataScannerRuleResponse,
    SensitiveDataScannerRuleUpdate: SensitiveDataScannerRuleUpdate_1.SensitiveDataScannerRuleUpdate,
    SensitiveDataScannerRuleUpdateRequest: SensitiveDataScannerRuleUpdateRequest_1.SensitiveDataScannerRuleUpdateRequest,
    SensitiveDataScannerRuleUpdateResponse: SensitiveDataScannerRuleUpdateResponse_1.SensitiveDataScannerRuleUpdateResponse,
    SensitiveDataScannerStandardPattern: SensitiveDataScannerStandardPattern_1.SensitiveDataScannerStandardPattern,
    SensitiveDataScannerStandardPatternAttributes: SensitiveDataScannerStandardPatternAttributes_1.SensitiveDataScannerStandardPatternAttributes,
    SensitiveDataScannerStandardPatternData: SensitiveDataScannerStandardPatternData_1.SensitiveDataScannerStandardPatternData,
    SensitiveDataScannerStandardPatternsResponseData: SensitiveDataScannerStandardPatternsResponseData_1.SensitiveDataScannerStandardPatternsResponseData,
    SensitiveDataScannerStandardPatternsResponseItem: SensitiveDataScannerStandardPatternsResponseItem_1.SensitiveDataScannerStandardPatternsResponseItem,
    SensitiveDataScannerTextReplacement: SensitiveDataScannerTextReplacement_1.SensitiveDataScannerTextReplacement,
    ServiceAccountCreateAttributes: ServiceAccountCreateAttributes_1.ServiceAccountCreateAttributes,
    ServiceAccountCreateData: ServiceAccountCreateData_1.ServiceAccountCreateData,
    ServiceAccountCreateRequest: ServiceAccountCreateRequest_1.ServiceAccountCreateRequest,
    ServiceDefinitionCreateResponse: ServiceDefinitionCreateResponse_1.ServiceDefinitionCreateResponse,
    ServiceDefinitionData: ServiceDefinitionData_1.ServiceDefinitionData,
    ServiceDefinitionDataAttributes: ServiceDefinitionDataAttributes_1.ServiceDefinitionDataAttributes,
    ServiceDefinitionGetResponse: ServiceDefinitionGetResponse_1.ServiceDefinitionGetResponse,
    ServiceDefinitionMeta: ServiceDefinitionMeta_1.ServiceDefinitionMeta,
    ServiceDefinitionMetaWarnings: ServiceDefinitionMetaWarnings_1.ServiceDefinitionMetaWarnings,
    ServiceDefinitionV1: ServiceDefinitionV1_1.ServiceDefinitionV1,
    ServiceDefinitionV1Contact: ServiceDefinitionV1Contact_1.ServiceDefinitionV1Contact,
    ServiceDefinitionV1Info: ServiceDefinitionV1Info_1.ServiceDefinitionV1Info,
    ServiceDefinitionV1Integrations: ServiceDefinitionV1Integrations_1.ServiceDefinitionV1Integrations,
    ServiceDefinitionV1Org: ServiceDefinitionV1Org_1.ServiceDefinitionV1Org,
    ServiceDefinitionV1Resource: ServiceDefinitionV1Resource_1.ServiceDefinitionV1Resource,
    ServiceDefinitionV2: ServiceDefinitionV2_1.ServiceDefinitionV2,
    ServiceDefinitionV2Doc: ServiceDefinitionV2Doc_1.ServiceDefinitionV2Doc,
    ServiceDefinitionV2Dot1: ServiceDefinitionV2Dot1_1.ServiceDefinitionV2Dot1,
    ServiceDefinitionV2Dot1Email: ServiceDefinitionV2Dot1Email_1.ServiceDefinitionV2Dot1Email,
    ServiceDefinitionV2Dot1Integrations: ServiceDefinitionV2Dot1Integrations_1.ServiceDefinitionV2Dot1Integrations,
    ServiceDefinitionV2Dot1Link: ServiceDefinitionV2Dot1Link_1.ServiceDefinitionV2Dot1Link,
    ServiceDefinitionV2Dot1MSTeams: ServiceDefinitionV2Dot1MSTeams_1.ServiceDefinitionV2Dot1MSTeams,
    ServiceDefinitionV2Dot1Opsgenie: ServiceDefinitionV2Dot1Opsgenie_1.ServiceDefinitionV2Dot1Opsgenie,
    ServiceDefinitionV2Dot1Pagerduty: ServiceDefinitionV2Dot1Pagerduty_1.ServiceDefinitionV2Dot1Pagerduty,
    ServiceDefinitionV2Dot1Slack: ServiceDefinitionV2Dot1Slack_1.ServiceDefinitionV2Dot1Slack,
    ServiceDefinitionV2Dot2: ServiceDefinitionV2Dot2_1.ServiceDefinitionV2Dot2,
    ServiceDefinitionV2Dot2Contact: ServiceDefinitionV2Dot2Contact_1.ServiceDefinitionV2Dot2Contact,
    ServiceDefinitionV2Dot2Integrations: ServiceDefinitionV2Dot2Integrations_1.ServiceDefinitionV2Dot2Integrations,
    ServiceDefinitionV2Dot2Link: ServiceDefinitionV2Dot2Link_1.ServiceDefinitionV2Dot2Link,
    ServiceDefinitionV2Dot2Opsgenie: ServiceDefinitionV2Dot2Opsgenie_1.ServiceDefinitionV2Dot2Opsgenie,
    ServiceDefinitionV2Dot2Pagerduty: ServiceDefinitionV2Dot2Pagerduty_1.ServiceDefinitionV2Dot2Pagerduty,
    ServiceDefinitionV2Email: ServiceDefinitionV2Email_1.ServiceDefinitionV2Email,
    ServiceDefinitionV2Integrations: ServiceDefinitionV2Integrations_1.ServiceDefinitionV2Integrations,
    ServiceDefinitionV2Link: ServiceDefinitionV2Link_1.ServiceDefinitionV2Link,
    ServiceDefinitionV2MSTeams: ServiceDefinitionV2MSTeams_1.ServiceDefinitionV2MSTeams,
    ServiceDefinitionV2Opsgenie: ServiceDefinitionV2Opsgenie_1.ServiceDefinitionV2Opsgenie,
    ServiceDefinitionV2Repo: ServiceDefinitionV2Repo_1.ServiceDefinitionV2Repo,
    ServiceDefinitionV2Slack: ServiceDefinitionV2Slack_1.ServiceDefinitionV2Slack,
    ServiceDefinitionsListResponse: ServiceDefinitionsListResponse_1.ServiceDefinitionsListResponse,
    ServiceNowTicket: ServiceNowTicket_1.ServiceNowTicket,
    ServiceNowTicketResult: ServiceNowTicketResult_1.ServiceNowTicketResult,
    Shift: Shift_1.Shift,
    ShiftData: ShiftData_1.ShiftData,
    ShiftDataAttributes: ShiftDataAttributes_1.ShiftDataAttributes,
    ShiftDataRelationships: ShiftDataRelationships_1.ShiftDataRelationships,
    ShiftDataRelationshipsUser: ShiftDataRelationshipsUser_1.ShiftDataRelationshipsUser,
    ShiftDataRelationshipsUserData: ShiftDataRelationshipsUserData_1.ShiftDataRelationshipsUserData,
    SingleAggregatedConnectionResponseArray: SingleAggregatedConnectionResponseArray_1.SingleAggregatedConnectionResponseArray,
    SingleAggregatedConnectionResponseData: SingleAggregatedConnectionResponseData_1.SingleAggregatedConnectionResponseData,
    SingleAggregatedConnectionResponseDataAttributes: SingleAggregatedConnectionResponseDataAttributes_1.SingleAggregatedConnectionResponseDataAttributes,
    SlackIntegrationMetadata: SlackIntegrationMetadata_1.SlackIntegrationMetadata,
    SlackIntegrationMetadataChannelItem: SlackIntegrationMetadataChannelItem_1.SlackIntegrationMetadataChannelItem,
    SlackTriggerWrapper: SlackTriggerWrapper_1.SlackTriggerWrapper,
    SloReportCreateRequest: SloReportCreateRequest_1.SloReportCreateRequest,
    SloReportCreateRequestAttributes: SloReportCreateRequestAttributes_1.SloReportCreateRequestAttributes,
    SloReportCreateRequestData: SloReportCreateRequestData_1.SloReportCreateRequestData,
    SoftwareCatalogTriggerWrapper: SoftwareCatalogTriggerWrapper_1.SoftwareCatalogTriggerWrapper,
    Span: Span_1.Span,
    SpansAggregateBucket: SpansAggregateBucket_1.SpansAggregateBucket,
    SpansAggregateBucketAttributes: SpansAggregateBucketAttributes_1.SpansAggregateBucketAttributes,
    SpansAggregateBucketValueTimeseriesPoint: SpansAggregateBucketValueTimeseriesPoint_1.SpansAggregateBucketValueTimeseriesPoint,
    SpansAggregateData: SpansAggregateData_1.SpansAggregateData,
    SpansAggregateRequest: SpansAggregateRequest_1.SpansAggregateRequest,
    SpansAggregateRequestAttributes: SpansAggregateRequestAttributes_1.SpansAggregateRequestAttributes,
    SpansAggregateResponse: SpansAggregateResponse_1.SpansAggregateResponse,
    SpansAggregateResponseMetadata: SpansAggregateResponseMetadata_1.SpansAggregateResponseMetadata,
    SpansAggregateSort: SpansAggregateSort_1.SpansAggregateSort,
    SpansAttributes: SpansAttributes_1.SpansAttributes,
    SpansCompute: SpansCompute_1.SpansCompute,
    SpansFilter: SpansFilter_1.SpansFilter,
    SpansFilterCreate: SpansFilterCreate_1.SpansFilterCreate,
    SpansGroupBy: SpansGroupBy_1.SpansGroupBy,
    SpansGroupByHistogram: SpansGroupByHistogram_1.SpansGroupByHistogram,
    SpansListRequest: SpansListRequest_1.SpansListRequest,
    SpansListRequestAttributes: SpansListRequestAttributes_1.SpansListRequestAttributes,
    SpansListRequestData: SpansListRequestData_1.SpansListRequestData,
    SpansListRequestPage: SpansListRequestPage_1.SpansListRequestPage,
    SpansListResponse: SpansListResponse_1.SpansListResponse,
    SpansListResponseLinks: SpansListResponseLinks_1.SpansListResponseLinks,
    SpansListResponseMetadata: SpansListResponseMetadata_1.SpansListResponseMetadata,
    SpansMetricCompute: SpansMetricCompute_1.SpansMetricCompute,
    SpansMetricCreateAttributes: SpansMetricCreateAttributes_1.SpansMetricCreateAttributes,
    SpansMetricCreateData: SpansMetricCreateData_1.SpansMetricCreateData,
    SpansMetricCreateRequest: SpansMetricCreateRequest_1.SpansMetricCreateRequest,
    SpansMetricFilter: SpansMetricFilter_1.SpansMetricFilter,
    SpansMetricGroupBy: SpansMetricGroupBy_1.SpansMetricGroupBy,
    SpansMetricResponse: SpansMetricResponse_1.SpansMetricResponse,
    SpansMetricResponseAttributes: SpansMetricResponseAttributes_1.SpansMetricResponseAttributes,
    SpansMetricResponseCompute: SpansMetricResponseCompute_1.SpansMetricResponseCompute,
    SpansMetricResponseData: SpansMetricResponseData_1.SpansMetricResponseData,
    SpansMetricResponseFilter: SpansMetricResponseFilter_1.SpansMetricResponseFilter,
    SpansMetricResponseGroupBy: SpansMetricResponseGroupBy_1.SpansMetricResponseGroupBy,
    SpansMetricUpdateAttributes: SpansMetricUpdateAttributes_1.SpansMetricUpdateAttributes,
    SpansMetricUpdateCompute: SpansMetricUpdateCompute_1.SpansMetricUpdateCompute,
    SpansMetricUpdateData: SpansMetricUpdateData_1.SpansMetricUpdateData,
    SpansMetricUpdateRequest: SpansMetricUpdateRequest_1.SpansMetricUpdateRequest,
    SpansMetricsResponse: SpansMetricsResponse_1.SpansMetricsResponse,
    SpansQueryFilter: SpansQueryFilter_1.SpansQueryFilter,
    SpansQueryOptions: SpansQueryOptions_1.SpansQueryOptions,
    SpansResponseMetadataPage: SpansResponseMetadataPage_1.SpansResponseMetadataPage,
    SpansWarning: SpansWarning_1.SpansWarning,
    Spec: Spec_1.Spec,
    StateVariable: StateVariable_1.StateVariable,
    StateVariableProperties: StateVariableProperties_1.StateVariableProperties,
    Step: Step_1.Step,
    StepDisplay: StepDisplay_1.StepDisplay,
    StepDisplayBounds: StepDisplayBounds_1.StepDisplayBounds,
    TagFilter: TagFilter_1.TagFilter,
    Team: Team_1.Team,
    TeamAttributes: TeamAttributes_1.TeamAttributes,
    TeamCreate: TeamCreate_1.TeamCreate,
    TeamCreateAttributes: TeamCreateAttributes_1.TeamCreateAttributes,
    TeamCreateRelationships: TeamCreateRelationships_1.TeamCreateRelationships,
    TeamCreateRequest: TeamCreateRequest_1.TeamCreateRequest,
    TeamLink: TeamLink_1.TeamLink,
    TeamLinkAttributes: TeamLinkAttributes_1.TeamLinkAttributes,
    TeamLinkCreate: TeamLinkCreate_1.TeamLinkCreate,
    TeamLinkCreateRequest: TeamLinkCreateRequest_1.TeamLinkCreateRequest,
    TeamLinkResponse: TeamLinkResponse_1.TeamLinkResponse,
    TeamLinksResponse: TeamLinksResponse_1.TeamLinksResponse,
    TeamPermissionSetting: TeamPermissionSetting_1.TeamPermissionSetting,
    TeamPermissionSettingAttributes: TeamPermissionSettingAttributes_1.TeamPermissionSettingAttributes,
    TeamPermissionSettingResponse: TeamPermissionSettingResponse_1.TeamPermissionSettingResponse,
    TeamPermissionSettingUpdate: TeamPermissionSettingUpdate_1.TeamPermissionSettingUpdate,
    TeamPermissionSettingUpdateAttributes: TeamPermissionSettingUpdateAttributes_1.TeamPermissionSettingUpdateAttributes,
    TeamPermissionSettingUpdateRequest: TeamPermissionSettingUpdateRequest_1.TeamPermissionSettingUpdateRequest,
    TeamPermissionSettingsResponse: TeamPermissionSettingsResponse_1.TeamPermissionSettingsResponse,
    TeamReference: TeamReference_1.TeamReference,
    TeamReferenceAttributes: TeamReferenceAttributes_1.TeamReferenceAttributes,
    TeamRelationships: TeamRelationships_1.TeamRelationships,
    TeamRelationshipsLinks: TeamRelationshipsLinks_1.TeamRelationshipsLinks,
    TeamResponse: TeamResponse_1.TeamResponse,
    TeamRoutingRules: TeamRoutingRules_1.TeamRoutingRules,
    TeamRoutingRulesData: TeamRoutingRulesData_1.TeamRoutingRulesData,
    TeamRoutingRulesDataRelationships: TeamRoutingRulesDataRelationships_1.TeamRoutingRulesDataRelationships,
    TeamRoutingRulesDataRelationshipsRules: TeamRoutingRulesDataRelationshipsRules_1.TeamRoutingRulesDataRelationshipsRules,
    TeamRoutingRulesDataRelationshipsRulesDataItems: TeamRoutingRulesDataRelationshipsRulesDataItems_1.TeamRoutingRulesDataRelationshipsRulesDataItems,
    TeamRoutingRulesRequest: TeamRoutingRulesRequest_1.TeamRoutingRulesRequest,
    TeamRoutingRulesRequestData: TeamRoutingRulesRequestData_1.TeamRoutingRulesRequestData,
    TeamRoutingRulesRequestDataAttributes: TeamRoutingRulesRequestDataAttributes_1.TeamRoutingRulesRequestDataAttributes,
    TeamRoutingRulesRequestRule: TeamRoutingRulesRequestRule_1.TeamRoutingRulesRequestRule,
    TeamTarget: TeamTarget_1.TeamTarget,
    TeamUpdate: TeamUpdate_1.TeamUpdate,
    TeamUpdateAttributes: TeamUpdateAttributes_1.TeamUpdateAttributes,
    TeamUpdateRelationships: TeamUpdateRelationships_1.TeamUpdateRelationships,
    TeamUpdateRequest: TeamUpdateRequest_1.TeamUpdateRequest,
    TeamsResponse: TeamsResponse_1.TeamsResponse,
    TeamsResponseLinks: TeamsResponseLinks_1.TeamsResponseLinks,
    TeamsResponseMeta: TeamsResponseMeta_1.TeamsResponseMeta,
    TeamsResponseMetaPagination: TeamsResponseMetaPagination_1.TeamsResponseMetaPagination,
    TimeRestriction: TimeRestriction_1.TimeRestriction,
    TimeRestrictions: TimeRestrictions_1.TimeRestrictions,
    TimeseriesFormulaQueryRequest: TimeseriesFormulaQueryRequest_1.TimeseriesFormulaQueryRequest,
    TimeseriesFormulaQueryResponse: TimeseriesFormulaQueryResponse_1.TimeseriesFormulaQueryResponse,
    TimeseriesFormulaRequest: TimeseriesFormulaRequest_1.TimeseriesFormulaRequest,
    TimeseriesFormulaRequestAttributes: TimeseriesFormulaRequestAttributes_1.TimeseriesFormulaRequestAttributes,
    TimeseriesResponse: TimeseriesResponse_1.TimeseriesResponse,
    TimeseriesResponseAttributes: TimeseriesResponseAttributes_1.TimeseriesResponseAttributes,
    TimeseriesResponseSeries: TimeseriesResponseSeries_1.TimeseriesResponseSeries,
    TriggerRateLimit: TriggerRateLimit_1.TriggerRateLimit,
    Unit: Unit_1.Unit,
    UnpublishAppResponse: UnpublishAppResponse_1.UnpublishAppResponse,
    UpdateActionConnectionRequest: UpdateActionConnectionRequest_1.UpdateActionConnectionRequest,
    UpdateActionConnectionResponse: UpdateActionConnectionResponse_1.UpdateActionConnectionResponse,
    UpdateAppRequest: UpdateAppRequest_1.UpdateAppRequest,
    UpdateAppRequestData: UpdateAppRequestData_1.UpdateAppRequestData,
    UpdateAppRequestDataAttributes: UpdateAppRequestDataAttributes_1.UpdateAppRequestDataAttributes,
    UpdateAppResponse: UpdateAppResponse_1.UpdateAppResponse,
    UpdateAppResponseData: UpdateAppResponseData_1.UpdateAppResponseData,
    UpdateAppResponseDataAttributes: UpdateAppResponseDataAttributes_1.UpdateAppResponseDataAttributes,
    UpdateCustomFrameworkRequest: UpdateCustomFrameworkRequest_1.UpdateCustomFrameworkRequest,
    UpdateCustomFrameworkResponse: UpdateCustomFrameworkResponse_1.UpdateCustomFrameworkResponse,
    UpdateOpenAPIResponse: UpdateOpenAPIResponse_1.UpdateOpenAPIResponse,
    UpdateOpenAPIResponseAttributes: UpdateOpenAPIResponseAttributes_1.UpdateOpenAPIResponseAttributes,
    UpdateOpenAPIResponseData: UpdateOpenAPIResponseData_1.UpdateOpenAPIResponseData,
    UpdateResourceEvaluationFiltersRequest: UpdateResourceEvaluationFiltersRequest_1.UpdateResourceEvaluationFiltersRequest,
    UpdateResourceEvaluationFiltersRequestData: UpdateResourceEvaluationFiltersRequestData_1.UpdateResourceEvaluationFiltersRequestData,
    UpdateResourceEvaluationFiltersResponse: UpdateResourceEvaluationFiltersResponse_1.UpdateResourceEvaluationFiltersResponse,
    UpdateResourceEvaluationFiltersResponseData: UpdateResourceEvaluationFiltersResponseData_1.UpdateResourceEvaluationFiltersResponseData,
    UpdateRuleRequest: UpdateRuleRequest_1.UpdateRuleRequest,
    UpdateRuleRequestData: UpdateRuleRequestData_1.UpdateRuleRequestData,
    UpdateRuleResponse: UpdateRuleResponse_1.UpdateRuleResponse,
    UpdateRuleResponseData: UpdateRuleResponseData_1.UpdateRuleResponseData,
    UpdateWorkflowRequest: UpdateWorkflowRequest_1.UpdateWorkflowRequest,
    UpdateWorkflowResponse: UpdateWorkflowResponse_1.UpdateWorkflowResponse,
    UpsertCatalogEntityResponse: UpsertCatalogEntityResponse_1.UpsertCatalogEntityResponse,
    UrlParam: UrlParam_1.UrlParam,
    UrlParamUpdate: UrlParamUpdate_1.UrlParamUpdate,
    UsageApplicationSecurityMonitoringResponse: UsageApplicationSecurityMonitoringResponse_1.UsageApplicationSecurityMonitoringResponse,
    UsageAttributesObject: UsageAttributesObject_1.UsageAttributesObject,
    UsageDataObject: UsageDataObject_1.UsageDataObject,
    UsageLambdaTracedInvocationsResponse: UsageLambdaTracedInvocationsResponse_1.UsageLambdaTracedInvocationsResponse,
    UsageObservabilityPipelinesResponse: UsageObservabilityPipelinesResponse_1.UsageObservabilityPipelinesResponse,
    UsageTimeSeriesObject: UsageTimeSeriesObject_1.UsageTimeSeriesObject,
    User: User_1.User,
    UserAttributes: UserAttributes_1.UserAttributes,
    UserCreateAttributes: UserCreateAttributes_1.UserCreateAttributes,
    UserCreateData: UserCreateData_1.UserCreateData,
    UserCreateRequest: UserCreateRequest_1.UserCreateRequest,
    UserInvitationData: UserInvitationData_1.UserInvitationData,
    UserInvitationDataAttributes: UserInvitationDataAttributes_1.UserInvitationDataAttributes,
    UserInvitationRelationships: UserInvitationRelationships_1.UserInvitationRelationships,
    UserInvitationResponse: UserInvitationResponse_1.UserInvitationResponse,
    UserInvitationResponseData: UserInvitationResponseData_1.UserInvitationResponseData,
    UserInvitationsRequest: UserInvitationsRequest_1.UserInvitationsRequest,
    UserInvitationsResponse: UserInvitationsResponse_1.UserInvitationsResponse,
    UserRelationshipData: UserRelationshipData_1.UserRelationshipData,
    UserRelationships: UserRelationships_1.UserRelationships,
    UserResponse: UserResponse_1.UserResponse,
    UserResponseRelationships: UserResponseRelationships_1.UserResponseRelationships,
    UserTarget: UserTarget_1.UserTarget,
    UserTeam: UserTeam_1.UserTeam,
    UserTeamAttributes: UserTeamAttributes_1.UserTeamAttributes,
    UserTeamCreate: UserTeamCreate_1.UserTeamCreate,
    UserTeamPermission: UserTeamPermission_1.UserTeamPermission,
    UserTeamPermissionAttributes: UserTeamPermissionAttributes_1.UserTeamPermissionAttributes,
    UserTeamRelationships: UserTeamRelationships_1.UserTeamRelationships,
    UserTeamRequest: UserTeamRequest_1.UserTeamRequest,
    UserTeamResponse: UserTeamResponse_1.UserTeamResponse,
    UserTeamUpdate: UserTeamUpdate_1.UserTeamUpdate,
    UserTeamUpdateRequest: UserTeamUpdateRequest_1.UserTeamUpdateRequest,
    UserTeamsResponse: UserTeamsResponse_1.UserTeamsResponse,
    UserUpdateAttributes: UserUpdateAttributes_1.UserUpdateAttributes,
    UserUpdateData: UserUpdateData_1.UserUpdateData,
    UserUpdateRequest: UserUpdateRequest_1.UserUpdateRequest,
    UsersRelationship: UsersRelationship_1.UsersRelationship,
    UsersResponse: UsersResponse_1.UsersResponse,
    ValidationError: ValidationError_1.ValidationError,
    ValidationErrorMeta: ValidationErrorMeta_1.ValidationErrorMeta,
    ValidationResponse: ValidationResponse_1.ValidationResponse,
    Vulnerability: Vulnerability_1.Vulnerability,
    VulnerabilityAttributes: VulnerabilityAttributes_1.VulnerabilityAttributes,
    VulnerabilityCvss: VulnerabilityCvss_1.VulnerabilityCvss,
    VulnerabilityDependencyLocations: VulnerabilityDependencyLocations_1.VulnerabilityDependencyLocations,
    VulnerabilityRelationships: VulnerabilityRelationships_1.VulnerabilityRelationships,
    VulnerabilityRelationshipsAffects: VulnerabilityRelationshipsAffects_1.VulnerabilityRelationshipsAffects,
    VulnerabilityRelationshipsAffectsData: VulnerabilityRelationshipsAffectsData_1.VulnerabilityRelationshipsAffectsData,
    VulnerabilityRisks: VulnerabilityRisks_1.VulnerabilityRisks,
    WorkflowData: WorkflowData_1.WorkflowData,
    WorkflowDataAttributes: WorkflowDataAttributes_1.WorkflowDataAttributes,
    WorkflowDataRelationships: WorkflowDataRelationships_1.WorkflowDataRelationships,
    WorkflowDataUpdate: WorkflowDataUpdate_1.WorkflowDataUpdate,
    WorkflowDataUpdateAttributes: WorkflowDataUpdateAttributes_1.WorkflowDataUpdateAttributes,
    WorkflowInstanceCreateMeta: WorkflowInstanceCreateMeta_1.WorkflowInstanceCreateMeta,
    WorkflowInstanceCreateRequest: WorkflowInstanceCreateRequest_1.WorkflowInstanceCreateRequest,
    WorkflowInstanceCreateResponse: WorkflowInstanceCreateResponse_1.WorkflowInstanceCreateResponse,
    WorkflowInstanceCreateResponseData: WorkflowInstanceCreateResponseData_1.WorkflowInstanceCreateResponseData,
    WorkflowInstanceListItem: WorkflowInstanceListItem_1.WorkflowInstanceListItem,
    WorkflowListInstancesResponse: WorkflowListInstancesResponse_1.WorkflowListInstancesResponse,
    WorkflowListInstancesResponseMeta: WorkflowListInstancesResponseMeta_1.WorkflowListInstancesResponseMeta,
    WorkflowListInstancesResponseMetaPage: WorkflowListInstancesResponseMetaPage_1.WorkflowListInstancesResponseMetaPage,
    WorkflowTriggerWrapper: WorkflowTriggerWrapper_1.WorkflowTriggerWrapper,
    WorkflowUserRelationship: WorkflowUserRelationship_1.WorkflowUserRelationship,
    WorkflowUserRelationshipData: WorkflowUserRelationshipData_1.WorkflowUserRelationshipData,
    WorklflowCancelInstanceResponse: WorklflowCancelInstanceResponse_1.WorklflowCancelInstanceResponse,
    WorklflowCancelInstanceResponseData: WorklflowCancelInstanceResponseData_1.WorklflowCancelInstanceResponseData,
    WorklflowGetInstanceResponse: WorklflowGetInstanceResponse_1.WorklflowGetInstanceResponse,
    WorklflowGetInstanceResponseData: WorklflowGetInstanceResponseData_1.WorklflowGetInstanceResponseData,
    WorklflowGetInstanceResponseDataAttributes: WorklflowGetInstanceResponseDataAttributes_1.WorklflowGetInstanceResponseDataAttributes,
    XRayServicesIncludeAll: XRayServicesIncludeAll_1.XRayServicesIncludeAll,
    XRayServicesIncludeOnly: XRayServicesIncludeOnly_1.XRayServicesIncludeOnly,
};
const oneOfMap = {
    APIKeyResponseIncludedItem: ["User", "LeakedKey"],
    AWSAuthConfig: ["AWSAuthConfigKeys", "AWSAuthConfigRole"],
    AWSCredentials: ["AWSAssumeRole"],
    AWSCredentialsUpdate: ["AWSAssumeRoleUpdate"],
    AWSNamespaceFilters: [
        "AWSNamespaceFiltersExcludeOnly",
        "AWSNamespaceFiltersIncludeOnly",
    ],
    AWSRegions: ["AWSRegionsIncludeAll", "AWSRegionsIncludeOnly"],
    ActionConnectionIntegration: ["AWSIntegration", "HTTPIntegration"],
    ActionConnectionIntegrationUpdate: [
        "AWSIntegrationUpdate",
        "HTTPIntegrationUpdate",
    ],
    ActionQueryCondition: ["boolean", "string"],
    ActionQueryDebounceInMs: ["number", "string"],
    ActionQueryMockedOutputs: ["string", "ActionQueryMockedOutputsObject"],
    ActionQueryMockedOutputsEnabled: ["boolean", "string"],
    ActionQueryOnlyTriggerManually: ["boolean", "string"],
    ActionQueryPollingIntervalInMs: ["number", "string"],
    ActionQueryRequiresConfirmation: ["boolean", "string"],
    ActionQueryShowToastOnError: ["boolean", "string"],
    ActionQuerySpec: ["string", "ActionQuerySpecObject"],
    ActionQuerySpecInputs: ["string", "{ [key: string]: any; }"],
    ApplicationKeyResponseIncludedItem: ["User", "Role", "LeakedKey"],
    AuthNMappingCreateRelationships: [
        "AuthNMappingRelationshipToRole",
        "AuthNMappingRelationshipToTeam",
    ],
    AuthNMappingIncluded: ["SAMLAssertionAttribute", "Role", "AuthNMappingTeam"],
    AuthNMappingUpdateRelationships: [
        "AuthNMappingRelationshipToRole",
        "AuthNMappingRelationshipToTeam",
    ],
    CIAppAggregateBucketValue: [
        "string",
        "number",
        "Array<CIAppAggregateBucketValueTimeseriesPoint>",
    ],
    CIAppCreatePipelineEventRequestAttributesResource: [
        "CIAppPipelineEventPipeline",
        "CIAppPipelineEventStage",
        "CIAppPipelineEventJob",
        "CIAppPipelineEventStep",
    ],
    CIAppGroupByMissing: ["string", "number"],
    CIAppGroupByTotal: ["boolean", "string", "number"],
    CIAppPipelineEventPipeline: [
        "CIAppPipelineEventFinishedPipeline",
        "CIAppPipelineEventInProgressPipeline",
    ],
    ComponentGridPropertiesIsVisible: ["string", "boolean"],
    ComponentPropertiesIsVisible: ["boolean", "string"],
    ContainerImageItem: ["ContainerImage", "ContainerImageGroup"],
    ContainerItem: ["Container", "ContainerGroup"],
    CustomDestinationForwardDestination: [
        "CustomDestinationForwardDestinationHttp",
        "CustomDestinationForwardDestinationSplunk",
        "CustomDestinationForwardDestinationElasticsearch",
    ],
    CustomDestinationHttpDestinationAuth: [
        "CustomDestinationHttpDestinationAuthBasic",
        "CustomDestinationHttpDestinationAuthCustomHeader",
    ],
    CustomDestinationResponseForwardDestination: [
        "CustomDestinationResponseForwardDestinationHttp",
        "CustomDestinationResponseForwardDestinationSplunk",
        "CustomDestinationResponseForwardDestinationElasticsearch",
    ],
    CustomDestinationResponseHttpDestinationAuth: [
        "CustomDestinationResponseHttpDestinationAuthBasic",
        "CustomDestinationResponseHttpDestinationAuthCustomHeader",
    ],
    DowntimeMonitorIdentifier: [
        "DowntimeMonitorIdentifierId",
        "DowntimeMonitorIdentifierTags",
    ],
    DowntimeResponseIncludedItem: ["User", "DowntimeMonitorIncludedItem"],
    DowntimeScheduleCreateRequest: [
        "DowntimeScheduleRecurrencesCreateRequest",
        "DowntimeScheduleOneTimeCreateUpdateRequest",
    ],
    DowntimeScheduleResponse: [
        "DowntimeScheduleRecurrencesResponse",
        "DowntimeScheduleOneTimeResponse",
    ],
    DowntimeScheduleUpdateRequest: [
        "DowntimeScheduleRecurrencesUpdateRequest",
        "DowntimeScheduleOneTimeCreateUpdateRequest",
    ],
    EntityV3: [
        "EntityV3Service",
        "EntityV3Datastore",
        "EntityV3Queue",
        "EntityV3System",
        "EntityV3API",
    ],
    EntityV3APISpecInterface: [
        "EntityV3APISpecInterfaceFileRef",
        "EntityV3APISpecInterfaceDefinition",
    ],
    EscalationPolicyIncluded: [
        "TeamReference",
        "EscalationPolicyStep",
        "EscalationPolicyUser",
        "ScheduleData",
    ],
    EscalationTarget: ["TeamTarget", "UserTarget", "ScheduleTarget"],
    EventPayloadAttributes: ["ChangeEventCustomAttributes"],
    HTTPCredentials: ["HTTPTokenAuth"],
    HTTPCredentialsUpdate: ["HTTPTokenAuthUpdate"],
    IncidentAttachmentAttributes: [
        "IncidentAttachmentPostmortemAttributes",
        "IncidentAttachmentLinkAttributes",
    ],
    IncidentAttachmentUpdateAttributes: [
        "IncidentAttachmentPostmortemAttributes",
        "IncidentAttachmentLinkAttributes",
    ],
    IncidentAttachmentsResponseIncludedItem: ["User"],
    IncidentFieldAttributes: [
        "IncidentFieldAttributesSingleValue",
        "IncidentFieldAttributesMultipleValue",
    ],
    IncidentIntegrationMetadataMetadata: [
        "SlackIntegrationMetadata",
        "JiraIntegrationMetadata",
        "MSTeamsIntegrationMetadata",
    ],
    IncidentIntegrationMetadataResponseIncludedItem: ["User"],
    IncidentResponseIncludedItem: ["IncidentUserData", "IncidentAttachmentData"],
    IncidentServiceIncludedItems: ["User"],
    IncidentTeamIncludedItems: ["User"],
    IncidentTimelineCellCreateAttributes: [
        "IncidentTimelineCellMarkdownCreateAttributes",
    ],
    IncidentTodoAssignee: ["string", "IncidentTodoAnonymousAssignee"],
    IncidentTodoResponseIncludedItem: ["User"],
    ListEntityCatalogResponseIncludedItem: [
        "EntityResponseIncludedSchema",
        "EntityResponseIncludedRawSchema",
        "EntityResponseIncludedRelatedEntity",
        "EntityResponseIncludedOncall",
        "EntityResponseIncludedIncident",
    ],
    LogsAggregateBucketValue: [
        "string",
        "number",
        "Array<LogsAggregateBucketValueTimeseriesPoint>",
    ],
    LogsArchiveCreateRequestDestination: [
        "LogsArchiveDestinationAzure",
        "LogsArchiveDestinationGCS",
        "LogsArchiveDestinationS3",
    ],
    LogsArchiveDestination: [
        "LogsArchiveDestinationAzure",
        "LogsArchiveDestinationGCS",
        "LogsArchiveDestinationS3",
    ],
    LogsGroupByMissing: ["string", "number"],
    LogsGroupByTotal: ["boolean", "string", "number"],
    MetricAssetResponseIncluded: [
        "MetricDashboardAsset",
        "MetricMonitorAsset",
        "MetricNotebookAsset",
        "MetricSLOAsset",
    ],
    MetricVolumes: ["MetricDistinctVolume", "MetricIngestedIndexedVolume"],
    MetricsAndMetricTagConfigurations: ["Metric", "MetricTagConfiguration"],
    MonitorConfigPolicyPolicy: ["MonitorConfigPolicyTagPolicy"],
    MonitorConfigPolicyPolicyCreateRequest: [
        "MonitorConfigPolicyTagPolicyCreateRequest",
    ],
    MonitorNotificationRuleFilter: ["MonitorNotificationRuleFilterTags"],
    MonitorNotificationRuleResponseIncludedItem: ["User"],
    ObservabilityPipelineConfigDestinationItem: [
        "ObservabilityPipelineDatadogLogsDestination",
        "ObservabilityPipelineAmazonS3Destination",
        "ObservabilityPipelineGoogleCloudStorageDestination",
        "ObservabilityPipelineSplunkHecDestination",
        "ObservabilityPipelineSumoLogicDestination",
        "ObservabilityPipelineElasticsearchDestination",
        "ObservabilityPipelineRsyslogDestination",
        "ObservabilityPipelineSyslogNgDestination",
        "AzureStorageDestination",
        "MicrosoftSentinelDestination",
        "ObservabilityPipelineGoogleChronicleDestination",
        "ObservabilityPipelineNewRelicDestination",
        "ObservabilityPipelineSentinelOneDestination",
        "ObservabilityPipelineOpenSearchDestination",
        "ObservabilityPipelineAmazonOpenSearchDestination",
    ],
    ObservabilityPipelineConfigProcessorItem: [
        "ObservabilityPipelineFilterProcessor",
        "ObservabilityPipelineParseJSONProcessor",
        "ObservabilityPipelineQuotaProcessor",
        "ObservabilityPipelineAddFieldsProcessor",
        "ObservabilityPipelineRemoveFieldsProcessor",
        "ObservabilityPipelineRenameFieldsProcessor",
        "ObservabilityPipelineGenerateMetricsProcessor",
        "ObservabilityPipelineSampleProcessor",
        "ObservabilityPipelineParseGrokProcessor",
        "ObservabilityPipelineSensitiveDataScannerProcessor",
        "ObservabilityPipelineOcsfMapperProcessor",
        "ObservabilityPipelineAddEnvVarsProcessor",
        "ObservabilityPipelineDedupeProcessor",
        "ObservabilityPipelineEnrichmentTableProcessor",
        "ObservabilityPipelineReduceProcessor",
        "ObservabilityPipelineThrottleProcessor",
    ],
    ObservabilityPipelineConfigSourceItem: [
        "ObservabilityPipelineKafkaSource",
        "ObservabilityPipelineDatadogAgentSource",
        "ObservabilityPipelineSplunkTcpSource",
        "ObservabilityPipelineSplunkHecSource",
        "ObservabilityPipelineAmazonS3Source",
        "ObservabilityPipelineFluentdSource",
        "ObservabilityPipelineFluentBitSource",
        "ObservabilityPipelineHttpServerSource",
        "ObservabilityPipelineSumoLogicSource",
        "ObservabilityPipelineRsyslogSource",
        "ObservabilityPipelineSyslogNgSource",
        "ObservabilityPipelineAmazonDataFirehoseSource",
        "ObservabilityPipelineGooglePubSubSource",
        "ObservabilityPipelineHttpClientSource",
        "ObservabilityPipelineLogstashSource",
    ],
    ObservabilityPipelineMetricValue: [
        "ObservabilityPipelineGeneratedMetricIncrementByOne",
        "ObservabilityPipelineGeneratedMetricIncrementByField",
    ],
    ObservabilityPipelineOcsfMapperProcessorMappingMapping: [
        "ObservabilityPipelineOcsfMappingLibrary",
    ],
    ObservabilityPipelineSensitiveDataScannerProcessorAction: [
        "ObservabilityPipelineSensitiveDataScannerProcessorActionRedact",
        "ObservabilityPipelineSensitiveDataScannerProcessorActionHash",
        "ObservabilityPipelineSensitiveDataScannerProcessorActionPartialRedact",
    ],
    ObservabilityPipelineSensitiveDataScannerProcessorPattern: [
        "ObservabilityPipelineSensitiveDataScannerProcessorCustomPattern",
        "ObservabilityPipelineSensitiveDataScannerProcessorLibraryPattern",
    ],
    ObservabilityPipelineSensitiveDataScannerProcessorScope: [
        "ObservabilityPipelineSensitiveDataScannerProcessorScopeInclude",
        "ObservabilityPipelineSensitiveDataScannerProcessorScopeExclude",
        "ObservabilityPipelineSensitiveDataScannerProcessorScopeAll",
    ],
    Query: ["ActionQuery", "DataTransform", "StateVariable"],
    RUMAggregateBucketValue: [
        "string",
        "number",
        "Array<RUMAggregateBucketValueTimeseriesPoint>",
    ],
    RUMGroupByMissing: ["string", "number"],
    RUMGroupByTotal: ["boolean", "string", "number"],
    RoutingRuleAction: ["SendSlackMessageAction", "SendTeamsMessageAction"],
    ScalarColumn: ["GroupScalarColumn", "DataScalarColumn"],
    ScalarQuery: ["MetricsScalarQuery", "EventsScalarQuery"],
    ScheduleDataIncludedItem: [
        "TeamReference",
        "Layer",
        "ScheduleMember",
        "ScheduleUser",
    ],
    SecurityMonitoringRuleConvertPayload: [
        "SecurityMonitoringStandardRulePayload",
        "SecurityMonitoringSignalRulePayload",
    ],
    SecurityMonitoringRuleCreatePayload: [
        "SecurityMonitoringStandardRuleCreatePayload",
        "SecurityMonitoringSignalRuleCreatePayload",
        "CloudConfigurationRuleCreatePayload",
    ],
    SecurityMonitoringRuleQuery: [
        "SecurityMonitoringStandardRuleQuery",
        "SecurityMonitoringSignalRuleQuery",
    ],
    SecurityMonitoringRuleResponse: [
        "SecurityMonitoringStandardRuleResponse",
        "SecurityMonitoringSignalRuleResponse",
    ],
    SecurityMonitoringRuleTestPayload: [
        "SecurityMonitoringStandardRuleTestPayload",
    ],
    SecurityMonitoringRuleValidatePayload: [
        "SecurityMonitoringStandardRulePayload",
        "SecurityMonitoringSignalRulePayload",
        "CloudConfigurationRulePayload",
    ],
    SensitiveDataScannerGetConfigIncludedItem: [
        "SensitiveDataScannerRuleIncludedItem",
        "SensitiveDataScannerGroupIncludedItem",
    ],
    ServiceDefinitionSchema: [
        "ServiceDefinitionV1",
        "ServiceDefinitionV2",
        "ServiceDefinitionV2Dot1",
        "ServiceDefinitionV2Dot2",
    ],
    ServiceDefinitionV2Contact: [
        "ServiceDefinitionV2Email",
        "ServiceDefinitionV2Slack",
        "ServiceDefinitionV2MSTeams",
    ],
    ServiceDefinitionV2Dot1Contact: [
        "ServiceDefinitionV2Dot1Email",
        "ServiceDefinitionV2Dot1Slack",
        "ServiceDefinitionV2Dot1MSTeams",
    ],
    ServiceDefinitionsCreateRequest: [
        "ServiceDefinitionV2Dot2",
        "ServiceDefinitionV2Dot1",
        "ServiceDefinitionV2",
        "string",
    ],
    ShiftIncluded: ["ScheduleUser"],
    SpansAggregateBucketValue: [
        "string",
        "number",
        "Array<SpansAggregateBucketValueTimeseriesPoint>",
    ],
    SpansGroupByMissing: ["string", "number"],
    SpansGroupByTotal: ["boolean", "string", "number"],
    TeamIncluded: ["User", "TeamLink", "UserTeamPermission"],
    TeamRoutingRulesIncluded: ["RoutingRule"],
    TimeseriesQuery: ["MetricsTimeseriesQuery", "EventsTimeseriesQuery"],
    Trigger: [
        "APITriggerWrapper",
        "AppTriggerWrapper",
        "CaseTriggerWrapper",
        "ChangeEventTriggerWrapper",
        "DatabaseMonitoringTriggerWrapper",
        "DashboardTriggerWrapper",
        "GithubWebhookTriggerWrapper",
        "IncidentTriggerWrapper",
        "MonitorTriggerWrapper",
        "NotebookTriggerWrapper",
        "ScheduleTriggerWrapper",
        "SecurityTriggerWrapper",
        "SelfServiceTriggerWrapper",
        "SlackTriggerWrapper",
        "SoftwareCatalogTriggerWrapper",
        "WorkflowTriggerWrapper",
    ],
    UpsertCatalogEntityRequest: ["EntityV3", "string"],
    UpsertCatalogEntityResponseIncludedItem: ["EntityResponseIncludedSchema"],
    UserResponseIncludedItem: ["Organization", "Permission", "Role"],
    UserTeamIncluded: ["User", "Team"],
    XRayServicesList: ["XRayServicesIncludeAll", "XRayServicesIncludeOnly"],
};
class ObjectSerializer {
    static serialize(data, type, format) {
        if (data == undefined || type == "any") {
            return data;
        }
        else if (data instanceof util_1.UnparsedObject) {
            return data._data;
        }
        else if (primitives.includes(type.toLowerCase()) &&
            typeof data == type.toLowerCase()) {
            return data;
        }
        else if (type.startsWith(ARRAY_PREFIX)) {
            if (!Array.isArray(data)) {
                throw new TypeError(`mismatch types '${data}' and '${type}'`);
            }
            // Array<Type> => Type
            const subType = type.substring(ARRAY_PREFIX.length, type.length - 1);
            const transformedData = [];
            for (const element of data) {
                transformedData.push(ObjectSerializer.serialize(element, subType, format));
            }
            return transformedData;
        }
        else if (type.startsWith(TUPLE_PREFIX)) {
            // We only support homegeneus tuples
            const subType = type
                .substring(TUPLE_PREFIX.length, type.length - 1)
                .split(", ")[0];
            const transformedData = [];
            for (const element of data) {
                transformedData.push(ObjectSerializer.serialize(element, subType, format));
            }
            return transformedData;
        }
        else if (type.startsWith(MAP_PREFIX)) {
            // { [key: string]: Type; } => Type
            const subType = type.substring(MAP_PREFIX.length, type.length - 3);
            const transformedData = {};
            for (const key in data) {
                transformedData[key] = ObjectSerializer.serialize(data[key], subType, format);
            }
            return transformedData;
        }
        else if (type === "Date") {
            if ("string" == typeof data) {
                return data;
            }
            if (format == "date" || format == "date-time") {
                return (0, util_1.dateToRFC3339String)(data);
            }
            else {
                return data.toISOString();
            }
        }
        else {
            if (enumsMap[type]) {
                if (enumsMap[type].includes(data)) {
                    return data;
                }
                throw new TypeError(`unknown enum value '${data}'`);
            }
            if (oneOfMap[type]) {
                const oneOfs = [];
                for (const oneOf of oneOfMap[type]) {
                    try {
                        oneOfs.push(ObjectSerializer.serialize(data, oneOf, format));
                    }
                    catch (e) {
                        logger_1.logger.debug(`could not serialize ${oneOf} (${e})`);
                    }
                }
                if (oneOfs.length > 1) {
                    throw new TypeError(`${data} matches multiple types from ${oneOfMap[type]} ${oneOfs}`);
                }
                if (oneOfs.length == 0) {
                    throw new TypeError(`${data} doesn't match any type from ${oneOfMap[type]} ${oneOfs}`);
                }
                return oneOfs[0];
            }
            if (!typeMap[type]) {
                // dont know the type
                throw new TypeError(`unknown type '${type}'`);
            }
            // get the map for the correct type.
            const attributesMap = typeMap[type].getAttributeTypeMap();
            const instance = {};
            for (const attributeName in data) {
                const attributeObj = attributesMap[attributeName];
                if (attributeName === "_unparsed" ||
                    attributeName === "additionalProperties") {
                    continue;
                }
                else if (attributeObj === undefined &&
                    !("additionalProperties" in attributesMap)) {
                    throw new Error("unexpected attribute " + attributeName + " of type " + type);
                }
                else if (attributeObj) {
                    instance[attributeObj.baseName] = ObjectSerializer.serialize(data[attributeName], attributeObj.type, attributeObj.format);
                }
            }
            if (data.additionalProperties) {
                const additionalPropertiesMap = attributesMap["additionalProperties"];
                if (additionalPropertiesMap) {
                    for (const key in data.additionalProperties) {
                        instance[key] = ObjectSerializer.serialize(data.additionalProperties[key], additionalPropertiesMap.type, additionalPropertiesMap.format);
                    }
                }
                else {
                    throw new Error(`additionalProperties found in ${type}`);
                }
            }
            // check for required properties
            for (const attributeName in attributesMap) {
                const attributeObj = attributesMap[attributeName];
                if ((attributeObj === null || attributeObj === void 0 ? void 0 : attributeObj.required) &&
                    instance[attributeObj.baseName] === undefined) {
                    throw new Error(`missing required property '${attributeObj.baseName}'`);
                }
            }
            return instance;
        }
    }
    static deserialize(data, type, format = "") {
        var _a;
        if (data == undefined || type == "any") {
            return data;
        }
        else if (primitives.includes(type.toLowerCase()) &&
            typeof data == type.toLowerCase()) {
            return data;
        }
        else if (type.startsWith(ARRAY_PREFIX)) {
            // Assert the passed data is Array type
            if (!Array.isArray(data)) {
                throw new TypeError(`mismatch types '${data}' and '${type}'`);
            }
            // Array<Type> => Type
            const subType = type.substring(ARRAY_PREFIX.length, type.length - 1);
            const transformedData = [];
            for (const element of data) {
                transformedData.push(ObjectSerializer.deserialize(element, subType, format));
            }
            return transformedData;
        }
        else if (type.startsWith(TUPLE_PREFIX)) {
            // [Type,...] => Type
            const subType = type
                .substring(TUPLE_PREFIX.length, type.length - 1)
                .split(", ")[0];
            const transformedData = [];
            for (const element of data) {
                transformedData.push(ObjectSerializer.deserialize(element, subType, format));
            }
            return transformedData;
        }
        else if (type.startsWith(MAP_PREFIX)) {
            // { [key: string]: Type; } => Type
            const subType = type.substring(MAP_PREFIX.length, type.length - 3);
            const transformedData = {};
            for (const key in data) {
                transformedData[key] = ObjectSerializer.deserialize(data[key], subType, format);
            }
            return transformedData;
        }
        else if (type === "Date") {
            try {
                return (0, util_1.dateFromRFC3339String)(data);
            }
            catch (_b) {
                return new Date(data);
            }
        }
        else {
            if (enumsMap[type]) {
                if (enumsMap[type].includes(data)) {
                    return data;
                }
                return new util_1.UnparsedObject(data);
            }
            if (oneOfMap[type]) {
                const oneOfs = [];
                for (const oneOf of oneOfMap[type]) {
                    try {
                        const d = ObjectSerializer.deserialize(data, oneOf, format);
                        if (!(d === null || d === void 0 ? void 0 : d._unparsed)) {
                            oneOfs.push(d);
                        }
                    }
                    catch (e) {
                        logger_1.logger.debug(`could not deserialize ${oneOf} (${e})`);
                    }
                }
                if (oneOfs.length != 1) {
                    return new util_1.UnparsedObject(data);
                }
                return oneOfs[0];
            }
            if (!typeMap[type]) {
                // dont know the type
                throw new TypeError(`unknown type '${type}'`);
            }
            const instance = new typeMap[type]();
            const attributesMap = typeMap[type].getAttributeTypeMap();
            const attributesBaseNames = Object.keys(attributesMap).reduce((o, key) => Object.assign(o, { [attributesMap[key].baseName]: "" }), {});
            const extraAttributes = Object.keys(data).filter((key) => !Object.prototype.hasOwnProperty.call(attributesBaseNames, key));
            if (extraAttributes.length > 0) {
                if ("additionalProperties" in attributesMap) {
                    if (!instance.additionalProperties) {
                        instance.additionalProperties = {};
                    }
                    const attributeObj = attributesMap["additionalProperties"];
                    for (const key in extraAttributes) {
                        instance.additionalProperties[extraAttributes[key]] =
                            ObjectSerializer.deserialize(data[extraAttributes[key]], attributeObj.type, attributeObj.format);
                    }
                }
                else {
                    throw new Error(`found extra attributes '${extraAttributes}' in ${type}`);
                }
            }
            for (const attributeName in attributesMap) {
                const attributeObj = attributesMap[attributeName];
                if (attributeName === "additionalProperties") {
                    continue;
                }
                instance[attributeName] = ObjectSerializer.deserialize(data[attributeObj.baseName], attributeObj.type, attributeObj.format);
                // check for required properties
                if ((attributeObj === null || attributeObj === void 0 ? void 0 : attributeObj.required) && instance[attributeName] === undefined) {
                    throw new Error(`missing required property '${attributeName}'`);
                }
                if (instance[attributeName] instanceof util_1.UnparsedObject ||
                    ((_a = instance[attributeName]) === null || _a === void 0 ? void 0 : _a._unparsed)) {
                    instance._unparsed = true;
                }
                if (Array.isArray(instance[attributeName])) {
                    for (const d of instance[attributeName]) {
                        if (d instanceof util_1.UnparsedObject || (d === null || d === void 0 ? void 0 : d._unparsed)) {
                            instance._unparsed = true;
                            break;
                        }
                    }
                }
            }
            return instance;
        }
    }
    /**
     * Normalize media type
     *
     * We currently do not handle any media types attributes, i.e. anything
     * after a semicolon. All content is assumed to be UTF-8 compatible.
     */
    static normalizeMediaType(mediaType) {
        if (mediaType === undefined) {
            return undefined;
        }
        return mediaType.split(";")[0].trim().toLowerCase();
    }
    /**
     * From a list of possible media types, choose the one we can handle best.
     *
     * The order of the given media types does not have any impact on the choice
     * made.
     */
    static getPreferredMediaType(mediaTypes) {
        /** According to OAS 3 we should default to json */
        if (!mediaTypes) {
            return "application/json";
        }
        const normalMediaTypes = mediaTypes.map(this.normalizeMediaType);
        let selectedMediaType = undefined;
        let selectedRank = -Infinity;
        for (const mediaType of normalMediaTypes) {
            if (mediaType === undefined) {
                continue;
            }
            const supported = supportedMediaTypes[mediaType];
            if (supported !== undefined && supported > selectedRank) {
                selectedMediaType = mediaType;
                selectedRank = supported;
            }
        }
        if (selectedMediaType === undefined) {
            throw new Error("None of the given media types are supported: " + mediaTypes.join(", "));
        }
        return selectedMediaType;
    }
    /**
     * Convert data to a string according the given media type
     */
    static stringify(data, mediaType) {
        if (mediaType === "application/json" || mediaType === "text/json") {
            return JSON.stringify(data);
        }
        throw new Error("The mediaType " +
            mediaType +
            " is not supported by ObjectSerializer.stringify.");
    }
    /**
     * Parse data from a string according to the given media type
     */
    static parse(rawData, mediaType) {
        try {
            return JSON.parse(rawData);
        }
        catch (error) {
            logger_1.logger.debug(`could not parse ${mediaType}: ${error}`);
            return rawData;
        }
    }
}
exports.ObjectSerializer = ObjectSerializer;
//# sourceMappingURL=ObjectSerializer.js.map